webpackJsonp([1],{

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/table/_table.js
var _table = __webpack_require__("fnDg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/table/table.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var table = (_table["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/table/table.vue
function injectStyle (ssrContext) {
  __webpack_require__("4veK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  table,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var table_table = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+H51":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"lead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ticketId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"input"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"question"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"answer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mandatory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submittedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postedAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type_original"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfMandatoryQuestions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfQuestions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfQuestionsAnswered"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfMessages"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfQuestionsSeenByVisitor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agentResponseTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chatTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seenByVisitorTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"closedByVisitorTime"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"visitor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timezone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timezone_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"region_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"region_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"longitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viewUuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visitorUuid"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"navigator"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"href"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"language"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userAgent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"screenWidth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"screenHeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"docWidth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"docHeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viewportWidth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viewportHeight"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"context"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prompt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"chat"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byRepresentative"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timestamp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seenAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"question"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logs"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1490}};
    doc.loc.source = {"body":"query lead($id: Int) {\n  lead(id: $id) {\n    companyId\n    campaignId\n    ticketId\n    agentId\n    created\n    updated\n    completed\n    input\n    notes\n    company {\n      id\n      companyName\n    }\n    campaign {\n      id\n      campaignName\n    }\n    questions {\n      fieldName\n      question\n      answer\n      options\n      mandatory\n      type\n    }\n    workflow {\n      submittedAt\n      emailedAt\n      postedAt\n    }\n    data {\n      type\n      type_original\n      stats {\n        numberOfMandatoryQuestions\n        numberOfQuestions\n        numberOfQuestionsAnswered\n        numberOfMessages\n        numberOfQuestionsSeenByVisitor\n        agentResponseTime\n        chatTime\n        seenByVisitorTime\n        closedByVisitorTime\n      }\n      visitor {\n        ip\n        timezone\n        timezone_id\n        zip\n        city\n        country_code\n        country_name\n        region_code\n        region_name\n        currency\n        latitude\n        longitude\n        viewUuid\n        visitorUuid\n      }\n      navigator {\n        deviceType\n        href\n        language\n        userAgent\n        screenWidth\n        screenHeight\n        docWidth\n        docHeight\n        viewportWidth\n        viewportHeight\n      },\n      context {\n        title\n        subtitle\n        prompt\n      }\n      chat {\n        byRepresentative\n        message\n        timestamp\n        seenAt\n        question {\n          type\n          options\n        }\n      }\n      call\n      logs\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["lead"] = oneQuery(doc, "lead");
        


/***/ }),

/***/ "+ros":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+u7E":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateLanding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LandingPageInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLanding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":146}};
    doc.loc.source = {"body":"mutation updateLanding($campaignId: ID!, $input: LandingPageInput!) {\n  updateLanding(campaignId: $campaignId, input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updateLanding"] = oneQuery(doc, "updateLanding");
        


/***/ }),

/***/ "/rWf":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlanInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":109}};
    doc.loc.source = {"body":"mutation updatePlan($id: ID!, $input: PlanInput!) {\n  updatePlan(id: $id, input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updatePlan"] = oneQuery(doc, "updatePlan");
        


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0vHi":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCompany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCompany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":99}};
    doc.loc.source = {"body":"mutation createCompany($input: CompanyInput!) {\n  createCompany(input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["createCompany"] = oneQuery(doc, "createCompany");
        


/***/ }),

/***/ "1Prk":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"agentsName"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentsName"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":80}};
    doc.loc.source = {"body":"query agentsName {\n  agentsName {\n    result {\n      id,\n      name\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["agentsName"] = oneQuery(doc, "agentsName");
        


/***/ }),

/***/ "2OLb":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assignableUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descending"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignableUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"descending"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descending"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":258}};
    doc.loc.source = {"body":"query assignableUsers(\n  $companyId: Int\n  $descending: Boolean\n  $sortBy: String\n  $limit: Int\n) {\n  assignableUsers(\n    companyId: $companyId\n    descending: $descending\n    sortBy: $sortBy\n    limit: $limit\n  ) {\n    id\n    name\n    email\n    role\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["assignableUsers"] = oneQuery(doc, "assignableUsers");
        


/***/ }),

/***/ "4+62":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/user.d11a452.png";

/***/ }),

/***/ "4/hK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4veK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5S2H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6YeP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Gbs":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"balance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":65}};
    doc.loc.source = {"body":"query balance($id: Int) {\n  balance(id: $id) {\n    balance\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["balance"] = oneQuery(doc, "balance");
        


/***/ }),

/***/ "7PHd":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"landingPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"landingPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"head"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"body"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"settings"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"theme"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":135}};
    doc.loc.source = {"body":"query landingPage($campaignId: ID!) {\n  landingPage(campaignId: $campaignId) {\n    head\n    body\n    settings\n    theme\n    name\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["landingPage"] = oneQuery(doc, "landingPage");
        


/***/ }),

/***/ "7c67":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7nA6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "84UR":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"payment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payment"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":145}};
    doc.loc.source = {"body":"mutation createPayment($companyId: ID!, $payment: PaymentInput!) {\n  createPayment(companyId: $companyId, payment: $payment) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["createPayment"] = oneQuery(doc, "createPayment");
        


/***/ }),

/***/ "85oc":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"agents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descending"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"period"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"descending"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descending"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"agentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"period"},"value":{"kind":"Variable","name":{"kind":"Name","value":"period"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalLeads"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completedLeads"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partialLeads"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ctrLeads"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalDP"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mandatoryDP"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"collectedDP"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completedDP"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageRT"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minRT"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxRT"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageCT"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minCT"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxCT"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ctrDP"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ctrCompletedDP"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partialsDP"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ctrPartialsDP"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":639}};
    doc.loc.source = {"body":"query agents($descending: Boolean, $sortBy: String, $limit: Int, $page: Int, $agentId: String, $period: String) {\n  agents(descending: $descending, sortBy: $sortBy, limit: $limit, page: $page, agentId: $agentId, period: $period) {\n    result {\n      id\n      name,\n      totalLeads,\n      completedLeads,\n      partialLeads,\n      ctrLeads,\n      totalDP,\n      mandatoryDP,\n      collectedDP,\n      completedDP,\n      notes,\n      averageRT,\n      minRT,\n      maxRT,\n      averageCT,\n      minCT,\n      maxCT,\n      ctrDP,\n      ctrCompletedDP,\n      partialsDP,\n      ctrPartialsDP,\n    }\n    meta {\n      limit\n      count\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["agents"] = oneQuery(doc, "agents");
        


/***/ }),

/***/ "8azP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8i23":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8rN0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ABp2":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"company"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"website"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overdue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stripeSourceId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":204}};
    doc.loc.source = {"body":"query company($id: Int) {\n  company(id: $id) {\n    id\n    companyName\n    status\n    currency\n    description\n    address\n    website\n    created\n    overdue\n    stripeSourceId\n    stripeCustomerId\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["company"] = oneQuery(doc, "company");
        


/***/ }),

/***/ "AJN+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AomL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AxLj":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOrUpdateWebhook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"webhook"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WebhookInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrUpdateWebhook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"webhook"},"value":{"kind":"Variable","name":{"kind":"Name","value":"webhook"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":164}};
    doc.loc.source = {"body":"mutation createOrUpdateWebhook($campaignId: ID!, $webhook: WebhookInput!) {\n  createOrUpdateWebhook(campaignId: $campaignId, webhook: $webhook) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["createOrUpdateWebhook"] = oneQuery(doc, "createOrUpdateWebhook");
        


/***/ }),

/***/ "AxlZ":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCampaignPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignPolicyInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCampaignPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":163}};
    doc.loc.source = {"body":"mutation updateCampaignPolicy($campaignId: ID!, $input: CampaignPolicyInput!) {\n  updateCampaignPolicy(campaignId: $campaignId, input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updateCampaignPolicy"] = oneQuery(doc, "updateCampaignPolicy");
        


/***/ }),

/***/ "BOTv":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"transactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descending"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"descending"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descending"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leadId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":405}};
    doc.loc.source = {"body":"query transactions($descending: Boolean, $sortBy: String, $limit: Int, $page: Int, $name: String, $where: String) {\n  transactions(descending: $descending, sortBy: $sortBy, limit: $limit, page: $page, name: $name, where: $where) {\n    result {\n      id\n      companyId\n      created\n      createdBy\n      notes\n      currency\n      amount\n      leadId\n    }\n    meta {\n      limit\n      count\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["transactions"] = oneQuery(doc, "transactions");
        


/***/ }),

/***/ "BSNT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BxM0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C9Ib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CC0Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CtNn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cyu/":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"signupByUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignupInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signupByUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"companyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":240}};
    doc.loc.source = {"body":"mutation signupByUser($input: SignupInput!) {\n  signupByUser(input: $input) {\n    token\n    permission\n    user {\n      name\n      email\n      phone\n      role {\n        role_type\n        id\n      }\n      companyId\n      status\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["signupByUser"] = oneQuery(doc, "signupByUser");
        


/***/ }),

/***/ "DizW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ESIV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ETBo":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":130}};
    doc.loc.source = {"body":"mutation createTransaction($id: ID!, $input: TransactionInput!) {\n  createTransaction(id: $id, input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["createTransaction"] = oneQuery(doc, "createTransaction");
        


/***/ }),

/***/ "GQbz":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"webhook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webhook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"params"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleParam"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":270}};
    doc.loc.source = {"body":"query webhook($campaignId: ID!) {\n  webhook(campaignId: $campaignId) {\n    id\n    campaignId\n    isEnabled\n    url\n    type {\n      id\n      type\n    }\n    params {\n      ... on SimpleParam {\n        id\n        name\n        type\n        value\n      }\n      \n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["webhook"] = oneQuery(doc, "webhook");
        


/***/ }),

/***/ "GWS0":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"balances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":82}};
    doc.loc.source = {"body":"query balances($id: Int!) {\n  balances(id: $id) {\n    balance\n    currency\n  }\n} \n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["balances"] = oneQuery(doc, "balances");
        


/***/ }),

/***/ "GXit":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H5Up":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":82}};
    doc.loc.source = {"body":"mutation removeCampaign($id: ID!) {\n  removeCampaign(id: $id) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["removeCampaign"] = oneQuery(doc, "removeCampaign");
        


/***/ }),

/***/ "HDej":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"campaignPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newRequest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataPoint"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lead"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partialLead"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderPercent"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":160}};
    doc.loc.source = {"body":"query campaignPlan($id: Int) {\n  campaignPlan(id: $id) {\n    newRequest\n    dataPoint\n    notes\n    lead\n    partialLead\n    orderAmount\n    orderPercent\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["campaignPlan"] = oneQuery(doc, "campaignPlan");
        


/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form-input/_form-input.js
var _form_input = __webpack_require__("qRo1");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var form_input = (_form_input["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
function injectStyle (ssrContext) {
  __webpack_require__("n9mN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_input,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_input_form_input = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ILpv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iw3e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J/yo":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WidgetInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWidget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":115}};
    doc.loc.source = {"body":"mutation updateWidget($id: ID!, $input: WidgetInput!) {\n  updateWidget(id: $id, input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updateWidget"] = oneQuery(doc, "updateWidget");
        


/***/ }),

/***/ "J77E":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"leads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descending"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"period"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"answer"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"descending"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descending"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"period"},"value":{"kind":"Variable","name":{"kind":"Name","value":"period"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"answer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"answer"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfMandatoryQuestions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfQuestions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfQuestionsAnswered"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"names"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phones"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":664}};
    doc.loc.source = {"body":"query leads($descending: Boolean, $sortBy: String, $limit: Int, $page: Int, $campaignId: Int, $period: String, $status: String, $id: String, $answer: String) {\n  leads(descending: $descending, sortBy: $sortBy, limit: $limit, page: $page, campaignId: $campaignId, period: $period, status: $status, id: $id, answer: $answer) {\n    result {\n      id\n      campaignName\n      campaignId\n      created\n      data {\n        stats {\n          numberOfMandatoryQuestions\n          numberOfQuestions\n          numberOfQuestionsAnswered\n        }\n      }\n      completed\n      notes\n      names\n      phones\n      emails\n    }\n    meta {\n      limit\n      count\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["leads"] = oneQuery(doc, "leads");
        


/***/ }),

/***/ "JBko":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"plan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balanceLimit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newRequest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataPoint"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lead"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partialLead"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderPercent"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":161}};
    doc.loc.source = {"body":"query plan($id: Int) {\n  plan(id: $id) {\n    balanceLimit\n    newRequest\n    dataPoint\n    notes\n    lead\n    partialLead\n    orderAmount\n    orderPercent\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["plan"] = oneQuery(doc, "plan");
        


/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/modal/_modal.js
var _modal = __webpack_require__("rKsW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/modal/modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var modal = (_modal["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/modal/modal.vue
function injectStyle (ssrContext) {
  __webpack_require__("xBwK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  modal,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var modal_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form-file/_form-file.js
var _form_file = __webpack_require__("9NuQ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-file/form-file.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var form_file = (_form_file["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-file/form-file.vue
function injectStyle (ssrContext) {
  __webpack_require__("Y9O/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_file,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_file_form_file = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jikj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K28h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K7Rd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KfMs":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"questions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descending"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"descending"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descending"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fieldName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"question"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mandatory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"params"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":386}};
    doc.loc.source = {"body":"query questions($limit: Int, $page: Int, $descending: Boolean, $sortBy: String, $where: String) {\n  questions(limit: $limit, page: $page, descending: $descending, sortBy: $sortBy, where: $where) {\n    result {\n      id\n      fieldName\n      question\n      type\n      mandatory\n      created\n      campaignId\n      params\n      order\n    }\n    meta {\n      limit\n      count\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["questions"] = oneQuery(doc, "questions");
        


/***/ }),

/***/ "KjBi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LKpP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LNGa":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assignedUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignedUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":115}};
    doc.loc.source = {"body":"query assignedUsers($campaignId: Int!) {\n  assignedUsers(campaignId: $campaignId) {\n    id\n    email\n    role\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["assignedUsers"] = oneQuery(doc, "assignedUsers");
        


/***/ }),

/***/ "Lx+I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M18t":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"billing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descending"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"descending"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descending"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"last4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brand"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exp"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":367}};
    doc.loc.source = {"body":"query billing($descending: Boolean, $sortBy: String, $limit: Int, $page: Int, $name: String, $id: Int) {\n  billing(descending: $descending, sortBy: $sortBy, limit: $limit, page: $page, name: $name, id: $id) {\n    result {\n      id\n      name\n      email\n      zip\n      country\n      last4\n      brand\n      exp\n    },\n    meta {\n      limit\n      count\n    }\n  },\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["billing"] = oneQuery(doc, "billing");
        


/***/ }),

/***/ "Mexu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N6Zi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/index.js + 121 modules
var es = __webpack_require__("e6fC");

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Breadcrumb.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Breadcrumb = ({
  name: 'breadcrumbs',
  props: {
    current: String
  },
  computed: {
    titles: function titles() {
      return this.$store.state.route.meta.breadcrumbs || [];
    },
    isNotRoot: function isNotRoot() {
      return this.$store.state.route.path !== '/';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bb5c136","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
var Breadcrumb_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row page-titles"},[_c('div',{staticClass:"col-md-6 col-8 align-self-center"},[_c('ol',{staticClass:"breadcrumb"},[_vm._l((_vm.titles),function(title){return (_vm.titles.length)?_c('li',{key:title.name,staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":{ name: title.name }}},[_vm._v(_vm._s(title.text))])],1):_vm._e()}),_vm._v(" "),(_vm.current)?_c('li',{staticClass:"breadcrumb-item"},[_vm._v("\n          "+_vm._s(_vm.current)+"\n        ")]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: Breadcrumb_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Breadcrumb = (esExports);
// CONCATENATED MODULE: ./src/components/Breadcrumb.vue
function injectStyle (ssrContext) {
  __webpack_require__("Wfjt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bb5c136"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Breadcrumb,
  components_Breadcrumb,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Breadcrumb = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-notification/dist/index.js
var dist = __webpack_require__("CLX7");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vue-moment/dist/vue-moment.js
var vue_moment = __webpack_require__("8AgW");
var vue_moment_default = /*#__PURE__*/__webpack_require__.n(vue_moment);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/v-mask/dist/v-mask.esm.js
var v_mask_esm = __webpack_require__("1I9z");

// EXTERNAL MODULE: ./node_modules/vue2-filters/dist/vue2-filters.js
var vue2_filters = __webpack_require__("OjAt");
var vue2_filters_default = /*#__PURE__*/__webpack_require__.n(vue2_filters);

// EXTERNAL MODULE: ./node_modules/material-design-icons-iconfont/dist/material-design-icons.css
var material_design_icons = __webpack_require__("gJtD");
var material_design_icons_default = /*#__PURE__*/__webpack_require__.n(material_design_icons);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/dist/bootstrap-vue.css
var bootstrap_vue = __webpack_require__("9M+g");
var bootstrap_vue_default = /*#__PURE__*/__webpack_require__.n(bootstrap_vue);

// EXTERNAL MODULE: ./node_modules/dialog-polyfill/dialog-polyfill.css
var dialog_polyfill = __webpack_require__("iJZB");
var dialog_polyfill_default = /*#__PURE__*/__webpack_require__.n(dialog_polyfill);

// EXTERNAL MODULE: ./src/assets/css/vue-multiselect.min.css
var vue_multiselect_min = __webpack_require__("ptbP");
var vue_multiselect_min_default = /*#__PURE__*/__webpack_require__.n(vue_multiselect_min);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.min.css
var vuetify_min = __webpack_require__("7zck");
var vuetify_min_default = /*#__PURE__*/__webpack_require__.n(vuetify_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//





/* harmony default export */ var App = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isWhiteLabel'])),
  created: function created() {
    // if (!this.isWhiteLabel) {
    //   const jiraServiceDesk = document.createElement('script');
    //   jiraServiceDesk.setAttribute('data-jsd-embedded',"");
    //   jiraServiceDesk.setAttribute('async',"");
    //   jiraServiceDesk.setAttribute('data-key',"8bb1d566-19d3-4b9c-ad95-b7d781019a64");
    //   jiraServiceDesk.setAttribute('data-base-url',"https://jsd-widget.atlassian.com");
    //   jiraServiceDesk.setAttribute('src',"https://jsd-widget.atlassian.com/assets/embed.js");
    //   document.head.appendChild(jiraServiceDesk);
    // }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da70e84e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('keep-alive',{attrs:{"include":['CampaignDetails', 'CompanyDetails']}},[_c('router-view')],1)],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("U9Rq")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vue-apollo/dist/vue-apollo.esm.js
var vue_apollo_esm = __webpack_require__("69U5");

// EXTERNAL MODULE: ./node_modules/apollo-client/bundle.esm.js
var bundle_esm = __webpack_require__("ZEWO");

// EXTERNAL MODULE: ./node_modules/apollo-link-http/lib/bundle.esm.js + 1 modules
var lib_bundle_esm = __webpack_require__("gyJL");

// EXTERNAL MODULE: ./node_modules/apollo-cache-inmemory/lib/bundle.esm.js + 3 modules
var apollo_cache_inmemory_lib_bundle_esm = __webpack_require__("1bcK");

// EXTERNAL MODULE: ./node_modules/apollo-link-context/lib/index.js
var lib = __webpack_require__("SR+g");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/apollo.js








var httpLink = new lib_bundle_esm["a" /* HttpLink */]({
  uri: "https://api.nextlead.io/graphql"
});

var authLink = Object(lib["setContext"])(function (_, _ref) {
  var headers = _ref.headers;

  var auth = JSON.parse(localStorage.getItem('auth')) || {};

  return {
    headers: extends_default()({}, headers, {
      authorization: auth.token || ''
    })
  };
});

// Create the apollo client
var apolloClient = new bundle_esm["a" /* ApolloClient */]({
  link: authLink.concat(httpLink),
  cache: new apollo_cache_inmemory_lib_bundle_esm["a" /* InMemoryCache */](),
  connectToDevTools: true
});

var apolloProvider = new vue_apollo_esm["a" /* default */]({
  defaultClient: apolloClient
});

// Install the vue plugin
vue_esm["default"].use(vue_apollo_esm["a" /* default */]);

/* harmony default export */ var apollo = (apolloProvider);
// EXTERNAL MODULE: ./src/graphql/Campaigns/Campaign.gql
var Campaign = __webpack_require__("xmWa");
var Campaign_default = /*#__PURE__*/__webpack_require__.n(Campaign);

// EXTERNAL MODULE: ./src/graphql/Campaigns/RemoveCampaign.gql
var RemoveCampaign = __webpack_require__("H5Up");
var RemoveCampaign_default = /*#__PURE__*/__webpack_require__.n(RemoveCampaign);

// EXTERNAL MODULE: ./src/graphql/Campaigns/UpdateWidget.gql
var UpdateWidget = __webpack_require__("J/yo");
var UpdateWidget_default = /*#__PURE__*/__webpack_require__.n(UpdateWidget);

// EXTERNAL MODULE: ./src/graphql/Companies/Company.gql
var Company = __webpack_require__("ABp2");
var Company_default = /*#__PURE__*/__webpack_require__.n(Company);

// EXTERNAL MODULE: ./src/graphql/Balance/CompanyBalances.gql
var CompanyBalances = __webpack_require__("xCFp");
var CompanyBalances_default = /*#__PURE__*/__webpack_require__.n(CompanyBalances);

// EXTERNAL MODULE: ./src/graphql/Balance/AdminCompanyBalances.gql
var AdminCompanyBalances = __webpack_require__("GWS0");
var AdminCompanyBalances_default = /*#__PURE__*/__webpack_require__.n(AdminCompanyBalances);

// CONCATENATED MODULE: ./src/helpers/mixpanel.js
window.mixpanel.init('55563430541b356168bfd4f0bfb1a4ea', {
  protocol: 'https'
});

/* harmony default export */ var mixpanel = (window.mixpanel);
// CONCATENATED MODULE: ./src/store/actions.js













/* harmony default export */ var actions = ({
  login: function login(_ref, auth) {
    var dispatch = _ref.dispatch;

    dispatch('setAuth', auth);
    localStorage.setItem('auth', stringify_default()(auth));
    dispatch('prepForClient');
  },
  logout: function logout(_ref2) {
    var commit = _ref2.commit;

    commit('setAuth', null);
    localStorage.removeItem('auth');
    sessionStorage.removeItem('signupStep');
    sessionStorage.removeItem('landingUrl');
    sessionStorage.removeItem('newCampaignId');
  },
  checkAuth: function checkAuth(_ref3) {
    var dispatch = _ref3.dispatch;

    var auth = localStorage.getItem('auth');
    if (auth) {
      dispatch('setAuth', JSON.parse(auth));
    }
    dispatch('prepForClient');
  },
  checkWhiteLabel: function checkWhiteLabel(_ref4) {
    var commit = _ref4.commit;

    var hostname = window.location.hostname;
    commit('setWhiteLabel', !hostname.includes('nextlead'));
  },
  setAuth: function setAuth(_ref5, auth) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch,
        getters = _ref5.getters;

    commit('setAuth', auth);
    var getAuthUser = auth.user;
    if (getAuthUser && getAuthUser.role && getAuthUser.role.role_type === 'client') {
      mixpanel.identify(getAuthUser.companyId);
    }
    dispatch('trackEvent', { name: 'Signin' });
  },
  trackEvent: function trackEvent(_ref6, _ref7) {
    var getters = _ref6.getters;
    var name = _ref7.name,
        options = _ref7.options;

    var getAuthUser = getters.getAuthUser;
    if (getAuthUser && getAuthUser.role && getAuthUser.role.role_type === 'client') {
      mixpanel.track(name, options);
    }
  },


  // trackAffilate ({getters}, {affiliateId} ) {
  //   const getAuthUser = getters.getAuthUser;
  //   if (getAuthUser && getAuthUser.role && getAuthUser.role.role_type === 'client') {
  //     mixpanel.people.set({ affiliateId });
  //   }
  // },

  prepForClient: function prepForClient(_ref8) {
    var dispatch = _ref8.dispatch,
        getters = _ref8.getters;

    var getAuthUser = getters.getAuthUser;
    if (getAuthUser && getAuthUser.role && getAuthUser.role.role_type === 'client') {
      var companyId = +getAuthUser.companyId;
      dispatch('fetchCompany', companyId);
      dispatch('fetchCompanyBalances', companyId);

      // try {
      //   window.fcWidget.init({
      //     token: "e901e1f5-db22-478a-bd36-e3c7516c3e86",
      //     host: "https://wchat.freshchat.com"
      //   });
      //
      //   window.fcWidget.setExternalId(getAuthUser.id);
      //   window.fcWidget.user.setFirstName(getAuthUser.name);
      //   window.fcWidget.user.setEmail(getAuthUser.email);
      //   window.fcWidget.user.setPhone(getAuthUser.phone);
      // } catch (e) {
      //   // eslint-disable-next-line
      //   console.log(e);
      // }
    }
  },
  toggleMenu: function toggleMenu(_ref9) {
    var commit = _ref9.commit;

    commit('toggleMenu');
  },
  checkCurrentStep: function checkCurrentStep(_ref10) {
    var commit = _ref10.commit;

    var savedStep = sessionStorage.getItem('signupStep');
    if (savedStep) {
      commit('setLastSignupStep', +savedStep);
    }
    var landingURL = sessionStorage.getItem('landingURL');
    if (landingURL) {
      commit('setLandingUrl', landingURL);
    }
    var newCampaignId = sessionStorage.getItem('newCampaignId');
    if (newCampaignId) {
      commit('setNewCampaignId', newCampaignId);
    }
  },
  submitStep: function submitStep(_ref11, step) {
    var commit = _ref11.commit;

    var nextStep = step + 1;
    sessionStorage.setItem('signupStep', nextStep);
    commit('setLastSignupStep', nextStep);
  },
  saveLandingUrl: function saveLandingUrl(_ref12, landingURL) {
    var commit = _ref12.commit;

    sessionStorage.setItem('landingURL', landingURL);
    commit('setLandingUrl', landingURL);
  },
  saveNewCampaignId: function saveNewCampaignId(_ref13, campaignId) {
    var commit = _ref13.commit;

    sessionStorage.setItem('newCampaignId', campaignId);
    commit('setNewCampaignId', campaignId);
  },
  fetchCompany: function fetchCompany(_ref14, companyId) {
    var _this = this;

    var commit = _ref14.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _ref15, data, company;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return apolloClient.query({
                query: Company_default.a,
                variables: { id: companyId },
                fetchPolicy: 'network-only'
              });

            case 2:
              _ref15 = _context.sent;
              data = _ref15.data;
              company = {
                id: data.company.id,
                companyName: data.company.companyName,
                description: data.company.description,
                website: data.company.website,
                address: data.company.address,
                currency: data.company.currency,
                status: data.company.status,
                stripeCustomerId: data.company.stripeCustomerId,
                stripeSourceId: data.company.stripeSourceId,
                overdue: data.company.overdue
              };

              commit('setCompany', company);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  fetchCompanyBalances: function fetchCompanyBalances(_ref16, companyId) {
    var _this2 = this;

    var commit = _ref16.commit,
        getters = _ref16.getters;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var _ref17, data;

      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return apolloClient.query({
                query: getters.isUserAdmin ? AdminCompanyBalances_default.a : CompanyBalances_default.a,
                variables: { id: companyId },
                fetchPolicy: 'network-only'
              });

            case 2:
              _ref17 = _context2.sent;
              data = _ref17.data;

              commit('setCompanyBalances', data.balances);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  fetchCampaign: function fetchCampaign(_ref18, campaignId) {
    var _this3 = this;

    var commit = _ref18.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var _ref19, data, campaign;

      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return apolloClient.query({
                query: Campaign_default.a,
                variables: { id: parseInt(campaignId) },
                fetchPolicy: 'network-only'
              });

            case 2:
              _ref19 = _context3.sent;
              data = _ref19.data;
              campaign = {
                campaignName: data.campaign.campaignName,
                created: data.campaign.created,
                dispatchTo: data.campaign.dispatchTo,
                dispatchToPhone: data.campaign.dispatchToPhone,
                id: data.campaign.id,
                status: data.campaign.status,
                editable: data.campaign.editable,
                whiteLabel: data.campaign.whiteLabel,
                widget: JSON.parse(data.campaign.widget),
                company: data.campaign.company,
                type: data.campaign.type
              };

              commit('setCampaign', campaign);

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  deleteCampaign: function deleteCampaign(_ref20, campaignId) {
    var _this4 = this;

    var commit = _ref20.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return apolloClient.mutate({
                mutation: RemoveCampaign_default.a,
                variables: { id: campaignId }
              });

            case 2:
              commit('setCampaign', { widget: {} });

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  updateWidget: function updateWidget(_ref21) {
    var _this5 = this;

    var commit = _ref21.commit,
        getters = _ref21.getters;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      var campaign, newCampaign;
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              campaign = getters.campaign;
              _context5.next = 3;
              return apolloClient.mutate({
                mutation: UpdateWidget_default.a,
                variables: {
                  id: campaign.id,
                  input: campaign.widget
                }
              });

            case 3:
              newCampaign = extends_default()({}, campaign, {
                widget: campaign.widget
              });

              commit('setCampaign', newCampaign);

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});
// CONCATENATED MODULE: ./src/store/mutations.js
/* harmony default export */ var mutations = ({
  setAuth: function setAuth(state, auth) {
    state.auth = auth;
  },

  toggleMenu: function toggleMenu(state) {
    state.isMenuMinimized = !state.isMenuMinimized;
  },

  setLastSignupStep: function setLastSignupStep(state, step) {
    state.lastSignupStep = step;
  },

  setLandingUrl: function setLandingUrl(state, landingURL) {
    state.landingURL = landingURL;
  },

  setNewCampaignId: function setNewCampaignId(state, newCampaignId) {
    state.newCampaignId = newCampaignId;
  },

  setCompany: function setCompany(state, company) {
    state.company = company;
  },

  setCampaign: function setCampaign(state, campaign) {
    state.campaign = campaign;
  },

  setCompanyBalances: function setCompanyBalances(state, balances) {
    state.companyBalances = balances;
  },

  setWhiteLabel: function setWhiteLabel(state, isWhiteLabel) {
    state.isWhiteLabel = isWhiteLabel;
  }
});
// CONCATENATED MODULE: ./src/store/getters.js
/* harmony default export */ var store_getters = ({
  getAuth: function getAuth(state) {
    return state.auth;
  },
  getAuthUser: function getAuthUser(state) {
    return state.auth && state.auth.user;
  },
  getAuthToken: function getAuthToken(state) {
    return state.auth && state.auth.token;
  },
  getLastSignupStep: function getLastSignupStep(state) {
    return state.lastSignupStep;
  },
  getLandingUrl: function getLandingUrl(state) {
    return state.landingURL;
  },
  getNewCampaignId: function getNewCampaignId(state) {
    return state.newCampaignId;
  },
  getCompany: function getCompany(state) {
    return state.company;
  },
  campaign: function campaign(state) {
    return state.campaign;
  },
  getCompanyBalances: function getCompanyBalances(state) {
    return state.companyBalances;
  },
  isWhiteLabel: function isWhiteLabel(state) {
    return state.isWhiteLabel;
  },
  isUserClient: function isUserClient(state) {
    return state.auth && state.auth.user && state.auth.user.role && state.auth.user.role.role_type === 'client';
  },
  isUserAdmin: function isUserAdmin(state) {
    return state.auth && state.auth.user && state.auth.user.role && state.auth.user.role.role_type === 'administrator';
  }
});
// CONCATENATED MODULE: ./src/store/index.js






vue_esm["default"].use(vuex_esm["a" /* default */]);

var state = {
  auth: null,
  lastSignupStep: 1,
  landingURL: '',
  newCampaignId: null,
  isMenuMinimized: false,
  company: {
    id: 0,
    companyName: '',
    description: '',
    website: '',
    address: '',
    currency: '',
    status: true
  },
  campaign: {
    widget: {}
  },
  companyBalances: [],
  isWhiteLabel: false
};

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: state,
  getters: store_getters,
  actions: actions,
  mutations: mutations
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Navigation.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Navigation = ({
  name: 'navigation',

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['isMenuMinimized']), Object(vuex_esm["c" /* mapGetters */])(['getCompany', 'isUserClient', 'getCompanyBalances', 'isWhiteLabel']), {
    user: function user() {
      return this.$store.getters.getAuthUser;
    },
    photo: function photo() {
      if (this.user && this.user.photo) {
        return JSON.parse(this.user.photo);
      }
    },
    name: function name() {
      if (this.user) {
        return this.user.name;
      }
    },
    companyId: function companyId() {
      var _user = this.user,
          companyId = _user.companyId,
          roleType = _user.role.role_type;


      return companyId && roleType === 'client' ? companyId : undefined;
    },
    title: function title() {
      return this.isUserClient && this.getCompany.companyName ? this.getCompany.companyName : 'Admin Panel';
    },
    balances: function balances() {
      return this.getCompanyBalances;
    }
  }),

  methods: extends_default()({
    logout: function logout() {
      this.$store.dispatch('logout');
      this.$router.replace('/login');
    }
  }, Object(vuex_esm["b" /* mapActions */])(['toggleMenu']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75388b36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
var Navigation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"topbar"},[_c('nav',{staticClass:"navbar top-navbar navbar-expand-md navbar-light"},[_c('div',{staticClass:"navbar-header"},[(_vm.isWhiteLabel)?_c('a',{staticClass:"navbar-brand"},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"show-when-menu-expanded logo-text"},[_vm._v("Portal")])]):_c('a',{staticClass:"navbar-brand"},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"show-when-menu-expanded logo-text"},[_vm._v("Lead")])])]),_vm._v(" "),_c('div',{staticClass:"navbar-collapse"},[_c('ul',{staticClass:"navbar-nav mt-md-0 "},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link nav-toggler hidden-md-up text-muted waves-effect waves-dark",on:{"click":function($event){$event.preventDefault();return _vm.toggleMenu()}}},[_c('i',{staticClass:"mdi",class:[_vm.isMenuMinimized ? 'mdi-menu' : 'mdi-arrow-left']})])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark",on:{"click":function($event){$event.preventDefault();return _vm.toggleMenu()}}},[_c('i',{staticClass:"icon-arrow-left-circle mdi",class:[_vm.isMenuMinimized ? 'mdi-menu' : 'mdi-arrow-left']})])])]),_vm._v(" "),_c('span',{staticClass:"navbar-brand mb-0 h2 mr-auto text-muted"},[_c('span',{staticClass:"pr-3"},[_vm._v(_vm._s(_vm.title)+" ")]),_vm._v(" "),(_vm.isUserClient && _vm.getCompany.overdue)?_c('span',{staticClass:"label label-rounded label-danger"},[_vm._v("Overdue")]):_vm._e()]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav my-lg-0"},[_c('b-nav-item-dropdown',{attrs:{"right":""}},[_c('template',{slot:"button-content"},[_c('img',{staticClass:"profile-pic",attrs:{"src":__webpack_require__("4+62"),"alt":"user"}}),_vm._v(" "),_c('span',{staticClass:"text-muted waves-effect waves-dark"},[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_c('b-dropdown-header',[_c('h4',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.user.email))])]),_vm._v(" "),(_vm.companyId && !_vm.isWhiteLabel)?_c('b-dropdown-divider'):_vm._e(),_vm._v(" "),(_vm.companyId && !_vm.isWhiteLabel)?_c('b-dropdown-item',{attrs:{"to":{ name: 'EditCompany', params: { id: _vm.companyId }, query: { tab: 'detail' }}}},[_c('i',{staticClass:"mdi mdi-city"}),_vm._v("  Company Settings")]):_vm._e(),_vm._v(" "),(_vm.companyId && !_vm.isWhiteLabel)?_c('b-dropdown-item',{attrs:{"to":{ name: 'EditCompany', params: { id: _vm.companyId }, query: { tab: 'billing' }}}},[_c('i',{staticClass:"mdi mdi-credit-card"}),_vm._v("  Billing & Payments")]):_vm._e(),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_c('i',{staticClass:"mdi mdi-power"}),_vm._v("  Logout")])],2)],1)])])])}
var Navigation_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_c('span',{staticClass:"show-when-menu-collapsed logo-collapsed"},[_vm._v("CP")]),_vm._v(" "),_c('span',{staticClass:"show-when-menu-expanded logo-expanded"},[_vm._v("Client")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_c('span',{staticClass:"show-when-menu-collapsed logo-collapsed"},[_vm._v("NL")]),_vm._v(" "),_c('span',{staticClass:"show-when-menu-expanded logo-expanded"},[_vm._v("Next")])])}]
var Navigation_esExports = { render: Navigation_render, staticRenderFns: Navigation_staticRenderFns }
/* harmony default export */ var components_Navigation = (Navigation_esExports);
// CONCATENATED MODULE: ./src/components/Navigation.vue
function Navigation_injectStyle (ssrContext) {
  __webpack_require__("vaFs")
}
var Navigation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Navigation___vue_template_functional__ = false
/* styles */
var Navigation___vue_styles__ = Navigation_injectStyle
/* scopeId */
var Navigation___vue_scopeId__ = "data-v-75388b36"
/* moduleIdentifier (server only) */
var Navigation___vue_module_identifier__ = null
var Navigation_Component = Navigation_normalizeComponent(
  Navigation,
  components_Navigation,
  Navigation___vue_template_functional__,
  Navigation___vue_styles__,
  Navigation___vue_scopeId__,
  Navigation___vue_module_identifier__
)

/* harmony default export */ var src_components_Navigation = (Navigation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RightSidebar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var RightSidebar = ({
  name: 'right-sidebar'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8d617f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RightSidebar.vue
var RightSidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var RightSidebar_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-sidebar"},[_c('div',{staticClass:"slimscrollright"},[_c('div',{staticClass:"rpanel-title"},[_vm._v(" Chat "),_c('span',[_c('i',{staticClass:"ti-close right-side-toggle"})])]),_vm._v(" "),_c('div',{staticClass:"r-panel-body"})])])}]
var RightSidebar_esExports = { render: RightSidebar_render, staticRenderFns: RightSidebar_staticRenderFns }
/* harmony default export */ var components_RightSidebar = (RightSidebar_esExports);
// CONCATENATED MODULE: ./src/components/RightSidebar.vue
function RightSidebar_injectStyle (ssrContext) {
  __webpack_require__("xTCs")
}
var RightSidebar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RightSidebar___vue_template_functional__ = false
/* styles */
var RightSidebar___vue_styles__ = RightSidebar_injectStyle
/* scopeId */
var RightSidebar___vue_scopeId__ = "data-v-c8d617f0"
/* moduleIdentifier (server only) */
var RightSidebar___vue_module_identifier__ = null
var RightSidebar_Component = RightSidebar_normalizeComponent(
  RightSidebar,
  components_RightSidebar,
  RightSidebar___vue_template_functional__,
  RightSidebar___vue_styles__,
  RightSidebar___vue_scopeId__,
  RightSidebar___vue_module_identifier__
)

/* harmony default export */ var src_components_RightSidebar = (RightSidebar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mainMenuList = [{
  name: 'Leads',
  to: '/leads',
  icon: 'mdi-account-multiple',
  granted: 'leads.find',
  showForWhiteLabel: true
}, {
  name: 'Lead Search',
  to: '/search/lead',
  icon: 'mdi-account-search',
  granted: 'leads.search',
  showForWhiteLabel: true
},
// {
//   name: 'Tickets',
//   to: '/tickets',
//   icon: 'mdi-ticket-account',
//   granted: 'tickets.find',
//   showForWhiteLabel: true,
// },
{
  name: 'Users',
  to: '/users',
  icon: 'mdi-account-multiple',
  granted: 'users.find',
  showForWhiteLabel: true
}, {
  name: 'Campaigns',
  to: '/campaigns',
  icon: 'mdi-group',
  granted: 'campaigns.find',
  showForWhiteLabel: false
}, {
  name: 'Companies',
  to: '/companies',
  icon: 'mdi-briefcase',
  granted: 'companies.find',
  showForWhiteLabel: false
}, {
  name: 'Reports',
  icon: 'mdi-folder-account',
  granted: 'reports.find',
  showForWhiteLabel: false,
  to: '',
  child: [{
    name: 'Agents',
    to: '/reports/agents',
    granted: 'reports.find',
    icon: 'mdi-chevron-right'
  }]
}];

var guidesMenuList = [{
  name: 'Guides',
  icon: 'mdi-lightbulb-outline',
  to: '',
  child: [{
    name: 'FAQs',
    to: { path: '/guides/6mIlYrimmIokCNGWyWZwxt' },
    icon: 'mdi-help'
  }, {
    name: 'How-Tos',
    to: { path: '/guides/1DR0caf6Is8Q6CeIKKKKAy' },
    icon: 'mdi-book-multiple'
  }, {
    name: 'Screens',
    to: { path: '/guides/4xsyJcaBK0gUgKsoci0qm2' },
    icon: 'mdi-image-filter'
  }]
}];

/* harmony default export */ var Sidebar = ({
  name: 'sidebar',
  data: function data() {
    return {
      menus: mainMenuList,
      guides: guidesMenuList
    };
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthUser', 'getCompanyBalances', 'isUserClient', 'getCompany', 'isWhiteLabel']), {
    isReportsPage: function isReportsPage() {
      return (/reports/gi.test(this.$route.path)
      );
    },
    isGuidesPage: function isGuidesPage() {
      return (/guides/gi.test(this.$route.path)
      );
    },
    user: function user() {
      return this.getAuthUser;
    },
    balances: function balances() {
      return this.getCompanyBalances;
    },
    isNoPayment: function isNoPayment() {
      return !(this.getCompany && this.getCompany.stripeSourceId);
    },
    grantedMenu: function grantedMenu() {
      var _this = this;

      var menu = this.menus.filter(function (menuItem) {
        return _this.$router.canSee([menuItem.granted]);
      });
      var _user = this.user,
          companyId = _user.companyId,
          roleType = _user.role.role_type;


      if (companyId && roleType === 'client') {
        menu.push({
          name: 'Company',
          to: '/companies/edit/' + this.user.companyId,
          icon: 'mdi-city',
          granted: 'companies.update'
        });
      }
      return menu;
    },
    name: function name() {
      if (this.user) {
        return this.user.name;
      }
    },
    photo: function photo() {
      if (this.user && this.user.photo) {
        return JSON.parse(this.user.photo);
      }
    }
  }),

  methods: {
    logout: function logout() {
      this.$store.dispatch('logout');
      this.$router.replace('/login');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93f770dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
var Sidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"left-sidebar"},[_c('div',{staticClass:"scroll-sidebar"},[(_vm.isUserClient && !_vm.isWhiteLabel)?_c('div',{staticClass:"user-profile px-3 hide-on-mini"},[_c('div',{staticClass:"card bg-light-extra mb-1"},[_c('div',{staticClass:"card-body py-3 px-2"},[_c('div',{staticClass:"text-center"},[_vm._l((_vm.balances),function(balance,index){return _c('span',{key:index},[_c('span',{staticClass:"font-20",class:{ 'text-danger': balance.balance < 0 }},[_vm._v(_vm._s(_vm._f("currency")(balance.balance)))]),_vm._v(" "),(_vm.balances.length > index+1)?_c('span',[_vm._v(", ")]):_vm._e()])}),_vm._v(" "),_c('h6',{staticClass:"mt-2 text-muted"},[_vm._v("account balance")])],2)])]),_vm._v(" "),(_vm.isNoPayment)?_c('router-link',{staticClass:"btn waves-effect waves-light btn-block btn-danger mt-3",attrs:{"tag":"button","to":{ name: 'NewCard' }}},[_vm._v("\n        Add Payment Card\n      ")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('ul',{attrs:{"id":"sidebarnav"}},[(_vm.isUserClient && !_vm.isWhiteLabel)?_c('li',{staticClass:"nav-devider hide-on-mini"}):_vm._e(),_vm._v(" "),_vm._l((_vm.grantedMenu),function(menu){return _c('li',{key:menu.name},[(menu.child)?_c('div',{staticClass:"nav-collapse"},[_c('div',{staticClass:"holder"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.reports",modifiers:{"reports":true}}]},[_c('i',{staticClass:"mdi",class:menu.icon}),_vm._v(" "),_c('span',{staticClass:"hide-menu"},[_vm._v(_vm._s(menu.name))])])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"reports","visible":_vm.isReportsPage}},_vm._l((menu.child),function(child){return _c('router-link',{key:child.name,staticClass:"sub-link",attrs:{"to":child.to}},[_c('i',{staticClass:"mdi",class:child.icon}),_vm._v(" "),_c('span',{staticClass:"hide-menu"},[_vm._v(_vm._s(child.name))])])}),1)],1):(!_vm.isUserClient)?_c('router-link',{attrs:{"to":menu.to}},[_c('i',{staticClass:"mdi",class:menu.icon}),_vm._v(" "),_c('span',{staticClass:"hide-menu"},[_vm._v(_vm._s(menu.name))])]):(_vm.isUserClient && !_vm.isWhiteLabel)?_c('router-link',{attrs:{"to":menu.to}},[_c('i',{staticClass:"mdi",class:menu.icon}),_vm._v(" "),_c('span',{staticClass:"hide-menu"},[_vm._v(_vm._s(menu.name))])]):(_vm.isUserClient && _vm.isWhiteLabel && menu.showForWhiteLabel)?_c('router-link',{attrs:{"to":menu.to}},[_c('i',{staticClass:"mdi",class:menu.icon}),_vm._v(" "),_c('span',{staticClass:"hide-menu"},[_vm._v(_vm._s(menu.name))])]):_vm._e()],1)}),_vm._v(" "),_c('li',{staticClass:"nav-devider"}),_vm._v(" "),_vm._l((_vm.guides),function(menu){return (!_vm.isWhiteLabel)?_c('li',{key:menu.name},[(menu.child)?_c('div',{staticClass:"nav-collapse"},[_c('div',{staticClass:"holder"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.guides",modifiers:{"guides":true}}]},[_c('i',{staticClass:"mdi",class:menu.icon}),_vm._v(" "),_c('span',{staticClass:"hide-menu"},[_vm._v(_vm._s(menu.name))])])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"guides","visible":_vm.isGuidesPage}},_vm._l((menu.child),function(child){return _c('router-link',{key:child.name,staticClass:"sub-link",attrs:{"to":child.to}},[_c('i',{staticClass:"mdi",class:child.icon}),_vm._v(" "),_c('span',{staticClass:"hide-menu"},[_vm._v(_vm._s(child.name))])])}),1)],1):_c('router-link',{attrs:{"to":menu.to}},[_c('i',{staticClass:"mdi",class:menu.icon}),_vm._v(" "),_c('span',{staticClass:"hide-menu"},[_vm._v(_vm._s(menu.name))])])],1):_vm._e()})],2)])]),_vm._v(" "),_c('div',{staticClass:"sidebar-footer"},[_c('a',{staticClass:"link",attrs:{"href":"","data-toggle":"tooltip","title":"Logout"},on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_c('i',{staticClass:"mdi mdi-power"})])])])}
var Sidebar_staticRenderFns = []
var Sidebar_esExports = { render: Sidebar_render, staticRenderFns: Sidebar_staticRenderFns }
/* harmony default export */ var components_Sidebar = (Sidebar_esExports);
// CONCATENATED MODULE: ./src/components/Sidebar.vue
function Sidebar_injectStyle (ssrContext) {
  __webpack_require__("ftLw")
}
var Sidebar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Sidebar___vue_template_functional__ = false
/* styles */
var Sidebar___vue_styles__ = Sidebar_injectStyle
/* scopeId */
var Sidebar___vue_scopeId__ = "data-v-93f770dc"
/* moduleIdentifier (server only) */
var Sidebar___vue_module_identifier__ = null
var Sidebar_Component = Sidebar_normalizeComponent(
  Sidebar,
  components_Sidebar,
  Sidebar___vue_template_functional__,
  Sidebar___vue_styles__,
  Sidebar___vue_scopeId__,
  Sidebar___vue_module_identifier__
)

/* harmony default export */ var src_components_Sidebar = (Sidebar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Dashboard.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Dashboard = ({
  components: {
    Breadcrumb: src_components_Breadcrumb,
    Navigation: src_components_Navigation,
    RightSidebar: src_components_RightSidebar,
    Sidebar: src_components_Sidebar
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['isMenuMinimized', 'isWhiteLabel']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d15a996a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
var Dashboard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'mini-sidebar': _vm.isMenuMinimized},attrs:{"id":"main-wrapper"}},[_c('navigation'),_vm._v(" "),_c('sidebar'),_vm._v(" "),_c('div',{staticClass:"page-wrapper"},[_c('notifications',{attrs:{"group":"error","position":"bottom right"}}),_vm._v(" "),_c('notifications',{attrs:{"group":"success","position":"bottom right"}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('router-view',{attrs:{"name":"modal"}}),_vm._v(" "),_c('right-sidebar'),_vm._v(" "),_c('footer',{staticClass:"footer"},[_vm._v("\n        © 2019 "),(_vm.isWhiteLabel)?_c('span',[_vm._v("Client Portal")]):_c('span',[_vm._v("Nextlead Portal")])])],1)],1)}
var Dashboard_staticRenderFns = []
var Dashboard_esExports = { render: Dashboard_render, staticRenderFns: Dashboard_staticRenderFns }
/* harmony default export */ var components_Dashboard = (Dashboard_esExports);
// CONCATENATED MODULE: ./src/components/Dashboard.vue
function Dashboard_injectStyle (ssrContext) {
  __webpack_require__("NUn7")
}
var Dashboard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Dashboard___vue_template_functional__ = false
/* styles */
var Dashboard___vue_styles__ = Dashboard_injectStyle
/* scopeId */
var Dashboard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Dashboard___vue_module_identifier__ = null
var Dashboard_Component = Dashboard_normalizeComponent(
  Dashboard,
  components_Dashboard,
  Dashboard___vue_template_functional__,
  Dashboard___vue_styles__,
  Dashboard___vue_scopeId__,
  Dashboard___vue_module_identifier__
)

/* harmony default export */ var src_components_Dashboard = (Dashboard_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Mobile.vue
//
//
//
//

/* harmony default export */ var Mobile = ({
  name: 'mobile'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3064cbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile.vue
var Mobile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var Mobile_staticRenderFns = []
var Mobile_esExports = { render: Mobile_render, staticRenderFns: Mobile_staticRenderFns }
/* harmony default export */ var components_Mobile = (Mobile_esExports);
// CONCATENATED MODULE: ./src/components/Mobile.vue
var Mobile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Mobile___vue_template_functional__ = false
/* styles */
var Mobile___vue_styles__ = null
/* scopeId */
var Mobile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Mobile___vue_module_identifier__ = null
var Mobile_Component = Mobile_normalizeComponent(
  Mobile,
  components_Mobile,
  Mobile___vue_template_functional__,
  Mobile___vue_styles__,
  Mobile___vue_scopeId__,
  Mobile___vue_module_identifier__
)

/* harmony default export */ var src_components_Mobile = (Mobile_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.umd.js
var vuedraggable_umd = __webpack_require__("w/TU");
var vuedraggable_umd_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_umd);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pagination.vue

/* harmony default export */ var Pagination = ({
  name: 'pagination',
  props: {
    page: Number,
    perPage: Number,
    recordsTotal: Number
  },
  computed: {
    pagination: function pagination() {
      var current = this.page + 1;
      var last = Math.ceil(this.recordsTotal / this.perPage);
      var delta = Math.max(5 - current, 4 - last + current, 1);
      var left = current - delta;
      var right = current + delta + 1;
      var range = [];

      var prev = 1;
      for (var i = 1; i <= last; i += 1) {
        if (i === 1 || i === last || i >= left && i < right) {
          if (i - prev > 1) {
            range.push('…');
          }
          range.push(i);
          prev = i;
        }
      }

      return range;
    }
  },
  methods: {
    changePage: function changePage(page, _ref) {
      var parentElement = _ref.parentElement;

      if (parentElement.classList.contains('disabled') || page === this.page) {
        return;
      }

      this.$emit('page', page);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1d5af3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
var Pagination_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item",class:{ disabled: _vm.page === 0 }},[_c('a',{staticClass:"page-link",attrs:{"href":"#","tabindex":"0"},on:{"click":function($event){$event.preventDefault();return _vm.changePage(_vm.page - 1, $event.target)}}},[_vm._v("Previous")])]),_vm._v(" "),_vm._l((_vm.pagination),function(p,index){return _c('li',{key:index,staticClass:"page-item",class:{
      disabled: p === '…',
      active: p - 1 === _vm.page,
    }},[_c('a',{staticClass:"page-link",attrs:{"href":"#","tabindex":"0"},on:{"click":function($event){$event.preventDefault();return _vm.changePage(p - 1, $event.target)}}},[_vm._v(_vm._s(p))])])}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ disabled: _vm.page === Math.ceil(this.recordsTotal / this.perPage) - 1 }},[_c('a',{staticClass:"page-link",attrs:{"href":"#","tabindex":"0"},on:{"click":function($event){$event.preventDefault();return _vm.changePage(_vm.page + 1, $event.target)}}},[_vm._v("Next")])])],2)}
var Pagination_staticRenderFns = []
var Pagination_esExports = { render: Pagination_render, staticRenderFns: Pagination_staticRenderFns }
/* harmony default export */ var components_Pagination = (Pagination_esExports);
// CONCATENATED MODULE: ./src/components/Pagination.vue
function Pagination_injectStyle (ssrContext) {
  __webpack_require__("PgCQ")
}
var Pagination_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Pagination___vue_template_functional__ = false
/* styles */
var Pagination___vue_styles__ = Pagination_injectStyle
/* scopeId */
var Pagination___vue_scopeId__ = "data-v-d1d5af3e"
/* moduleIdentifier (server only) */
var Pagination___vue_module_identifier__ = null
var Pagination_Component = Pagination_normalizeComponent(
  Pagination,
  components_Pagination,
  Pagination___vue_template_functional__,
  Pagination___vue_styles__,
  Pagination___vue_scopeId__,
  Pagination___vue_module_identifier__
)

/* harmony default export */ var src_components_Pagination = (Pagination_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/symbol.js
var symbol = __webpack_require__("5QVw");
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);

// CONCATENATED MODULE: ./src/mixins/AsyncInput.js




var TIMER_ID = symbol_default()('@@TIMER_ID');
var HIDDEN_VALUE = symbol_default()('@@HIDDEN_VALUE');

/* harmony default export */ var AsyncInput = (function (emmiterName) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
  return {
    data: function data() {
      var _ref;

      return _ref = {}, defineProperty_default()(_ref, TIMER_ID, null), defineProperty_default()(_ref, HIDDEN_VALUE, null), _ref;
    },

    computed: {
      actualValue: function actualValue() {
        return this[HIDDEN_VALUE] || this.value;
      }
    },
    methods: {
      onAsyncInputChange: function onAsyncInputChange(event) {
        var _this = this;

        clearTimeout(this[TIMER_ID]);
        vue_esm["default"].set(this, HIDDEN_VALUE, event.target.value);
        this[TIMER_ID] = setTimeout(function () {
          return _this[emmiterName](event);
        }, duration);
      }
    }
  };
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Grid.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Grid = ({
  components: { Pagination: src_components_Pagination, Draggable: vuedraggable_umd_default.a },
  mixins: [AsyncInput('changeSearch')],
  props: {
    placeholder: String,
    columns: Array,
    hideSearch: Boolean,
    value: Array,
    limit: Number,
    page: Number,
    meta: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    orderable: {
      type: Boolean,
      default: false
    },
    search: String
  },
  data: function data() {
    return {
      showOptions: [10, 25, 50, 100],
      sortBy: this.orderable ? 'order' : 'created',
      descending: !this.orderable
    };
  },

  methods: {
    get: lodash["get"],
    changeSearch: function changeSearch(event) {
      this.$emit('change', event.target.value);
    },
    changePage: function changePage(page) {
      this.$emit('page', page);
    },
    changeLimit: function changeLimit(limit) {
      this.$emit('limit', limit);
    },
    onOrderChanged: function onOrderChanged(event) {
      this.$emit('ordered', event);
    },
    changeSort: function changeSort(column) {
      this.$emit('sort', column);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08e47980","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid.vue
var Grid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col flex-grow-0"},[_c('div',{staticClass:"items-per-page"},[_c('label',{staticClass:"per-page"},[_c('select',{staticClass:"form-control input-sm",on:{"change":_vm.changeLimit}},_vm._l((_vm.showOptions),function(option){return _c('option',{key:option,domProps:{"value":option,"selected":option == _vm.limit}},[_vm._v("\n              Show "+_vm._s(option)+"\n            ")])}),0)])])]),_vm._v(" "),(!_vm.hideSearch)?_c('div',{staticClass:"col text-right"},[_c('div',{staticClass:"form-group form-inline"},[_vm._t("filter",[_vm._t("additional-filter"),_vm._v(" "),_c('input',{staticClass:"search-input form-control pull-right",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.search},on:{"input":_vm.onAsyncInputChange}})])],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"table-responsive"},[(_vm.value && _vm.value.length)?_c('table',{staticClass:"table table-striped table-hover table-bordered"},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(column){return _c('th',{key:column.field,staticClass:"sorting",class:{
                sorting_desc: _vm.descending && column.field === _vm.sortBy,
                sorting_asc: !_vm.descending && column.field === _vm.sortBy,
              },on:{"click":function($event){return _vm.changeSort(column)}}},[_vm._v("\n              "+_vm._s(column.title)+"\n            ")])}),0)]),_vm._v(" "),(_vm.orderable)?_c('draggable',{staticClass:"sortable",attrs:{"list":_vm.value,"element":'tbody'},on:{"change":function($event){return _vm.onOrderChanged($event)}}},_vm._l((_vm.value),function(row){return _c('tr',{key:row.id},_vm._l((_vm.columns),function(column){return _c('td',{key:column.field},[_vm._t(column.field,[_vm._v("\n                    "+_vm._s(_vm.get(row, column.field, null))+"\n                  ")],{"row":row})],2)}),0)}),0):_vm._l((_vm.value),function(row){return _c('tr',{key:row.id},_vm._l((_vm.columns),function(column){return _c('td',{key:column.field},[_vm._t(column.field,[_vm._v("\n                  "+_vm._s(_vm.get(row, column.field))+"\n                ")],{"row":row})],2)}),0)})],2):_vm._e(),_vm._v(" "),(!_vm.value || !_vm.value.length)?_c('div',{staticClass:"text-center no-data-label"},[_c('i',[_vm._v("Nothing to show")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-3"},[_c('pagination',{staticClass:"float-right",attrs:{"page":_vm.page,"perPage":_vm.limit,"recordsTotal":_vm.meta.count},on:{"page":_vm.changePage}})],1)])])}
var Grid_staticRenderFns = []
var Grid_esExports = { render: Grid_render, staticRenderFns: Grid_staticRenderFns }
/* harmony default export */ var components_Grid = (Grid_esExports);
// CONCATENATED MODULE: ./src/components/Grid.vue
function Grid_injectStyle (ssrContext) {
  __webpack_require__("eesH")
}
var Grid_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Grid___vue_template_functional__ = false
/* styles */
var Grid___vue_styles__ = Grid_injectStyle
/* scopeId */
var Grid___vue_scopeId__ = "data-v-08e47980"
/* moduleIdentifier (server only) */
var Grid___vue_module_identifier__ = null
var Grid_Component = Grid_normalizeComponent(
  Grid,
  components_Grid,
  Grid___vue_template_functional__,
  Grid___vue_styles__,
  Grid___vue_scopeId__,
  Grid___vue_module_identifier__
)

/* harmony default export */ var src_components_Grid = (Grid_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Spinner.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var Spinner = ({
  name: 'spinner',
  props: {
    fullScreen: { type: Boolean, default: false }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f398e41c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner.vue
var Spinner_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",class:{'fullScreen': _vm.fullScreen}},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke-width":"2","stroke-miterlimit":"10"}})])])}
var Spinner_staticRenderFns = []
var Spinner_esExports = { render: Spinner_render, staticRenderFns: Spinner_staticRenderFns }
/* harmony default export */ var components_Spinner = (Spinner_esExports);
// CONCATENATED MODULE: ./src/components/Spinner.vue
function Spinner_injectStyle (ssrContext) {
  __webpack_require__("N6Zi")
}
var Spinner_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Spinner___vue_template_functional__ = false
/* styles */
var Spinner___vue_styles__ = Spinner_injectStyle
/* scopeId */
var Spinner___vue_scopeId__ = "data-v-f398e41c"
/* moduleIdentifier (server only) */
var Spinner___vue_module_identifier__ = null
var Spinner_Component = Spinner_normalizeComponent(
  Spinner,
  components_Spinner,
  Spinner___vue_template_functional__,
  Spinner___vue_styles__,
  Spinner___vue_scopeId__,
  Spinner___vue_module_identifier__
)

/* harmony default export */ var src_components_Spinner = (Spinner_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DataTable.vue







/* harmony default export */ var DataTable = ({
  name: 'data-table',
  components: {
    Grid: src_components_Grid,
    Spinner: src_components_Spinner
  },
  props: {
    columns: Array,
    fieldName: String,
    query: Object,
    placeholder: String,
    hideSearch: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    variables: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    onClickHandler: {
      type: Function,
      default: function _default() {}
    },
    rowClickable: {
      type: Boolean,
      default: false
    },
    orderable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    paramsJSON: function paramsJSON() {
      return stringify_default()(this.params);
    }
  },
  data: function data() {
    return {
      limit: 25,
      page: 0,
      searchResult: '',
      showSpinner: 0,
      data: null,
      items: []
    };
  },
  render: function render(element) {
    var _this = this;

    var children = keys_default()(this.$slots).map(function (slot) {
      return element('template', { slot: slot }, _this.$slots[slot]);
    });
    return this.showSpinner ? element('div', { class: 'spinner-wrap' }, [element('spinner')]) : element('grid', {
      props: extends_default()({}, this.$props, {
        meta: this.data.meta,
        value: this.items,
        page: this.page,
        limit: this.limit,
        search: this.searchResult
      }),
      scopedSlots: this.$scopedSlots,
      attrs: this.$attrs,
      on: {
        page: this.changePage,
        ordered: this.onOrderChanged,
        limit: this.changeLimit,
        sort: this.changeSort,
        change: this.changeSearch
      }
    }, children);
  },

  apollo: {
    data: {
      query: function query() {
        return this.query;
      },

      fetchPolicy: 'network-only',
      update: function update(data) {
        return data[this.fieldName];
      },
      result: function result(_ref) {
        var data = _ref.data,
            loading = _ref.loading;

        if (!loading) {
          this.items = data[this.fieldName].result;
        }
      },

      loadingKey: 'showSpinner',
      variables: function variables() {
        return extends_default()({}, this.variables, {
          limit: parseInt(this.limit),
          page: parseInt(this.page),
          name: this.searchResult,
          where: this.paramsJSON,
          descending: this.descending,
          sortBy: this.sortBy
        });
      }
    }
  },
  methods: {
    changeSearch: function changeSearch(searchResult) {
      this.searchResult = searchResult;
    },
    changeLimit: function changeLimit(event) {
      this.limit = +event.target.value;
    },
    changePage: function changePage(page) {
      this.page = page;
    },
    setFirstPage: function setFirstPage() {
      this.page = 0;
    },
    changeSort: function changeSort(column) {
      if (column.skipSorting) {
        return;
      }
      this.descending = !this.descending;
      this.sortBy = column.field;
      this.setFirstPage();
    },
    onOrderChanged: function onOrderChanged() {
      var affectedItems = [];
      for (var i in this.items) {
        var item = this.items[i];
        var newOrder = +i + 1;
        if (item.order !== newOrder) {
          this.items[i] = extends_default()({}, item, {
            order: newOrder
          });
          affectedItems.push(this.items[i]);
        }
      }
      this.$emit('ordered', affectedItems);
    },
    onRefreshData: function onRefreshData() {
      /* eslint-disable dot-notation */
      this.$apollo.queries['data'].refresh();
    }
  }
});
// CONCATENATED MODULE: ./src/components/DataTable.vue
function DataTable_injectStyle (ssrContext) {
  __webpack_require__("AJN+")
}
var DataTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var DataTable___vue_template_functional__ = false
/* styles */
var DataTable___vue_styles__ = DataTable_injectStyle
/* scopeId */
var DataTable___vue_scopeId__ = "data-v-14d02cd2"
/* moduleIdentifier (server only) */
var DataTable___vue_module_identifier__ = null
var DataTable_Component = DataTable_normalizeComponent(
  DataTable,
  __vue_template__,
  DataTable___vue_template_functional__,
  DataTable___vue_styles__,
  DataTable___vue_scopeId__,
  DataTable___vue_module_identifier__
)

/* harmony default export */ var components_DataTable = (DataTable_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/is-nan.js
var is_nan = __webpack_require__("MICi");
var is_nan_default = /*#__PURE__*/__webpack_require__.n(is_nan);

// EXTERNAL MODULE: ./node_modules/lodash/fp/compose.js
var compose = __webpack_require__("T0ro");
var compose_default = /*#__PURE__*/__webpack_require__.n(compose);

// EXTERNAL MODULE: ./node_modules/lodash/reduce.js
var lodash_reduce = __webpack_require__("M+Z9");
var reduce_default = /*#__PURE__*/__webpack_require__.n(lodash_reduce);

// EXTERNAL MODULE: ./node_modules/lodash/concat.js
var lodash_concat = __webpack_require__("NxPG");
var concat_default = /*#__PURE__*/__webpack_require__.n(lodash_concat);

// CONCATENATED MODULE: ./src/helpers/stdlib.js







var stdlib_betterConcat = function betterConcat(iterable) {
  for (var _len = arguments.length, elements = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    elements[_key - 1] = arguments[_key];
  }

  return concat_default()(iterable, elements);
};

var stdlib_abstract = {
  transduce: function transduce(reduce, concat, transducer, iterable, initial) {
    return reduce(transducer(concat), iterable, initial);
  },

  reduce: function reduce(processor) {
    return function () {
      return processor;
    };
  },

  filter: function filter(predicate) {
    return function (concat) {
      return function (iterable, element) {
        return predicate(element) ? concat(iterable, element) : iterable;
      };
    };
  },

  map: function map(mapper) {
    return function (concat) {
      return function (iterable, element) {
        return concat(iterable, mapper(element));
      };
    };
  },

  withElementAt: function withElementAt(newElementIndex, newElement) {
    return function (concat) {
      return function (iterable, element, currentIndex) {
        return currentIndex === newElementIndex ? concat(iterable, newElement, element) : concat(iterable, element);
      };
    };
  }
};

var stdlib_implment = function implment(reduce, concat, defaultInitial) {
  return extends_default()({}, stdlib_abstract, {
    compute: function compute() {
      for (var _len2 = arguments.length, transducers = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        transducers[_key2] = arguments[_key2];
      }

      return function (iterable) {
        var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultInitial;
        return stdlib_abstract.transduce(reduce, concat, compose_default.a.apply(undefined, transducers), iterable, initial);
      };
    }
  });
};

var array = stdlib_implment(reduce_default.a, stdlib_betterConcat, []);

var stdlib_option = function option(key, param) {
  return is_nan_default()(param) || param === undefined ? {} : defineProperty_default()({}, key, param);
};

var optionIf = function optionIf(predicate, key, param) {
  return predicate ? stdlib_option(key, param) : {};
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LeadGrid.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var DEFAULT_COLUMNS = [{ field: 'completed', title: '' }, { field: 'id', title: 'Lead ID' }, { field: 'created', title: 'Created At' }, { field: 'campaignName', title: 'Campaign' }, { field: 'data.stats.numberOfQuestionsAnswered', title: 'A#', skipSorting: true }, { field: 'names', title: 'Name' }, { field: 'phones', title: 'Phone' }, { field: 'emails', title: 'Email' },
// { field: 'data.stats.numberOfQuestions', title: '#TQs' },
// { field: 'data.stats.numberOfMandatoryQuestions', title: '#MQs' },
{ field: 'notes', title: 'Notes', skipSorting: true }];

/* harmony default export */ var LeadGrid = ({
  components: {
    DataTable: components_DataTable
  },
  props: {
    role: {
      type: String,
      validator: function validator(str) {
        return ['administrator', 'client'].includes(str);
      },
      required: true
    },
    query: Object,
    onClickLead: Function,
    filters: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isWhiteLabel']), {
    columns: function columns() {
      if (this.role === 'admin') {
        return array.compute(array.withElementAt(2, { field: 'companyName', title: 'Company' }))(DEFAULT_COLUMNS);
      }
      return DEFAULT_COLUMNS;
    }
  }),
  isClient: function isClient() {
    return this.role === 'client';
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c707664","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeadGrid.vue
var LeadGrid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"columns":_vm.columns,"fieldName":"leads","variables":_vm.filters,"query":_vm.query,"onClickHandler":_vm.onClickLead,"rowClickable":!!_vm.$router.canSee(['leads.find'])},scopedSlots:_vm._u([{key:"id",fn:function(props){return _c('span',{},[_c('router-link',{attrs:{"to":{ name: 'LeadDetails', params: { id: props.row.id } }},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v("\n      "+_vm._s(props.row.id)+"\n    ")])],1)}},{key:"campaignName",fn:function(props){return _c('span',{},[(_vm.isWhiteLabel)?_c('span',[_vm._v(_vm._s(props.row.campaignName))]):_c('router-link',{attrs:{"to":{ name: 'CampaignDetails', params: { id: props.row.campaignId } }}},[_vm._v("\n      "+_vm._s(props.row.campaignName)+"\n    ")])],1)}},{key:"created",fn:function(props){return _c('span',{},[_vm._v("\n    "+_vm._s(_vm._f("moment")(props.row.created,"MMM Do YYYY, h:mm:ss a"))+"\n  ")])}},{key:"completed",fn:function(props){return _c('span',{},[(props.row.completed)?_c('i',{staticClass:"mdi mdi-check text-success"}):_vm._e()])}},{key:"names",fn:function(props){return (props.row.names)?_c('span',{},[_vm._v("\n    "+_vm._s(props.row.names.join(", "))+"\n  ")]):_vm._e()}},{key:"phones",fn:function(props){return (props.row.phones)?_c('span',{},[_vm._v("\n    "+_vm._s(props.row.phones.join(", "))+"\n  ")]):_vm._e()}},{key:"emails",fn:function(props){return (props.row.emails)?_c('span',{},[_vm._v("\n    "+_vm._s(props.row.emails.join(", "))+"\n  ")]):_vm._e()}},{key:"actions",fn:function(props){return _c('span',{},[_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('router-link',{attrs:{"to":{ name: 'LeadDetails', params: { id: props.row.id } }},on:{"click":function($event){$event.stopPropagation();}}},[_c('i',{staticClass:"mdi mdi-file-outline text-inverse m-r-10"})])],1)])}}],null,true)},[_c('div',{staticClass:"filter-controls pull-right",attrs:{"slot":"filter"},slot:"filter"},[_vm._t("filter")],2)])}
var LeadGrid_staticRenderFns = []
var LeadGrid_esExports = { render: LeadGrid_render, staticRenderFns: LeadGrid_staticRenderFns }
/* harmony default export */ var components_LeadGrid = (LeadGrid_esExports);
// CONCATENATED MODULE: ./src/components/LeadGrid.vue
var LeadGrid_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LeadGrid___vue_template_functional__ = false
/* styles */
var LeadGrid___vue_styles__ = null
/* scopeId */
var LeadGrid___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LeadGrid___vue_module_identifier__ = null
var LeadGrid_Component = LeadGrid_normalizeComponent(
  LeadGrid,
  components_LeadGrid,
  LeadGrid___vue_template_functional__,
  LeadGrid___vue_styles__,
  LeadGrid___vue_scopeId__,
  LeadGrid___vue_module_identifier__
)

/* harmony default export */ var src_components_LeadGrid = (LeadGrid_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Companies/Companies.gql
var Companies = __webpack_require__("fVsU");
var Companies_default = /*#__PURE__*/__webpack_require__.n(Companies);

// EXTERNAL MODULE: ./src/graphql/Campaigns/AssignableCampaigns.gql
var AssignableCampaigns = __webpack_require__("rQbI");
var AssignableCampaigns_default = /*#__PURE__*/__webpack_require__.n(AssignableCampaigns);

// EXTERNAL MODULE: ./src/graphql/Leads/Admin.gql
var Admin = __webpack_require__("rGpa");
var Admin_default = /*#__PURE__*/__webpack_require__.n(Admin);

// EXTERNAL MODULE: ./src/graphql/Leads/Client.gql
var Client = __webpack_require__("J77E");
var Client_default = /*#__PURE__*/__webpack_require__.n(Client);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/vue-multiselect/dist/vue-multiselect.min.js
var dist_vue_multiselect_min = __webpack_require__("RUzx");
var dist_vue_multiselect_min_default = /*#__PURE__*/__webpack_require__.n(dist_vue_multiselect_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CustomMultiselect.vue





/* harmony default export */ var CustomMultiselect = ({
  name: 'custom-multiselect',
  components: {
    Multiselect: dist_vue_multiselect_min_default.a
  },
  props: {
    name: String,
    disabled: Boolean,
    options: {
      type: Array,
      default: []
    },
    isValid: Boolean,
    fieldName: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Object]
    },
    defaultValue: [String, Object],
    'data-vv-value': String,
    'data-vv-name': String,
    'track-by': String
  },
  mounted: function mounted() {
    if (this.defaultValue !== undefined && this.defaultValue !== null) {
      this.$emit('input', typeof_default()(this.defaultValue) === 'object' ? extends_default()({}, this.defaultValue) : this.defaultValue);
    }
  },
  render: function render(h) {
    var _this = this;

    var self = this;

    return h(dist_vue_multiselect_min_default.a, {
      attrs: this.$attrs,
      props: extends_default()({}, this.$props, {
        'custom-label': function customLabel(data) {
          if (typeof data === 'string') {
            return data;
          }

          if (!_this.$props.fieldName) {
            /* eslint-disable no-console */
            console.error('Multiselect must have a fieldName props');
          }

          return data[_this.$props.fieldName];
        }
      }),
      class: {
        'error-multiselect': !this.$props.isValid
      },
      on: {
        input: function input(selectItem) {
          self.$emit('input', selectItem);
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./src/components/CustomMultiselect.vue
function CustomMultiselect_injectStyle (ssrContext) {
  __webpack_require__("LKpP")
}
var CustomMultiselect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var CustomMultiselect___vue_template__ = null
/* template functional */
var CustomMultiselect___vue_template_functional__ = false
/* styles */
var CustomMultiselect___vue_styles__ = CustomMultiselect_injectStyle
/* scopeId */
var CustomMultiselect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CustomMultiselect___vue_module_identifier__ = null
var CustomMultiselect_Component = CustomMultiselect_normalizeComponent(
  CustomMultiselect,
  CustomMultiselect___vue_template__,
  CustomMultiselect___vue_template_functional__,
  CustomMultiselect___vue_styles__,
  CustomMultiselect___vue_scopeId__,
  CustomMultiselect___vue_module_identifier__
)

/* harmony default export */ var components_CustomMultiselect = (CustomMultiselect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Leads/Leads.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Leads = ({
  name: 'Leads',
  components: {
    LeadGrid: src_components_LeadGrid,
    Multiselect: components_CustomMultiselect
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthUser', 'getAuthToken', 'isWhiteLabel']), {
    isClient: function isClient() {
      return this.getAuthUser.role.role_type === 'client';
    },
    query: function query() {
      return this.isClient ? Client_default.a : Admin_default.a;
    },
    variables: function variables() {
      return {
        campaignId: parseInt(this.campaignId),
        companyId: parseInt(this.companyId),
        period: this.period,
        status: this.status
      };
    },
    companyId: function companyId() {
      return this.company ? this.company.id : 0;
    }
  }),

  data: function data() {
    return {
      companies: [],
      campaigns: [],
      periods: [{
        value: 'today',
        title: 'Today'
      }, {
        value: 'yesterday',
        title: 'Yesterday'
      }, {
        value: 'last-7-days',
        title: 'Last 7 days'
      }, {
        value: 'week',
        title: 'This week'
      }, {
        value: 'month',
        title: 'This month'
      }, {
        value: 'last-month',
        title: 'Last month'
      }, {
        value: 'last-6-month',
        title: 'Last 6 months'
      }],
      statuses: [{
        value: '',
        title: 'Any status'
      }, {
        value: 'completed',
        title: 'Completed'
      }, {
        value: 'partial',
        title: 'Partial'
      }],
      campaignId: 0,
      company: null,
      period: 'last-7-days',
      status: '',
      csvExportEndpoint: "https://api.nextlead.io" + '/csv-export'
    };
  },


  apollo: {
    companies: {
      query: Companies_default.a,
      fetchPolicy: 'network-only',
      result: function result(_ref) {
        var data = _ref.data,
            loading = _ref.loading;

        if (!loading) {
          this.companies = data.companies.result;
        }
      },
      variables: function variables() {
        return {
          limit: -1,
          status: true
        };
      },
      skip: function skip() {
        return this.isClient;
      }
    },

    campaigns: {
      query: AssignableCampaigns_default.a,
      fetchPolicy: 'network-only',
      update: function update(data) {
        return data.assignableCampaigns;
      },
      result: function result(_ref2) {
        var data = _ref2.data,
            loading = _ref2.loading;

        if (!loading) {
          this.campaigns = data.assignableCampaigns;
        }
      },
      variables: function variables() {
        return {
          companyId: parseInt(this.companyId)
        };
      },
      skip: function skip() {
        return !this.isClient && this.companyId <= 0;
      }
    }
  },

  methods: {
    onClickHandler: function onClickHandler(row) {
      if (this.$router.canSee(['leads.find'])) {
        this.$router.push({ name: 'Lead', params: { id: row.id } });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11e43aaf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Leads/Leads.vue
var Leads_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('breadcrumbs'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"pb-3"},[_c('form',{attrs:{"method":"post","action":_vm.csvExportEndpoint}},[_c('input',{attrs:{"type":"hidden","name":"campaignId"},domProps:{"value":_vm.campaignId}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"companyId"},domProps:{"value":_vm.companyId}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"period"},domProps:{"value":_vm.period}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"status"},domProps:{"value":_vm.status}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"token"},domProps:{"value":_vm.getAuthToken}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info float-right"},[_vm._v("\n                Export as CSV\n              ")])]),_vm._v(" "),_c('h3',{staticClass:"card-title"},[_vm._v("Leads")])]),_vm._v(" "),_c('lead-grid',{attrs:{"filters":_vm.variables,"role":_vm.getAuthUser.role.role_type,"query":_vm.query,"onClickLead":_vm.onClickHandler}},[_c('div',{staticClass:"filter-controls pull-right",attrs:{"slot":"filter"},slot:"filter"},[(!_vm.isClient)?_c('multiselect',{staticClass:"form-control",attrs:{"id":"company-filter","options":_vm.companies,"fieldName":"companyName","defaultValue":_vm.company,"name":"company","placeholder":"Select a company","isValid":true},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}}):_vm._e(),_vm._v(" "),(!(_vm.isWhiteLabel && _vm.isClient))?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.campaignId),expression:"campaignId"}],staticClass:"form-control",attrs:{"disabled":!_vm.isClient && _vm.companyId <= 0,"id":"campaign-filter"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.campaignId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"","value":"0"}},[_vm._v("All Campaigns")]),_vm._v(" "),_vm._l((_vm.campaigns),function(campaign){return _c('option',{key:campaign.id,domProps:{"value":campaign.id}},[_vm._v(_vm._s(campaign.campaignName))])})],2):_vm._e(),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.period),expression:"period"}],staticClass:"form-control",attrs:{"id":"period-filter"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.period=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.periods),function(period){return _c('option',{key:period.value,domProps:{"value":period.value}},[_vm._v(_vm._s(period.title))])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.statuses),function(status){return _c('option',{key:status.value,domProps:{"value":status.value}},[_vm._v(_vm._s(status.title))])}),0)],1)])],1)])])])],1)}
var Leads_staticRenderFns = []
var Leads_esExports = { render: Leads_render, staticRenderFns: Leads_staticRenderFns }
/* harmony default export */ var Leads_Leads = (Leads_esExports);
// CONCATENATED MODULE: ./src/pages/Leads/Leads.vue
function Leads_injectStyle (ssrContext) {
  __webpack_require__("sA56")
}
var Leads_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Leads___vue_template_functional__ = false
/* styles */
var Leads___vue_styles__ = Leads_injectStyle
/* scopeId */
var Leads___vue_scopeId__ = "data-v-11e43aaf"
/* moduleIdentifier (server only) */
var Leads___vue_module_identifier__ = null
var Leads_Component = Leads_normalizeComponent(
  Leads,
  Leads_Leads,
  Leads___vue_template_functional__,
  Leads___vue_styles__,
  Leads___vue_scopeId__,
  Leads___vue_module_identifier__
)

/* harmony default export */ var pages_Leads_Leads = (Leads_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Dropdown.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Dropdown = ({
  name: 'Dropdown',
  props: {
    options: Array,
    value: String,
    defaultValue: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  created: function created() {
    document.body.addEventListener('click', this.hide);
  },
  destroyed: function destroyed() {
    document.body.removeEventListener('click', this.hide);
  },
  data: function data() {
    return {
      isOpened: false
    };
  },

  computed: {
    actualValue: function actualValue() {
      return this.value || this.defaultValue;
    },
    selectedLabel: function selectedLabel() {
      var _this = this;

      var selected = this.options.find(function (o) {
        return isEqual_default()(o.value, _this.actualValue);
      });
      return selected ? selected.label : 'Select one';
    }
  },
  methods: {
    isActive: function isActive(opt) {
      return this.actualValue === opt.value ? 'active' : '';
    },
    onDropdownToggle: function onDropdownToggle() {
      this.isOpened = !this.isOpened;
    },
    hide: function hide() {
      this.isOpened = false;
    },
    onChange: function onChange(opt) {
      if (this.disabled) {
        return;
      }
      if (!this.isActive(opt)) {
        this.$emit('selected', opt.value);
      }
      this.hide();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99fa3b20","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dropdown.vue
var Dropdown_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown"},[_c('div',{staticClass:"dropdown-body"},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle waves-effect",attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onDropdownToggle($event)}}},[_c('span',{staticClass:"t-dropdown-value"},[_vm._v(_vm._s(_vm.selectedLabel))]),_vm._v(" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),(!_vm.disabled && _vm.isOpened)?_c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},_vm._l((_vm.options),function(opt){return _c('li',{staticClass:"t-dropdown-item",class:{'active': _vm.isActive(opt) && !_vm.disabled, 'disabled': _vm.disabled}},[_c('a',{class:("t-" + (opt.label.replace(/\s/g, '-').toLowerCase())),attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onChange(opt)}}},[_vm._v("\n          "+_vm._s(opt.label)+"\n        ")])])}),0):_vm._e()])])}
var Dropdown_staticRenderFns = []
var Dropdown_esExports = { render: Dropdown_render, staticRenderFns: Dropdown_staticRenderFns }
/* harmony default export */ var components_Dropdown = (Dropdown_esExports);
// CONCATENATED MODULE: ./src/components/Dropdown.vue
function Dropdown_injectStyle (ssrContext) {
  __webpack_require__("zqTu")
}
var Dropdown_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Dropdown___vue_template_functional__ = false
/* styles */
var Dropdown___vue_styles__ = Dropdown_injectStyle
/* scopeId */
var Dropdown___vue_scopeId__ = "data-v-99fa3b20"
/* moduleIdentifier (server only) */
var Dropdown___vue_module_identifier__ = null
var Dropdown_Component = Dropdown_normalizeComponent(
  Dropdown,
  components_Dropdown,
  Dropdown___vue_template_functional__,
  Dropdown___vue_styles__,
  Dropdown___vue_scopeId__,
  Dropdown___vue_module_identifier__
)

/* harmony default export */ var src_components_Dropdown = (Dropdown_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VariantInput.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VariantInput = ({
  name: 'VariantInput',
  mixins: [AsyncInput('onSyncInputChange')],
  components: { Dropdown: src_components_Dropdown },
  props: {
    options: Array,
    async: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object
    }
  },
  methods: {
    onDropdownChange: function onDropdownChange(option) {
      this.$emit('input', { option: option });
    },
    onSyncInputChange: function onSyncInputChange(_ref) {
      var text = _ref.target.value;

      this.$emit('input', extends_default()({}, this.actualValue, { text: text }));
    },
    onInputChange: function onInputChange(event) {
      return this[this.async ? 'onAsyncInputChange' : 'onSyncInputChange'](event);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cab7810","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VariantInput.vue
var VariantInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group"},[_c('dropdown',{staticClass:"input-group-btn left-floated-item",attrs:{"options":_vm.options,"value":_vm.actualValue.option,"defaultValue":_vm.options[0].value},on:{"selected":_vm.onDropdownChange}}),_vm._v(" "),_c('input',{staticClass:"form-control right-floated-item",domProps:{"value":_vm.actualValue.text},on:{"input":_vm.onInputChange}})],1)}
var VariantInput_staticRenderFns = []
var VariantInput_esExports = { render: VariantInput_render, staticRenderFns: VariantInput_staticRenderFns }
/* harmony default export */ var components_VariantInput = (VariantInput_esExports);
// CONCATENATED MODULE: ./src/components/VariantInput.vue
function VariantInput_injectStyle (ssrContext) {
  __webpack_require__("yJHn")
}
var VariantInput_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VariantInput___vue_template_functional__ = false
/* styles */
var VariantInput___vue_styles__ = VariantInput_injectStyle
/* scopeId */
var VariantInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VariantInput___vue_module_identifier__ = null
var VariantInput_Component = VariantInput_normalizeComponent(
  VariantInput,
  components_VariantInput,
  VariantInput___vue_template_functional__,
  VariantInput___vue_styles__,
  VariantInput___vue_scopeId__,
  VariantInput___vue_module_identifier__
)

/* harmony default export */ var src_components_VariantInput = (VariantInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Search/Search.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Search = ({
  components: {
    VariantInput: src_components_VariantInput,
    LeadGrid: src_components_LeadGrid
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthUser', 'getAuthToken']), {
    searchVariants: function searchVariants() {
      return [{ label: 'Lead ID', value: 'id' }, { label: 'Text in Answer', value: 'answer' }];
    },
    query: function query() {
      return this.getAuthUser.role.role_type ? Client_default.a : Admin_default.a;
    },
    variables: function variables() {
      return defineProperty_default()({}, this.searchFilters.option, this.searchFilters.text || undefined);
    }
  }),
  data: function data() {
    return {
      searchFilters: {
        option: 'id'
      }
    };
  },

  methods: {
    onClickHandler: function onClickHandler(row) {
      if (this.$router.canSee(['leads.find'])) {
        this.$router.push({ name: 'Lead', params: { id: row.id } });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9101c84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Search/Search.vue
var Search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('breadcrumbs'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h3',{staticClass:"card-title pb-3"},[_vm._v("Leads")]),_vm._v(" "),_c('lead-grid',{attrs:{"filters":_vm.variables,"role":_vm.getAuthUser.role.role_type,"query":_vm.query,"onClickLead":_vm.onClickHandler}},[_c('div',{staticClass:"filter-controls pull-right",attrs:{"slot":"filter"},slot:"filter"},[_c('variant-input',{attrs:{"async":"","options":_vm.searchVariants},model:{value:(_vm.searchFilters),callback:function ($$v) {_vm.searchFilters=$$v},expression:"searchFilters"}})],1)])],1)])])])],1)}
var Search_staticRenderFns = []
var Search_esExports = { render: Search_render, staticRenderFns: Search_staticRenderFns }
/* harmony default export */ var Search_Search = (Search_esExports);
// CONCATENATED MODULE: ./src/pages/Search/Search.vue
var Search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Search___vue_template_functional__ = false
/* styles */
var Search___vue_styles__ = null
/* scopeId */
var Search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Search___vue_module_identifier__ = null
var Search_Component = Search_normalizeComponent(
  Search,
  Search_Search,
  Search___vue_template_functional__,
  Search___vue_styles__,
  Search___vue_scopeId__,
  Search___vue_module_identifier__
)

/* harmony default export */ var pages_Search_Search = (Search_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/firebase/app/dist/index.esm.js
var index_esm = __webpack_require__("uLgv");

// EXTERNAL MODULE: ./node_modules/firebase/database/dist/index.esm.js
var dist_index_esm = __webpack_require__("hZls");

// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/index.esm.js
var auth_dist_index_esm = __webpack_require__("dih4");

// CONCATENATED MODULE: ./src/helpers/firebase.js




index_esm["a" /* default */].initializeApp({
  projectId: 'nextlead-portal',
  databaseURL: 'https://nextlead-portal.firebaseio.com',
  apiKey: 'AIzaSyDbxXDuCfjwLPRPAZZSDzydIeWuq-aU8a0'
});

var db = index_esm["a" /* default */].database().ref();
var Timestamp = index_esm["a" /* default */].database.ServerValue.TIMESTAMP;

index_esm["a" /* default */].auth().signInWithEmailAndPassword('admin@admin.admin', 'admin@admin.admin').catch(function (error) {
  // eslint-disable-next-line
  console.log(error.code + ' : ' + error.message);
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Tickets/Tickets.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var COLUMNS = [{ field: 'id', title: 'ID' }, { field: 'createdAt', title: 'Created' }, { field: 'searchText', title: 'Input' }, { field: 'metadata.campaignName', title: 'Campaign' }, { field: 'representativeName', title: 'Agent' }, { field: 'info.deviceType', title: 'Device' }, { field: 'messages.length', title: 'Msg(s)' }, { field: 'assignedAt', title: 'Taken (sec)' }, { field: 'updatesByVisitor', title: 'Left (sec)' }];

/* harmony default export */ var Tickets = ({
  components: { Spinner: src_components_Spinner, Grid: src_components_Grid },
  created: function created() {
    this.ref = db.child('tickets').orderByChild('createdAt');
    this.fetchData();
  },
  destroyed: function destroyed() {
    this.ref.off('value');
  },

  computed: {
    columns: function columns() {
      return COLUMNS;
    }
  },
  data: function data() {
    return {
      tickets: [],
      limit: 10,
      page: 0,
      showSpinner: false,
      meta: { count: 0 }
    };
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.showSpinner = true;
      this.ref.off('value');
      this.ref.on('value', function (sagment) {
        var value = sagment.val() || {};
        var offset = _this.page * _this.limit;
        var tickets = keys_default()(value).map(function (id) {
          return extends_default()({}, value[id], {
            messages: values_default()(value[id].messages || {}),
            id: id
          });
        }).sort(function (a, b) {
          return b.createdAt - a.createdAt;
        });
        _this.meta = { count: tickets.length };
        _this.tickets = tickets.slice(offset, offset + _this.limit);
        _this.showSpinner = false;
      });
    },
    openMessages: function openMessages(row) {
      this.$router.push({ name: 'Messages', params: { ticketId: row.id } });
    },
    changeLimit: function changeLimit(event) {
      this.limit = +event.target.value;
      this.fetchData();
    },
    changePage: function changePage(page) {
      this.page = page;
      this.fetchData();
    },
    setFirstPage: function setFirstPage() {
      this.page = 0;
      this.fetchData();
    }
  },
  filters: {
    last: function last(str, count) {
      return str.slice(-count);
    },
    seconds: function seconds(number) {
      return (number / 1000).toFixed(0);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-447fedd7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Tickets/Tickets.vue
var Tickets_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('breadcrumbs'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h3',{staticClass:"card-title pb-3"},[_vm._v("Tickets")]),_vm._v(" "),(_vm.showSpinner)?_c('div',{staticClass:"spinner-wrap"},[_c('spinner')],1):_c('grid',{attrs:{"hideSearch":"","fieldName":"tickets","columns":_vm.columns,"value":_vm.tickets,"limit":_vm.limit,"page":_vm.page,"meta":_vm.meta},on:{"limit":_vm.changeLimit,"page":_vm.changePage},scopedSlots:_vm._u([{key:"id",fn:function(props){return _c('span',{},[_c('router-link',{attrs:{"to":{ name: 'Messages', params: { ticketId: props.row.id } }},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v("\n                "+_vm._s(_vm._f("last")(props.row.id,4))+"\n              ")])],1)}},{key:"assignedAt",fn:function(props){return _c('span',{},[(props.row.assignedAt)?_c('span',[_vm._v("\n                "+_vm._s(_vm._f("seconds")(props.row.assignedAt - props.row.createdAt))+"\n              ")]):_c('span',[_vm._v("\n                Not assigned\n              ")])])}},{key:"messages.length",fn:function(props){return _c('span',{},[_vm._v("\n              "+_vm._s(props.row.messages ? props.row.messages.length : 0)+"\n            ")])}},{key:"representativeName",fn:function(props){return _c('span',{},[_vm._v("\n              "+_vm._s(props.row.representativeName || 'Anonym')+"\n            ")])}},{key:"updatesByVisitor",fn:function(props){return _c('span',{},[(props.row.updatesByVisitor && props.row.updatesByVisitor.closedByVisitorAt)?_c('span',[_vm._v("\n                "+_vm._s(_vm._f("seconds")(props.row.updatesByVisitor.closedByVisitorAt - props.row.createdAt))+"\n              ")]):_c('span',[_vm._v("Not closed")])])}},{key:"createdAt",fn:function(props){return _c('span',{},[_vm._v("\n              "+_vm._s(_vm._f("date")(props.row.createdAt))+"\n            ")])}}])})],1)])])])],1)}
var Tickets_staticRenderFns = []
var Tickets_esExports = { render: Tickets_render, staticRenderFns: Tickets_staticRenderFns }
/* harmony default export */ var Tickets_Tickets = (Tickets_esExports);
// CONCATENATED MODULE: ./src/pages/Tickets/Tickets.vue
var Tickets_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Tickets___vue_template_functional__ = false
/* styles */
var Tickets___vue_styles__ = null
/* scopeId */
var Tickets___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Tickets___vue_module_identifier__ = null
var Tickets_Component = Tickets_normalizeComponent(
  Tickets,
  Tickets_Tickets,
  Tickets___vue_template_functional__,
  Tickets___vue_styles__,
  Tickets___vue_scopeId__,
  Tickets___vue_module_identifier__
)


/* harmony default export */ var pages_Tickets_Tickets = (Tickets_Component.exports);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/ol/Map.js + 46 modules
var Map = __webpack_require__("trid");

// EXTERNAL MODULE: ./node_modules/ol/source/XYZ.js + 14 modules
var XYZ = __webpack_require__("irp0");

// EXTERNAL MODULE: ./node_modules/ol/View.js + 3 modules
var View = __webpack_require__("Lfyu");

// EXTERNAL MODULE: ./node_modules/ol/geom/Point.js
var Point = __webpack_require__("T18w");

// EXTERNAL MODULE: ./node_modules/ol/Feature.js
var Feature = __webpack_require__("nq2H");

// EXTERNAL MODULE: ./node_modules/ol/layer/Tile.js + 1 modules
var Tile = __webpack_require__("Mdwg");

// EXTERNAL MODULE: ./node_modules/ol/layer/Vector.js
var Vector = __webpack_require__("Umvz");

// EXTERNAL MODULE: ./node_modules/ol/source/Vector.js + 3 modules
var source_Vector = __webpack_require__("WMwB");

// EXTERNAL MODULE: ./node_modules/ol/interaction.js + 32 modules
var interaction = __webpack_require__("TDso");

// EXTERNAL MODULE: ./node_modules/ol/proj.js + 5 modules
var proj = __webpack_require__("yGLh");

// EXTERNAL MODULE: ./node_modules/ol/style.js + 7 modules
var style = __webpack_require__("beD/");

// EXTERNAL MODULE: ./node_modules/ol/ol.css
var ol = __webpack_require__("ktr9");
var ol_default = /*#__PURE__*/__webpack_require__.n(ol);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Map.vue

//
//
//















/* harmony default export */ var components_Map = ({
  props: {
    zoom: {
      type: Number,
      default: 10
    },
    lat: {
      type: Number,
      default: 0
    },
    lng: {
      type: Number,
      default: 0
    },
    marker: Boolean
  },
  mounted: function mounted() {
    this.mountMap();
  },
  updated: function updated() {
    this.mountMap();
  },

  methods: {
    createStyle: function createStyle(src) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return new style["b" /* Style */]({
        image: new style["a" /* Icon */](extends_default()({}, options, {
          anchor: [0.5, 1],
          src: src
        }))
      });
    },
    mountMap: function mountMap() {
      var coords = Object(proj["d" /* fromLonLat */])([this.lng, this.lat]);
      var iconFeature = new Feature["a" /* default */](new Point["a" /* default */](coords));
      iconFeature.set('style', this.createStyle("/static/map-marker.svg", { scale: 0.1 }));
      this.$map = new Map["a" /* default */]({
        target: 'map',
        interactions: Object(interaction["a" /* defaults */])({
          onFocusOnly: true,
          mouseWheelZoom: false
        }),
        loadTilesWhileInteracting: true,
        layers: [new Tile["a" /* default */]({
          source: new XYZ["a" /* default */]({
            url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'
          })
        }), this.marker && new Vector["a" /* default */]({
          style: function style(f) {
            return f.get('style');
          },
          source: new source_Vector["a" /* default */]({ features: [iconFeature] })
        })],
        view: new View["a" /* default */]({
          center: coords,
          zoom: this.zoom
        })
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b21948f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
var Map_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"map"}})}
var Map_staticRenderFns = []
var Map_esExports = { render: Map_render, staticRenderFns: Map_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Map = (Map_esExports);
// CONCATENATED MODULE: ./src/components/Map.vue
function Map_injectStyle (ssrContext) {
  __webpack_require__("8rN0")
}
var Map_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Map___vue_template_functional__ = false
/* styles */
var Map___vue_styles__ = Map_injectStyle
/* scopeId */
var Map___vue_scopeId__ = "data-v-4b21948f"
/* moduleIdentifier (server only) */
var Map___vue_module_identifier__ = null
var Map_Component = Map_normalizeComponent(
  components_Map,
  selectortype_template_index_0_src_components_Map,
  Map___vue_template_functional__,
  Map___vue_styles__,
  Map___vue_scopeId__,
  Map___vue_module_identifier__
)

/* harmony default export */ var src_components_Map = (Map_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Lead/Lead.gql
var Lead = __webpack_require__("+H51");
var Lead_default = /*#__PURE__*/__webpack_require__.n(Lead);

// EXTERNAL MODULE: ./src/graphql/Transactions/TransactionsByLeadId.gql
var TransactionsByLeadId = __webpack_require__("mWDM");
var TransactionsByLeadId_default = /*#__PURE__*/__webpack_require__.n(TransactionsByLeadId);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Leads/LeadDetails.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var LeadDetails = ({
  name: 'LeadsDetails',
  components: {
    MapComponent: src_components_Map,
    Spinner: src_components_Spinner
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      showSpinner: 0,
      isOverdue: false,
      lead: {},
      transactions: []
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getCompany', 'isUserAdmin', 'getAuthUser', 'isWhiteLabel']), {
    isCompleted: function isCompleted() {
      return this.lead.completed;
    },
    ticketId: function ticketId() {
      return this.lead.ticketId;
    },
    company: function company() {
      if (this.lead && this.lead.company) {
        return this.lead.company;
      }
      return {};
    },
    campaign: function campaign() {
      if (this.lead && this.lead.campaign) {
        return this.lead.campaign;
      }
      return {};
    },
    leadData: function leadData() {
      if (this.lead && this.lead.data) {
        return this.lead.data;
      }
      return {};
    },
    context: function context() {
      if (this.leadData && this.leadData.context) {
        return this.leadData.context;
      }
      return {};
    },
    visitor: function visitor() {
      if (this.leadData && this.leadData.visitor) {
        return this.leadData.visitor;
      }
      return {};
    },
    stats: function stats() {
      if (this.leadData && this.leadData.stats) {
        return this.leadData.stats;
      }
      return {};
    },
    chat: function chat() {
      if (this.leadData && this.leadData.chat) {
        return this.leadData.chat;
      }
      return {};
    },
    navigator: function navigator() {
      if (this.leadData && this.leadData.navigator) {
        return this.leadData.navigator;
      }
      return {};
    },
    isCall: function isCall() {
      return this.call.from;
    },
    isChat: function isChat() {
      return this.leadData && this.leadData.type === 'chat';
    },
    call: function call() {
      return this.leadData && this.leadData.call ? this.leadData.call : {};
    },
    type: function type() {
      return this.leadData ? this.leadData.type : null;
    },
    creditLink: function creditLink() {
      return 'https://docs.google.com/forms/d/e/1FAIpQLSe00rC51gw7GaLTk5Ne3HmbUXacT5WdMa71o3X7s7jQ0bkJVw/viewform?usp=pp_url&entry.2039617643=' + this.getAuthUser.email + '&entry.105432001=' + this.id + '&entry.2023113411=' + this.campaign.campaignName;
    },
    hasTransactions: function hasTransactions() {
      return !!(this.transactions && this.transactions.length > 0);
    },
    howOldInHours: function howOldInHours() {
      return moment_default()().diff(moment_default()(this.lead.created), 'hours');
    }
  }),
  methods: {
    timestamp: function timestamp(_timestamp) {
      var date = new Date(_timestamp);
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  },
  apollo: {
    lead: {
      query: Lead_default.a,
      loadingKey: 'showSpinner',
      error: function error(_ref) {
        var errors = _ref.graphQLErrors;

        this.isOverdue = Boolean(errors && errors.find(function (a) {
          return a.name === 'ACCESS_DENIED';
        }));
      },
      variables: function variables() {
        return {
          id: parseInt(this.id)
        };
      },
      result: function result(_ref2) {
        var data = _ref2.data,
            loading = _ref2.loading;

        if (!loading) {
          this.lead = data.lead;
        }
      }
    },
    transactionsByLeadId: {
      query: TransactionsByLeadId_default.a,
      loadingKey: 'showSpinner',
      error: function error(_ref3) {
        var errors = _ref3.graphQLErrors;

        this.isOverdue = Boolean(errors && errors.find(function (a) {
          return a.name === 'ACCESS_DENIED';
        }));
      },
      variables: function variables() {
        return {
          id: parseInt(this.id)
        };
      },
      result: function result(_ref4) {
        var data = _ref4.data,
            loading = _ref4.loading;

        if (!loading) {
          this.transactions = data.transactionsByLeadId;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-def8bf4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Leads/LeadDetails.vue
var LeadDetails_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row page-titles"},[_c('div',{staticClass:"col-md-6"},[_c('breadcrumbs',{attrs:{"current":_vm.id}})],1)]),_vm._v(" "),(_vm.showSpinner)?_c('div',{staticClass:"spinner-wrap"},[_c('spinner')],1):(!_vm.isOverdue)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"card card-outline-inverse-light"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"mb-0"},[_vm._v("Lead "+_vm._s(_vm.isCompleted ? 'Completed' : 'Partial'))])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table no-border"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("ID")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.id))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Ticket")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.ticketId))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Created")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.lead.created,"MMM Do YYYY, h:mm:ss a")))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Customer")]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'EditCompany', params: { id: _vm.company.id } }}},[_vm._v("\n                        "+_vm._s(_vm.company.companyName)+"\n                      ")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Campaign")]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'CampaignDetails', params: { id: _vm.campaign.id } }}},[_vm._v("\n                        "+_vm._s(_vm.campaign.campaignName)+"\n                      ")])],1)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"card card-outline-inverse-light"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table no-border"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Title")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.context.title))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Subtitle")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.context.subtitle))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Prompt")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.context.prompt))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Type")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.leadData.type))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Original Type")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.leadData.type_original))])])])])])])])]),_vm._v(" "),(_vm.navigator.href)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card card-outline-inverse-light"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('h5',[_c('a',{attrs:{"href":_vm.navigator.href,"target":"_blank"}},[_vm._v(_vm._s(_vm.navigator.href))])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card card-outline-info"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v(_vm._s(_vm.lead.input))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card card-outline-info"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.lead.questions),function(question){return _c('tr',{key:question.id},[_c('td',[_vm._v(_vm._s(question.fieldName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(question.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(question.question))]),_vm._v(" "),_c('td',[(question.type === 'Date')?_c('span',[_vm._v("\n                        "+_vm._s(_vm._f("date")(question.answer))+"\n                      ")]):_c('span',[_vm._v("\n                        "+_vm._s(question.answer.join(', '))+"\n                        ")])])])}),0)])])])])]),_vm._v(" "),(_vm.lead.notes)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card card-outline-info"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v(_vm._s(_vm.lead.notes))])])])]):_vm._e(),_vm._v(" "),(_vm.isChat)?_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"card card-outline-inverse-light"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"mb-0"},[_vm._v("Chat with Agent # "+_vm._s(_vm.lead.agentId))])]),_vm._v(" "),_c('div',{staticClass:"card-body fixed-height chat-rbox p-0"},[_c('ul',{staticClass:"chat-list"},_vm._l((_vm.chat),function(item){return _c('li',{key:item.key,class:{'reverse': item.byRepresentative}},[(item.byRepresentative)?_c('div',{staticClass:"chat-content"},[_c('h5',[_c('span',{staticClass:"timestamp"},[_vm._v("("+_vm._s(_vm._f("moment")(item.timestamp,"h:mm a"))+")  ")]),_vm._v("\n                    Agent\n                  ")]),_vm._v(" "),_c('div',{staticClass:"box bg-light-inverse"},[_vm._v("\n                    "+_vm._s(item.message)+"\n                    "),(item.seenAt)?_c('div',{staticClass:"timestamp"},[_c('i',{staticClass:"mdi mdi-check"}),_vm._v(" Seen at "+_vm._s(_vm._f("moment")(item.seenAt,"h:mm a")))]):_vm._e()])]):_c('div',{staticClass:"chat-content"},[_c('h5',[_vm._v("\n                    Lead\n                    "),_c('span',{staticClass:"timestamp"},[_vm._v("  ("+_vm._s(_vm._f("moment")(item.timestamp,"h:mm a"))+")")])]),_vm._v(" "),_c('div',{staticClass:"box bg-light-info"},[_vm._v(_vm._s(item.message))])])])}),0)])])]):_vm._e(),_vm._v(" "),(_vm.isCall)?_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"card card-outline-inverse-light"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"card-body fixed-height"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table no-border"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("City")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.call.city))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("State/Province")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.call.state))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Country")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.call.country))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Zip/Postal")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.call.zip))])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.isChat)?_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"card card-outline-inverse-light"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"card-body fixed-height"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table no-border"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Total questions")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stats.numberOfQuestions))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Mandatory questions")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stats.numberOfMandatoryQuestions))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Answered questions")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stats.numberOfQuestionsAnswered))])]),_vm._v(" "),(!_vm.isCall)?_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Questions seen by visitor")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stats.numberOfQuestionsSeenByVisitor))])]):_vm._e(),_vm._v(" "),(!_vm.isCall)?_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Messages in chat")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stats.numberOfMessages))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Agent Responded")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("duration")(_vm.stats.agentResponseTime,'asSeconds'))+" sec")])]),_vm._v(" "),(!_vm.isCall)?_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Seen by visitor for")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("duration")(_vm.stats.seenByVisitorTime,'asSeconds'))+" sec")])]):_vm._e(),_vm._v(" "),(!_vm.isCall)?_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Closed by visitor after")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("duration")(_vm.stats.closedByVisitorTime,'asSeconds'))+" sec")])]):_vm._e(),_vm._v(" "),(!_vm.isCall)?_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Chat duration")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("duration")(_vm.stats.chatTime,'asSeconds'))+" sec")])]):_vm._e(),_vm._v(" "),(_vm.isCall && _vm.call.recording)?_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Call Duration")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.call.recording.RecordingDuration)+" sec")])]):_vm._e(),_vm._v(" "),(_vm.isCall && _vm.call.recording)?_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Call Recording")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":_vm.call.recording.RecordingUrl,"target":"_blank"}},[_vm._v("Play")])])]):_vm._e(),_vm._v(" "),(_vm.isCall && _vm.call.vm)?_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Voicemail Duration")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.call.vm.RecordingDuration)+" sec")])]):_vm._e(),_vm._v(" "),(_vm.isCall && _vm.call.vm)?_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Voicemail Recording")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":_vm.call.vm.RecordingUrl,"target":"_blank"}},[_vm._v("Play")])])]):_vm._e()])])])])])]):_vm._e(),_vm._v(" "),(!_vm.isCall)?_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"card card-outline-inverse-light"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"card-body fixed-height"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table no-border"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("IP Address")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.visitor.ip))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Time Zone")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.visitor.timezone)+" ("+_vm._s(_vm.visitor.timezone_id)+")")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Currency")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.visitor.currency))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("City")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.visitor.city))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Region")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.visitor.region_name)+" ("+_vm._s(_vm.visitor.region_code)+")")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Country")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.visitor.country_name)+" ("+_vm._s(_vm.visitor.country_code)+")")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Zip/Postal")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.visitor.zip))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Geo (lat/long)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.visitor.latitude)+" , "+_vm._s(_vm.visitor.longitude))])])])])])])])]):_vm._e(),_vm._v(" "),(!_vm.isCall)?_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"card card-outline-inverse-light"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"card-body fixed-height"},[_c('table',{staticClass:"table no-border"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Type")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.navigator.deviceType))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Screen")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.navigator.screenWidth)+" x "+_vm._s(_vm.navigator.screenHeight))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Viewport")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.navigator.viewportWidth)+" x "+_vm._s(_vm.navigator.viewportHeight))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Page")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.navigator.docWidth)+" x "+_vm._s(_vm.navigator.docHeight))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("Language")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.navigator.language))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"strong"},[_vm._v("User Agent")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.navigator.userAgent))])])])])])])]):_vm._e(),_vm._v(" "),(Number.isFinite(_vm.visitor.latitude) && Number.isFinite(_vm.visitor.longitude))?_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card card-outline-inverse-light"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"card-body fixed-height p-0"},[_c('map-component',{attrs:{"lat":_vm.visitor.latitude,"lng":_vm.visitor.longitude,"zoom":10,"marker":""}})],1)])]):_vm._e(),_vm._v(" "),(_vm.hasTransactions)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card card-outline-inverse-light"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Amount")]),_vm._v(" "),_c('th',[_vm._v("Notes")]),_vm._v(" "),(_vm.isUserAdmin)?_c('th',{staticClass:"text-right"},[_vm._v("Actions")]):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((_vm.transactions),function(trx){return _c('tr',{key:trx.id},[_c('td',[_vm._v(_vm._s(_vm._f("moment")(trx.created,"MMM Do YYYY")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.currency)+" "+_vm._s(_vm._f("currency")(trx.amount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(trx.notes))]),_vm._v(" "),(_vm.isUserAdmin && trx.amount < 0)?_c('td',[_c('router-link',{staticClass:"btn btn-info float-right",attrs:{"tag":"button","to":{ name: 'LeadRefund', params: {trx: trx} }}},[_vm._v("\n                      Refund\n                    ")])],1):_vm._e()])}),0)])])])])]):_vm._e()]):_c('div',{staticClass:"card card-outline-inverse-light"},[_c('div',{staticClass:"card-body without-details"},[_c('h2',[_vm._v("Your account is overdue, please add a payment method.")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-info",attrs:{"to":{ name: 'EditCompany', params: { id: _vm.getCompany.id }, query: { tab: 'billing' } }}},[_vm._v("\n\t\t\t\t\tAdd Payment Method\n\t\t\t\t")])],1)])])}
var LeadDetails_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"mb-0"},[_vm._v("Widget Context")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"mb-0"},[_vm._v("Origin URL")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"mb-0 text-white"},[_vm._v("Visitor Input")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"mb-0 text-white"},[_vm._v("Visitor Answers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Field")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Question")]),_vm._v(" "),_c('th',[_vm._v("Answer")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"mb-0 text-white"},[_vm._v("Agent Notes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"mb-0"},[_vm._v("Call Geo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"mb-0"},[_vm._v("Stats")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"mb-0"},[_vm._v("Visitor Info")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"mb-0"},[_vm._v("Device Info")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"mb-0"},[_vm._v("Map")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"mb-0"},[_vm._v("Transactions")])])}]
var LeadDetails_esExports = { render: LeadDetails_render, staticRenderFns: LeadDetails_staticRenderFns }
/* harmony default export */ var Leads_LeadDetails = (LeadDetails_esExports);
// CONCATENATED MODULE: ./src/pages/Leads/LeadDetails.vue
function LeadDetails_injectStyle (ssrContext) {
  __webpack_require__("7nA6")
}
var LeadDetails_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LeadDetails___vue_template_functional__ = false
/* styles */
var LeadDetails___vue_styles__ = LeadDetails_injectStyle
/* scopeId */
var LeadDetails___vue_scopeId__ = "data-v-def8bf4e"
/* moduleIdentifier (server only) */
var LeadDetails___vue_module_identifier__ = null
var LeadDetails_Component = LeadDetails_normalizeComponent(
  LeadDetails,
  Leads_LeadDetails,
  LeadDetails___vue_template_functional__,
  LeadDetails___vue_styles__,
  LeadDetails___vue_scopeId__,
  LeadDetails___vue_module_identifier__
)

/* harmony default export */ var pages_Leads_LeadDetails = (LeadDetails_Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Leads/LeadMobile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var LeadMobile = ({
  name: 'LeadsDetails',
  components: {
    MapComponent: src_components_Map,
    Spinner: src_components_Spinner
  },
  data: function data() {
    return {
      showSpinner: false,
      token: this.$route.params.token,
      lead: {},
      timer: "",
      oldInMins: 0,
      alert: true,
      phone: null,
      headers: [{
        text: 'Question',
        align: 'left',
        sortable: false,
        value: 'question'
      }, {
        text: 'Answer',
        align: 'left',
        sortable: false,
        value: 'answer'
      }]
    };
  },

  computed: {
    questions: function questions() {
      if (this.lead && this.lead.questions) {
        var questions = this.lead.questions;
        if (this.lead.data.context.prompt) {
          questions.unshift({
            question: this.lead.data.context.prompt,
            answer: [this.lead.input]
          });
        }

        return questions;
      }
      return null;
    },
    location: function location() {
      return this.lead && this.lead.data && this.lead.data.visitor ? this.lead.data.visitor : null;
    },
    device: function device() {
      if (this.lead && this.lead.data && this.lead.data.navigator) {
        var _lead$data$navigator = this.lead.data.navigator,
            deviceType = _lead$data$navigator.deviceType,
            screenHeight = _lead$data$navigator.screenHeight,
            screenWidth = _lead$data$navigator.screenWidth,
            userAgent = _lead$data$navigator.userAgent;

        return [{
          key: "type",
          value: deviceType
        }, {
          key: "screen",
          value: screenWidth + ' x ' + screenHeight
        }, {
          key: "browser",
          value: userAgent
        }];
      }
      return null;
    }
  },
  mounted: function mounted() {
    this.fetchLead();
  },

  methods: {
    fetchLead: function fetchLead() {
      var _this = this;

      this.showSpinner = true;
      var url = "https://api.nextlead.io" + '/lead/' + this.token;
      return axios_default.a.get(url).then(function (response) {
        _this.lead = response.data.lead;
      }).finally(function () {
        _this.showSpinner = false;
        _this.findPhone();
        _this.startTimer();
      });
    },

    startTimer: function startTimer() {
      var _this2 = this;

      var interval = setInterval(function () {
        var diff = moment_default()().diff(_this2.lead.created);
        _this2.timer = moment_default.a.utc(diff);
        _this2.oldInMins = diff / 60000;
        if (_this2.oldInMins >= 60) {
          clearInterval(interval);
        }
      }, 1000);
    },
    findPhone: function findPhone() {
      var _this3 = this;

      this.lead.questions.forEach(function (q) {
        var answer = q.answer,
            type = q.type;

        if (type === "Phone") {
          _this3.phone = answer[0];
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55069291","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Leads/LeadMobile.vue
var LeadMobile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-toolbar',{attrs:{"color":"blue","dark":"","fixed":"","app":"","clipped-right":"","app":""}},[_c('v-toolbar-title',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.lead.campaignName))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","href":("/leads/" + (_vm.lead.id))}},[_c('v-icon',[_vm._v("launch")])],1)],1),_vm._v(" "),_c('v-content',[_c('v-container',[_c('v-alert',{staticClass:"mb-4",attrs:{"dismissible":"","color":_vm.oldInMins < 60 ? 'info' : 'error',"outline":""},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_c('div',[_vm._v("ACT FAST: Sales Conversions are up to 380% within the 1st Minute. Drop below 80% after 5 Minutes.")])]),_vm._v(" "),(_vm.oldInMins > 60)?_c('div',{staticClass:"subheading"},[_c('v-icon',[_vm._v("schedule")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.lead.created,"lll"))+"\n      ")],1):_c('div',{staticClass:"title text-info"},[_c('v-icon',{attrs:{"color":"info"}},[_vm._v("timer")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.timer,"mm:ss"))+"\n      ")],1),_vm._v(" "),(_vm.questions)?_c('v-card',{staticClass:"mt-4"},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("question_answer")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"text-truncate"},[_vm._v("\n            #"+_vm._s(_vm.lead.id)+"\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.phone)?_c('v-btn',{attrs:{"color":"success","round":"","depressed":"","href":'tel:'+_vm.phone}},[_c('v-icon',[_vm._v("phone")])],1):_vm._e()],1),_vm._v(" "),_c('v-data-table',{attrs:{"items":_vm.questions,"hide-actions":"","hide-headers":"","loading":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(props.item.question))]),_vm._v(" "),_c('td',{},[_c('div',{staticClass:"hidden-md-and-up"},[_vm._v("\n                "+_vm._s(props.item.question)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"font-weight-medium"},[(props.item.type === 'Date')?_c('span',[_vm._v("\n                "+_vm._s(_vm._f("date")(props.item.answer))+"\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(props.item.answer.join(', '))+"\n              ")])])])]}}],null,false,1560894193)})],1):_vm._e(),_vm._v(" "),(_vm.location)?_c('v-card',{staticClass:"mt-4"},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("my_location")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.location.city)+", "+_vm._s(_vm.location.region_code))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('map-component',{attrs:{"lat":_vm.location.latitude,"lng":_vm.location.longitude,"zoom":12,"marker":""}})],1):_vm._e(),_vm._v(" "),(_vm.device)?_c('v-card',{staticClass:"mt-4"},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("devices")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"text-truncate"},[_vm._v("Device")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-data-table',{attrs:{"items":_vm.device,"hide-actions":"","hide-headers":"","loading":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{},[_vm._v(_vm._s(props.item.key))]),_vm._v(" "),_c('td',{staticClass:"text-truncate font-weight-medium"},[_vm._v("\n              "+_vm._s(props.item.value)+"\n            ")])]}}],null,false,183982329)})],1):_vm._e()],1)],1)],1)}
var LeadMobile_staticRenderFns = []
var LeadMobile_esExports = { render: LeadMobile_render, staticRenderFns: LeadMobile_staticRenderFns }
/* harmony default export */ var Leads_LeadMobile = (LeadMobile_esExports);
// CONCATENATED MODULE: ./src/pages/Leads/LeadMobile.vue
function LeadMobile_injectStyle (ssrContext) {
  __webpack_require__("w4X2")
}
var LeadMobile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LeadMobile___vue_template_functional__ = false
/* styles */
var LeadMobile___vue_styles__ = LeadMobile_injectStyle
/* scopeId */
var LeadMobile___vue_scopeId__ = "data-v-55069291"
/* moduleIdentifier (server only) */
var LeadMobile___vue_module_identifier__ = null
var LeadMobile_Component = LeadMobile_normalizeComponent(
  LeadMobile,
  Leads_LeadMobile,
  LeadMobile___vue_template_functional__,
  LeadMobile___vue_styles__,
  LeadMobile___vue_scopeId__,
  LeadMobile___vue_module_identifier__
)

/* harmony default export */ var pages_Leads_LeadMobile = (LeadMobile_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Users/Users.gql
var Users = __webpack_require__("vsB3");
var Users_default = /*#__PURE__*/__webpack_require__.n(Users);

// EXTERNAL MODULE: ./src/graphql/Users/UserRole.gql
var UserRole = __webpack_require__("YfVO");
var UserRole_default = /*#__PURE__*/__webpack_require__.n(UserRole);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Users/Users.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Users_Users = ({
  name: 'Users',
  components: {
    DataTable: components_DataTable
  },

  data: function data() {
    return {
      columns: [{ field: 'id', title: 'Id' }, { field: 'photo', title: 'Photo' }, { field: 'name', title: 'Name' }, { field: 'role_type', title: 'Role' }, { field: 'email', title: 'Email' }, { field: 'companyName', title: 'Company' }, { field: 'status', title: 'Status' }, { field: 'phone', title: 'Phone' }, { field: 'created', title: 'Created' }, { field: 'actions', title: 'Actions', skipSorting: true }],
      query: Users_default.a,
      roles: [],
      roleId: ''
    };
  },


  computed: {
    variables: function variables() {
      var filter = {};
      if (this.roleId) {
        filter.roleId = this.roleId;
      }
      return {
        filter: filter
      };
    }
  },

  apollo: {
    roles: {
      query: UserRole_default.a,
      fetchPolicy: 'network-only',
      result: function result(_ref) {
        var data = _ref.data,
            loading = _ref.loading;

        if (!loading) {
          this.roles = data.roles;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7065c32c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Users/Users.vue
var Users_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('breadcrumbs'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('router-link',{staticClass:"btn btn-info float-right",attrs:{"tag":"button","to":{ name: 'AddUser' }}},[_vm._v("\n            Create Account\n          ")]),_vm._v(" "),_c('h3',{staticClass:"card-title pb-3"},[_vm._v("Users")]),_vm._v(" "),_c('data-table',{attrs:{"columns":_vm.columns,"fieldName":"users","query":_vm.query,"variables":_vm.variables,"placeholder":"Search by Name"},scopedSlots:_vm._u([{key:"photo",fn:function(props){return _c('span',{},[_c('router-link',{attrs:{"to":{ name: 'UserPhoto', params: { id: props.row.id } }}},[(props.row.photo && props.row.photo.thumb50)?_c('img',{staticClass:"img-circle",attrs:{"width":"50px","src":props.row.photo.thumb50}}):_c('i',{staticClass:"mdi mdi-account-circle user-icon"})])],1)}},{key:"name",fn:function(props){return _c('span',{},[_c('router-link',{attrs:{"to":{ name: 'UpdateUser', params: { userId: props.row.id } }}},[_vm._v("\n                "+_vm._s(props.row.name)+"\n              ")])],1)}},{key:"companyName",fn:function(props){return _c('span',{},[_c('router-link',{attrs:{"to":{ name: 'EditCompany', params: { id: props.row.companyId } }}},[_vm._v("\n                "+_vm._s(props.row.companyName)+"\n              ")])],1)}},{key:"status",fn:function(props){return _c('span',{},[_vm._v("\n              "+_vm._s(props.row.status ? 'Active' : 'Inactive')+"\n            ")])}},{key:"created",fn:function(props){return _c('span',{},[_vm._v("\n              "+_vm._s(_vm._f("moment")(props.row.created,"MMM Do YYYY, h:mm:ss a"))+"\n            ")])}},{key:"actions",fn:function(props){return _c('span',{},[_c('router-link',{attrs:{"to":{ name: 'UpdateUser', params: { userId: props.row.id } }}},[_c('i',{staticClass:"mdi mdi-pencil text-inverse m-r-10"})]),_vm._v(" "),(props.row.role_type !== 'administrator')?_c('router-link',{directives:[{name:"granted",rawName:"v-granted",value:('users.find'),expression:"'users.find'"}],attrs:{"to":{ name: 'AssignCampaigns', params: { userId: props.row.id, role: props.row.role_type } }}},[_c('i',{staticClass:"mdi mdi-checkbox-marked-outline text-inverse"})]):_vm._e()],1)}}])},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.roleId),expression:"roleId"}],staticClass:"form-control",attrs:{"slot":"additional-filter"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.roleId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}},slot:"additional-filter"},[_c('option',{attrs:{"value":""}},[_vm._v("All roles")]),_vm._v(" "),_vm._l((_vm.roles),function(role){return _c('option',{key:role.id,domProps:{"value":role.id}},[_vm._v(_vm._s(role.role_type))])})],2)])],1)])])])],1)}
var Users_staticRenderFns = []
var Users_esExports = { render: Users_render, staticRenderFns: Users_staticRenderFns }
/* harmony default export */ var pages_Users_Users = (Users_esExports);
// CONCATENATED MODULE: ./src/pages/Users/Users.vue
function Users_injectStyle (ssrContext) {
  __webpack_require__("ILpv")
}
var Users_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Users___vue_template_functional__ = false
/* styles */
var Users___vue_styles__ = Users_injectStyle
/* scopeId */
var Users___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Users___vue_module_identifier__ = null
var Users_Component = Users_normalizeComponent(
  Users_Users,
  pages_Users_Users,
  Users___vue_template_functional__,
  Users___vue_styles__,
  Users___vue_scopeId__,
  Users___vue_module_identifier__
)

/* harmony default export */ var src_pages_Users_Users = (Users_Component.exports);

// EXTERNAL MODULE: ./node_modules/superagent/lib/client.js
var client = __webpack_require__("GG98");
var client_default = /*#__PURE__*/__webpack_require__.n(client);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Login/Login.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Login = ({
  name: 'Login',
  data: function data() {
    return {
      form: {},
      showSpinner: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isWhiteLabel'])),
  methods: {
    login: function login() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var isValid, email, password;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validateAll();

              case 2:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                email = _this.form.email;
                password = _this.form.password;


                _this.showSpinner = true;

                client_default.a.post("https://api.nextlead.io" + '/login').set('Content-Type', 'application/json').send(stringify_default()({ email: email, password: password })).then(function (data) {
                  _this.$store.dispatch('login', data.body);

                  // go to the console
                  _this.$router.push({ path: '/' });
                }).catch(function (e) {
                  _this.$notify({
                    group: 'error',
                    type: 'error',
                    text: e.message
                  });
                }).finally(function () {
                  _this.showSpinner = false;
                });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d61fcd68","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-register"},[_c('notifications',{attrs:{"group":"error","position":"bottom right"}}),_vm._v(" "),(!_vm.isWhiteLabel)?_c('div',{staticClass:"container grid-list-md text-xs-center"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"login-box card shadow-sm"},[_c('div',{staticClass:"card-body"},[_c('form',{staticClass:"form-horizontal form-material",on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h3',{staticClass:"box-title m-b-20"},[_vm._v("Sign In")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model.trim",value:(_vm.form.email),expression:"form.email",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('email')},attrs:{"type":"text","name":"email","placeholder":"Email"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"invalid-feedback"},[_vm._v("\n              "+_vm._s(_vm.errors.first('email'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model.trim",value:(_vm.form.password),expression:"form.password",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('password')},attrs:{"type":"password","name":"password","placeholder":"Password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"invalid-feedback"},[_vm._v("\n              "+_vm._s(_vm.errors.first('password'))+"\n            ")])])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),(_vm.showSpinner)?_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke-width":"2","stroke-miterlimit":"10"}})]):_vm._e()])]),_vm._v(" "),(!_vm.isWhiteLabel)?_c('div',{staticClass:"container grid-list-md text-xs-center"},[_c('div',{staticClass:"layout align-center justify-center row"},[_c('span',{staticClass:"pr-2"},[_vm._v("Don't have an account?")]),_c('router-link',{attrs:{"to":"/signup"}},[_vm._v(" Sign up Now")])],1)]):_vm._e()],1)}
var Login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout align-center justify-center row"},[_c('img',{staticClass:"logo item",attrs:{"src":__webpack_require__("n5R8")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group text-center m-t-20"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light",attrs:{"type":"submit"}},[_vm._v("Sign In")])])])}]
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var Login_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/pages/Login/Login.vue
function Login_injectStyle (ssrContext) {
  __webpack_require__("k/Wj")
}
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = Login_injectStyle
/* scopeId */
var Login___vue_scopeId__ = "data-v-d61fcd68"
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  Login_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var pages_Login_Login = (Login_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Campaigns/Campaigns.gql
var Campaigns = __webpack_require__("oU2R");
var Campaigns_default = /*#__PURE__*/__webpack_require__.n(Campaigns);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Campaigns/Campaigns.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Campaigns_Campaigns = ({
  name: 'Campaigns',
  components: {
    DataTable: components_DataTable
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthUser', 'isUserAdmin', 'getCompany']), {
    isAdmin: function isAdmin() {
      return this.isUserAdmin;
    },
    campaigns: function campaigns() {
      return Campaigns_default.a;
    },
    surveyLink: function surveyLink() {
      return 'https://docs.google.com/forms/d/e/1FAIpQLSc2SoUSmtj80xFSCHfJ8qDYJaPCgDL0Gp3skfR4WmjkEpFoQw/viewform?usp=pp_url&entry.368622878=' + encodeURIComponent(this.getCompany.companyName) + '&entry.2039617643=' + encodeURIComponent(this.getAuthUser.email) + '&entry.1879569208=' + encodeURIComponent(this.getAuthUser.phone);
    },
    headers: function headers() {
      return [{ field: 'id', title: 'ID' }, { title: '', field: 'type' }, { title: '', field: 'status' }, {
        title: 'Campaign Name*',
        field: 'campaignName'
      }, { title: 'Company', field: 'companyName' }, { title: 'Email to*', field: 'dispatchTo' }, { title: 'Created', field: 'created' }, { title: 'Actions', field: 'actions', skipSorting: true }];
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a4e3f54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Campaigns/Campaigns.vue
var Campaigns_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('breadcrumbs'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(_vm.isAdmin)?_c('b-dropdown',{directives:[{name:"granted",rawName:"v-granted",value:('campaigns.create'),expression:"'campaigns.create'"}],staticClass:"float-right",attrs:{"text":"Create Campaign","variant":"info"}},[_c('b-dropdown-item',{attrs:{"to":{ name: 'NewShopifyCampaign' }}},[_vm._v("Shopify Campaign")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'NewCampaign' }}},[_vm._v("Lead Campaign")])],1):_c('a',{staticClass:"btn btn-info float-right",attrs:{"target":"_blank","href":_vm.surveyLink}},[_vm._v("Start New Campaign")]),_vm._v(" "),_c('h3',{staticClass:"card-title pb-3"},[_vm._v("Campaigns")]),_vm._v(" "),_c('DataTable',{attrs:{"columns":_vm.headers,"fieldName":"campaigns","query":_vm.campaigns,"placeholder":"Search by Campaign name"},scopedSlots:_vm._u([{key:"type",fn:function(props){return _c('span',{},[(props.row.type === 'shopify')?_c('i',{staticClass:"mdi mdi-cart text-inverse"}):_vm._e()])}},{key:"status",fn:function(props){return _c('span',{class:[props.row.status ? 'text-success' : '', 'text-danger']},[_c('i',{staticClass:"mdi mdi-checkbox-blank-circle"})])}},{key:"campaignName",fn:function(props){return _c('span',{},[_c('router-link',{attrs:{"to":{ name: 'CampaignDetails', params: { id: props.row.id } }}},[_vm._v(_vm._s(props.row.campaignName))])],1)}},{key:"companyName",fn:function(props){return _c('span',{},[_c('router-link',{attrs:{"to":{ name: 'EditCompany', params: { id: props.row.companyId } }}},[_vm._v(_vm._s(props.row.companyName))])],1)}},{key:"created",fn:function(props){return _c('span',{},[_vm._v(_vm._s(_vm._f("moment")(props.row.created,"MMM Do YYYY")))])}},{key:"actions",fn:function(props){return _c('span',{},[(_vm.isAdmin && props.row.type === 'shopify')?_c('router-link',{attrs:{"to":{ name: 'EditShopifyCampaign', params: { id: props.row.id } }}},[_c('i',{staticClass:"mdi mdi-pencil text-inverse m-r-10"})]):_vm._e(),_vm._v(" "),(_vm.isAdmin && props.row.type !== 'shopify')?_c('router-link',{attrs:{"to":{ name: 'EditCampaign', params: { id: props.row.id } }}},[_c('i',{staticClass:"mdi mdi-pencil text-inverse m-r-10"})]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('router-link',{directives:[{name:"granted",rawName:"v-granted",value:('users.find'),expression:"'users.find'"}],attrs:{"to":{ 
                  name: 'AssignUsers', 
                  params: { campaignId: props.row.id },
                  query: {companyId: props.row.companyId}
                }}},[_c('i',{staticClass:"mdi mdi-checkbox-marked-outline text-inverse"})]):_vm._e()],1)}}])})],1)])])])],1)}
var Campaigns_staticRenderFns = []
var Campaigns_esExports = { render: Campaigns_render, staticRenderFns: Campaigns_staticRenderFns }
/* harmony default export */ var pages_Campaigns_Campaigns = (Campaigns_esExports);
// CONCATENATED MODULE: ./src/pages/Campaigns/Campaigns.vue
var Campaigns_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Campaigns___vue_template_functional__ = false
/* styles */
var Campaigns___vue_styles__ = null
/* scopeId */
var Campaigns___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Campaigns___vue_module_identifier__ = null
var Campaigns_Component = Campaigns_normalizeComponent(
  Campaigns_Campaigns,
  pages_Campaigns_Campaigns,
  Campaigns___vue_template_functional__,
  Campaigns___vue_styles__,
  Campaigns___vue_scopeId__,
  Campaigns___vue_module_identifier__
)

/* harmony default export */ var src_pages_Campaigns_Campaigns = (Campaigns_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Companies/Companies.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Companies_Companies = ({
  name: 'Companies',
  components: {
    DataTable: components_DataTable
  },
  data: function data() {
    return {
      companies: Companies_default.a,
      headers: [{ field: 'id', title: 'Id' }, { title: 'Company Name', field: 'companyName' }, { title: 'Description', field: 'description' }, { title: 'Status', field: 'status' }, { title: 'Created', field: 'created' }, { title: 'Overdue', field: 'overdue' }, { title: 'Overdue Since', field: 'overdueSince' }, { title: 'Actions', field: 'actions', skipSorting: true }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90d98b02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Companies.vue
var Companies_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('breadcrumbs'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('router-link',{staticClass:"btn btn-info float-right",attrs:{"tag":"button","to":{ name: 'NewCompany' }}},[_vm._v("\n            Create Company\n          ")]),_vm._v(" "),_c('h3',{staticClass:"card-title pb-3"},[_vm._v("Companies")]),_vm._v(" "),_c('DataTable',{attrs:{"columns":_vm.headers,"fieldName":"companies","query":_vm.companies,"placeholder":"Search by Company name"},scopedSlots:_vm._u([{key:"companyName",fn:function(props){return _c('span',{},[_c('router-link',{attrs:{"to":{ name: 'EditCompany', params: { id: props.row.id } }}},[_vm._v("\n                "+_vm._s(props.row.companyName)+"\n              ")])],1)}},{key:"description",fn:function(props){return _c('span',{staticClass:"truncate"},[_vm._v("\n              "+_vm._s(props.row.description)+"\n            ")])}},{key:"created",fn:function(props){return _c('span',{},[_vm._v("\n              "+_vm._s(_vm._f("moment")(props.row.created,"MMM Do YYYY"))+"\n            ")])}},{key:"status",fn:function(props){return _c('span',{},[_vm._v("\n              "+_vm._s(props.row.status ? 'Active' : 'Inactive')+"\n            ")])}},{key:"overdue",fn:function(props){return _c('span',{},[_vm._v("\n              "+_vm._s(props.row.overdue ? 'Yes' : '')+"\n            ")])}},{key:"overdueSince",fn:function(props){return _c('span',{},[_vm._v("\n              "+_vm._s(_vm._f("moment")(props.row.overdueSince,"MMM Do YYYY"))+"\n            ")])}},{key:"actions",fn:function(props){return _c('span',{},[_c('router-link',{attrs:{"to":{ name: 'EditCompany', params: { id: props.row.id } }}},[_c('i',{staticClass:"mdi mdi-pencil text-inverse m-r-10"})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"mdi mdi-checkbox-marked-outline text-inverse"})])],1)}}])})],1)])])])],1)}
var Companies_staticRenderFns = []
var Companies_esExports = { render: Companies_render, staticRenderFns: Companies_staticRenderFns }
/* harmony default export */ var pages_Companies_Companies = (Companies_esExports);
// CONCATENATED MODULE: ./src/pages/Companies/Companies.vue
function Companies_injectStyle (ssrContext) {
  __webpack_require__("lsUh")
}
var Companies_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Companies___vue_template_functional__ = false
/* styles */
var Companies___vue_styles__ = Companies_injectStyle
/* scopeId */
var Companies___vue_scopeId__ = "data-v-90d98b02"
/* moduleIdentifier (server only) */
var Companies___vue_module_identifier__ = null
var Companies_Component = Companies_normalizeComponent(
  Companies_Companies,
  pages_Companies_Companies,
  Companies___vue_template_functional__,
  Companies___vue_styles__,
  Companies___vue_scopeId__,
  Companies___vue_module_identifier__
)

/* harmony default export */ var src_pages_Companies_Companies = (Companies_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__("Dc7M");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-switches/src/switches.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var switches = ({
    name: 'switches',

    props: {
        typeBold: {
            default: false
        },

        value: {
            default: false
        },

        disabled: {
            default: false
        },

        label: {
            default: ''
        },

        textEnabled: {
            default: ''
        },

        textDisabled: {
            default: ''
        },

        color: {
            default: 'default'
        },

        theme: {
            default: 'default'
        },

        emitOnMount: {
            default: true
        }
    },

    mounted: function mounted() {
        if (this.emitOnMount) {
            this.$emit('input', this.value);
        }
    },


    methods: {
        trigger: function trigger(e) {
            this.$emit('input', e.target.checked);
        }
    },

    computed: {
        classObject: function classObject() {
            var _ref;

            var color = this.color,
                value = this.value,
                theme = this.theme,
                typeBold = this.typeBold,
                disabled = this.disabled;


            return _ref = {
                'vue-switcher': true
            }, defineProperty_default()(_ref, 'vue-switcher--unchecked', !value), defineProperty_default()(_ref, 'vue-switcher--disabled', disabled), defineProperty_default()(_ref, 'vue-switcher--bold', typeBold), defineProperty_default()(_ref, 'vue-switcher--bold--unchecked', typeBold && !value), defineProperty_default()(_ref, 'vue-switcher-theme--' + theme, color), defineProperty_default()(_ref, 'vue-switcher-color--' + color, color), _ref;
        },
        shouldShowLabel: function shouldShowLabel() {
            return this.label !== '' || this.textEnabled !== '' || this.textDisabled !== '';
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e4870fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-switches/src/switches.vue
var switches_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classObject},[(_vm.shouldShowLabel)?_c('span',{staticClass:"vue-switcher__label"},[(_vm.label)?_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}):_vm._e(),_vm._v(" "),(!_vm.label && _vm.value)?_c('span',{domProps:{"textContent":_vm._s(_vm.textEnabled)}}):_vm._e(),_vm._v(" "),(!_vm.label && !_vm.value)?_c('span',{domProps:{"textContent":_vm._s(_vm.textDisabled)}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.trigger}}),_vm._v(" "),_c('div')])}
var switches_staticRenderFns = []
var switches_esExports = { render: switches_render, staticRenderFns: switches_staticRenderFns }
/* harmony default export */ var src_switches = (switches_esExports);
// CONCATENATED MODULE: ./node_modules/vue-switches/src/switches.vue
function switches_injectStyle (ssrContext) {
  __webpack_require__("fYSq")
}
var switches_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var switches___vue_template_functional__ = false
/* styles */
var switches___vue_styles__ = switches_injectStyle
/* scopeId */
var switches___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var switches___vue_module_identifier__ = null
var switches_Component = switches_normalizeComponent(
  switches,
  src_switches,
  switches___vue_template_functional__,
  switches___vue_styles__,
  switches___vue_scopeId__,
  switches___vue_module_identifier__
)

/* harmony default export */ var vue_switches_src_switches = (switches_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Companies/EditCompany.gql
var EditCompany = __webpack_require__("vcXL");
var EditCompany_default = /*#__PURE__*/__webpack_require__.n(EditCompany);

// EXTERNAL MODULE: ./src/graphql/Currencies/Currencies.gql
var Currencies = __webpack_require__("R8cP");
var Currencies_default = /*#__PURE__*/__webpack_require__.n(Currencies);

// EXTERNAL MODULE: ./src/graphql/Companies/CompanyPlan.gql
var CompanyPlan = __webpack_require__("JBko");
var CompanyPlan_default = /*#__PURE__*/__webpack_require__.n(CompanyPlan);

// EXTERNAL MODULE: ./src/graphql/Companies/EditCompanyPlan.gql
var EditCompanyPlan = __webpack_require__("/rWf");
var EditCompanyPlan_default = /*#__PURE__*/__webpack_require__.n(EditCompanyPlan);

// EXTERNAL MODULE: ./src/graphql/Transactions/Transactions.gql
var Transactions = __webpack_require__("BOTv");
var Transactions_default = /*#__PURE__*/__webpack_require__.n(Transactions);

// EXTERNAL MODULE: ./src/graphql/Billing/Billing.gql
var Billing = __webpack_require__("M18t");
var Billing_default = /*#__PURE__*/__webpack_require__.n(Billing);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Companies/CompanyDetails.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ var CompanyDetails = ({
  name: 'CompanyDetails',
  components: {
    Spinner: src_components_Spinner,
    Switches: vue_switches_src_switches,
    DataTable: components_DataTable
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      showSpinner: 0,
      currencies: [],
      isLoaded: false,
      plan: {
        balanceLimit: 0,
        newRequest: 0,
        dataPoint: 0,
        notes: 0,
        lead: 0,
        partialLead: 0,
        orderAmount: 0,
        orderPercent: 0
      },
      transactions: {
        headers: [{ field: 'id', title: 'Id' }, { title: 'Lead', field: 'leadId' }, { title: 'Date', field: 'created' }, { title: 'User', field: 'createdBy' }, { title: 'Description', field: 'notes' }, { title: 'Currency', field: 'currency' }, { title: 'Amount', field: 'amount' }],
        body: Transactions_default.a
      },
      billing: {
        headers: [{ title: 'Name', field: 'name' }, { title: 'Email', field: 'email' }, { title: 'Brand', field: 'brand' }, { title: 'Card', field: 'last4' }, { title: 'Exp. Date', field: 'exp' }, { title: 'Actions', field: 'actions', skipSorting: true }],
        body: Billing_default.a
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthUser', 'isUserAdmin', 'isUserClient', 'getCompany', 'getCompanyBalances']), {
    currencyObj: {
      get: function get() {
        var currencyId = this.currency || 0;
        var result = this.currencies.find(function (obj) {
          return +obj.id === +currencyId;
        });
        return result || {};
      }
    },
    currency: {
      get: function get() {
        return this.getCompany && this.getCompany.currency || '';
      },
      set: function set(currency) {
        this.setCompany(extends_default()({}, this.getCompany, { currency: currency }));
      }
    },
    balanceLimit: {
      get: function get() {
        return this.plan && this.plan.balanceLimit || '';
      },
      set: function set(val) {
        this.plan.balanceLimit = val;
      }
    },
    newRequest: {
      get: function get() {
        return this.plan && this.plan.newRequest || '';
      },
      set: function set(val) {
        this.plan.newRequest = val;
      }
    },
    dataPoint: {
      get: function get() {
        return this.plan && this.plan.dataPoint || '';
      },
      set: function set(val) {
        this.plan.dataPoint = val;
      }
    },
    notes: {
      get: function get() {
        return this.plan && this.plan.notes || '';
      },
      set: function set(val) {
        this.plan.notes = val;
      }
    },
    lead: {
      get: function get() {
        return this.plan && this.plan.lead || '';
      },
      set: function set(val) {
        this.plan.lead = val;
      }
    },
    partialLead: {
      get: function get() {
        return this.plan && this.plan.partialLead || '';
      },
      set: function set(val) {
        this.plan.partialLead = val;
      }
    },
    orderPercent: {
      get: function get() {
        return this.plan && this.plan.orderPercent || '';
      },
      set: function set(val) {
        this.plan.orderPercent = val;
      }
    },
    orderAmount: {
      get: function get() {
        return this.plan && this.plan.orderAmount || '';
      },
      set: function set(val) {
        this.plan.orderAmount = val;
      }
    },
    variables: function variables() {
      return {
        id: +this.id
      };
    },
    isClient: function isClient() {
      return this.isUserClient;
    },
    isAdmin: function isAdmin() {
      return this.isUserAdmin;
    },
    balances: function balances() {
      return this.getCompanyBalances;
    }
  }),
  mounted: function mounted() {
    this.fetchCompany(+this.$route.params.id);
    this.fetchCompanyBalances(+this.$route.params.id);
  },

  watch: {
    '$route.params.id': function $routeParamsId(newId) {
      this.fetchCompany(+newId);
      this.fetchCompanyBalances(+newId);
    }
  },
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(['setCompany']), Object(vuex_esm["b" /* mapActions */])(['fetchCompany', 'fetchCompanyBalances']), {
    onSubmit: function onSubmit(tab) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var valid;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(tab === 'onCompanyEdit')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return _this.$validator.validateAll();

              case 4:
                valid = _context.sent;

                if (valid) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return');

              case 7:
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return');

              case 12:

                _this[tab]();

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    onCompanyEdit: function onCompanyEdit() {
      var _this2 = this;

      this.apolloMutateRequest({
        mutation: EditCompany_default.a,
        variables: {
          id: this.id,
          input: omit_default()(this.getCompany, ['overdue', 'overdueSince', 'id'])
        },
        refetchQueries: function refetchQueries(_ref) {
          var data = _ref.data;

          var response = data.updateCompany;
          return response && response.success ? ['companies'] : [];
        },
        success: function success() {
          _this2.setCompany(_this2.getCompany);
          _this2.$notify({
            group: 'success',
            type: 'success',
            text: 'Company was edited'
          });
        },
        error: function error(e) {
          if (e.message.includes('ER_DUP_ENTRY')) {
            _this2.$validator.errors.add('companyName', 'This Company Name already exists');
          } else {
            _this2.$notify({
              group: 'error',
              type: 'error',
              text: e.message
            });
          }
        }
      });
    },
    onPlanEdit: function onPlanEdit() {
      var _this3 = this;

      this.apolloMutateRequest({
        mutation: EditCompanyPlan_default.a,
        variables: {
          id: this.id,
          input: {
            balanceLimit: parseFloat(this.plan.balanceLimit),
            newRequest: parseFloat(this.plan.newRequest),
            dataPoint: parseFloat(this.plan.dataPoint),
            notes: parseFloat(this.plan.notes),
            lead: parseFloat(this.plan.lead),
            partialLead: parseFloat(this.plan.partialLead),
            orderAmount: parseFloat(this.plan.orderAmount),
            orderPercent: parseFloat(this.plan.orderPercent)
          }
        },
        refetchQueries: function refetchQueries(_ref2) {
          var data = _ref2.data;

          var response = data.updatePlan;
          return response && response.success ? ['plan'] : [];
        },
        success: function success() {
          _this3.$notify({
            group: 'success',
            type: 'success',
            text: 'Plan was edited'
          });
        },
        error: function error(e) {
          _this3.$notify({
            group: 'error',
            type: 'error',
            text: e.message
          });
        }
      });
    },
    apolloMutateRequest: function apolloMutateRequest(options) {
      this.$apollo.mutate({
        mutation: options.mutation,
        variables: options.variables,
        refetchQueries: options.refetchQueries
      }).then(options.success).catch(options.error);
    },
    openTab: function openTab(tabName) {
      if (this.isLoaded && tabName !== 'transactions' && tabName !== 'billing') {
        this.$apollo.queries[tabName].refresh();
      }
      if (tabName === 'transactions') {
        this.$refs.transactionTable.onRefreshData();
      }
      if (tabName === 'billing') {
        this.$refs.billingTable.onRefreshData();
      }
    },
    setDefaultCard: function setDefaultCard(stripeSourceId) {
      var _this4 = this;

      this.setCompany(extends_default()({}, this.getCompany, { stripeSourceId: stripeSourceId }));
      this.apolloMutateRequest({
        mutation: EditCompany_default.a,
        variables: {
          id: this.id,
          input: omit_default()(this.getCompany, ['overdue', 'overdueSince', 'id'])
        },
        error: function error(e) {
          _this4.$notify({
            group: 'error',
            type: 'error',
            text: e.message
          });
        }
      });
    }
  }),
  apollo: {
    currencies: {
      query: Currencies_default.a,
      fetchPolicy: 'cache-and-network',
      result: function result(_ref3) {
        var data = _ref3.data,
            loading = _ref3.loading;

        if (!loading) {
          this.currencies = data.currencies;
        }
      }
    },
    plan: {
      query: CompanyPlan_default.a,
      fetchPolicy: 'cache-and-network',
      variables: function variables() {
        return {
          id: +this.id
        };
      },
      result: function result(_ref4) {
        var data = _ref4.data,
            loading = _ref4.loading;

        if (!loading) {
          this.plan = {
            balanceLimit: data.plan && data.plan.balanceLimit,
            newRequest: data.plan && data.plan.newRequest,
            dataPoint: data.plan && data.plan.dataPoint,
            notes: data.plan && data.plan.notes,
            lead: data.plan && data.plan.lead,
            partialLead: data.plan && data.plan.partialLead,
            orderPercent: data.plan && data.plan.orderPercent,
            orderAmount: data.plan && data.plan.orderAmount
          };
        }
      },
      skip: function skip() {
        return !this.id;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0713d400","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/CompanyDetails.vue
var CompanyDetails_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[(_vm.isAdmin)?_c('breadcrumbs',{attrs:{"current":_vm.getCompany.companyName}}):_vm._e(),_vm._v(" "),(_vm.showSpinner)?_c('div',{staticClass:"spinner-wrap"},[_c('spinner')],1):_vm._e(),_vm._v(" "),(!_vm.showSpinner)?_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"d-flex no-block justify-center"},[_c('h4',{staticClass:"font-medium text-inverse"},[_vm._v(_vm._s(_vm.getCompany.companyName))]),_vm._v(" "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('span',[_vm._v("Balance:")]),_vm._v(" "),_vm._l((_vm.balances),function(balance,index){return _c('span',{key:index,staticClass:"pl-0 mt-2"},[_c('span',{staticClass:"h6 ml-2",class:{ 'text-danger': balance.balance < 0 }},[_vm._v(_vm._s(_vm._f("currency")(balance.balance)))]),_vm._v(" "),(_vm.balances.length > index+1)?_c('span',[_vm._v(",")]):_vm._e()])})],2)])]),_vm._v(" "),_c('b-tabs',{attrs:{"nav-class":"customtab"}},[_c('reoute-tab',{staticClass:"card-body",attrs:{"name":"detail","title":"Detail","active":""},on:{"click":function($event){return _vm.openTab('company')}}},[_c('form',[_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"id":"campanyName","label":"Company name","label-for":"campanyName"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.getCompany.companyName),expression:"getCompany.companyName",modifiers:{"trim":true}},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('companyName')},attrs:{"id":"campanyName","type":"text","placeholder":"Enter company name","data-vv-as":"Company Name","name":"companyName","autofocus":""},domProps:{"value":(_vm.getCompany.companyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getCompany, "companyName", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('companyName')),expression:"errors.has('companyName')"}],staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.first('companyName')))])]),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"id":"website","label":"Website","label-for":"website"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getCompany.website),expression:"getCompany.website"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('website')},attrs:{"id":"website","type":"text","placeholder":"Enter website","data-vv-as":"Website","name":"website"},domProps:{"value":(_vm.getCompany.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getCompany, "website", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('website')),expression:"errors.has('website')"}],staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.first('website')))])]),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"id":"address","label":"Address","label-for":"address"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.getCompany.address),expression:"getCompany.address"}],staticClass:"form-control main-textarea",attrs:{"rows":"3","placeholder":"Enter address"},domProps:{"value":(_vm.getCompany.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getCompany, "address", $event.target.value)}}})]),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"id":"description","label":"Description","label-for":"description"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.getCompany.description),expression:"getCompany.description"}],staticClass:"form-control main-textarea",attrs:{"rows":"3","placeholder":"Enter description"},domProps:{"value":(_vm.getCompany.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getCompany, "description", $event.target.value)}}})]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"currency"}},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-md-3"},[_vm._v("Currency")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currency),expression:"currency"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('currency')},attrs:{"id":"company-filter","name":"currency","data-vv-as":"Currency","disabled":!_vm.isAdmin},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currency=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"","disabled":"","value":""}},[_vm._v("Select currency")]),_vm._v(" "),_vm._l((_vm.currencies),function(curr){return _c('option',{key:curr.id,domProps:{"value":+curr.id}},[_vm._v(_vm._s(curr.name))])})],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('currency')),expression:"errors.has('currency')"}],staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.first('currency')))])])])]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"status"}},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-md-3"},[_vm._v("Active")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('switches',{attrs:{"color":"green"},model:{value:(_vm.getCompany.status),callback:function ($$v) {_vm.$set(_vm.getCompany, "status", $$v)},expression:"getCompany.status"}})],1)])]),_vm._v(" "),_c('b-form-group',[_c('div',{},[_c('button',{staticClass:"btn btn-info text-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.onSubmit('onCompanyEdit')}}},[_vm._v("Save")])])])],1)]),_vm._v(" "),_c('reoute-tab',{staticClass:"card-body",attrs:{"name":"plan","title":"Plan","id":"tab-plan"},on:{"click":function($event){return _vm.openTab('plan')}}},[_c('form',{staticStyle:{"max-width":"400px"}},[_c('div',{staticClass:"row pb-4 pt-3"},[_c('div',{staticClass:"col-md-7"},[_vm._v("Currency")]),_vm._v(" "),_c('div',{staticClass:"col-md-5 text-info"},[_vm._v(_vm._s(_vm.currencyObj.name)+" ("+_vm._s(_vm.currencyObj.code)+")")])]),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"balanceLimit","label":"Balance Limit","label-for":"balanceLimit"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("$")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.balanceLimit),expression:"balanceLimit"}],staticClass:"form-control",attrs:{"id":"balanceLimit","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter amount","name":"balanceLimit","autofocus":""},domProps:{"value":(_vm.balanceLimit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.balanceLimit=$event.target.value}}})])]),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"newRequestPrice","label":"Price per New Request","label-for":"newRequestPrice"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("$")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newRequest),expression:"newRequest"}],staticClass:"form-control",attrs:{"id":"newRequestPrice","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter amount"},domProps:{"value":(_vm.newRequest)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newRequest=$event.target.value}}})])]),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"dataPointPrice","label":"Price per Data Point","label-for":"dataPointPrice"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("$")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataPoint),expression:"dataPoint"}],staticClass:"form-control",attrs:{"id":"dataPointPrice","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter amount"},domProps:{"value":(_vm.dataPoint)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dataPoint=$event.target.value}}})])]),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"notesPrice","label":"Price per Notes","label-for":"notesPrice"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("$")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notes),expression:"notes"}],staticClass:"form-control",attrs:{"id":"notesPrice","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter amount"},domProps:{"value":(_vm.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notes=$event.target.value}}})])]),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"completedLeadPrice","label":"Price per Completed Lead","label-for":"completedLeadPrice"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("$")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lead),expression:"lead"}],staticClass:"form-control",attrs:{"id":"completedLeadPrice","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter amount"},domProps:{"value":(_vm.lead)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lead=$event.target.value}}})])]),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"partialLeadPrice","label":"Price per Partial Lead","label-for":"partialLeadPrice"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("$")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.partialLead),expression:"partialLead"}],staticClass:"form-control",attrs:{"id":"partialLeadPrice","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter amount"},domProps:{"value":(_vm.partialLead)},on:{"input":function($event){if($event.target.composing){ return; }_vm.partialLead=$event.target.value}}})])]),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"orderAmount","label":"Amount per Order","label-for":"partialLeadPrice"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("$")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderAmount),expression:"orderAmount"}],staticClass:"form-control",attrs:{"id":"orderAmount","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter amount"},domProps:{"value":(_vm.orderAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.orderAmount=$event.target.value}}})])]),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"orderPercent","label":"Percent per Order","label-for":"partialLeadPrice"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("%")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderPercent),expression:"orderPercent"}],staticClass:"form-control",attrs:{"id":"orderPercent","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter percent"},domProps:{"value":(_vm.orderPercent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.orderPercent=$event.target.value}}})])]),_vm._v(" "),_c('b-form-group',[_c('div',{},[(_vm.isAdmin)?_c('button',{staticClass:"btn btn-info text-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.onSubmit('onPlanEdit')}}},[_vm._v("Save")]):_vm._e()])])],1)]),_vm._v(" "),_c('reoute-tab',{staticClass:"card-body",attrs:{"name":"transactions","id":"tab-transactions","title":"Transactions"},on:{"click":function($event){return _vm.openTab('transactions')}}},[_c('div',[(_vm.isAdmin)?_c('router-link',{staticClass:"btn btn-info float-right",attrs:{"tag":"button","to":{ name: 'NewTransaction' }}},[_c('i',{staticClass:"mdi mdi-plus"}),_vm._v(" New Transaction\n            ")]):_vm._e()],1),_vm._v(" "),_c('DataTable',{ref:"transactionTable",attrs:{"columns":_vm.transactions.headers,"fieldName":"transactions","query":_vm.transactions.body,"params":{companyId: +_vm.id},"placeholder":"Search by Transaction amount"},scopedSlots:_vm._u([{key:"id",fn:function(props){return _c('span',{},[_vm._v(_vm._s(props.row.id))])}},{key:"leadId",fn:function(props){return _c('span',{},[_c('router-link',{attrs:{"to":{ name: 'LeadDetails', params: { id: props.row.leadId } }},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(props.row.leadId))])],1)}},{key:"created",fn:function(props){return _c('span',{},[_vm._v(_vm._s(_vm._f("moment")(props.row.created,"MMM Do YYYY, h:mm:ss a")))])}},{key:"createdBy",fn:function(props){return _c('span',{},[_vm._v(_vm._s(props.row.createdBy))])}},{key:"notes",fn:function(props){return _c('span',{},[_vm._v(_vm._s(props.row.notes))])}},{key:"currency",fn:function(props){return _c('div',{staticClass:"text-center"},[_vm._v(_vm._s(props.row.currency || '----'))])}},{key:"amount",fn:function(props){return _c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(props.row.amount)))])}}],null,false,3933579016)})],1),_vm._v(" "),_c('reoute-tab',{staticClass:"card-body",attrs:{"name":"billing","title":"Billing"},on:{"click":function($event){return _vm.openTab('billing')}}},[_c('div',[_c('router-link',{staticClass:"btn btn-info float-right",attrs:{"tag":"button","to":{ name: 'NewCard' }}},[_c('i',{staticClass:"mdi mdi-plus"}),_vm._v(" Add New Card\n            ")])],1),_vm._v(" "),_c('DataTable',{ref:"billingTable",attrs:{"columns":_vm.billing.headers,"fieldName":"billing","query":_vm.billing.body,"hideSearch":true,"variables":_vm.variables},scopedSlots:_vm._u([{key:"last4",fn:function(props){return _c('div',{staticClass:"las4"},[_vm._v(".."+_vm._s(props.row.last4))])}},{key:"actions",fn:function(props){return _c('div',{staticClass:"actions"},[(_vm.isAdmin)?_c('router-link',{staticClass:"btn btn-success btn-sm",attrs:{"tag":"button","to":{ name: 'NewPayment', query: { cardId: props.row.id, cardNumber: props.row.last4 } }}},[_vm._v("Pay With")]):_vm._e(),_vm._v(" "),(props.row.id !== _vm.getCompany.stripeSourceId)?_c('button',{staticClass:"btn btn-inverse btn-sm",on:{"click":function($event){return _vm.setDefaultCard(props.row.id)}}},[_vm._v("Make Default")]):_c('div',[_vm._v("Default Card")])],1)}}],null,false,1237595941)})],1)],1)],1)]):_vm._e()],1)}
var CompanyDetails_staticRenderFns = []
var CompanyDetails_esExports = { render: CompanyDetails_render, staticRenderFns: CompanyDetails_staticRenderFns }
/* harmony default export */ var Companies_CompanyDetails = (CompanyDetails_esExports);
// CONCATENATED MODULE: ./src/pages/Companies/CompanyDetails.vue
function CompanyDetails_injectStyle (ssrContext) {
  __webpack_require__("K7Rd")
}
var CompanyDetails_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CompanyDetails___vue_template_functional__ = false
/* styles */
var CompanyDetails___vue_styles__ = CompanyDetails_injectStyle
/* scopeId */
var CompanyDetails___vue_scopeId__ = "data-v-0713d400"
/* moduleIdentifier (server only) */
var CompanyDetails___vue_module_identifier__ = null
var CompanyDetails_Component = CompanyDetails_normalizeComponent(
  CompanyDetails,
  Companies_CompanyDetails,
  CompanyDetails___vue_template_functional__,
  CompanyDetails___vue_styles__,
  CompanyDetails___vue_scopeId__,
  CompanyDetails___vue_module_identifier__
)

/* harmony default export */ var pages_Companies_CompanyDetails = (CompanyDetails_Component.exports);

// EXTERNAL MODULE: ./node_modules/sweetalert2/dist/sweetalert2.all.js
var sweetalert2_all = __webpack_require__("e7x4");
var sweetalert2_all_default = /*#__PURE__*/__webpack_require__.n(sweetalert2_all);

// EXTERNAL MODULE: ./node_modules/vue2-simplert/dist/simplert.umd.js
var simplert_umd = __webpack_require__("1S+A");
var simplert_umd_default = /*#__PURE__*/__webpack_require__.n(simplert_umd);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ConfirmButton.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ConfirmButton = ({
  name: 'confirm-button',
  components: {
    Simplert: simplert_umd_default.a
  },
  props: {
    title: {
      type: String,
      default: 'Are you sure?'
    },
    message: {
      type: String,
      default: 'You will not be able to restore it!'
    },
    data: [Object, String, Number]
  },

  data: function data() {
    return {
      isVisible: true
    };
  },


  methods: {
    openConfirm: function openConfirm() {
      var _this = this;

      this.$refs.simplert.openSimplert({
        title: this.title,
        message: this.message,
        customConfirmBtnText: 'Yes, delete it!',
        customCloseBtnText: 'No, keep it',
        type: 'info',
        useConfirmBtn: true,
        onConfirm: function onConfirm() {
          return _this.$emit('confirm', _this.data);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ae4e5ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmButton.vue
var ConfirmButton_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"userIcon":true}}),_vm._v(" "),_c('i',{staticClass:"mdi mdi-delete remove-button",on:{"click":_vm.openConfirm}})],1)}
var ConfirmButton_staticRenderFns = []
var ConfirmButton_esExports = { render: ConfirmButton_render, staticRenderFns: ConfirmButton_staticRenderFns }
/* harmony default export */ var components_ConfirmButton = (ConfirmButton_esExports);
// CONCATENATED MODULE: ./src/components/ConfirmButton.vue
function ConfirmButton_injectStyle (ssrContext) {
  __webpack_require__("Iw3e")
  __webpack_require__("TutB")
}
var ConfirmButton_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ConfirmButton___vue_template_functional__ = false
/* styles */
var ConfirmButton___vue_styles__ = ConfirmButton_injectStyle
/* scopeId */
var ConfirmButton___vue_scopeId__ = "data-v-0ae4e5ec"
/* moduleIdentifier (server only) */
var ConfirmButton___vue_module_identifier__ = null
var ConfirmButton_Component = ConfirmButton_normalizeComponent(
  ConfirmButton,
  components_ConfirmButton,
  ConfirmButton___vue_template_functional__,
  ConfirmButton___vue_styles__,
  ConfirmButton___vue_scopeId__,
  ConfirmButton___vue_module_identifier__
)

/* harmony default export */ var src_components_ConfirmButton = (ConfirmButton_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CustomInput.vue

/* harmony default export */ var CustomInput = ({
  name: 'custom-input',
  data: function data() {
    return {
      value: ''
    };
  },

  props: {
    name: String,
    defaultValue: {
      type: String,
      default: ''
    },
    isValid: Boolean,
    modelValue: {
      type: [String, Object]
    },
    type: String
  },
  watch: {
    modelValue: function modelValue() {
      this.value = this.modelValue;
    }
  },
  model: {
    prop: 'modelValue'
  },
  mounted: function mounted() {
    if (this.defaultValue !== undefined && !(this.defaultValue === this.modelValue && this.modelValue === '')) {
      this.value = this.defaultValue;
      return this.$emit('input', this.defaultValue);
    }
  },
  render: function render(h) {
    var self = this;

    return h('input', {
      attrs: this.$attrs,
      props: this.$props,
      class: {
        'is-invalid': !this.$props.isValid
      },
      on: {
        input: function input(event) {
          self.value = event.target.value;
          self.$emit('input', self.value);
        }
      },
      domProps: { value: self.modelValue }
    });
  }
});
// CONCATENATED MODULE: ./src/components/CustomInput.vue
function CustomInput_injectStyle (ssrContext) {
  __webpack_require__("wE0Q")
}
var CustomInput_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var CustomInput___vue_template__ = null
/* template functional */
var CustomInput___vue_template_functional__ = false
/* styles */
var CustomInput___vue_styles__ = CustomInput_injectStyle
/* scopeId */
var CustomInput___vue_scopeId__ = "data-v-6c8a18e8"
/* moduleIdentifier (server only) */
var CustomInput___vue_module_identifier__ = null
var CustomInput_Component = CustomInput_normalizeComponent(
  CustomInput,
  CustomInput___vue_template__,
  CustomInput___vue_template_functional__,
  CustomInput___vue_styles__,
  CustomInput___vue_scopeId__,
  CustomInput___vue_module_identifier__
)

/* harmony default export */ var components_CustomInput = (CustomInput_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DraggableFileInput.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DraggableFileInput = ({
  props: {
    uploadButtonText: {
      type: String,
      default: 'Upload file'
    },
    accept: {
      type: String,
      default: 'image/*'
    }
  },
  data: function data() {
    return {
      readyToLoad: false
    };
  },

  methods: {
    setReadyToLoad: function setReadyToLoad(readyToLoad) {
      this.readyToLoad = readyToLoad;
    },
    openFilesModal: function openFilesModal() {
      this.$refs.fileInput.click();
    },
    updateFiles: function updateFiles(files) {
      this.readyToLoad = false;
      this.$emit('input', files);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1428043f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DraggableFileInput.vue
var DraggableFileInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-info",on:{"click":_vm.openFilesModal}},[_c('i',{staticClass:"mdi mdi-cloud-upload"}),_vm._v(" "+_vm._s(_vm.uploadButtonText)+"\n  ")]),_vm._v(" "),_c('section',{staticClass:"files-drag-zone",class:{ 'files-drag-zone--dragover': _vm.readyToLoad },on:{"drop":function($event){$event.preventDefault();$event.stopPropagation();return _vm.updateFiles($event.dataTransfer.files)},"dragover":function($event){$event.preventDefault();$event.stopPropagation();return _vm.setReadyToLoad(true)},"dragleave":function($event){$event.preventDefault();$event.stopPropagation();return _vm.setReadyToLoad(false)}}},[_vm._t("default")],2),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"hidden":"","multiple":"","type":"file","accept":_vm.accept},on:{"input":function($event){return _vm.updateFiles($event.target.files)}}})])}
var DraggableFileInput_staticRenderFns = []
var DraggableFileInput_esExports = { render: DraggableFileInput_render, staticRenderFns: DraggableFileInput_staticRenderFns }
/* harmony default export */ var components_DraggableFileInput = (DraggableFileInput_esExports);
// CONCATENATED MODULE: ./src/components/DraggableFileInput.vue
function DraggableFileInput_injectStyle (ssrContext) {
  __webpack_require__("7c67")
}
var DraggableFileInput_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DraggableFileInput___vue_template_functional__ = false
/* styles */
var DraggableFileInput___vue_styles__ = DraggableFileInput_injectStyle
/* scopeId */
var DraggableFileInput___vue_scopeId__ = "data-v-1428043f"
/* moduleIdentifier (server only) */
var DraggableFileInput___vue_module_identifier__ = null
var DraggableFileInput_Component = DraggableFileInput_normalizeComponent(
  DraggableFileInput,
  components_DraggableFileInput,
  DraggableFileInput___vue_template_functional__,
  DraggableFileInput___vue_styles__,
  DraggableFileInput___vue_scopeId__,
  DraggableFileInput___vue_module_identifier__
)

/* harmony default export */ var src_components_DraggableFileInput = (DraggableFileInput_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Campaigns/Files.gql
var Files = __webpack_require__("oFuQ");
var Files_default = /*#__PURE__*/__webpack_require__.n(Files);

// EXTERNAL MODULE: ./src/graphql/Campaigns/DeleteFile.gql
var DeleteFile = __webpack_require__("YRmT");
var DeleteFile_default = /*#__PURE__*/__webpack_require__.n(DeleteFile);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Campaigns/Details/Files.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Details_Files = ({
  components: {
    DraggableFileInput: src_components_DraggableFileInput,
    Spinner: src_components_Spinner
  },
  props: {
    campaignId: Number
  },
  data: function data() {
    return {
      files: [],
      loading: 0,
      activeIndex: -1
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthToken'])),
  methods: {
    fileQuery: function fileQuery(file) {
      return extends_default()({}, this.$route.query, {
        url: file.url,
        name: file.name
      });
    },
    setFilesUpload: function setFilesUpload(filesToUpload) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var newFiles, uploadedFiles;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (filesToUpload.length) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                newFiles = [].concat(toConsumableArray_default()(filesToUpload));

                _this.files = _this.files.concat(newFiles);
                _context.next = 6;
                return _this.uploadFiles(newFiles);

              case 6:
                uploadedFiles = _context.sent;

                _this.files = _this.files.filter(function (f) {
                  return !_this.isNativeFile(f);
                }).concat(uploadedFiles);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setActiveIndex: function setActiveIndex(activeIndex) {
      this.activeIndex = activeIndex;
    },
    isNativeFile: function isNativeFile(file) {
      return file instanceof File;
    },
    uploadFiles: function uploadFiles(files) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var data, response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = new FormData();

                files.forEach(function (file) {
                  return data.append('files[]', file, file.name);
                });
                _context2.next = 4;
                return client_default.a.post("https://api.nextlead.io" + '/upload-files/' + _this2.$route.params.id).set('Authorization', _this2.getAuthToken).send(data);

              case 4:
                response = _context2.sent;
                return _context2.abrupt('return', response.body);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    deleteFile: function deleteFile(fileId) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _ref, isConfirmed;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return sweetalert2_all_default()({
                  title: 'Are you sure?',
                  text: "You won't be able to revert this!",
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, delete it!'
                });

              case 2:
                _ref = _context3.sent;
                isConfirmed = _ref.value;

                if (isConfirmed) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt('return');

              case 6:
                _this3.files = _this3.files.filter(function (f) {
                  return f.id !== fileId;
                });
                _this3.$apollo.mutate({
                  mutation: DeleteFile_default.a,
                  variables: { fileId: fileId }
                });

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    copyLinkToBuffer: function copyLinkToBuffer(text) {
      var input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$notify({
        type: 'success',
        group: 'success',
        text: 'Link was copied to clipboard'
      });
    }
  },
  apollo: {
    files: {
      query: Files_default.a,
      loadingKey: 'loading',
      fetchPolicy: 'network-only',
      variables: function variables() {
        return {
          campaignId: this.campaignId
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0257d433","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Campaigns/Details/Files.vue
var Files_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable-file-input',{on:{"input":_vm.setFilesUpload}},[(_vm.loading != 0)?_c('spinner'):(_vm.files.length)?_c('ul',{staticClass:"files"},_vm._l((_vm.files),function(file){return _c('li',{staticClass:"image-item"},[(_vm.isNativeFile(file))?_c('b-progress',{staticClass:"loading-bar",attrs:{"animated":""}},[_c('b-progress-bar',{attrs:{"value":100,"variant":"success"}},[_c('span',{staticClass:"file-name"},[_vm._v(_vm._s(file.name))])])],1):_c('div',{key:file.id,staticClass:"image",style:(("background-image: url(" + (file.url) + ")")),on:{"mouseover":function($event){return _vm.setActiveIndex(file.id)}}}),_vm._v(" "),(_vm.activeIndex === file.id)?_c('div',{staticClass:"actions",on:{"mouseover":function($event){return _vm.setActiveIndex(file.id)},"mouseout":function($event){return _vm.setActiveIndex(-1)}}},[_c('router-link',{attrs:{"tag":"button","to":{ name: 'FileModal', query: _vm.fileQuery(file) }}},[_c('i',{staticClass:"mdi mdi-magnify-plus"})]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.copyLinkToBuffer(file.url)}}},[_c('i',{staticClass:"mdi mdi-link-variant"})]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.deleteFile(file.id)}}},[_c('i',{staticClass:"mdi mdi-delete"})])],1):_vm._e()],1)}),0):_vm._e()],1)}
var Files_staticRenderFns = []
var Files_esExports = { render: Files_render, staticRenderFns: Files_staticRenderFns }
/* harmony default export */ var Campaigns_Details_Files = (Files_esExports);
// CONCATENATED MODULE: ./src/pages/Campaigns/Details/Files.vue
function Files_injectStyle (ssrContext) {
  __webpack_require__("qpFb")
}
var Files_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Files___vue_template_functional__ = false
/* styles */
var Files___vue_styles__ = Files_injectStyle
/* scopeId */
var Files___vue_scopeId__ = "data-v-0257d433"
/* moduleIdentifier (server only) */
var Files___vue_module_identifier__ = null
var Files_Component = Files_normalizeComponent(
  Details_Files,
  Campaigns_Details_Files,
  Files___vue_template_functional__,
  Files___vue_styles__,
  Files___vue_scopeId__,
  Files___vue_module_identifier__
)

/* harmony default export */ var pages_Campaigns_Details_Files = (Files_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("+6Bu");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// EXTERNAL MODULE: ./node_modules/uuid/v1.js
var v1 = __webpack_require__("gApy");
var v1_default = /*#__PURE__*/__webpack_require__.n(v1);

// EXTERNAL MODULE: ./src/graphql/Webhooks/Webhook.gql
var Webhook = __webpack_require__("GQbz");
var Webhook_default = /*#__PURE__*/__webpack_require__.n(Webhook);

// EXTERNAL MODULE: ./src/graphql/Webhooks/Types.gql
var Types = __webpack_require__("uib0");
var Types_default = /*#__PURE__*/__webpack_require__.n(Types);

// EXTERNAL MODULE: ./src/graphql/Webhooks/CreateOrUpdateWebhook.gql
var CreateOrUpdateWebhook = __webpack_require__("AxLj");
var CreateOrUpdateWebhook_default = /*#__PURE__*/__webpack_require__.n(CreateOrUpdateWebhook);

// EXTERNAL MODULE: ./src/graphql/Questions/QuestionsCompact.gql
var QuestionsCompact = __webpack_require__("Psz0");
var QuestionsCompact_default = /*#__PURE__*/__webpack_require__.n(QuestionsCompact);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Campaigns/Details/Webhook.vue








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Details_Webhook = ({
  components: {
    Switches: vue_switches_src_switches
  },
  props: {
    campaignId: {
      type: Number,
      required: true
    }
  },
  computed: {
    webhookParamsTypes: function webhookParamsTypes() {
      return [{ value: 'form', text: 'Lead Form Field' }, { value: 'others', text: 'Other Lead Data' }, { value: 'string', text: 'String' }, { value: 'path', text: 'Lead Data Path' }];
    },
    webhookOtherValues: function webhookOtherValues() {
      return [{ value: 'leadId', text: 'Lead ID' }, { value: 'campaignId', text: 'Campaign ID' }, { value: 'visitorInput', text: 'Visitor Input' }, { value: 'agentNotes', text: 'Agent Notes' }];
    }
  },
  data: function data() {
    return {
      webhook: {
        isEnabled: false,
        url: '',
        type: null,
        params: [{ id: v1_default()(), name: '', type: 'string', initialValueOpts: {}, value: '' }]
      },
      webhookTypes: [],
      questions: []
    };
  },

  methods: {
    getParamValueError: function getParamValueError(index) {
      return this.webhook.params[index].type === 'Form Field' && !this.questions.length ? 'Add questions to select this option or select other type in the row.' : this.errors.first('paramValue' + index);
    },
    addParam: function addParam() {
      this.webhook.params = [].concat(toConsumableArray_default()(this.webhook.params), [{ id: v1_default()(), name: '', type: 'Form Field', initialValueOpts: {}, value: '' }]);
    },
    createOrUpdateWebhook: function createOrUpdateWebhook() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _webhook, type, params, data, newParams;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _webhook = _this.webhook, type = _webhook.type, params = _webhook.params, data = objectWithoutProperties_default()(_webhook, ['type', 'params']);
                newParams = params.map(function (param) {
                  var value = param.value,
                      initialValueOpts = param.initialValueOpts,
                      rest = objectWithoutProperties_default()(param, ['value', 'initialValueOpts']);

                  if ((typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object') {
                    return extends_default()({ value: stringify_default()(value) }, rest);
                  }
                  return extends_default()({ value: value }, rest);
                });
                _context.prev = 2;
                _context.next = 5;
                return _this.$apollo.mutate({
                  mutation: CreateOrUpdateWebhook_default.a,
                  variables: {
                    campaignId: _this.campaignId,
                    webhook: extends_default()({}, data, { typeId: type.id, params: newParams })
                  }
                });

              case 5:
                _this.$notify({
                  group: 'success',
                  type: 'success',
                  text: 'Saved'
                });
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                _this.$notify({
                  group: 'error',
                  type: 'error',
                  text: _context.t0.message
                });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 8]]);
      }))();
    },
    removeParam: function removeParam(index) {
      this.webhook.params = this.webhook.params.filter(function (_, i) {
        return i !== index;
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var valid;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                valid = _context2.sent;

                if (valid) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return');

              case 6:
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);
                return _context2.abrupt('return');

              case 11:
                _context2.prev = 11;
                _context2.next = 14;
                return _this2.createOrUpdateWebhook();

              case 14:
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t1 = _context2['catch'](11);

                _this2.$notify({
                  group: 'error',
                  type: 'error',
                  text: _context2.t1.message
                });

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8], [11, 16]]);
      }))();
    }
  },
  apollo: {
    webhookTypes: {
      query: Types_default.a,
      fetchPolicy: 'network-only',
      result: function result(_ref) {
        var data = _ref.data,
            loading = _ref.loading;

        if (!loading) {
          this.webhookTypes = data.webhookTypes.map(function (_ref2) {
            var id = _ref2.id,
                type = _ref2.type;
            return {
              text: type,
              value: {
                id: id,
                type: type,
                __typename: 'WebhookType'
              }
            };
          });
        }
      }
    },
    webhook: {
      query: Webhook_default.a,
      fetchPolicy: 'network-only',
      loadingKey: 'showSpinner',
      variables: function variables() {
        return {
          campaignId: this.campaignId
        };
      },
      update: function update(data) {
        if (data.webhook.id === null) {
          return this.webhook;
        }
        var _data$webhook = data.webhook,
            isEnabled = _data$webhook.isEnabled,
            url = _data$webhook.url,
            type = _data$webhook.type,
            params = _data$webhook.params;

        var newParams = params.map(function (param) {
          var type = param.type,
              value = param.value,
              __typename = param.__typename,
              rest = objectWithoutProperties_default()(param, ['type', 'value', '__typename']);

          var newValue = value;

          try {
            newValue = JSON.parse(value);
          } catch (e) {
            newValue = value;
          }

          var initialValueOpts = defineProperty_default()({}, type, newValue);

          return extends_default()({ type: type, value: newValue, initialValueOpts: initialValueOpts }, rest);
        });

        return { isEnabled: isEnabled, url: url, type: type, params: [].concat(toConsumableArray_default()(newParams)) };
      }
    },
    questions: {
      query: QuestionsCompact_default.a,
      fetchPolicy: 'network-only',
      variables: function variables() {
        return {
          where: stringify_default()({ campaignId: +this.campaignId })
        };
      },
      result: function result(_ref3) {
        var data = _ref3.data,
            loading = _ref3.loading;

        if (!loading) {
          this.questions = data.questions.result.map(function (_ref4) {
            var id = _ref4.id,
                fieldName = _ref4.fieldName;
            return {
              id: id,
              fieldName: fieldName
            };
          });
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-955b7b9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Campaigns/Details/Webhook.vue
var Webhook_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-body"},[_c('div',{staticClass:"form-group row"},[(_vm.webhook.isEnabled)?_c('label',{staticClass:"col-sm-6 col-md-2"},[_vm._v("Enabled")]):_c('label',{staticClass:"col-sm-6 col-md-2 text-danger"},[_vm._v("Disabled")]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-sm-12"},[_c('switches',{attrs:{"color":"green"},model:{value:(_vm.webhook.isEnabled),callback:function ($$v) {_vm.$set(_vm.webhook, "isEnabled", $$v)},expression:"webhook.isEnabled"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-6 col-md-2"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"type","name":"type","options":_vm.webhookTypes,"isValid":!_vm.errors.has('type'),"data-vv-as":"Type"},model:{value:(_vm.webhook.type),callback:function ($$v) {_vm.$set(_vm.webhook, "type", $$v)},expression:"webhook.type"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('type')),expression:"errors.has('type')"}],staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors.first('type')))])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-6 col-md-2"},[_vm._v("URL")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.webhook.url),expression:"webhook.url"},{name:"validate",rawName:"v-validate",value:('required|url'),expression:"'required|url'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('webhookUrl')},attrs:{"type":"text","name":"webhookUrl","placeholder":"Type webhook url here","data-vv-as":"url"},domProps:{"value":(_vm.webhook.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.webhook, "url", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('webhookUrl')),expression:"errors.has('webhookUrl')"}],staticClass:"error-message"},[_vm._v("\n            "+_vm._s(_vm.errors.first('webhookUrl'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-sm-6 col-md-2"},[_vm._v("Params")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-10"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered no-wrap"},[(_vm.webhook.params.length > 0)?_c('thead',[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('tbody',_vm._l((_vm.webhook.params),function(param,index){return _c('tr',{key:index},[_c('td',[_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"type","name":"type","options":_vm.webhookParamsTypes,"isValid":!_vm.errors.has(("paramType" + index)),"data-vv-as":"Type"},model:{value:(param.type),callback:function ($$v) {_vm.$set(param, "type", $$v)},expression:"param.type"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(("paramType" + index))),expression:"errors.has(`paramType${index}`)"}],staticClass:"error-message"},[_vm._v("\n                  "+_vm._s(_vm.errors.first(("paramType" + index)))+"\n                ")])],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(param.name),expression:"param.name"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has(("paramName" + index))},attrs:{"name":("paramName" + index),"type":"text","placeholder":"Enter field name","data-vv-as":"Name"},domProps:{"value":(param.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(param, "name", $event.target.value)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(("paramName" + index))),expression:"errors.has(`paramName${index}`)"}],staticClass:"error-message"},[_vm._v("\n                "+_vm._s(_vm.errors.first(("paramName" + index)))+"\n                ")])]),_vm._v(" "),_c('td',[(param.type==='string')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(param.value),expression:"param.value"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has(("paramValue" + index))},attrs:{"type":"text","name":("paramValue" + index),"placeholder":"Enter param value","isValid":!_vm.errors.has(("paramValue" + index)),"data-vv-as":"Value"},domProps:{"value":(param.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(param, "value", $event.target.value)}}}):_vm._e(),_vm._v(" "),(param.type==='path')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(param.value),expression:"param.value"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has(("paramValue" + index))},attrs:{"type":"text","name":("paramValue" + index),"placeholder":"Enter path to data","isValid":!_vm.errors.has(("paramValue" + index)),"data-vv-as":"Value"},domProps:{"value":(param.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(param, "value", $event.target.value)}}}):(param.type==='others')?_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"name":("paramValue" + index),"options":_vm.webhookOtherValues,"isValid":!_vm.errors.has(("paramValue" + index)),"data-vv-as":"Value"},model:{value:(param.value),callback:function ($$v) {_vm.$set(param, "value", $$v)},expression:"param.value"}}):(param.type==='form')?_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"options":_vm.questions,"text-field":"fieldName","value-field":"fieldName","name":("paramValue" + index),"isValid":!_vm.errors.has(("paramValue" + index)),"data-vv-as":"Value"},model:{value:(param.value),callback:function ($$v) {_vm.$set(param, "value", $$v)},expression:"param.value"}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(("paramValue" + index))),expression:"errors.has(`paramValue${index}`)"}],staticClass:"error-message"},[_vm._v("\n                "+_vm._s(_vm.getParamValueError(index))+"\n                ")])],1),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{on:{"click":function($event){return _vm.removeParam(index)}}},[_c('i',{staticClass:"mdi mdi-delete"})])])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('button',{staticClass:"btn btn-secondary btn-rounded btn-sm",on:{"click":_vm.addParam}},[_c('i',{staticClass:"mdi mdi-plus"}),_vm._v(" Add Param\n                ")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"mt-5"},[_c('button',{staticClass:"btn btn-info",on:{"click":_vm.submit}},[_vm._v("\n      Save Webhook Settings\n    ")])])])}
var Webhook_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Value")]),_vm._v(" "),_c('th')])}]
var Webhook_esExports = { render: Webhook_render, staticRenderFns: Webhook_staticRenderFns }
/* harmony default export */ var Campaigns_Details_Webhook = (Webhook_esExports);
// CONCATENATED MODULE: ./src/pages/Campaigns/Details/Webhook.vue
function Webhook_injectStyle (ssrContext) {
  __webpack_require__("rUqi")
}
var Webhook_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Webhook___vue_template_functional__ = false
/* styles */
var Webhook___vue_styles__ = Webhook_injectStyle
/* scopeId */
var Webhook___vue_scopeId__ = "data-v-955b7b9e"
/* moduleIdentifier (server only) */
var Webhook___vue_module_identifier__ = null
var Webhook_Component = Webhook_normalizeComponent(
  Details_Webhook,
  Campaigns_Details_Webhook,
  Webhook___vue_template_functional__,
  Webhook___vue_styles__,
  Webhook___vue_scopeId__,
  Webhook___vue_module_identifier__
)

/* harmony default export */ var pages_Campaigns_Details_Webhook = (Webhook_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Questions/Questions.gql
var Questions = __webpack_require__("KfMs");
var Questions_default = /*#__PURE__*/__webpack_require__.n(Questions);

// EXTERNAL MODULE: ./src/graphql/Questions/DeleteQuestion.gql
var DeleteQuestion = __webpack_require__("fAmc");
var DeleteQuestion_default = /*#__PURE__*/__webpack_require__.n(DeleteQuestion);

// EXTERNAL MODULE: ./src/graphql/Questions/OrderQuestions.gql
var OrderQuestions = __webpack_require__("RgsP");
var OrderQuestions_default = /*#__PURE__*/__webpack_require__.n(OrderQuestions);

// EXTERNAL MODULE: ./src/helpers/notifications.js
var notifications = __webpack_require__("cmmC");
var notifications_default = /*#__PURE__*/__webpack_require__.n(notifications);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Campaigns/Details/LeadForm.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var LeadForm = ({
  components: {
    DataTable: components_DataTable,
    ConfirmButton: src_components_ConfirmButton
  },
  props: {
    campaignId: {
      type: Number,
      required: true
    }
  },
  computed: {
    queryColumns: function queryColumns() {
      return [{ field: 'fieldName', title: 'Field Name' }, { field: 'question', title: 'Question' }, { field: 'type', title: 'Type' }, { field: 'mandatory', title: 'Mandatory' }, { field: 'created', title: 'Created' }, { field: 'actions', title: 'Actions' }];
    },
    QUESTIONS: function QUESTIONS() {
      return Questions_default.a;
    }
  },
  methods: {
    onQuestionsOrdered: function onQuestionsOrdered(affrectedItems) {
      var items = affrectedItems.map(function (item) {
        return {
          id: item.id,
          order: item.order
        };
      });

      this.$apollo.mutate({
        mutation: OrderQuestions_default.a,
        variables: {
          input: items
        }
      });
    },
    removeQuestion: function removeQuestion(id) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$apollo.mutate({
                  mutation: DeleteQuestion_default.a,
                  variables: {
                    id: id
                  },
                  refetchQueries: function refetchQueries(_ref) {
                    var data = _ref.data;
                    return data.deleteQuestion.success ? ['questions'] : [];
                  }
                });

              case 3:
                _this.$notify(Object(notifications["success"])('Question was removed'));
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                _this.$notify(Object(notifications["error"])(_context.t0.message));

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e950e216","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Campaigns/Details/LeadForm.vue
var LeadForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"columns":_vm.queryColumns,"fieldName":"questions","query":_vm.QUESTIONS,"placeholder":"Search by Name","orderable":true,"params":{ campaignId: _vm.campaignId }},on:{"ordered":_vm.onQuestionsOrdered},scopedSlots:_vm._u([{key:"mandatory",fn:function(props){return _c('span',{},[_vm._v("\n    "+_vm._s(props.row.mandatory ? 'Required' : 'Optional')+"\n  ")])}},{key:"created",fn:function(props){return _c('span',{},[_vm._v("\n    "+_vm._s(_vm._f("moment")(props.row.created,"MMM Do YYYY, h:mm:ss a"))+"\n  ")])}},{key:"actions",fn:function(props){return _c('span',{},[_c('router-link',{attrs:{"to":{
         name: 'EditQuestion',
         params: { questionId: props.row.id, id: String(_vm.campaignId) }
       }}},[_c('i',{staticClass:"mdi mdi-pencil text-inverse m-r-10"})]),_vm._v(" "),_c('confirm-button',{attrs:{"data":props.row.id},on:{"confirm":_vm.removeQuestion}})],1)}}])},[_c('span',{staticClass:"pull-right",attrs:{"slot":"filter"},slot:"filter"},[_c('router-link',{staticClass:"btn btn-info add-button",attrs:{"tag":"button","type":"button","to":{ name: 'NewQuestion', params: { id: String(_vm.campaignId) } }}},[_c('i',{staticClass:"mdi mdi-playlist-plus"}),_vm._v(" Add\n    ")])],1)])}
var LeadForm_staticRenderFns = []
var LeadForm_esExports = { render: LeadForm_render, staticRenderFns: LeadForm_staticRenderFns }
/* harmony default export */ var Details_LeadForm = (LeadForm_esExports);
// CONCATENATED MODULE: ./src/pages/Campaigns/Details/LeadForm.vue
var LeadForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LeadForm___vue_template_functional__ = false
/* styles */
var LeadForm___vue_styles__ = null
/* scopeId */
var LeadForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LeadForm___vue_module_identifier__ = null
var LeadForm_Component = LeadForm_normalizeComponent(
  LeadForm,
  Details_LeadForm,
  LeadForm___vue_template_functional__,
  LeadForm___vue_styles__,
  LeadForm___vue_scopeId__,
  LeadForm___vue_module_identifier__
)

/* harmony default export */ var Campaigns_Details_LeadForm = (LeadForm_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__("w9Mt");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: ./node_modules/codemirror/lib/codemirror.js
var codemirror = __webpack_require__("8U58");
var codemirror_default = /*#__PURE__*/__webpack_require__.n(codemirror);

// EXTERNAL MODULE: ./node_modules/codemirror/lib/codemirror.css
var lib_codemirror = __webpack_require__("4/hK");
var lib_codemirror_default = /*#__PURE__*/__webpack_require__.n(lib_codemirror);

// EXTERNAL MODULE: ./node_modules/codemirror/theme/neo.css
var neo = __webpack_require__("bF3y");
var neo_default = /*#__PURE__*/__webpack_require__.n(neo);

// EXTERNAL MODULE: ./node_modules/codemirror/mode/htmlmixed/htmlmixed.js
var htmlmixed = __webpack_require__("8Nur");
var htmlmixed_default = /*#__PURE__*/__webpack_require__.n(htmlmixed);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CodeEditor.vue

//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var CodeEditor = ({
  name: 'CodeEditor',
  props: {
    language: String,
    lineNumbers: Boolean,
    theme: {
      type: String,
      default: function _default() {
        return 'neo';
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [{ title: 'main' }];
      }
    }
  },
  data: function data() {
    return {
      activeTab: 0
    };
  },
  mounted: function mounted() {
    this.editor = new codemirror_default.a(document.getElementById('editor'), {
      mode: this.language,
      theme: this.theme,
      tabSize: 2,
      lineNumbers: this.lineNumbers
    });
    if (this.value[0].code) {
      this.editor.setValue(this.value[0].code);
    }
    this.editor.on('change', this.updateCode);
  },

  methods: {
    updateCode: function updateCode() {
      var _this = this;

      this.$emit('input', this.value.map(function (file, tab) {
        return extends_default()({}, file, {
          code: tab === _this.activeTab ? _this.editor.getValue() : file.code
        });
      }));
    },
    changeTab: function changeTab(tab) {
      this.activeTab = tab;
      this.editor.setValue(this.value[this.activeTab].code);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70123498","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CodeEditor.vue
var CodeEditor_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor__container"},[_c('section',{staticClass:"editor__tabs"},[_c('b-tabs',{on:{"input":_vm.changeTab}},_vm._l((_vm.value),function(tab){return _c('b-tab',{key:tab.title,attrs:{"title":tab.title}})}),1)],1),_vm._v(" "),_c('section',{staticClass:"tabcontent-border",attrs:{"id":"editor"}})])}
var CodeEditor_staticRenderFns = []
var CodeEditor_esExports = { render: CodeEditor_render, staticRenderFns: CodeEditor_staticRenderFns }
/* harmony default export */ var components_CodeEditor = (CodeEditor_esExports);
// CONCATENATED MODULE: ./src/components/CodeEditor.vue
function CodeEditor_injectStyle (ssrContext) {
  __webpack_require__("C9Ib")
}
var CodeEditor_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CodeEditor___vue_template_functional__ = false
/* styles */
var CodeEditor___vue_styles__ = CodeEditor_injectStyle
/* scopeId */
var CodeEditor___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CodeEditor___vue_module_identifier__ = null
var CodeEditor_Component = CodeEditor_normalizeComponent(
  CodeEditor,
  components_CodeEditor,
  CodeEditor___vue_template_functional__,
  CodeEditor___vue_styles__,
  CodeEditor___vue_scopeId__,
  CodeEditor___vue_module_identifier__
)

/* harmony default export */ var src_components_CodeEditor = (CodeEditor_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Campaigns/LandingPage.gql
var LandingPage = __webpack_require__("7PHd");
var LandingPage_default = /*#__PURE__*/__webpack_require__.n(LandingPage);

// EXTERNAL MODULE: ./src/graphql/Campaigns/EditLandingPage.gql
var EditLandingPage = __webpack_require__("+u7E");
var EditLandingPage_default = /*#__PURE__*/__webpack_require__.n(EditLandingPage);

// EXTERNAL MODULE: ./src/graphql/Campaigns/CreateLandingPage.gql
var CreateLandingPage = __webpack_require__("azm8");
var CreateLandingPage_default = /*#__PURE__*/__webpack_require__.n(CreateLandingPage);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Campaigns/Details/LandingPage.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import { getWidgetCode } from '@/helpers/widget';

/* harmony default export */ var Details_LandingPage = ({
  name: 'LandingPage',
  components: { CodeEditor: src_components_CodeEditor },
  props: { campaignId: Number },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['campaign', 'isUserAdmin', 'isWhiteLabel']), {
    landingURL: function landingURL() {
      return this.campaign.whiteLabel ? "https://pages.leadgen.live" + '/' + this.landingPage.name : "https://pages.nextlead.io" + '/' + this.landingPage.name;
    },
    landingCode: function landingCode() {
      return [{
        title: 'body.html',
        code: this.draft.body
      }, {
        title: 'head.html',
        code: this.draft.head
      }];
    },
    landingSource: function landingSource() {
      return '\n        <html>\n          <head>' + this.landingPage.head + '</head>\n          <body>\n            ' + this.landingPage.body + '\n          </body>\n        </html>\n      ';
    },
    canEdit: function canEdit() {
      if (this.isUserAdmin) {
        return true;
      }
      return this.campaign ? this.campaign.editable : false;
    }
  }),
  methods: {
    generateLandingPage: function generateLandingPage() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var variables;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                variables = pick_default()(_this, ['campaignId']);

                if (_this.themeUrl) {
                  variables.input = { url: _this.themeUrl };
                }
                _context.next = 4;
                return _this.$apollo.mutate({
                  mutation: CreateLandingPage_default.a,
                  variables: variables
                });

              case 4:
                _this.landingPage = _context.sent.data.createLanding;

                _this.$emit('created', true);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateLandingPage: function updateLandingPage() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.editMode = false;
                assign_default()(_this2.landingPage, _this2.draft);
                _context2.next = 4;
                return _this2.$apollo.mutate({
                  mutation: EditLandingPage_default.a,
                  variables: {
                    campaignId: _this2.campaignId,
                    input: pick_default()(_this2.draft, ['body', 'head', 'settings'])
                  }
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    closeEditing: function closeEditing() {
      this.editMode = false;
      assign_default()(this.draft, this.landingPage);
    },
    goToEditMode: function goToEditMode() {
      this.editMode = true;
    },
    editCode: function editCode(_ref) {
      var _ref2 = slicedToArray_default()(_ref, 2),
          body = _ref2[0],
          head = _ref2[1];

      this.draft.body = body.code;
      this.draft.head = head.code;
    }
  },
  data: function data() {
    return {
      landingPage: null,
      draft: '',
      editMode: false,
      themeUrl: null
    };
  },

  apollo: {
    landingPage: {
      query: LandingPage_default.a,
      loadingKey: 'showSpinner',
      fetchPolicy: 'network-only',
      variables: function variables() {
        return {
          campaignId: this.campaignId
        };
      },
      result: function result(_ref3) {
        var data = _ref3.data,
            loading = _ref3.loading;

        if (loading) {
          return;
        }
        if (data.landingPage) {
          vue_esm["default"].set(this, 'landingPage', extends_default()({}, data.landingPage));
          vue_esm["default"].set(this, 'draft', extends_default()({}, data.landingPage));
          this.$emit('created', Boolean(data.landingPage));
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a5e6eb3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Campaigns/Details/LandingPage.vue
var LandingPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"landing-creator"},[(_vm.landingPage && !_vm.editMode)?_c('div',{staticClass:"editor-container"},[_c('section',{staticClass:"edit-section mb-3"},[_c('h5',{staticClass:"landing-url"},[_c('i',{staticClass:"mdi mdi-lock"}),_vm._v(" "),_c('a',{attrs:{"href":_vm.landingURL,"target":"_blank"}},[_vm._v(_vm._s(_vm.landingURL))])]),_vm._v(" "),(_vm.canEdit)?_c('button',{staticClass:"btn btn-rounded btn-info float-right",on:{"click":_vm.goToEditMode}},[_vm._v("Edit Page")]):_vm._e()]),_vm._v(" "),_c('iframe',{staticClass:"virtual-landing",attrs:{"srcdoc":_vm.landingSource}})]):(_vm.editMode)?_c('div',{staticClass:"editor-container"},[_c('section',{staticClass:"editor-section"},[_c('code-editor',{attrs:{"language":"htmlmixed","lineNumbers":"","value":_vm.landingCode},on:{"input":_vm.editCode}})],1),_vm._v(" "),_c('section',{staticClass:"text-right mt-3"},[_c('button',{staticClass:"btn btn-cancel btn-edit btn-inverse",on:{"click":_vm.closeEditing}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-save btn-edit btn-info ml-2",on:{"click":_vm.updateLandingPage}},[_vm._v("Save Changes")])])]):_c('div',{staticClass:"virtual-landing"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"virtual-primary-content"},[(_vm.isUserAdmin)?_c('div',{staticClass:"mb-3",staticStyle:{"min-width":"400px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.themeUrl),expression:"themeUrl"}],staticClass:"form-control",attrs:{"type":"url","placeholder":"Enter theme URL (optional)"},domProps:{"value":(_vm.themeUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.themeUrl=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-info generate-landing",on:{"click":_vm.generateLandingPage}},[_vm._v("\n          Generate Landing Page\n        ")])])]),_vm._v(" "),_vm._m(1)])])}
var LandingPage_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"virtual-header"},[_c('div',{staticClass:"logo"}),_vm._v(" "),_c('div',{staticClass:"nav"},[_c('div',{staticClass:"nav-link"}),_vm._v(" "),_c('div',{staticClass:"nav-link"}),_vm._v(" "),_c('div',{staticClass:"nav-link"}),_vm._v(" "),_c('div',{staticClass:"nav-link"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"virtual-secondary-content"},[_c('div',{staticClass:"primary-block"}),_vm._v(" "),_c('div',{staticClass:"light-block"}),_vm._v(" "),_c('div',{staticClass:"secondary-block"})])}]
var LandingPage_esExports = { render: LandingPage_render, staticRenderFns: LandingPage_staticRenderFns }
/* harmony default export */ var Campaigns_Details_LandingPage = (LandingPage_esExports);
// CONCATENATED MODULE: ./src/pages/Campaigns/Details/LandingPage.vue
function LandingPage_injectStyle (ssrContext) {
  __webpack_require__("v/oQ")
}
var LandingPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LandingPage___vue_template_functional__ = false
/* styles */
var LandingPage___vue_styles__ = LandingPage_injectStyle
/* scopeId */
var LandingPage___vue_scopeId__ = "data-v-4a5e6eb3"
/* moduleIdentifier (server only) */
var LandingPage___vue_module_identifier__ = null
var LandingPage_Component = LandingPage_normalizeComponent(
  Details_LandingPage,
  Campaigns_Details_LandingPage,
  LandingPage___vue_template_functional__,
  LandingPage___vue_styles__,
  LandingPage___vue_scopeId__,
  LandingPage___vue_module_identifier__
)

/* harmony default export */ var pages_Campaigns_Details_LandingPage = (LandingPage_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__("2R8v");
var taggedTemplateLiteral_default = /*#__PURE__*/__webpack_require__.n(taggedTemplateLiteral);

// CONCATENATED MODULE: ./src/helpers/widget.js


var _templateObject = taggedTemplateLiteral_default()(['<script>\n      window.nexleadSettings = {\n        campaignId: ', '\n      };\n    </script>\n    <script>\n      ', '\n    </script>'], ['<script>\n      window.nexleadSettings = {\n        campaignId: ', '\n      };\n    </script>\n    <script>\n      ', '\n    </script>']),
    _templateObject2 = taggedTemplateLiteral_default()(['<script>\n    window.nexleadSettings = {\n      campaignId: ', ',\n      store: \'{your shopify store name}\',\n      token: \'{your api token}\',\n      theme: \'darkBlue\',\n      cta: \'Buy Now!\',\n      title: \'On Sale Now\',\n    };\n  </script>\n  <script>\n    ', '\n  </script>'], ['<script>\n    window.nexleadSettings = {\n      campaignId: ', ',\n      store: \'{your shopify store name}\',\n      token: \'{your api token}\',\n      theme: \'darkBlue\',\n      cta: \'Buy Now!\',\n      title: \'On Sale Now\',\n    };\n  </script>\n  <script>\n    ', '\n  </script>']);

var minifiedBootstrapCode = '!function(){window;var n=document;i=function(){var e=n.createElement("script"),t=n.getElementsByTagName("script")[0];e.type="text/javascript",e.async=!0,e.src="' + "https://client.nextlead.io" + '/widget/widget-min.js",t.parentNode.insertBefore(e,t)},window.addEventListener("load",i,!1)}();';
var productBootstrapCode = '!function(){window;var n=document;i=function(){var e=n.createElement("script"),t=n.getElementsByTagName("script")[0];e.type="text/javascript",e.async=!0,e.src="' + "https://widget.nextlead.io" + '/widget/product.js",t.parentNode.insertBefore(e,t)},window.addEventListener("load",i,!1)}();';

function format(str) {
  var size = -1;
  return str.replace(/\n(\s+)/g, function (m, m1) {
    if (size < 0) {
      size = m1.replace(/\t/g, '    ').length;
    }
    return '\n' + m1.slice(Math.min(m1.length, size));
  });
}

function dedent(callSite) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (typeof callSite === 'string') {
    return format(callSite);
  }
  if (typeof callSite === 'function') {
    return function () {
      return format(callSite.apply(undefined, arguments));
    };
  }
  var output = callSite.slice(0, args.length + 1).map(function (text, i) {
    return (i === 0 ? '' : args[i - 1]) + text;
  }).join('');

  return format(output);
}

var getWidgetCode = function getWidgetCode(campaignId) {
  return dedent(_templateObject, campaignId, minifiedBootstrapCode);
};

var getShopifyWidgetCode = function getShopifyWidgetCode(campaignId) {
  return dedent(_templateObject2, campaignId, productBootstrapCode);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Campaigns/Details/WidgetCode.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var WidgetCode = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['campaign']), {
    widget: function widget() {
      return this.campaign.widget || {};
    },
    widgetCode: function widgetCode() {
      return getWidgetCode(this.campaign.id);
    },
    widgetCodeShopify: function widgetCodeShopify() {
      return getShopifyWidgetCode(this.campaign.id);
    },
    isStaticPosition: function isStaticPosition() {
      return this.widget && this.widget.position === 'static';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21175310","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Campaigns/Details/WidgetCode.vue
var WidgetCode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.campaign.type)?_c('section',[(_vm.isStaticPosition)?_c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" Step 1")]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[_c('b-form-textarea',{attrs:{"id":"widget-code","value":_vm.widgetCode,"rows":10,"max-rows":12},nativeOn:{"click":function($event){$event.preventDefault();return $event.target.select()}}})],1),_vm._v(" "),(_vm.isStaticPosition)?_c('div',[_vm._m(1),_vm._v(" "),_c('blockquote',[_vm._v("\n        Insert the following tag on your web page where you want the widget to appear.\n      ")]),_vm._v(" "),(_vm.isStaticPosition)?_c('div',[_c('code',[_vm._v("<div id=\"nextlead-widget\"></div>")])]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.campaign.type === 'shopify')?_c('section',[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',[_c('b-form-textarea',{attrs:{"id":"widget-code","value":_vm.widgetCodeShopify,"rows":10,"max-rows":12},nativeOn:{"click":function($event){$event.preventDefault();return $event.target.select()}}})],1),_vm._v(" "),_vm._m(4)]):_vm._e()])}
var WidgetCode_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',[_vm._v("\n      This is the JavaScript code for this widget. Copy and paste this code before "),_c('b',[_vm._v("</BODY>")]),_vm._v(" tag of every web page that you want to show widget on. \n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"card-title mt-3"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" Step 2")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"card-title"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" Step 1")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',[_vm._v("\n      This is the JavaScript code for this widget. Copy and paste this code before "),_c('b',[_vm._v("</BODY>")]),_vm._v(" tag of every web page that you want to show widget on. \n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"card-title mt-3"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(" Step 2")]),_vm._v(" "),_c('blockquote',[_vm._v("\n        Add the "),_c('strong',[_vm._v("'nextlead-product'")]),_vm._v(" attribute on your web page element where you want the widget to appear.\n      ")]),_vm._v(" "),_c('div',[_c('code',[_vm._v("<section nextlead-product=\"{product id}\">...</section>")])])])}]
var WidgetCode_esExports = { render: WidgetCode_render, staticRenderFns: WidgetCode_staticRenderFns }
/* harmony default export */ var Details_WidgetCode = (WidgetCode_esExports);
// CONCATENATED MODULE: ./src/pages/Campaigns/Details/WidgetCode.vue
function WidgetCode_injectStyle (ssrContext) {
  __webpack_require__("BSNT")
}
var WidgetCode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WidgetCode___vue_template_functional__ = false
/* styles */
var WidgetCode___vue_styles__ = WidgetCode_injectStyle
/* scopeId */
var WidgetCode___vue_scopeId__ = "data-v-21175310"
/* moduleIdentifier (server only) */
var WidgetCode___vue_module_identifier__ = null
var WidgetCode_Component = WidgetCode_normalizeComponent(
  WidgetCode,
  Details_WidgetCode,
  WidgetCode___vue_template_functional__,
  WidgetCode___vue_styles__,
  WidgetCode___vue_scopeId__,
  WidgetCode___vue_module_identifier__
)

/* harmony default export */ var Campaigns_Details_WidgetCode = (WidgetCode_Component.exports);

// EXTERNAL MODULE: ./node_modules/google-libphonenumber/dist/libphonenumber.js
var libphonenumber = __webpack_require__("8c38");
var libphonenumber_default = /*#__PURE__*/__webpack_require__.n(libphonenumber);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Campaigns/Details/WidgetConfig.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var PNF = libphonenumber_default.a.PhoneNumberFormat;
var phoneUtil = libphonenumber_default.a.PhoneNumberUtil.getInstance();

/* harmony default export */ var WidgetConfig = ({
  components: {
    Spinner: src_components_Spinner,
    ConfirmButton: src_components_ConfirmButton
  },
  props: {
    showSpinner: Boolean
  },
  data: function data() {
    return {
      questions: []
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['campaign', 'isUserAdmin']), {
    campaignId: function campaignId() {
      return this.campaign ? this.campaign.id : null;
    },
    widget: function widget() {
      return this.campaign ? this.campaign.widget : {};
    },
    agent: function agent() {
      return this.campaign && this.campaign.widget && this.campaign.widget.agent ? this.campaign.widget.agent : {
        longText: 'Click to Chat',
        shortText: 'Chat',
        position: 'top',
        enabled: false
      };
    },
    phone: function phone() {
      return this.campaign && this.campaign.widget && this.campaign.widget.phone ? this.campaign.widget.phone : {
        shortText: 'Call',
        position: 'top',
        enabled: false
      };
    },
    exitOffer: function exitOffer() {
      return this.campaign && this.campaign.widget && this.campaign.widget.exitOffer ? this.campaign.widget.exitOffer : {
        title: 'Surprise!',
        text: 'You\'ve unlocked our secret sale.',
        button: 'Get it Now',
        enabled: false
      };
    },

    mode: {
      get: function get() {
        return this.widget && this.widget.mode ? this.widget.mode : 'form';
      },
      set: function set(newValue) {
        if (this.widget) {
          this.widget.mode = newValue;
        }
      }
    },
    themes: function themes() {
      return [{ value: 'dark', text: 'Dark' }, { value: 'white', text: 'White' }, { value: 'blue', text: 'Blue' }];
    },
    positions: function positions() {
      return [{ value: 'static', text: 'Static' }, { value: 'floating-bottom', text: 'Floating Bottom' }];
    },
    modes: function modes() {
      return [{ value: 'form', text: 'Step-by-Step Form' }, { value: 'chat', text: 'Live Agent Chat' }];
    },
    agentButtonPosition: function agentButtonPosition() {
      return [{ value: 'top', text: 'Top Right' }, { value: 'bottom', text: 'Bottom Right' }];
    },
    callButtonPosition: function callButtonPosition() {
      return [{ value: 'top', text: 'Top Left' }, { value: 'bottom', text: 'Bottom Left' }];
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['updateWidget']), {
    update: function update() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var phoneNumber;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (_this.phone.phone) {
                  phoneNumber = phoneUtil.parseAndKeepRawInput(_this.phone.phone, 'US');

                  _this.widget.phone = extends_default()({}, _this.phone, {
                    international: phoneUtil.format(phoneNumber, PNF.INTERNATIONAL),
                    national: phoneUtil.format(phoneNumber, PNF.INTERNATIONAL),
                    e164: phoneUtil.format(phoneNumber, PNF.E164)
                  });
                }
                if (_this.agent.longText) {
                  _this.widget.agent = _this.agent;
                }
                if (_this.exitOffer.text) {
                  _this.widget.exitOffer = _this.exitOffer;
                }
                _context.next = 6;
                return _this.updateWidget();

              case 6:
                _this.$notify({
                  group: 'success',
                  type: 'success',
                  text: 'Saved'
                });
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this.$notify({
                  group: 'error',
                  type: 'error',
                  text: _context.t0.message
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    }
  }),
  apollo: {
    questions: {
      query: QuestionsCompact_default.a,
      fetchPolicy: 'network-only',
      variables: function variables() {
        return {
          where: stringify_default()({ campaignId: +this.campaignId })
        };
      },
      result: function result(_ref) {
        var data = _ref.data,
            loading = _ref.loading;

        if (!loading) {
          this.questions = data.questions.result.map(function (_ref2) {
            var id = _ref2.id,
                fieldName = _ref2.fieldName;
            return {
              id: id,
              fieldName: fieldName
            };
          });
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ede61cae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Campaigns/Details/WidgetConfig.vue
var WidgetConfig_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSpinner)?_c('spinner',{attrs:{"fullScreen":""}}):_c('section',[_c('h5',{staticClass:"card-title"},[_vm._v("Widget Config")]),_vm._v(" "),_c('hr',{staticClass:"mt-0 mb-5"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 text-right col-form-label"},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"type here"},model:{value:(_vm.widget.title),callback:function ($$v) {_vm.$set(_vm.widget, "title", $$v)},expression:"widget.title"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" goes just above the input box when in Floating Bottom position ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 text-right col-form-label"},[_vm._v("Sub title")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"type here"},model:{value:(_vm.widget.subTitle),callback:function ($$v) {_vm.$set(_vm.widget, "subTitle", $$v)},expression:"widget.subTitle"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" goes just above the input box and below the Title ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 text-right col-form-label"},[_vm._v("Input Prompt")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"example: What are your needs?"},model:{value:(_vm.widget.inputPrompt),callback:function ($$v) {_vm.$set(_vm.widget, "inputPrompt", $$v)},expression:"widget.inputPrompt"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" engage your visitor with a question")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 text-right col-form-label"},[_vm._v("Position")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('b-form-select',{staticClass:"form-control",attrs:{"options":_vm.positions},model:{value:(_vm.widget.position),callback:function ($$v) {_vm.$set(_vm.widget, "position", $$v)},expression:"widget.position"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" affect widget initial position on a screen")])])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 text-right col-form-label"},[_vm._v("Color Theme")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('b-form-select',{staticClass:"form-control",attrs:{"options":_vm.themes},model:{value:(_vm.widget.theme),callback:function ($$v) {_vm.$set(_vm.widget, "theme", $$v)},expression:"widget.theme"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" affects look of the input box in Floating Bottom position ")])])],1)]),_vm._v(" "),(_vm.isUserAdmin)?_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 text-right col-form-label"},[_vm._v("Mode")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('b-form-select',{staticClass:"form-control",attrs:{"options":_vm.modes},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" how to react to visitor input ")])])],1)]):_vm._e()])]),_vm._v(" "),_c('h5',{staticClass:"card-title mt-5"},[_vm._v("Chat Config")]),_vm._v(" "),_c('hr',{staticClass:"mt-0 mb-5"}),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"},[_vm._v("Greeting message")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"example: Hi, my name is {name}.  I can help you to with your request"},model:{value:(_vm.widget.greeting),callback:function ($$v) {_vm.$set(_vm.widget, "greeting", $$v)},expression:"widget.greeting"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" the first message visitors will see at the start of their chat session; use \"{name}\" to insert live agent's name for a personal touch. ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"},[_vm._v("Thank you message")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"example: Thank you! We will be contacting you within the next 10 minutes"},model:{value:(_vm.widget.thanksMessage),callback:function ($$v) {_vm.$set(_vm.widget, "thanksMessage", $$v)},expression:"widget.thanksMessage"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" text visitors will see at the end of their chat session ")])])],1)]),_vm._v(" "),_c('h5',{staticClass:"card-title mt-5"},[_vm._v("Live Agent Button Config")]),_vm._v(" "),_c('hr',{staticClass:"mt-0 mb-5"}),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"},[_vm._v("Long Button Text")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"example: Click to Chat","maxlength":"30"},model:{value:(_vm.agent.longText),callback:function ($$v) {_vm.$set(_vm.agent, "longText", $$v)},expression:"agent.longText"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" the button label visitors will see on desktop and tables devices")])])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"},[_vm._v("Short Button Text")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"example: Chat","maxlength":"10"},model:{value:(_vm.agent.shortText),callback:function ($$v) {_vm.$set(_vm.agent, "shortText", $$v)},expression:"agent.shortText"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" the button label visitors will see on mobile devices ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"},[_vm._v("Position")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('b-form-select',{staticClass:"form-control",attrs:{"options":_vm.agentButtonPosition},model:{value:(_vm.agent.position),callback:function ($$v) {_vm.$set(_vm.agent, "position", $$v)},expression:"agent.position"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"}),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"custom-control custom-checkbox pb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agent.enabled),expression:"agent.enabled"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"liveAgentCheck"},domProps:{"checked":Array.isArray(_vm.agent.enabled)?_vm._i(_vm.agent.enabled,null)>-1:(_vm.agent.enabled)},on:{"change":function($event){var $$a=_vm.agent.enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.agent, "enabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.agent, "enabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.agent, "enabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"liveAgentCheck"}},[_vm._v(" "+_vm._s((_vm.agent.enabled) ? 'Enabled' : 'Disabled')+" ")])])])]),_vm._v(" "),_c('h5',{staticClass:"card-title mt-5"},[_vm._v("Call Button Config")]),_vm._v(" "),_c('hr',{staticClass:"mt-0 mb-5"}),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"},[_vm._v("Phone Number")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone.phone),expression:"phone.phone"},{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"},{name:"validate",rawName:"v-validate",value:({ regex: /^\(\d{3}\) \d{3}-\d{4}$/ }),expression:"{ regex: /^\\(\\d{3}\\) \\d{3}-\\d{4}$/ }"}],ref:"phone",staticClass:"form-control",class:{'is-invalid': _vm.errors.has('phone')},attrs:{"id":"phone","name":"phone","type":"tel","placeholder":"(999) 999-9999"},domProps:{"value":(_vm.phone.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.phone, "phone", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" the phone number visitors can use for click to call")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"},[_vm._v("Short Button Text")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"example: Call","maxlength":"10"},model:{value:(_vm.phone.shortText),callback:function ($$v) {_vm.$set(_vm.phone, "shortText", $$v)},expression:"phone.shortText"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" the button label visitors will see on mobile devices ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"},[_vm._v("Position")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('b-form-select',{staticClass:"form-control",attrs:{"options":_vm.callButtonPosition},model:{value:(_vm.phone.position),callback:function ($$v) {_vm.$set(_vm.phone, "position", $$v)},expression:"phone.position"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"}),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"custom-control custom-checkbox pb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone.enabled),expression:"phone.enabled"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"phoneCheck"},domProps:{"checked":Array.isArray(_vm.phone.enabled)?_vm._i(_vm.phone.enabled,null)>-1:(_vm.phone.enabled)},on:{"change":function($event){var $$a=_vm.phone.enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.phone, "enabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.phone, "enabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.phone, "enabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"phoneCheck"}},[_vm._v(" "+_vm._s((_vm.phone.enabled) ? 'Enabled' : 'Disabled')+" ")])])])]),_vm._v(" "),_c('h5',{staticClass:"card-title mt-5"},[_vm._v("Exit Offer Config")]),_vm._v(" "),_c('hr',{staticClass:"mt-0 mb-5"}),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"},[_vm._v("Offer Title")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"example: Surprise!","maxlength":"50"},model:{value:(_vm.exitOffer.title),callback:function ($$v) {_vm.$set(_vm.exitOffer, "title", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"exitOffer.title"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" the title visitors will see when offer is presented")])])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"},[_vm._v("Offer Text")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"example: You've unlocked our secret sale.","maxlength":"140"},model:{value:(_vm.exitOffer.text),callback:function ($$v) {_vm.$set(_vm.exitOffer, "text", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"exitOffer.text"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" the main message visitors will see when offer is presented")])])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"},[_vm._v("Button Text")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"example: Get it Now","maxlength":"30"},model:{value:(_vm.exitOffer.button),callback:function ($$v) {_vm.$set(_vm.exitOffer, "button", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"exitOffer.button"}}),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" the text of the submit button")])])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"},[_vm._v("Field")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[(_vm.questions.length)?_c('b-form-select',{staticClass:"form-control",attrs:{"options":_vm.questions,"text-field":"fieldName","value-field":"id","name":"fieldName"},model:{value:(_vm.exitOffer.field),callback:function ($$v) {_vm.$set(_vm.exitOffer, "field", $$v)},expression:"exitOffer.field"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" select the field name user need to populate in response to the offer.")])])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 text-right col-form-label"}),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"custom-control custom-checkbox pb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.exitOffer.enabled),expression:"exitOffer.enabled"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"exitOfferEnabled"},domProps:{"checked":Array.isArray(_vm.exitOffer.enabled)?_vm._i(_vm.exitOffer.enabled,null)>-1:(_vm.exitOffer.enabled)},on:{"change":function($event){var $$a=_vm.exitOffer.enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.exitOffer, "enabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.exitOffer, "enabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.exitOffer, "enabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"exitOfferEnabled"}},[_vm._v(" "+_vm._s((_vm.exitOffer.enabled) ? 'Enabled' : 'Disabled')+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"mt-5"},[_c('button',{staticClass:"btn btn-info",on:{"click":_vm.update}},[_vm._v("\n      Save Widget Config\n    ")])])])}
var WidgetConfig_staticRenderFns = []
var WidgetConfig_esExports = { render: WidgetConfig_render, staticRenderFns: WidgetConfig_staticRenderFns }
/* harmony default export */ var Details_WidgetConfig = (WidgetConfig_esExports);
// CONCATENATED MODULE: ./src/pages/Campaigns/Details/WidgetConfig.vue
var WidgetConfig_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WidgetConfig___vue_template_functional__ = false
/* styles */
var WidgetConfig___vue_styles__ = null
/* scopeId */
var WidgetConfig___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WidgetConfig___vue_module_identifier__ = null
var WidgetConfig_Component = WidgetConfig_normalizeComponent(
  WidgetConfig,
  Details_WidgetConfig,
  WidgetConfig___vue_template_functional__,
  WidgetConfig___vue_styles__,
  WidgetConfig___vue_scopeId__,
  WidgetConfig___vue_module_identifier__
)

/* harmony default export */ var Campaigns_Details_WidgetConfig = (WidgetConfig_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Campaigns/Questions.gql
var Campaigns_Questions = __webpack_require__("gO4H");
var Campaigns_Questions_default = /*#__PURE__*/__webpack_require__.n(Campaigns_Questions);

// EXTERNAL MODULE: ./src/graphql/Campaigns/RemoveQuestion.gql
var RemoveQuestion = __webpack_require__("rqlc");
var RemoveQuestion_default = /*#__PURE__*/__webpack_require__.n(RemoveQuestion);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Campaigns/Details/Questions.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var DEFAULT_QUESTIONS_LIMIT = 7;

/* harmony default export */ var Details_Questions = ({
  props: {
    campaignId: Number,
    updatedAt: Number
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthUser']), {
    limit: function limit() {
      return DEFAULT_QUESTIONS_LIMIT;
    }
  }),
  mounted: function mounted() {
    this.$refs.questionsList.addEventListener('scroll', this.onPagination);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.questionsList.removeEventListener('scroll', this.onPagination);
  },
  data: function data() {
    return {
      campaignQuestions: [],
      showSpinner: false,
      offset: 0,
      ended: false
    };
  },

  methods: {
    onPagination: function onPagination(_ref) {
      var _this = this;

      var target = _ref.target;

      var isBottom = target.scrollHeight === target.scrollTop + target.offsetHeight;
      if (this.ended || !isBottom) {
        return;
      }
      this.offset += this.limit;
      this.updateQuestions(function (olderQuestions) {
        return _this.campaignQuestions.concat(olderQuestions);
      });
    },
    updateQuestions: function updateQuestions() {
      var _this2 = this;

      var map = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (a) {
        return a;
      };
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref2, _ref2$data$campaignQu, result, count;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.fetchQuestions();

              case 2:
                _ref2 = _context.sent;
                _ref2$data$campaignQu = _ref2.data.campaignQuestions;
                result = _ref2$data$campaignQu.result;
                count = _ref2$data$campaignQu.meta.count;

                _this2.campaignQuestions = map(result);
                _this2.ended = _this2.campaignQuestions.length === count;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchQuestions: function fetchQuestions() {
      return this.$apollo.query({
        query: Campaigns_Questions_default.a,
        loadingKey: 'showSpinner',
        fetchPolicy: 'network-only',
        variables: {
          campaignId: this.campaignId,
          limit: this.limit,
          offset: this.offset
        }
      });
    },
    removeQuestion: function removeQuestion(questionId) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref3, isConfirmed;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return sweetalert2_all_default()({
                  title: 'Are you sure?',
                  text: "You won't be able to revert this!",
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, delete it!'
                });

              case 2:
                _ref3 = _context2.sent;
                isConfirmed = _ref3.value;

                if (isConfirmed) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return');

              case 6:
                _this3.campaignQuestions = _this3.campaignQuestions.filter(function (q) {
                  return q.id !== questionId;
                });
                return _context2.abrupt('return', _this3.$apollo.mutate({
                  mutation: RemoveQuestion_default.a,
                  variables: { questionId: questionId }
                }));

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },
  apollo: {
    campaignQuestions: {
      query: Campaigns_Questions_default.a,
      loadingKey: 'showSpinner',
      fetchPolicy: 'network-only',
      variables: function variables() {
        return {
          campaignId: this.campaignId,
          limit: this.limit,
          offset: 0
        };
      },
      result: function result(_ref4) {
        var data = _ref4.data,
            loading = _ref4.loading;

        if (loading) {
          return;
        }
        this.campaignQuestions = data.campaignQuestions.result;
      }
    }
  },
  watch: {
    updatedAt: function updatedAt() {
      this.offset = 0;
      this.updateQuestions();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1a817c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Campaigns/Details/Questions.vue
var Questions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"questions-container"},[_c('div',[_c('router-link',{staticClass:"btn btn-info",attrs:{"tag":"button","to":{ name: 'NewCampaignQuestion', params: { campaignId: _vm.campaignId }, query: { updatedAt: _vm.updatedAt } }}},[_c('i',{staticClass:"mdi mdi-playlist-plus"}),_vm._v(" Add Question & Answer\n    ")])],1),_vm._v(" "),(_vm.showSpinner)?_c('spinner',{attrs:{"fullScreen":""}}):_c('div',{ref:"questionsList",staticClass:"questions mt-5"},_vm._l((_vm.campaignQuestions),function(question){return _c('div',{staticClass:"question pb-3"},[_c('section',{staticClass:"question-text"},[_c('h5',[_vm._v(_vm._s(question.question))])]),_vm._v(" "),(question.answer)?_c('section',{staticClass:"answer"},[_c('p',{staticClass:"answer-text"},[_vm._v(_vm._s(question.answer))])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"question-menu"},[_c('router-link',{staticClass:"btn btn-outline-secondary btn-xs",attrs:{"tag":"button","to":{ name: 'EditCampaignQuestion', params: { questionId: question.id }, query: { question: question.question, answer: question.answer, updatedAt: _vm.updatedAt } }}},[_c('i',{staticClass:"mdi mdi-lead-pencil"}),_vm._v(" Edit\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-danger btn-xs ml-2",on:{"click":function($event){return _vm.removeQuestion(question.id)}}},[_c('i',{staticClass:"mdi mdi-delete"}),_vm._v(" Delete\n        ")])],1)])}),0)],1)}
var Questions_staticRenderFns = []
var Questions_esExports = { render: Questions_render, staticRenderFns: Questions_staticRenderFns }
/* harmony default export */ var Campaigns_Details_Questions = (Questions_esExports);
// CONCATENATED MODULE: ./src/pages/Campaigns/Details/Questions.vue
function Questions_injectStyle (ssrContext) {
  __webpack_require__("in+Y")
}
var Questions_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Questions___vue_template_functional__ = false
/* styles */
var Questions___vue_styles__ = Questions_injectStyle
/* scopeId */
var Questions___vue_scopeId__ = "data-v-a1a817c6"
/* moduleIdentifier (server only) */
var Questions___vue_module_identifier__ = null
var Questions_Component = Questions_normalizeComponent(
  Details_Questions,
  Campaigns_Details_Questions,
  Questions___vue_template_functional__,
  Questions___vue_styles__,
  Questions___vue_scopeId__,
  Questions___vue_module_identifier__
)

/* harmony default export */ var pages_Campaigns_Details_Questions = (Questions_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Campaigns/CampaignPolicy.gql
var CampaignPolicy = __webpack_require__("wDBB");
var CampaignPolicy_default = /*#__PURE__*/__webpack_require__.n(CampaignPolicy);

// EXTERNAL MODULE: ./src/graphql/Campaigns/CampaignPolicyCreate.gql
var CampaignPolicyCreate = __webpack_require__("bzhp");
var CampaignPolicyCreate_default = /*#__PURE__*/__webpack_require__.n(CampaignPolicyCreate);

// EXTERNAL MODULE: ./src/graphql/Campaigns/CampaignPolicyEdit.gql
var CampaignPolicyEdit = __webpack_require__("AxlZ");
var CampaignPolicyEdit_default = /*#__PURE__*/__webpack_require__.n(CampaignPolicyEdit);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Campaigns/Details/CampaignPolicy.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Details_CampaignPolicy = ({
  name: "CampaignPolicy",
  props: { campaignId: Number },
  data: function data() {
    return {
      policy: {
        created: null,
        updated: null,
        status: false,
        policy: '',
        name: null
      },
      campaignPolicy: null
    };
  },

  methods: {
    update: function update() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$apollo.mutate({
                  mutation: _this.campaignPolicy ? CampaignPolicyEdit_default.a : CampaignPolicyCreate_default.a,
                  variables: {
                    campaignId: _this.campaignId,
                    input: pick_default()(_this.policy, ['status', 'policy', 'name'])
                  }
                });

              case 3:
                _this.$notify({
                  type: 'success',
                  group: 'success',
                  text: 'Policy Saved'
                });
                _this.$apollo.queries.campaignPolicy.refetch();
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                _this.$notify({
                  group: 'error',
                  type: 'error',
                  text: _context.t0.message
                });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    }
  },
  apollo: {
    campaignPolicy: {
      query: CampaignPolicy_default.a,
      loadingKey: 'showSpinner',
      fetchPolicy: 'network-only',
      variables: function variables() {
        return {
          campaignId: this.campaignId
        };
      },
      result: function result(_ref) {
        var data = _ref.data,
            loading = _ref.loading;

        if (loading) {
          return;
        }
        if (data.campaignPolicy) {
          vue_esm["default"].set(this, 'policy', extends_default()({}, data.campaignPolicy));
          this.$emit('created', Boolean(data.campaignPolicy));
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-606770e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Campaigns/Details/CampaignPolicy.vue
var CampaignPolicy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('h5',[_vm._v("Validation Policy :")]),_vm._v(" "),_c('b-form-input',{staticClass:"mb-2",attrs:{"type":"text","placeholder":"Enter policy name"},model:{value:(_vm.policy.name),callback:function ($$v) {_vm.$set(_vm.policy, "name", $$v)},expression:"policy.name"}}),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"textarea1","placeholder":"Enter Validation Policy in JSON format","rows":6},model:{value:(_vm.policy.policy),callback:function ($$v) {_vm.$set(_vm.policy, "policy", $$v)},expression:"policy.policy"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2 mb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.policy.status),expression:"policy.status"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"checkbox0","value":"check"},domProps:{"checked":Array.isArray(_vm.policy.status)?_vm._i(_vm.policy.status,"check")>-1:(_vm.policy.status)},on:{"change":function($event){var $$a=_vm.policy.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="check",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.policy, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.policy, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.policy, "status", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"checkbox0"}},[_vm._v("Enabled")])]),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"btn btn-info",on:{"click":_vm.update}},[_vm._v("\n      Save Policy\n    ")])])],1)}
var CampaignPolicy_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',[_c('h6',[_vm._v("Operator List:")]),_vm._v(" "),_c('code',[_vm._v("equal, notEqual, greater, less, contain, null, notNull")]),_vm._v(" "),_c('h6',[_vm._v("Sample:")]),_vm._v(" "),_c('code',[_vm._v("[{\"or\": true, \"path\": \"questions.fieldName.yesOrNo\", \"operator\": \"contain\", \"value\": \"Yes\",\"required\": true}]")])])}]
var CampaignPolicy_esExports = { render: CampaignPolicy_render, staticRenderFns: CampaignPolicy_staticRenderFns }
/* harmony default export */ var Campaigns_Details_CampaignPolicy = (CampaignPolicy_esExports);
// CONCATENATED MODULE: ./src/pages/Campaigns/Details/CampaignPolicy.vue
function CampaignPolicy_injectStyle (ssrContext) {
  __webpack_require__("T5Lr")
}
var CampaignPolicy_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CampaignPolicy___vue_template_functional__ = false
/* styles */
var CampaignPolicy___vue_styles__ = CampaignPolicy_injectStyle
/* scopeId */
var CampaignPolicy___vue_scopeId__ = "data-v-606770e6"
/* moduleIdentifier (server only) */
var CampaignPolicy___vue_module_identifier__ = null
var CampaignPolicy_Component = CampaignPolicy_normalizeComponent(
  Details_CampaignPolicy,
  Campaigns_Details_CampaignPolicy,
  CampaignPolicy___vue_template_functional__,
  CampaignPolicy___vue_styles__,
  CampaignPolicy___vue_scopeId__,
  CampaignPolicy___vue_module_identifier__
)

/* harmony default export */ var pages_Campaigns_Details_CampaignPolicy = (CampaignPolicy_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Campaigns/CampaignPlan.gql
var CampaignPlan = __webpack_require__("HDej");
var CampaignPlan_default = /*#__PURE__*/__webpack_require__.n(CampaignPlan);

// EXTERNAL MODULE: ./src/graphql/Campaigns/EditCampaignPlan.gql
var EditCampaignPlan = __webpack_require__("kWYe");
var EditCampaignPlan_default = /*#__PURE__*/__webpack_require__.n(EditCampaignPlan);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Campaigns/Details/Plan.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Plan = ({
  props: {
    campaignId: Number
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthUser', 'isUserAdmin', 'campaign']), {
    isAdmin: function isAdmin() {
      return this.isUserAdmin;
    }
  }),
  data: function data() {
    return {
      plan: {},
      showSpinner: false
    };
  },

  methods: {
    update: function update() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var input;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                input = {
                  newRequest: Number(_this.plan.newRequest),
                  dataPoint: Number(_this.plan.dataPoint),
                  notes: Number(_this.plan.notes),
                  lead: Number(_this.plan.lead),
                  partialLead: Number(_this.plan.partialLead),
                  orderAmount: Number(_this.plan.orderAmount),
                  orderPercent: Number(_this.plan.orderPercent)
                };
                _context.next = 4;
                return _this.$apollo.mutate({
                  mutation: EditCampaignPlan_default.a,
                  variables: {
                    id: _this.campaignId,
                    input: input
                  }
                });

              case 4:
                _this.$notify({
                  group: 'success',
                  type: 'success',
                  text: 'Saved'
                });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                _this.$notify({
                  group: 'error',
                  type: 'error',
                  text: _context.t0.message
                });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    }
  },
  apollo: {
    campaignPlan: {
      query: CampaignPlan_default.a,
      loadingKey: 'showSpinner',
      fetchPolicy: 'network-only',
      variables: function variables() {
        return {
          id: this.campaignId
        };
      },
      result: function result(_ref) {
        var data = _ref.data,
            loading = _ref.loading;

        if (loading) {
          return;
        }
        this.plan = data.campaignPlan ? data.campaignPlan : {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28ae7bcb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Campaigns/Details/Plan.vue
var Plan_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"plan-container"},[(_vm.showSpinner)?_c('spinner',{attrs:{"fullScreen":""}}):_vm._e(),_vm._v(" "),_c('form',{staticStyle:{"max-width":"400px"}},[(!_vm.campaign.type)?_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"newRequestPrice","label":"Price per New Request","label-for":"newRequestPrice"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("$")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.plan.newRequest),expression:"plan.newRequest"}],staticClass:"form-control",attrs:{"id":"newRequestPrice","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter amount"},domProps:{"value":(_vm.plan.newRequest)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.plan, "newRequest", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(!_vm.campaign.type)?_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"dataPointPrice","label":"Price per Data Point","label-for":"dataPointPrice"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("$")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.plan.dataPoint),expression:"plan.dataPoint"}],staticClass:"form-control",attrs:{"id":"dataPointPrice","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter amount"},domProps:{"value":(_vm.plan.dataPoint)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.plan, "dataPoint", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(!_vm.campaign.type)?_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"notesPrice","label":"Price per Notes","label-for":"notesPrice"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("$")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.plan.notes),expression:"plan.notes"}],staticClass:"form-control",attrs:{"id":"notesPrice","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter amount"},domProps:{"value":(_vm.plan.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.plan, "notes", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(!_vm.campaign.type)?_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"completedLeadPrice","label":"Price per Completed Lead","label-for":"completedLeadPrice"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("$")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.plan.lead),expression:"plan.lead"}],staticClass:"form-control",attrs:{"id":"completedLeadPrice","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter amount"},domProps:{"value":(_vm.plan.lead)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.plan, "lead", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(!_vm.campaign.type)?_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"partialLeadPrice","label":"Price per Partial Lead","label-for":"partialLeadPrice"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("$")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.plan.partialLead),expression:"plan.partialLead"}],staticClass:"form-control",attrs:{"id":"partialLeadPrice","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter amount"},domProps:{"value":(_vm.plan.partialLead)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.plan, "partialLead", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(_vm.campaign.type === 'shopify')?_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"orderAmount","label":"Price per Order","label-for":"orderAmount"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("$")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.plan.orderAmount),expression:"plan.orderAmount"}],staticClass:"form-control",attrs:{"id":"orderAmount","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter amount"},domProps:{"value":(_vm.plan.orderAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.plan, "orderAmount", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(_vm.campaign.type === 'shopify')?_c('b-form-group',{attrs:{"horizontal":"","label-cols":7,"id":"orderPercent","label":"Percent per Order","label-for":"orderPercent"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("%")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.plan.orderPercent),expression:"plan.orderPercent"}],staticClass:"form-control",attrs:{"id":"orderPercent","type":"number","disabled":!_vm.isAdmin,"placeholder":"Enter percent"},domProps:{"value":(_vm.plan.orderPercent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.plan, "orderPercent", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('b-form-group',[_c('div',{},[(_vm.isAdmin)?_c('button',{staticClass:"btn btn-info text-right",attrs:{"type":"button"},on:{"click":_vm.update}},[_vm._v("\n          Save\n        ")]):_vm._e()])])],1)],1)}
var Plan_staticRenderFns = []
var Plan_esExports = { render: Plan_render, staticRenderFns: Plan_staticRenderFns }
/* harmony default export */ var Details_Plan = (Plan_esExports);
// CONCATENATED MODULE: ./src/pages/Campaigns/Details/Plan.vue
function Plan_injectStyle (ssrContext) {
  __webpack_require__("xzce")
}
var Plan_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Plan___vue_template_functional__ = false
/* styles */
var Plan___vue_styles__ = Plan_injectStyle
/* scopeId */
var Plan___vue_scopeId__ = "data-v-28ae7bcb"
/* moduleIdentifier (server only) */
var Plan___vue_module_identifier__ = null
var Plan_Component = Plan_normalizeComponent(
  Plan,
  Details_Plan,
  Plan___vue_template_functional__,
  Plan___vue_styles__,
  Plan___vue_scopeId__,
  Plan___vue_module_identifier__
)

/* harmony default export */ var Campaigns_Details_Plan = (Plan_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Campaigns/Details/CampaignDetails.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ var CampaignDetails = ({
  name: 'CampaignDetails',
  components: {
    ConfirmButton: src_components_ConfirmButton,
    LeadForm: Campaigns_Details_LeadForm,
    Multiselect: components_CustomMultiselect,
    LandingPage: pages_Campaigns_Details_LandingPage,
    CampaignQuestions: pages_Campaigns_Details_Questions,
    CustomInput: components_CustomInput,
    Files: pages_Campaigns_Details_Files,
    Webhook: pages_Campaigns_Details_Webhook,
    WidgetCode: Campaigns_Details_WidgetCode,
    WidgetConfig: Campaigns_Details_WidgetConfig,
    CampaignPolicy: pages_Campaigns_Details_CampaignPolicy,
    CampaignPlan: Campaigns_Details_Plan
  },
  data: function data() {
    return {
      isLandingExists: false,
      showSpinner: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthUser', 'isUserAdmin', 'campaign', 'isWhiteLabel']), {

    // isStaticPosition() {
    //   return get(this.campaign, 'widget.position') === 'static';
    // },

    isAdmin: function isAdmin() {
      return this.isUserAdmin;
    },
    canEdit: function canEdit() {
      if (this.isUserAdmin) {
        return true;
      }
      return this.campaign ? this.campaign.editable : false;
    },
    changeLink: function changeLink() {
      return 'https://docs.google.com/forms/d/e/1FAIpQLSeqSHxqd1qzQNedHIdg-7z6eAF9GRBB4EghLS_B0ShDWAkCig/viewform?usp=pp_url&entry.2039617643=' + encodeURIComponent(this.getAuthUser.email) + '&entry.2023113411=' + encodeURIComponent(this.campaign.campaignName) + '&entry.645503573=' + encodeURIComponent(this.id);
    },
    id: function id() {
      return this.$route.params.id;
    }
  }),

  mounted: function mounted() {
    this.fetchCampaign(this.$route.params.id);
  },


  watch: {
    '$route.params.id': function $routeParamsId(newId) {
      this.fetchCampaign(newId);
    }
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchCampaign', 'deleteCampaign', 'trackEvent']), {
    removeCampaign: function removeCampaign() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, isConfirmed;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return sweetalert2_all_default()({
                  title: 'Are you sure?',
                  text: "You won't be able to revert this!",
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, delete it!'
                });

              case 2:
                _ref = _context.sent;
                isConfirmed = _ref.value;

                if (isConfirmed) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:
                _this.showSpinner = true;
                _context.next = 9;
                return _this.deleteCampaign(_this.$route.params.id);

              case 9:
                _this.trackEvent({
                  name: "Campaign Deleted",
                  options: {
                    "campaign_uid": _this.$route.params.id
                  }
                });
                _this.$router.push({ name: 'Campaigns' });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setLandingExists: function setLandingExists(isLandingExists) {
      this.isLandingExists = isLandingExists;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cd6dbc3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Campaigns/Details/CampaignDetails.vue
var CampaignDetails_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row page-titles"},[_c('div',{staticClass:"col-md-8"},[_c('breadcrumbs',{attrs:{"current":_vm.id}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"float-right"},[_c('a',{staticClass:"btn btn-warning",attrs:{"target":"_blank","href":_vm.changeLink}},[_vm._v("Modify Campaign")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(_vm.canEdit)?_c('div',{staticClass:"float-right"},[(_vm.campaign.type === 'shopify')?_c('router-link',{staticClass:"btn btn-secondary",attrs:{"to":{ name: 'EditShopifyCampaign', params: { id: _vm.$route.params.id } }}},[_c('i',{staticClass:"mdi mdi-pencil"}),_vm._v(" Edit\n            ")]):_vm._e(),_vm._v(" "),(_vm.campaign.type !== 'shopify')?_c('router-link',{staticClass:"btn btn-secondary",attrs:{"to":{ name: 'EditCampaign', params: { id: _vm.$route.params.id } }}},[_c('i',{staticClass:"mdi mdi-pencil"}),_vm._v(" Edit\n            ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-success mr-1 ml-1",attrs:{"to":{name: 'CloneCampaign', params: { id: _vm.$route.params.id, name: _vm.campaign.campaignName+' Clone' }}}},[_c('i',{staticClass:"mdi mdi-content-copy"}),_vm._v(" Clone\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-delete",on:{"click":_vm.removeCampaign}},[_c('i',{staticClass:"mdi mdi-delete"}),_vm._v(" Delete\n            ")])],1):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.campaign.campaignName)),_c('span',{staticClass:"badge badge-info ml-2"},[_vm._v(_vm._s(_vm.campaign.type))])]),_vm._v(" "),(_vm.campaign.company && !_vm.campaign.whiteLabel)?_c('h6',{staticClass:"card-subtitle"},[_c('router-link',{attrs:{"to":{ name: 'EditCompany', params: { id: _vm.campaign.company.id } }}},[_vm._v("\n              "+_vm._s(_vm.campaign.company.companyName)+"\n            ")]),_vm._v(" "),(_vm.campaign.dispatchTo)?_c('span',[_vm._v("| "+_vm._s(_vm.campaign.dispatchTo))]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('b-tabs',{attrs:{"nav-class":"customtab"}},[(_vm.canEdit && !_vm.campaign.type)?_c('reoute-tab',{staticClass:"card-body",attrs:{"default":"","name":"lead_form","title":"Lead Form"}},[_c('div',{staticClass:"alert alert-info mb-5"},[_c('i',{staticClass:"mdi mdi-information"}),_vm._v("\n              Enter questions you want your visitors to provide answers to, including contact information (Phone or Email). You can change the order in which they will be presented to your visitors by dragging it with the mouse.\n            ")]),_vm._v(" "),_c('lead-form',{attrs:{"campaignId":+_vm.$route.params.id}}),_vm._v(" "),(_vm.isUserAdmin)?_c('campaign-policy',{attrs:{"campaignId":+_vm.$route.params.id}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.canEdit && !_vm.campaign.type)?_c('reoute-tab',{staticClass:"card-body",attrs:{"name":"widget_config","title":"Widget Config"}},[_c('div',{staticClass:"alert alert-info mb-5"},[_c('i',{staticClass:"mdi mdi-information"}),_vm._v("\n              Edit this campaign's input widget settings here. Online visitors initiate chat session with our live agents through this widget.\n            ")]),_vm._v(" "),_c('widget-config',{attrs:{"showSpinner":_vm.showSpinner}})],1):_vm._e(),_vm._v(" "),_c('reoute-tab',{staticClass:"card-body",attrs:{"name":"widget_code","title":"Widget Code"}},[_c('div',{staticClass:"alert alert-info mb-5"},[_c('i',{staticClass:"mdi mdi-information"}),_vm._v("\n              Follow instructions below to add input widget to your website.\n            ")]),_vm._v(" "),_c('widget-code')],1),_vm._v(" "),(_vm.isUserAdmin)?_c('reoute-tab',{staticClass:"card-body",attrs:{"name":"plan","title":"Plan"}},[_c('div',{staticClass:"alert alert-info mb-5"},[_c('i',{staticClass:"mdi mdi-information"}),_vm._v("\n              View/Edit the campaign pricing plan\n            ")]),_vm._v(" "),_c('campaign-plan',{attrs:{"campaignId":+_vm.$route.params.id}})],1):_vm._e(),_vm._v(" "),(!_vm.campaign.type)?_c('reoute-tab',{staticClass:"card-body",attrs:{"name":"q_a","title":"Q&A"}},[_c('div',{staticClass:"alert alert-info mb-5"},[_c('i',{staticClass:"mdi mdi-information"}),_vm._v("\n                Set up Frequently Asked Questions & Answers to guide your visitors through campaign questions that they may have difficulty with. For example, if you have a form question that prompts your visitor to share their phone number, you may need to explain your reasoning for doing so.\n            ")]),_vm._v(" "),_c('campaign-questions',{attrs:{"updatedAt":+_vm.$route.query.updatedAt,"campaignId":+_vm.$route.params.id}})],1):_vm._e(),_vm._v(" "),(_vm.canEdit && !_vm.campaign.type)?_c('reoute-tab',{staticClass:"card-body",attrs:{"name":"webhook","title":"Webhook"}},[_c('div',{staticClass:"alert alert-info mb-5"},[_c('i',{staticClass:"mdi mdi-information"}),_vm._v("\n              Configure a webhook that will be triggered on every lead submission. This allows you to post your lead to an external service or a CRM. Contact us or your developer for assistance.\n            ")]),_vm._v(" "),_c('webhook',{attrs:{"campaignId":+_vm.$route.params.id}})],1):_vm._e(),_vm._v(" "),_c('reoute-tab',{staticClass:"card-body",attrs:{"name":"landing_page","title":"Landing Page"}},[_c('div',{staticClass:"alert alert-info mb-5"},[_c('i',{staticClass:"mdi mdi-information"}),_vm._v("\n              This is your campaign's landing page with the input widget built-in. You can edit the page to change design and layout to your liking. Use the Files tab to upload your own graphics.\n            ")]),_vm._v(" "),_c('landing-page',{attrs:{"campaignId":+_vm.$route.params.id},on:{"created":_vm.setLandingExists}})],1),_vm._v(" "),(_vm.isLandingExists && _vm.canEdit)?_c('reoute-tab',{staticClass:"card-body",attrs:{"name":"files","title":"Files"}},[_c('div',{staticClass:"alert alert-info mb-5"},[_c('i',{staticClass:"mdi mdi-information"}),_vm._v("\n              Upload your own graphics files for use on this campaign's landing page.\n            ")]),_vm._v(" "),_c('files',{attrs:{"campaignId":+_vm.$route.params.id}})],1):_vm._e()],1)],1)])])])}
var CampaignDetails_staticRenderFns = []
var CampaignDetails_esExports = { render: CampaignDetails_render, staticRenderFns: CampaignDetails_staticRenderFns }
/* harmony default export */ var Details_CampaignDetails = (CampaignDetails_esExports);
// CONCATENATED MODULE: ./src/pages/Campaigns/Details/CampaignDetails.vue
var CampaignDetails_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CampaignDetails___vue_template_functional__ = false
/* styles */
var CampaignDetails___vue_styles__ = null
/* scopeId */
var CampaignDetails___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CampaignDetails___vue_module_identifier__ = null
var CampaignDetails_Component = CampaignDetails_normalizeComponent(
  CampaignDetails,
  Details_CampaignDetails,
  CampaignDetails___vue_template_functional__,
  CampaignDetails___vue_styles__,
  CampaignDetails___vue_scopeId__,
  CampaignDetails___vue_module_identifier__
)

/* harmony default export */ var Campaigns_Details_CampaignDetails = (CampaignDetails_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/NotFound/NotFound.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var NotFound = ({
  name: 'Login',
  data: function data() {
    return {
      hostname: location.hostname
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff2da5fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFound/NotFound.vue
var NotFound_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-8 col-md-6 offset-sm-0 offset-sm-2 offset-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body text-center"},[_c('h1',{staticClass:"card-title"},[_vm._v("\n              404\n            ")]),_vm._v(" "),_c('h2',{staticClass:"card-subtitle"},[_vm._v("\n              Page not found :(\n            ")]),_vm._v(" "),_c('p',{staticClass:"card-subtitle"},[_vm._v("\n              The page you are looking for doesn't exist or an other error occured.\n            ")]),_vm._v(" "),_c('p',{staticClass:"card-subtitle"},[_vm._v("\n              Head over to \n              "),_c('router-link',{attrs:{"to":{ name: 'Dashboard' }}},[_vm._v("\n                "+_vm._s(_vm.hostname)+"\n              ")]),_vm._v("\n               to choose a new direction.\n            ")],1)])])])])])])}
var NotFound_staticRenderFns = []
var NotFound_esExports = { render: NotFound_render, staticRenderFns: NotFound_staticRenderFns }
/* harmony default export */ var NotFound_NotFound = (NotFound_esExports);
// CONCATENATED MODULE: ./src/pages/NotFound/NotFound.vue
function NotFound_injectStyle (ssrContext) {
  __webpack_require__("VfHG")
}
var NotFound_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NotFound___vue_template_functional__ = false
/* styles */
var NotFound___vue_styles__ = NotFound_injectStyle
/* scopeId */
var NotFound___vue_scopeId__ = "data-v-ff2da5fe"
/* moduleIdentifier (server only) */
var NotFound___vue_module_identifier__ = null
var NotFound_Component = NotFound_normalizeComponent(
  NotFound,
  NotFound_NotFound,
  NotFound___vue_template_functional__,
  NotFound___vue_styles__,
  NotFound___vue_scopeId__,
  NotFound___vue_module_identifier__
)

/* harmony default export */ var pages_NotFound_NotFound = (NotFound_Component.exports);

// EXTERNAL MODULE: ./node_modules/contentful/dist/es-modules/contentful.js + 12 modules
var contentful = __webpack_require__("c/SZ");

// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/rich-text-types.es5.js
var rich_text_types_es5 = __webpack_require__("Ej2Q");
var rich_text_types_es5_default = /*#__PURE__*/__webpack_require__.n(rich_text_types_es5);

// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-html-renderer/dist/rich-text-html-renderer.es5.js
var rich_text_html_renderer_es5 = __webpack_require__("1bXE");
var rich_text_html_renderer_es5_default = /*#__PURE__*/__webpack_require__.n(rich_text_html_renderer_es5);

// CONCATENATED MODULE: ./src/helpers/contentful.js


var _renderNode;





function getProperty(obj, key) {
  return key.split('.').reduce(function (o, x) {
    return typeof o === 'undefined' || o === null ? o : o[x];
  }, obj);
} // getProperty()
function isEntryType(entry, type) {
  return getProperty(entry, 'data.target.sys.contentType.sys.id') === type;
}
function isVideoEntry(entry) {
  return isEntryType(entry, 'video');
}
function getVideoId(url) {
  // eslint-disable-next-line
  var m = /(?:^.*(?:\?v=|\&v=)([^#\&\?]*).*)/.exec(url);
  if (m.length >= 2) return m[1];
  return url;
}

var contentful_client = contentful["a" /* createClient */]({
  space: "4bmyqjwq5d2x",
  accessToken: "33f4e22fb6d65a3378f665dbd9c09b92b54fcf51505b87de69725ab5af835eda"
});

var fetchGuide = function fetchGuide() {
  return contentful_client.getEntries({
    'fields.name': 'root',
    content_type: 'category',
    include: '3'
  }).then(function (entry) {
    // console.log(entry);
    return entry.items[0];
  }).catch(
  /* eslint-disable no-console */
  console.error);
};

var fetchEntry = function fetchEntry(id) {
  return contentful_client.getEntry(id).then(function (entry) {
    return entry;
  }).catch(
  /* eslint-disable no-console */
  console.error);
};

var renderEmbeddedEntryBlock = function renderEmbeddedEntryBlock(entry) {
  // console.log('Embedded Entry', entry.data); // todo: remove in prod
  if (isVideoEntry(entry)) {
    var data = getProperty(entry, 'data.target');
    var vid = getVideoId(data.fields.url);
    return '\n    <section class="container-fluid">\n    <div class="video-container">\n    <iframe width="' + data.fields.width + '" height="' + data.fields.height + '" \n    src="https://www.youtube.com/embed/' + vid + '?autoplay=0&showinfo=0&controls=0&modestbranding=1" frameborder="0" allowfullscreen</iframe>\n    </div> \n    </section>\n';
  }
};

var renderEmbeddedAsset = function renderEmbeddedAsset(node) {
  /* eslint-disable no-console */

  var iconleft = 10; // icon left-margin offset
  var maxheight = 200; // max image height
  var imgmargin = 10; // total margin set in css (this is immutable); need this to calculate proper icon offset

  var zoomhtml = '';
  // eslint-disable-next-line
  var imgclass = '';
  var imgattr = '';

  var img = node.data.target.fields;
  var imgsize = node.data.target.fields.file.details.image;

  // console.log('img(', img.title, ',', imgsize.width, ',', imgsize.height, '):', img);

  var imgwidthscaled = imgsize.width;
  if (imgsize.height > maxheight - imgmargin) {
    // adjust offset as image will be scaled down
    imgwidthscaled = imgsize.width * ((maxheight - imgmargin) / imgsize.height);
    var iconoffsetx = imgwidthscaled / 2;
    iconoffsetx -= iconleft;
    zoomhtml = '<span class="icon mdi mdi-arrow-expand-all" style="margin-left:-' + iconoffsetx + 'px"></span>';
    imgclass = 'zoom';
  }

  if (/.gif/.test(img.file.url)) {
    imgclass += ' gif';
    imgattr += ' onmouseover="this.src=\'' + img.file.url + '\'"';
  }

  var desc = img.description;
  if (typeof desc === 'undefined') desc = '';

  return '\n    <div class="contentful-asset">\n      <!-- ' + img.title + ' ' + imgsize.width + 'x' + imgsize.height + '  width scaled: ' + imgwidthscaled + ' -->      \n      <img class="img-responsive img-center mt-5 mb-3" style="max-width: 760px" src="' + img.file.url + '" title="' + desc + '" alt="" ' + imgattr + '/>        \n      <!---->\n      ' + zoomhtml + '\n    </div>\n    ';

  // if (typeof desc === 'undefined') desc = '';
  //
  // img = node.data.target.fields;
  // /* eslint-disable no-console */
  // console.log('img:', img);
  //
  // return `
  //   <div class="contentful-asset">
  //     <img src="${node.data.target.fields.file.url}" title="${desc}" alt="" class="responsive"/>
  //     <span class="icon mdi mdi-arrow-expand-all" style="margin-left:-50px"></span>
  //   </div>
  //   `;
};

var htmlRenderOptions = {
  renderNode: (_renderNode = {}, defineProperty_default()(_renderNode, rich_text_types_es5["INLINES"].HYPERLINK, function (node, next) {
    return '<a href="' + node.data.uri + '" target="_blank">' + next(node.content) + '</a>';
  }), defineProperty_default()(_renderNode, rich_text_types_es5["BLOCKS"].EMBEDDED_ASSET, function (node) {
    return renderEmbeddedAsset(node);
  }), defineProperty_default()(_renderNode, rich_text_types_es5["BLOCKS"].EMBEDDED_ENTRY, function (node) {
    return renderEmbeddedEntryBlock(node);
  }), defineProperty_default()(_renderNode, rich_text_types_es5["INLINES"].EMBEDDED_ENTRY, function () {
    return 'inlines > embedded entry';
  }), _renderNode)
};

var contentful_renderDocument = function renderDocument(document) {
  var html = '';

  try {
    html = Object(rich_text_html_renderer_es5["documentToHtmlString"])(document, htmlRenderOptions);
  } catch (err) {
    html = 'Content not available. <!-- ' + err.message + ' -->';
  }

  return html;
};

var renderVideo = function renderVideo(video) {
  /* eslint-disable no-console */
  // console.log('Video', video);
  return '<img src="' + video.fields.file.url + '" alt="' + video.fields.title + '">';
};

// export const renderMarked = doc => {
//   return `<div class="markdown">${marked(doc, { sanitize: true })}</div>`;
// };
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Guide/Guide.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Guide = ({
  components: { Spinner: src_components_Spinner },
  props: {
    id: String
  },
  data: function data() {
    return {
      guide: {},
      isLoading: false
    };
  },
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.fetchData();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    '$route': 'fetchData'
  },
  computed: {
    documents: function documents() {
      return this.guide.fields.documents || [];
    }
  },
  mounted: function mounted() {
    var markedjs = document.createElement('script');
    markedjs.setAttribute('src', 'https://cdn.jsdelivr.net/npm/marked/marked.min.js');
    document.head.appendChild(markedjs);

    this.$nextTick(function () {
      // wait for entire view to render
      // will trigger before contentful async load completes
    });
  },

  methods: {
    renderDocument: contentful_renderDocument,
    renderVideo: renderVideo,
    fetchData: function fetchData() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoading = true;
                _context2.next = 3;
                return fetchEntry(_this2.id);

              case 3:
                _this2.guide = _context2.sent;

                _this2.isLoading = false;

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1267f90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Guide/Guide.vue
var Guide_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('spinner',{attrs:{"fullScreen":""}}):_c('section',{staticClass:"container-fluid"},[_c('header',[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.guide.fields.displayName))])]),_vm._v(" "),_c('v-expansion-panel',{attrs:{"popout":""}},_vm._l((_vm.documents),function(document,index){return _c('v-expansion-panel-content',{key:document.sys.id},[_c('div',{staticClass:"text-info",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n        "+_vm._s(index+1)+". "+_vm._s(document.fields.title)+"\n      ")]),_vm._v(" "),(document.fields.video)?_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{staticClass:"white",attrs:{"row":"","justify-center":""}},[_c('v-card',{staticClass:"border border-light z-depth-1 ma-1 elevation-1"},[_c('video',{staticClass:"img-responsive",staticStyle:{"max-width":"760px"},attrs:{"controls":"","src":document.fields.video.fields.file.url}})])],1)],1):_vm._e(),_vm._v(" "),_c('v-card',[_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.renderDocument(document.fields.body))}})],1)],1)}),1)],1)}
var Guide_staticRenderFns = []
var Guide_esExports = { render: Guide_render, staticRenderFns: Guide_staticRenderFns }
/* harmony default export */ var Guide_Guide = (Guide_esExports);
// CONCATENATED MODULE: ./src/pages/Guide/Guide.vue
function Guide_injectStyle (ssrContext) {
  __webpack_require__("Lx+I")
}
var Guide_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Guide___vue_template_functional__ = false
/* styles */
var Guide___vue_styles__ = Guide_injectStyle
/* scopeId */
var Guide___vue_scopeId__ = "data-v-e1267f90"
/* moduleIdentifier (server only) */
var Guide___vue_module_identifier__ = null
var Guide_Component = Guide_normalizeComponent(
  Guide,
  Guide_Guide,
  Guide___vue_template_functional__,
  Guide___vue_styles__,
  Guide___vue_scopeId__,
  Guide___vue_module_identifier__
)

/* harmony default export */ var pages_Guide_Guide = (Guide_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ModalButtons.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ModalButtons = ({
  name: 'modal-buttons',
  props: {
    disableButtons: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitButtonText: {
      type: String,
      default: 'Save'
    }
  },
  computed: {
    submitText: function submitText() {
      return this.loading ? 'Processing data' : this.submitButtonText;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c48a43b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalButtons.vue
var ModalButtons_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-info",class:{'with-spinner-btn': _vm.loading},attrs:{"disabled":_vm.disableButtons,"type":"button"},on:{"click":function($event){return _vm.$emit('save')}}},[_vm._v("\n    "+_vm._s(_vm.submitText)+"\n  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"disabled":_vm.disableButtons,"type":"button"},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("\n    Cancel\n  ")])])}
var ModalButtons_staticRenderFns = []
var ModalButtons_esExports = { render: ModalButtons_render, staticRenderFns: ModalButtons_staticRenderFns }
/* harmony default export */ var components_ModalButtons = (ModalButtons_esExports);
// CONCATENATED MODULE: ./src/components/ModalButtons.vue
function ModalButtons_injectStyle (ssrContext) {
  __webpack_require__("u4yn")
}
var ModalButtons_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ModalButtons___vue_template_functional__ = false
/* styles */
var ModalButtons___vue_styles__ = ModalButtons_injectStyle
/* scopeId */
var ModalButtons___vue_scopeId__ = "data-v-c48a43b4"
/* moduleIdentifier (server only) */
var ModalButtons___vue_module_identifier__ = null
var ModalButtons_Component = ModalButtons_normalizeComponent(
  ModalButtons,
  components_ModalButtons,
  ModalButtons___vue_template_functional__,
  ModalButtons___vue_styles__,
  ModalButtons___vue_scopeId__,
  ModalButtons___vue_module_identifier__
)

/* harmony default export */ var src_components_ModalButtons = (ModalButtons_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ModalTitle.vue
//
//
//
//
//
//
//

/* harmony default export */ var ModalTitle = ({
  name: 'modal-title',
  props: {
    title: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b483cca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalTitle.vue
var ModalTitle_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"modal-header bg-light"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.title))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close","aria-hidden":"true"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("×")])])}
var ModalTitle_staticRenderFns = []
var ModalTitle_esExports = { render: ModalTitle_render, staticRenderFns: ModalTitle_staticRenderFns }
/* harmony default export */ var components_ModalTitle = (ModalTitle_esExports);
// CONCATENATED MODULE: ./src/components/ModalTitle.vue
var ModalTitle_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ModalTitle___vue_template_functional__ = false
/* styles */
var ModalTitle___vue_styles__ = null
/* scopeId */
var ModalTitle___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ModalTitle___vue_module_identifier__ = null
var ModalTitle_Component = ModalTitle_normalizeComponent(
  ModalTitle,
  components_ModalTitle,
  ModalTitle___vue_template_functional__,
  ModalTitle___vue_styles__,
  ModalTitle___vue_scopeId__,
  ModalTitle___vue_module_identifier__
)

/* harmony default export */ var src_components_ModalTitle = (ModalTitle_Component.exports);

// CONCATENATED MODULE: ./src/mixins/ModalMixin.js
/* harmony default export */ var ModalMixin = ({
  methods: {
    close: function close() {
      this.$router.go(-1);
    }
  }
});
// EXTERNAL MODULE: ./node_modules/dialog-polyfill/dialog-polyfill.js
var dialog_polyfill_dialog_polyfill = __webpack_require__("Smrn");
var dialog_polyfill_dialog_polyfill_default = /*#__PURE__*/__webpack_require__.n(dialog_polyfill_dialog_polyfill);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Dialog = ({
  name: 'dialog-component',
  mixins: [ModalMixin],
  mounted: function mounted() {
    this.$nextTick(function onMounted() {
      var _this = this;

      dialog_polyfill_dialog_polyfill_default.a.registerDialog(this.$refs.dialog);
      this.$refs.dialog.showModal();
      document.addEventListener('keyup', function (e) {
        if (e.keyCode === 27) {
          // Esc
          _this.closeModal();
        }
      });
    });
  },

  methods: {
    closeModal: function closeModal() {
      if (this.customClose) {
        this.customClose();
      } else {
        this.close();
      }
    }
  },
  beforeUnmount: function beforeUnmount() {
    this.$refs.dialog.close();
    document.removeEventListener('keyup', this.closeModal);
  },

  components: {
    ModalButtons: src_components_ModalButtons,
    ModalTitle: src_components_ModalTitle
  },
  props: {
    size: {
      type: String,
      default: 'medium',
      validate: function validate(size) {
        return ['small', 'medium', 'large', 'extra-large'].includes(size);
      }
    },
    center: Boolean,
    title: String,
    customClose: Function,
    submitButtonText: String,
    hideModalButtons: {
      type: Boolean,
      default: false
    },
    disableButtons: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a4c760b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dialog.vue
var Dialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog',{ref:"dialog",staticClass:"custom-component",class:(_vm.size + " " + (_vm.center ? 'center' : '')),attrs:{"id":"dialog"}},[_c('modal-title',{attrs:{"title":_vm.title},on:{"close":_vm.closeModal}}),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2),_vm._v(" "),(!_vm.hideModalButtons)?_c('modal-buttons',{attrs:{"submitButtonText":_vm.submitButtonText,"disableButtons":_vm.disableButtons,"loading":_vm.loading},on:{"save":function($event){return _vm.$emit('submit')},"cancel":_vm.closeModal}}):_vm._e()],1)}
var Dialog_staticRenderFns = []
var Dialog_esExports = { render: Dialog_render, staticRenderFns: Dialog_staticRenderFns }
/* harmony default export */ var components_Dialog = (Dialog_esExports);
// CONCATENATED MODULE: ./src/components/Dialog.vue
function Dialog_injectStyle (ssrContext) {
  __webpack_require__("Mexu")
}
var Dialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Dialog___vue_template_functional__ = false
/* styles */
var Dialog___vue_styles__ = Dialog_injectStyle
/* scopeId */
var Dialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Dialog___vue_module_identifier__ = null
var Dialog_Component = Dialog_normalizeComponent(
  Dialog,
  components_Dialog,
  Dialog___vue_template_functional__,
  Dialog___vue_styles__,
  Dialog___vue_scopeId__,
  Dialog___vue_module_identifier__
)

/* harmony default export */ var src_components_Dialog = (Dialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Json.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Json = ({
  name: 'json',
  data: function data() {
    return {
      openedClildren: []
    };
  },

  props: {
    input: {
      validator: function validator() {
        return true;
      }
    },
    open: {
      type: Boolean,
      default: true
    },
    parentKey: {
      type: [String, Number, undefined]
    }
  },
  methods: {
    toggleSelf: function toggleSelf(key) {
      this.$emit('open', key);
    },
    childIsFolder: function childIsFolder(value) {
      return value !== null && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object';
    },
    childIsString: function childIsString(value) {
      return typeof value === 'string';
    },
    toggleChild: function toggleChild(key) {
      if (this.isChildOpen(key)) {
        this.openedClildren = this.openedClildren.filter(function (k) {
          return k !== key;
        });
        return;
      }
      this.openedClildren.push(key);
    },
    isChildOpen: function isChildOpen(key) {
      return this.openedClildren.includes(key);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6531d656","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Json.vue
var Json_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(Array.isArray(_vm.input))?_c('span',[_vm._v("[")]):_c('span',[_vm._v("{")]),_vm._v(" "),(!_vm.open)?_c('span',{staticClass:"collapsed",on:{"click":function($event){return _vm.toggleSelf(_vm.parentKey)}}},[_vm._v("· · ·")]):_c('ul',{class:{ array: Array.isArray(_vm.input) }},_vm._l((_vm.input),function(val,key){return _c('li',{key:val+key},[(_vm.childIsFolder(val))?_c('span',{staticClass:"folder",class:{ opened: _vm.isChildOpen(key) }},[_c('ins',{on:{"click":function($event){return _vm.toggleChild(key)}}},[_c('span',{staticClass:"key"},[_vm._v("\""+_vm._s(key)+"\": ")])]),_vm._v(" "),_c('json',{attrs:{"input":val,"open":_vm.isChildOpen(key),"parentKey":key},on:{"open":_vm.toggleChild}})],1):(_vm.childIsString(val))?_c('span',{staticClass:"plain"},[_c('span',{staticClass:"key"},[_vm._v("\""+_vm._s(key)+"\": ")]),_c('span',{staticClass:"value string"},[_vm._v(" \""+_vm._s(val)+"\",")])]):_c('span',{staticClass:"plain"},[_c('span',{staticClass:"key"},[_vm._v("\""+_vm._s(key)+"\": ")]),_c('span',{staticClass:"value"},[_vm._v(" "+_vm._s(val)+",")])])])}),0),_vm._v(" "),(Array.isArray(_vm.input))?_c('span',[_vm._v("]")]):_c('span',[_vm._v("}")]),_vm._v(" "),(_vm.parentKey)?_c('span',[_vm._v(",")]):_vm._e()])}
var Json_staticRenderFns = []
var Json_esExports = { render: Json_render, staticRenderFns: Json_staticRenderFns }
/* harmony default export */ var components_Json = (Json_esExports);
// CONCATENATED MODULE: ./src/components/Json.vue
function Json_injectStyle (ssrContext) {
  __webpack_require__("x885")
}
var Json_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Json___vue_template_functional__ = false
/* styles */
var Json___vue_styles__ = Json_injectStyle
/* scopeId */
var Json___vue_scopeId__ = "data-v-6531d656"
/* moduleIdentifier (server only) */
var Json___vue_module_identifier__ = null
var Json_Component = Json_normalizeComponent(
  Json,
  components_Json,
  Json___vue_template_functional__,
  Json___vue_styles__,
  Json___vue_scopeId__,
  Json___vue_module_identifier__
)

/* harmony default export */ var src_components_Json = (Json_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/LeadModal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var LeadModal = ({
  name: 'Lead',
  components: {
    DialogComponent: src_components_Dialog,
    Spinner: src_components_Spinner,
    json: src_components_Json
  },
  data: function data() {
    var id = this.$route && this.$route.params && this.$route.params.id ? +this.$route.params.id : -1;

    return {
      id: id,
      lead: {},
      title: 'Lead ID: ' + id,
      showSpinner: 0
    };
  },


  computed: {
    isLeadEmpty: function isLeadEmpty() {
      return Object(lodash["isEmpty"])(this.lead);
    }
  },
  apollo: {
    lead: {
      query: Lead_default.a,
      loadingKey: 'showSpinner',
      variables: function variables() {
        return {
          id: this.id
        };
      }
    }
  },
  methods: {
    closeModal: function closeModal() {
      this.$router.push({ name: 'Leads' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13df0fb3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/LeadModal.vue
var LeadModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-component',{attrs:{"title":this.title,"customClose":this.closeModal,"hideModalButtons":""}},[_c('div',{staticClass:"dialog-content"},[(!_vm.isLeadEmpty && !_vm.showSpinner)?_c('div',{staticClass:"lead-source"},[_c('json',{attrs:{"input":_vm.lead}})],1):_vm._e(),_vm._v(" "),(_vm.showSpinner)?_c('spinner'):_vm._e(),_vm._v(" "),(_vm.isLeadEmpty && !_vm.showSpinner)?_c('div',{staticClass:"text-center no-data-label"},[_c('i',[_vm._v("Nothing to show")])]):_vm._e()],1)])}
var LeadModal_staticRenderFns = []
var LeadModal_esExports = { render: LeadModal_render, staticRenderFns: LeadModal_staticRenderFns }
/* harmony default export */ var modals_LeadModal = (LeadModal_esExports);
// CONCATENATED MODULE: ./src/modals/LeadModal.vue
function LeadModal_injectStyle (ssrContext) {
  __webpack_require__("jyry")
}
var LeadModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LeadModal___vue_template_functional__ = false
/* styles */
var LeadModal___vue_styles__ = LeadModal_injectStyle
/* scopeId */
var LeadModal___vue_scopeId__ = "data-v-13df0fb3"
/* moduleIdentifier (server only) */
var LeadModal___vue_module_identifier__ = null
var LeadModal_Component = LeadModal_normalizeComponent(
  LeadModal,
  modals_LeadModal,
  LeadModal___vue_template_functional__,
  LeadModal___vue_styles__,
  LeadModal___vue_scopeId__,
  LeadModal___vue_module_identifier__
)

/* harmony default export */ var src_modals_LeadModal = (LeadModal_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Campaigns/AssignedCampaigns.gql
var AssignedCampaigns = __webpack_require__("RtgL");
var AssignedCampaigns_default = /*#__PURE__*/__webpack_require__.n(AssignedCampaigns);

// EXTERNAL MODULE: ./src/graphql/Campaigns/AssignCampaigns.gql
var AssignCampaigns = __webpack_require__("nDDb");
var AssignCampaigns_default = /*#__PURE__*/__webpack_require__.n(AssignCampaigns);

// EXTERNAL MODULE: ./src/graphql/Users/User.gql
var User = __webpack_require__("nyn+");
var User_default = /*#__PURE__*/__webpack_require__.n(User);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/AssignCampaign.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var AssignCampaign = ({
  name: 'assign-component',
  mixins: [ModalMixin],
  components: {
    Dialog: src_components_Dialog,
    Spinner: src_components_Spinner
  },
  props: {
    userId: Number
  },

  data: function data() {
    return {
      items: [],
      checkedItems: [],
      companies: [],
      roles: [],
      companyId: 0,
      user: {},
      showSpinner: 0,
      disableAll: false,
      loadingSaveBtn: false
    };
  },


  computed: {
    title: function title() {
      if (!this.user.role) {
        return '';
      }
      var _user = this.user,
          name = _user.name,
          role_type = _user.role.role_type;

      var capitalizedRole = role_type[0].toUpperCase() + role_type.slice(1);

      return name && capitalizedRole ? 'Assign Campaign to ' + name + ' (role \'' + capitalizedRole + '\')' : '';
    },
    isRepresentative: function isRepresentative() {
      if (!this.user.role) {
        return false;
      }
      return this.user.role.role_type === 'representative';
    },
    isAllChecked: function isAllChecked() {
      return this.checkedItems.length && this.checkedItems.length === this.items.length;
    },
    clientRole: function clientRole() {
      return this.roles.find(function (role) {
        return role.role_type === 'client';
      });
    }
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.disableAll = true;
      this.loadingSaveBtn = true;

      this.$apollo.mutate({
        mutation: AssignCampaigns_default.a,
        variables: {
          userId: this.userId,
          campaignIds: this.checkedItems.map(function (item) {
            return parseInt(item);
          })
        }
      }).then(function () {
        _this.close();

        _this.$notify({
          group: 'success',
          type: 'success',
          text: 'Campaign was assigned'
        });
      }).catch(function (e) {
        _this.$notify({
          group: 'error',
          type: 'error',
          text: e.message
        });
      }).finally(function () {
        _this.disableAll = false;
        _this.loadingSaveBtn = false;
      });
    },
    toggleAll: function toggleAll() {
      if (this.isAllChecked) {
        // uncheck
        this.checkedItems = [];
      } else {
        this.checkedItems = this.items.map(function (item) {
          return item.id;
        });
      }
    }
  },

  apollo: {
    assignableCampaigns: {
      query: AssignableCampaigns_default.a,
      loadingKey: 'showSpinner',
      fetchPolicy: 'network-only',
      result: function result(_ref) {
        var data = _ref.data,
            loading = _ref.loading;

        if (!loading) {
          this.items = data.assignableCampaigns;
        }
      },
      variables: function variables() {
        var query = {};
        if (this.isRepresentative) {
          query.companyId = this.companyId;
        } else {
          query.userId = this.userId;
        }
        return query;
      }
    },

    assignedCampaigns: {
      query: AssignedCampaigns_default.a,
      loadingKey: 'showSpinner',
      fetchPolicy: 'network-only',
      result: function result(_ref2) {
        var data = _ref2.data,
            loading = _ref2.loading;

        if (!loading) {
          this.checkedItems = Object(lodash["uniq"])(data.assignedCampaigns.map(function (item) {
            return item.id;
          }));
        }
      },
      variables: function variables() {
        return {
          userId: this.userId
        };
      }
    },

    roles: {
      query: UserRole_default.a,
      fetchPolicy: 'network-only',
      result: function result(_ref3) {
        var data = _ref3.data,
            loading = _ref3.loading;

        if (!loading) {
          this.roles = data.roles;
        }
      }
    },

    user: {
      query: User_default.a,
      fetchPolicy: 'network-only',
      result: function result(_ref4) {
        var data = _ref4.data,
            loading = _ref4.loading;

        if (!loading) {
          this.user = data.user;
        }
      },
      variables: function variables() {
        return {
          id: this.userId
        };
      }
    },

    companies: {
      query: Companies_default.a,
      fetchPolicy: 'network-only',
      result: function result(_ref5) {
        var data = _ref5.data,
            loading = _ref5.loading;

        if (!loading) {
          this.companies = data.companies.result;
        }
      },
      variables: function variables() {
        return {
          limit: -1,
          status: true
        };
      },
      skip: function skip() {
        return !this.isRepresentative || !this.clientRole;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67cbaf08","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/AssignCampaign.vue
var AssignCampaign_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"title":_vm.showSpinner ? '' : _vm.title,"disableButtons":_vm.disableAll || !!_vm.showSpinner,"loading":_vm.loadingSaveBtn},on:{"submit":_vm.onSubmit}},[(_vm.showSpinner)?_c('div',{staticClass:"spinner-wrap"},[_c('spinner')],1):_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"container"},[(_vm.isRepresentative)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"companyName"}},[_c('b',[_vm._v("Company Name:")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.companyId),expression:"companyId"}],staticClass:"form-control",attrs:{"id":"companyName"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.companyId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"","value":"0"}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.companies),function(company){return _c('option',{key:company.id,domProps:{"value":company.id}},[_vm._v(_vm._s(company.companyName))])})],2)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","disabled":_vm.disableAll},domProps:{"checked":_vm.isAllChecked},on:{"click":_vm.toggleAll}}),_vm._v(" "),_c('b',[_vm._v("Campaign Name")])])])]),_vm._v(" "),(_vm.isRepresentative)?_c('div',{staticClass:"col"},[_c('b',[_vm._v("Company Name")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"container items"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedItems),expression:"checkedItems"}],staticClass:"form-check-input",attrs:{"disabled":_vm.disableAll,"type":"checkbox"},domProps:{"value":item.id,"checked":Array.isArray(_vm.checkedItems)?_vm._i(_vm.checkedItems,item.id)>-1:(_vm.checkedItems)},on:{"change":function($event){var $$a=_vm.checkedItems,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedItems=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedItems=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedItems=$$c}}}}),_vm._v("\n              "+_vm._s(item.campaignName)+"\n            ")])])]),_vm._v(" "),(_vm.isRepresentative)?_c('div',{staticClass:"col"},[_vm._v("\n          "+_vm._s(item.companyName)+"\n        ")]):_vm._e()])}),0)])])}
var AssignCampaign_staticRenderFns = []
var AssignCampaign_esExports = { render: AssignCampaign_render, staticRenderFns: AssignCampaign_staticRenderFns }
/* harmony default export */ var modals_AssignCampaign = (AssignCampaign_esExports);
// CONCATENATED MODULE: ./src/modals/AssignCampaign.vue
function AssignCampaign_injectStyle (ssrContext) {
  __webpack_require__("UqoZ")
}
var AssignCampaign_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AssignCampaign___vue_template_functional__ = false
/* styles */
var AssignCampaign___vue_styles__ = AssignCampaign_injectStyle
/* scopeId */
var AssignCampaign___vue_scopeId__ = "data-v-67cbaf08"
/* moduleIdentifier (server only) */
var AssignCampaign___vue_module_identifier__ = null
var AssignCampaign_Component = AssignCampaign_normalizeComponent(
  AssignCampaign,
  modals_AssignCampaign,
  AssignCampaign___vue_template_functional__,
  AssignCampaign___vue_styles__,
  AssignCampaign___vue_scopeId__,
  AssignCampaign___vue_module_identifier__
)

/* harmony default export */ var src_modals_AssignCampaign = (AssignCampaign_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Users/AssignableUsers.gql
var AssignableUsers = __webpack_require__("2OLb");
var AssignableUsers_default = /*#__PURE__*/__webpack_require__.n(AssignableUsers);

// EXTERNAL MODULE: ./src/graphql/Users/AssignedUsers.gql
var AssignedUsers = __webpack_require__("LNGa");
var AssignedUsers_default = /*#__PURE__*/__webpack_require__.n(AssignedUsers);

// EXTERNAL MODULE: ./src/graphql/Users/AssignUsers.gql
var AssignUsers = __webpack_require__("zhG3");
var AssignUsers_default = /*#__PURE__*/__webpack_require__.n(AssignUsers);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/AssignUser.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var AssignUser = ({
  name: 'assign-component',
  mixins: [ModalMixin],
  components: {
    Dialog: src_components_Dialog,
    Spinner: src_components_Spinner
  },
  props: {
    campaignId: Number,
    companyId: Number
  },

  data: function data() {
    return {
      items: [],
      checkedItems: [],
      campaign: {
        campaignName: ''
      },
      showSpinner: 0,
      disableAll: false,
      loadingSaveBtn: false
    };
  },


  computed: {
    title: function title() {
      var campaignName = this.campaign.campaignName;

      return campaignName ? 'Assign User to ' + campaignName : '';
    },
    isAllChecked: function isAllChecked() {
      return this.checkedItems.length && this.checkedItems.length === this.items.length;
    }
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.disableAll = true;
      this.loadingSaveBtn = true;

      this.$apollo.mutate({
        mutation: AssignUsers_default.a,
        variables: {
          campaignId: this.campaignId,
          userIds: this.checkedItems.map(function (uid) {
            return parseInt(uid);
          }),
          users: this.items.map(function (_ref) {
            var id = _ref.id,
                email = _ref.email,
                role = _ref.role;
            return {
              id: id,
              email: email,
              role: role
            };
          })
        }
      }).then(function () {
        _this.close();

        _this.$notify({
          group: 'success',
          type: 'success',
          text: 'Campaign was assigned'
        });
      }).catch(function (e) {
        _this.$notify({
          group: 'error',
          type: 'error',
          text: e.message
        });
      }).finally(function () {
        _this.disableAll = false;
        _this.loadingSaveBtn = false;
      });
    },
    toggleAll: function toggleAll() {
      if (this.isAllChecked) {
        // uncheck
        this.checkedItems = [];
      } else {
        this.checkedItems = this.items.map(function (item) {
          return item.id;
        });
      }
    }
  },

  apollo: {
    assignableUsers: {
      query: AssignableUsers_default.a,
      fetchPolicy: 'network-only',
      loadingKey: 'showSpinner',
      result: function result(_ref2) {
        var data = _ref2.data,
            loading = _ref2.loading;

        if (!loading) {
          this.items = data.assignableUsers;
        }
      },
      variables: function variables() {
        return { companyId: this.companyId };
      }
    },
    assignedUsers: {
      query: AssignedUsers_default.a,
      fetchPolicy: 'network-only',
      result: function result(_ref3) {
        var data = _ref3.data,
            loading = _ref3.loading;

        if (!loading) {
          this.checkedItems = Object(lodash["uniq"])(data.assignedUsers.map(function (item) {
            return item.id;
          }));
        }
      },
      variables: function variables() {
        return {
          campaignId: this.campaignId
        };
      }
    },
    campaign: {
      query: Campaign_default.a,
      fetchPolicy: 'network-only',
      loadingKey: 'showSpinner',
      result: function result(_ref4) {
        var data = _ref4.data,
            loading = _ref4.loading;

        if (!loading) {
          this.campaign = data.campaign;
        }
      },
      variables: function variables() {
        return {
          id: this.campaignId
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b0926c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/AssignUser.vue
var AssignUser_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"title":_vm.showSpinner ? '' : _vm.title,"disableButtons":_vm.disableAll || !!_vm.showSpinner,"loading":_vm.loadingSaveBtn},on:{"submit":_vm.onSubmit}},[(_vm.showSpinner)?_c('div',{staticClass:"spinner-wrap"},[_c('spinner')],1):_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"container header-wrap"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","disabled":_vm.disableAll},domProps:{"checked":_vm.isAllChecked},on:{"click":_vm.toggleAll}}),_vm._v(" "),_c('b',[_vm._v("User Name")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('b',[_vm._v("User Email")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b',[_vm._v("User Role")])])])]),_vm._v(" "),_c('div',{staticClass:"container items"},_vm._l((_vm.items),function(item){return _c('label',{key:item.id,staticClass:"form-check-label"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedItems),expression:"checkedItems"}],staticClass:"form-check-input",attrs:{"type":"checkbox","disabled":_vm.disableAll},domProps:{"value":+item.id,"checked":Array.isArray(_vm.checkedItems)?_vm._i(_vm.checkedItems,+item.id)>-1:(_vm.checkedItems)},on:{"change":function($event){var $$a=_vm.checkedItems,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=+item.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedItems=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedItems=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedItems=$$c}}}}),_vm._v("\n              "+_vm._s(item.name)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_vm._v("\n            "+_vm._s(item.email)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_vm._v("\n            "+_vm._s(item.role)+"\n          ")])])])}),0)])])}
var AssignUser_staticRenderFns = []
var AssignUser_esExports = { render: AssignUser_render, staticRenderFns: AssignUser_staticRenderFns }
/* harmony default export */ var modals_AssignUser = (AssignUser_esExports);
// CONCATENATED MODULE: ./src/modals/AssignUser.vue
function AssignUser_injectStyle (ssrContext) {
  __webpack_require__("8i23")
}
var AssignUser_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AssignUser___vue_template_functional__ = false
/* styles */
var AssignUser___vue_styles__ = AssignUser_injectStyle
/* scopeId */
var AssignUser___vue_scopeId__ = "data-v-7b0926c9"
/* moduleIdentifier (server only) */
var AssignUser___vue_module_identifier__ = null
var AssignUser_Component = AssignUser_normalizeComponent(
  AssignUser,
  modals_AssignUser,
  AssignUser___vue_template_functional__,
  AssignUser___vue_styles__,
  AssignUser___vue_scopeId__,
  AssignUser___vue_module_identifier__
)

/* harmony default export */ var src_modals_AssignUser = (AssignUser_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Users/AddUser.gql
var AddUser = __webpack_require__("ZrH6");
var AddUser_default = /*#__PURE__*/__webpack_require__.n(AddUser);

// EXTERNAL MODULE: ./src/graphql/Users/UpdateUser.gql
var UpdateUser = __webpack_require__("fI04");
var UpdateUser_default = /*#__PURE__*/__webpack_require__.n(UpdateUser);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/AddUser.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var modals_AddUser = ({
  name: 'add-user',
  mixins: [ModalMixin],
  components: {
    Dialog: src_components_Dialog,
    Switches: vue_switches_src_switches,
    Multiselect: components_CustomMultiselect
  },
  props: {
    userId: Number
  },

  data: function data() {
    return {
      form: {
        role: null,
        company: null,
        status: true
      },
      roles: [],
      showSpinner: false,
      companies: []
    };
  },


  computed: {
    title: function title() {
      return this.userId ? 'Edit Account' : 'Create New Account';
    },
    prepareCompanies: function prepareCompanies() {
      return this.companies.map(function (company) {
        return {
          id: company.id,
          companyName: company.companyName
        };
      });
    },
    showCompanyInput: function showCompanyInput() {
      var _this = this;

      if (!this.form.role || !this.form.role.id || !this.roles.length) {
        return false;
      }

      return this.roles.find(function (role) {
        return +role.id === +_this.form.role.id;
      }).role_type === 'client';
    },
    passwordValidation: function passwordValidation() {
      return this.userId ? 'min:6' : 'required|min:6';
    }
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var isValid, user, mutation;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$validator.validateAll();

              case 2:
                isValid = _context.sent;


                if (isValid) {
                  // form data
                  user = {
                    name: _this2.form.name,
                    email: _this2.form.email,
                    phone: _this2.form.phone,
                    roleId: +_this2.form.role.id,
                    password: _this2.form.password,
                    status: !!_this2.form.status
                  };


                  if (_this2.form.company) {
                    user.companyId = parseInt(_this2.form.company.id);
                  }

                  mutation = void 0;
                  // update existing user

                  if (_this2.userId) {
                    mutation = _this2.updateUser(_this2.userId, user);
                  } else {
                    // create a new user
                    mutation = _this2.addUser(user);
                  }

                  _this2.showSpinner = true;

                  mutation.then(function () {
                    // hide modal
                    _this2.close();
                  }).catch(function (e) {
                    // highlight invalid fields
                    if (e.message.includes('ER_DUP_ENTRY')) {
                      _this2.$validator.errors.add('email', 'This email was registered');
                    } else if (e.graphQLErrors[0].data.field) {
                      _this2.$validator.errors.add(e.graphQLErrors[0].data.field, e.graphQLErrors[0].message);
                    } else {
                      _this2.$notify({
                        group: 'error',
                        type: 'error',
                        text: e.message
                      });
                    }
                  }).finally(function () {
                    _this2.showSpinner = false;
                  });
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    addUser: function addUser(user) {
      return this.$apollo.mutate({
        // Query
        mutation: AddUser_default.a,
        variables: {
          input: user
        },
        refetchQueries: function refetchQueries(_ref) {
          var data = _ref.data;

          return data.addUser.success ? ['users'] : [];
        }
      });
    },
    updateUser: function updateUser(id, user) {
      return this.$apollo.mutate({
        // Query
        mutation: UpdateUser_default.a,
        variables: {
          id: id,
          input: extends_default()({}, user, {
            companyId: this.showCompanyInput ? parseInt(user.companyId) : null
          })
        },
        refetchQueries: function refetchQueries(_ref2) {
          var data = _ref2.data;

          return data.updateUser.success ? ['users'] : [];
        }
      });
    }
  },

  apollo: {
    user: {
      query: User_default.a,
      fetchPolicy: 'network-only',
      result: function result(_ref3) {
        var data = _ref3.data,
            loading = _ref3.loading;

        if (loading) {
          return;
        }
        // fulfill form
        this.form = extends_default()({}, data.user, {
          role: { id: data.user.role.id, role_type: data.user.role.role_type },
          company: {
            id: data.user.company ? data.user.company.id : null,
            companyName: data.user.company ? data.user.company.companyName : null
          }
        });
      },
      variables: function variables() {
        return {
          id: this.userId
        };
      },
      skip: function skip() {
        return !this.userId;
      }
    },

    roles: {
      query: UserRole_default.a,
      fetchPolicy: 'network-only',
      result: function result(_ref4) {
        var data = _ref4.data,
            loading = _ref4.loading;

        if (!loading) {
          this.roles = data.roles.map(function (_ref5) {
            var id = _ref5.id,
                role_type = _ref5.role_type;
            return {
              id: id,
              role_type: role_type
            };
          });
        }
      }
    },

    companies: {
      query: Companies_default.a,
      fetchPolicy: 'network-only',
      result: function result(_ref6) {
        var data = _ref6.data,
            loading = _ref6.loading;

        if (!loading) {
          this.companies = data.companies.result.map(function (comp) {
            return {
              id: comp.id,
              companyName: comp.companyName
            };
          });
        }
      },
      variables: function variables() {
        return {
          limit: 0
        };
      },
      skip: function skip() {
        return !this.showCompanyInput;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3794214","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/AddUser.vue
var AddUser_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"title":_vm.title},on:{"submit":_vm.onSubmit}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model.trim",value:(_vm.form.name),expression:"form.name",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('name')},attrs:{"type":"text","id":"name","name":"name","autofocus":""},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('name')),expression:"errors.has('name')"}],staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.errors.first('name'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|emailStrict'),expression:"'required|emailStrict'"},{name:"model",rawName:"v-model.trim",value:(_vm.form.email),expression:"form.email",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('email')},attrs:{"type":"email","id":"email","name":"email"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.errors.first('email'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"},{name:"model",rawName:"v-model",value:(_vm.form.phone),expression:"form.phone"},{name:"validate",rawName:"v-validate",value:({ regex: /^\(\d{3}\) \d{3}-\d{4}$/ }),expression:"{ regex: /^\\(\\d{3}\\) \\d{3}-\\d{4}$/ }"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('phone')},attrs:{"type":"text","id":"phone","name":"phone","placeholder":"(999) 999-9999"},domProps:{"value":(_vm.form.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "phone", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('phone')),expression:"errors.has('phone')"}],staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.errors.first('phone'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role"}},[_vm._v("Role*")]),_vm._v(" "),_c('multiselect',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"role","options":_vm.roles,"fieldName":"role_type","defaultValue":_vm.form.role,"name":"role","data-vv-as":"Role","isValid":!_vm.errors.has('role')},model:{value:(_vm.form.role),callback:function ($$v) {_vm.$set(_vm.form, "role", $$v)},expression:"form.role"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('role')),expression:"errors.has('role')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('role'))+"\n      ")])],1),_vm._v(" "),(_vm.showCompanyInput)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"company"}},[_vm._v("Company*")]),_vm._v(" "),_c('multiselect',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"company","options":_vm.prepareCompanies,"fieldName":"companyName","name":"company","data-vv-as":"Company","isValid":!_vm.errors.has('company')},model:{value:(_vm.form.company),callback:function ($$v) {_vm.$set(_vm.form, "company", $$v)},expression:"form.company"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('company')),expression:"errors.has('company')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('company'))+"\n      ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.passwordValidation),expression:"passwordValidation"},{name:"model",rawName:"v-model.trim",value:(_vm.form.password),expression:"form.password",modifiers:{"trim":true}}],ref:"password",staticClass:"form-control",class:{'is-invalid': _vm.errors.has('password')},attrs:{"type":"password","id":"password","name":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.errors.first('password'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"password2"}},[_vm._v("Confirm Password*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.form.password ? 'required|confirmed:password' : ''),expression:"form.password ? 'required|confirmed:password' : ''"},{name:"model",rawName:"v-model.trim",value:(_vm.form.password2),expression:"form.password2",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('password2')},attrs:{"type":"password","id":"password2","data-vv-as":"confirm password","name":"password2"},domProps:{"value":(_vm.form.password2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password2", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password2')),expression:"errors.has('password2')"}],staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.errors.first('password2'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"password2"}},[_vm._v("Status")]),_vm._v(" "),_c('switches',{attrs:{"color":"green"},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])])}
var AddUser_staticRenderFns = []
var AddUser_esExports = { render: AddUser_render, staticRenderFns: AddUser_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_modals_AddUser = (AddUser_esExports);
// CONCATENATED MODULE: ./src/modals/AddUser.vue
function AddUser_injectStyle (ssrContext) {
  __webpack_require__("CC0Y")
}
var AddUser_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AddUser___vue_template_functional__ = false
/* styles */
var AddUser___vue_styles__ = AddUser_injectStyle
/* scopeId */
var AddUser___vue_scopeId__ = "data-v-a3794214"
/* moduleIdentifier (server only) */
var AddUser___vue_module_identifier__ = null
var AddUser_Component = AddUser_normalizeComponent(
  modals_AddUser,
  selectortype_template_index_0_src_modals_AddUser,
  AddUser___vue_template_functional__,
  AddUser___vue_styles__,
  AddUser___vue_scopeId__,
  AddUser___vue_module_identifier__
)

/* harmony default export */ var src_modals_AddUser = (AddUser_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Payment/CreatePayment.gql
var CreatePayment = __webpack_require__("84UR");
var CreatePayment_default = /*#__PURE__*/__webpack_require__.n(CreatePayment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/CreatePaymentModal.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var CreatePaymentModal = ({
  name: 'CreatePayment',
  components: { Dialog: src_components_Dialog, Spinner: src_components_Spinner },
  mixins: [ModalMixin],
  props: {
    id: String
  },
  data: function data() {
    return {
      errorMessage: {},
      currencies: [],
      showSpinner: false,
      form: {
        amount: 0,
        currencyId: 1,
        description: ''
      }
    };
  },

  computed: {
    title: function title() {
      return 'Card: **** **** **** ' + this.$route.query.cardNumber;
    }
  },
  methods: {
    createPayment: function createPayment() {
      return this.$apollo.mutate({
        mutation: CreatePayment_default.a,
        variables: {
          companyId: this.$route.params.id,
          payment: extends_default()({}, this.form, {
            amount: parseFloat(this.form.amount),
            currencyId: parseInt(this.form.currencyId),
            description: this.form.description,
            cardId: this.$route.query.cardId
          })
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var isValid;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:
                _this.showSpinner = true;
                _context.next = 9;
                return _this.createPayment();

              case 9:
                _this.$notify({
                  group: 'success',
                  type: 'success',
                  text: 'Payment was created'
                });
                _this.close();
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                _this.$notify({
                  group: 'error',
                  type: 'error',
                  text: _context.t0.message
                });

              case 16:
                _this.showSpinner = false;

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 13]]);
      }))();
    }
  },
  apollo: {
    currencies: {
      query: Currencies_default.a,
      loadingKey: 'showSpinner'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abcc4676","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/CreatePaymentModal.vue
var CreatePaymentModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"title":_vm.title,"submitButtonText":"Create Payment"},on:{"submit":_vm.onSubmit}},[(_vm.showSpinner)?_c('div',{staticClass:"spinner-wrap"},[_c('spinner')],1):_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"currency"}},[_vm._v("Currency")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.currencyId),expression:"form.currencyId"}],staticClass:"form-control",attrs:{"id":"currency"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "currencyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.currencies),function(currency){return _c('option',{key:currency.id,domProps:{"value":currency.id}},[_vm._v("\n          "+_vm._s(currency.code)+" - "+_vm._s(currency.name)+"\n        ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"amount"}},[_vm._v("Amount*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min_value:0.5'),expression:"'required|min_value:0.5'"},{name:"model",rawName:"v-model",value:(_vm.form.amount),expression:"form.amount"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('amount')},attrs:{"type":"number","id":"amount","name":"amount"},domProps:{"value":(_vm.form.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "amount", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('amount')),expression:"errors.has('amount')"}],staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.errors.first('amount'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"description"}},[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control main-textarea",attrs:{"rows":"3","id":"description","name":"description","placeholder":"Optional"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})])])])}
var CreatePaymentModal_staticRenderFns = []
var CreatePaymentModal_esExports = { render: CreatePaymentModal_render, staticRenderFns: CreatePaymentModal_staticRenderFns }
/* harmony default export */ var modals_CreatePaymentModal = (CreatePaymentModal_esExports);
// CONCATENATED MODULE: ./src/modals/CreatePaymentModal.vue
function CreatePaymentModal_injectStyle (ssrContext) {
  __webpack_require__("Y8Br")
}
var CreatePaymentModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreatePaymentModal___vue_template_functional__ = false
/* styles */
var CreatePaymentModal___vue_styles__ = CreatePaymentModal_injectStyle
/* scopeId */
var CreatePaymentModal___vue_scopeId__ = "data-v-abcc4676"
/* moduleIdentifier (server only) */
var CreatePaymentModal___vue_module_identifier__ = null
var CreatePaymentModal_Component = CreatePaymentModal_normalizeComponent(
  CreatePaymentModal,
  modals_CreatePaymentModal,
  CreatePaymentModal___vue_template_functional__,
  CreatePaymentModal___vue_styles__,
  CreatePaymentModal___vue_scopeId__,
  CreatePaymentModal___vue_module_identifier__
)

/* harmony default export */ var src_modals_CreatePaymentModal = (CreatePaymentModal_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Transactions/NewTransaction.gql
var NewTransaction = __webpack_require__("ETBo");
var NewTransaction_default = /*#__PURE__*/__webpack_require__.n(NewTransaction);

// EXTERNAL MODULE: ./src/graphql/Balance/Balance.gql
var Balance = __webpack_require__("7Gbs");
var Balance_default = /*#__PURE__*/__webpack_require__.n(Balance);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/AddTransactionModal.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var AddTransactionModal = ({
  name: 'add-transaction-component',
  mixins: [ModalMixin],
  components: {
    Dialog: src_components_Dialog,
    Switches: vue_switches_src_switches
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      transaction: {
        amount: 0,
        notes: 0
      },
      currency: {},
      currencies: [],
      balance: ''
    };
  },

  computed: {
    title: function title() {
      return 'Create New Transaction';
    },
    newBalance: function newBalance() {
      return this.balance + +this.transaction.amount;
    },

    amount: {
      get: function get() {
        return this.transaction && this.transaction.amount || '';
      },
      set: function set(val) {
        this.transaction.amount = val;
      }
    },
    currentBalance: {
      get: function get() {
        return this.balance || 0;
      },
      set: function set(val) {
        this.balance = val;
      }
    },
    notes: {
      get: function get() {
        return this.transaction && this.transaction.notes || '';
      },
      set: function set(val) {
        this.transaction.notes = val;
      }
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var isValid;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return');

              case 11:

                _this.createTransaction();

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    getCurrency: function getCurrency(companyCurrency) {
      var defaultCurrency = {
        name: 'Not set'
      };

      return this.currencies.find(function (currency) {
        return +currency.id === +companyCurrency;
      }) || defaultCurrency;
    },
    createTransaction: function createTransaction() {
      var _this2 = this;

      this.$apollo.mutate({
        mutation: NewTransaction_default.a,
        variables: {
          id: parseInt(this.id),
          input: {
            notes: this.transaction.notes,
            amount: parseFloat(this.transaction.amount),
            currencyId: parseInt(this.currency.id)
          }
        },
        refetchQueries: function refetchQueries(_ref) {
          var data = _ref.data;

          var response = data.createTransaction;
          return response && response.success ? ['transactions'] : [];
        }
      }).then(function () {
        _this2.$notify({
          group: 'success',
          type: 'success',
          text: 'Transaction was created'
        });
        _this2.close();
      }).catch(function (e) {
        _this2.$notify({
          group: 'error',
          type: 'error',
          text: e.message
        });
      });
    }
  },

  apollo: {
    currencies: {
      query: Currencies_default.a,
      fetchPolicy: 'cache-and-network',
      result: function result(_ref2) {
        var data = _ref2.data,
            loading = _ref2.loading;

        if (!loading) {
          this.currencies = data.currencies;
        }
      }
    },
    company: {
      query: Company_default.a,
      fetchPolicy: 'cache-and-network',
      variables: function variables() {
        return {
          id: +this.id
        };
      },
      result: function result(_ref3) {
        var data = _ref3.data,
            loading = _ref3.loading;

        if (!loading) {
          this.currency = this.getCurrency(data.company.currency);
        }
      },
      skip: function skip() {
        return !this.id;
      }
    },
    transaction: {
      query: Balance_default.a,
      fetchPolicy: 'cache-and-network',
      variables: function variables() {
        return {
          id: +this.id
        };
      },
      result: function result(_ref4) {
        var data = _ref4.data,
            loading = _ref4.loading;

        if (!loading) {
          this.balance = data.balance ? data.balance.balance : 0;
          this.transaction = {
            amount: '',
            notes: ''
          };
        }
      },
      skip: function skip() {
        return !this.id;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-378f63e1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/AddTransactionModal.vue
var AddTransactionModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"title":_vm.title},on:{"submit":_vm.onSubmit}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"amount"}},[_vm._v("Amount*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model.trim",value:(_vm.amount),expression:"amount",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('amount')},attrs:{"type":"number","id":"amount","name":"amount","autofocus":""},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('amount')),expression:"errors.has('amount')"}],staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.errors.first('amount'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"description"}},[_vm._v("Description*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notes),expression:"notes"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control main-textarea",class:{'is-invalid': _vm.errors.has('description')},attrs:{"rows":"3","id":"description","name":"description","placeholder":"Enter description"},domProps:{"value":(_vm.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notes=$event.target.value}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('description')),expression:"errors.has('description')"}],staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.errors.first('description'))+"\n      ")])]),_vm._v(" "),_c('div',[_vm._v("\n      Currency: "),_c('span',{staticClass:"badge badge-warning"},[_vm._v(_vm._s(_vm.currency.name)+" ("+_vm._s(_vm.currency.code)+")")])])])])}
var AddTransactionModal_staticRenderFns = []
var AddTransactionModal_esExports = { render: AddTransactionModal_render, staticRenderFns: AddTransactionModal_staticRenderFns }
/* harmony default export */ var modals_AddTransactionModal = (AddTransactionModal_esExports);
// CONCATENATED MODULE: ./src/modals/AddTransactionModal.vue
function AddTransactionModal_injectStyle (ssrContext) {
  __webpack_require__("Zymp")
}
var AddTransactionModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AddTransactionModal___vue_template_functional__ = false
/* styles */
var AddTransactionModal___vue_styles__ = AddTransactionModal_injectStyle
/* scopeId */
var AddTransactionModal___vue_scopeId__ = "data-v-378f63e1"
/* moduleIdentifier (server only) */
var AddTransactionModal___vue_module_identifier__ = null
var AddTransactionModal_Component = AddTransactionModal_normalizeComponent(
  AddTransactionModal,
  modals_AddTransactionModal,
  AddTransactionModal___vue_template_functional__,
  AddTransactionModal___vue_styles__,
  AddTransactionModal___vue_scopeId__,
  AddTransactionModal___vue_module_identifier__
)

/* harmony default export */ var src_modals_AddTransactionModal = (AddTransactionModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExclusiveChoice.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ExclusiveChoice = ({
  name: 'exclusive-choice',
  props: {
    question: Object,
    answer: String
  },
  computed: {
    value: {
      get: function get() {
        return this.answer;
      },
      set: function set(answer) {
        this.$emit('change', answer);
      }
    },
    prefix: function prefix() {
      return new Date().getTime();
    },
    options: function options() {
      if (this.question) {
        if (this.question.options) {
          return this.question.options;
        } else if (this.question.params) {
          return this.question.params.options;
        }
      }
      return [];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68706b63","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExclusiveChoice.vue
var ExclusiveChoice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.options),function(option){return _c('div',{staticClass:"choice-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"choice-input",attrs:{"type":"radio","id":(_vm.prefix + "-exclusive-" + (_vm.question.id) + "-" + option),"name":(_vm.prefix + "-exclusive-" + (_vm.question.id))},domProps:{"value":option,"checked":_vm._q(_vm.value,option)},on:{"change":function($event){_vm.value=option}}}),_vm._v(" "),_c('label',{staticClass:"choice-label",attrs:{"for":(_vm.prefix + "-exclusive-" + (_vm.question.id) + "-" + option)}},[_vm._v(_vm._s(option))])])}),0)}
var ExclusiveChoice_staticRenderFns = []
var ExclusiveChoice_esExports = { render: ExclusiveChoice_render, staticRenderFns: ExclusiveChoice_staticRenderFns }
/* harmony default export */ var components_ExclusiveChoice = (ExclusiveChoice_esExports);
// CONCATENATED MODULE: ./src/components/ExclusiveChoice.vue
function ExclusiveChoice_injectStyle (ssrContext) {
  __webpack_require__("uRGi")
}
var ExclusiveChoice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ExclusiveChoice___vue_template_functional__ = false
/* styles */
var ExclusiveChoice___vue_styles__ = ExclusiveChoice_injectStyle
/* scopeId */
var ExclusiveChoice___vue_scopeId__ = "data-v-68706b63"
/* moduleIdentifier (server only) */
var ExclusiveChoice___vue_module_identifier__ = null
var ExclusiveChoice_Component = ExclusiveChoice_normalizeComponent(
  ExclusiveChoice,
  components_ExclusiveChoice,
  ExclusiveChoice___vue_template_functional__,
  ExclusiveChoice___vue_styles__,
  ExclusiveChoice___vue_scopeId__,
  ExclusiveChoice___vue_module_identifier__
)

/* harmony default export */ var src_components_ExclusiveChoice = (ExclusiveChoice_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MultipleChoice.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MultipleChoice = ({
  name: 'multiple-choice',
  props: {
    question: Object,
    answer: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    value: {
      get: function get() {
        return this.answer;
      },
      set: function set(answer) {
        this.$emit('change', answer);
      }
    },
    prefix: function prefix() {
      return new Date().getTime();
    },
    options: function options() {
      if (this.question) {
        if (this.question.options) {
          return this.question.options;
        } else if (this.question.params) {
          return this.question.params.options;
        }
      }
      return [];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2da20313","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MultipleChoice.vue
var MultipleChoice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.options),function(option){return _c('div',{staticClass:"choice-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"choice-input",attrs:{"type":"checkbox","id":(_vm.prefix + "-multiple-" + (_vm.question.id) + "-" + option),"name":(_vm.prefix + "-multiple-" + (_vm.question.id))},domProps:{"value":option,"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,option)>-1:(_vm.value)},on:{"change":function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=option,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]))}else{$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.value=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"choice-label",attrs:{"for":(_vm.prefix + "-multiple-" + (_vm.question.id) + "-" + option)}},[_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(option))])])])}),0)}
var MultipleChoice_staticRenderFns = []
var MultipleChoice_esExports = { render: MultipleChoice_render, staticRenderFns: MultipleChoice_staticRenderFns }
/* harmony default export */ var components_MultipleChoice = (MultipleChoice_esExports);
// CONCATENATED MODULE: ./src/components/MultipleChoice.vue
function MultipleChoice_injectStyle (ssrContext) {
  __webpack_require__("pNQG")
}
var MultipleChoice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MultipleChoice___vue_template_functional__ = false
/* styles */
var MultipleChoice___vue_styles__ = MultipleChoice_injectStyle
/* scopeId */
var MultipleChoice___vue_scopeId__ = "data-v-2da20313"
/* moduleIdentifier (server only) */
var MultipleChoice___vue_module_identifier__ = null
var MultipleChoice_Component = MultipleChoice_normalizeComponent(
  MultipleChoice,
  components_MultipleChoice,
  MultipleChoice___vue_template_functional__,
  MultipleChoice___vue_styles__,
  MultipleChoice___vue_scopeId__,
  MultipleChoice___vue_module_identifier__
)

/* harmony default export */ var src_components_MultipleChoice = (MultipleChoice_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ChatMessage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ChatMessage = ({
  name: 'chat-message',
  components: {
    ExclusiveChoice: src_components_ExclusiveChoice,
    MultipleChoice: src_components_MultipleChoice
  },
  props: {
    message: Object
  },
  data: function data() {
    return {
      isCopyHovered: false,
      highlightCopyIcon: false
    };
  },

  computed: {
    timestamp: function timestamp() {
      var date = new Date(this.message.timestamp);
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    safeMessage: function safeMessage() {
      if (this.message) {
        var decoder = document.createElement('div');
        decoder.innerText = this.message.message;
        return decoder.innerHTML;
      }
      return '';
    },


    answer: {
      get: function get() {
        if (this.answers && this.message.question && this.message.question.id) {
          return this.answers[this.message.question.id];
        }
      },
      set: function set(answer) {
        this.setQuestionAnswer({
          questionId: this.message.question.id,
          answer: answer
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5281b28b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChatMessage.vue
var ChatMessage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-wrapper"},[_c('div',{staticClass:"chat-content",class:{hovered: _vm.isCopyHovered}},[(_vm.message.byRepresentative)?_c('h5',[_vm._v(_vm._s(_vm.message.representativeName))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box bg-light-success",class:[_vm.message.byRepresentative ? 'bg-light-success' : 'bg-light-info' ],domProps:{"innerHTML":_vm._s(_vm.safeMessage)}}),_vm._v(" "),(_vm.message.question)?_c('div',{staticClass:"options"},[(_vm.message.question.type === 'Multiple Choice')?_c('div',[_c('multiple-choice',{attrs:{"question":_vm.message.question,"answer":_vm.answer},on:{"change":function($event){_vm.answer = $event}}})],1):(_vm.message.question.type === 'Exclusive Choice')?_c('div',[_c('exclusive-choice',{attrs:{"question":_vm.message.question,"answer":_vm.answer},on:{"change":function($event){_vm.answer = $event}}})],1):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.message.isTyping)?_c('div',{staticClass:"chat-time text-danger"},[_vm._v("Typing ...")]):_c('div',{staticClass:"chat-time"},[_c('span',[_vm._v(_vm._s(_vm.timestamp))]),_vm._v(" "),(!_vm.message.byRepresentative)?_c('i',{staticClass:"fa fa-file-o copy-reply-btn",class:{'fa-file': _vm.highlightCopyIcon },on:{"mouseover":function($event){_vm.isCopyHovered = true},"mouseout":function($event){_vm.isCopyHovered = false},"click":function($event){return _vm.copyToClipboard(_vm.message.message)}}}):_vm._e()])])}
var ChatMessage_staticRenderFns = []
var ChatMessage_esExports = { render: ChatMessage_render, staticRenderFns: ChatMessage_staticRenderFns }
/* harmony default export */ var components_ChatMessage = (ChatMessage_esExports);
// CONCATENATED MODULE: ./src/components/ChatMessage.vue
function ChatMessage_injectStyle (ssrContext) {
  __webpack_require__("Jikj")
}
var ChatMessage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChatMessage___vue_template_functional__ = false
/* styles */
var ChatMessage___vue_styles__ = ChatMessage_injectStyle
/* scopeId */
var ChatMessage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChatMessage___vue_module_identifier__ = null
var ChatMessage_Component = ChatMessage_normalizeComponent(
  ChatMessage,
  components_ChatMessage,
  ChatMessage___vue_template_functional__,
  ChatMessage___vue_styles__,
  ChatMessage___vue_scopeId__,
  ChatMessage___vue_module_identifier__
)

/* harmony default export */ var src_components_ChatMessage = (ChatMessage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Chat.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Chat = ({
  name: 'chat',
  props: {
    messages: {
      type: Array,
      required: true
    },
    ticketId: String,
    location: String
  },
  components: {
    ChatMessage: src_components_ChatMessage
  },
  filters: {
    shorten: function shorten(value) {
      return value ? value.slice(value.length - 4) : '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ddd6349","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat.vue
var Chat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column-wrapper"},[_c('ul',{ref:"chat",staticClass:"chat-list"},[(_vm.ticketId)?_c('li',{staticClass:"text-center m-t-10"},[_c('span',{staticClass:"badge badge-pill badge-info"},[_c('i',{staticClass:"fa fa-map-marker p-r-10"}),_vm._v(_vm._s(_vm.location))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.messages),function(message){return _c('li',{key:message.key,class:{'reverse by-representative': message.byRepresentative}},[_c('chat-message',{attrs:{"message":message}})],1)}),_vm._v(" "),_c('li',{ref:"chatBottom",staticClass:"chat-bottom"})],2)])}
var Chat_staticRenderFns = []
var Chat_esExports = { render: Chat_render, staticRenderFns: Chat_staticRenderFns }
/* harmony default export */ var components_Chat = (Chat_esExports);
// CONCATENATED MODULE: ./src/components/Chat.vue
function Chat_injectStyle (ssrContext) {
  __webpack_require__("+ros")
}
var Chat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Chat___vue_template_functional__ = false
/* styles */
var Chat___vue_styles__ = Chat_injectStyle
/* scopeId */
var Chat___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Chat___vue_module_identifier__ = null
var Chat_Component = Chat_normalizeComponent(
  Chat,
  components_Chat,
  Chat___vue_template_functional__,
  Chat___vue_styles__,
  Chat___vue_scopeId__,
  Chat___vue_module_identifier__
)

/* harmony default export */ var src_components_Chat = (Chat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/Chat.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var modals_Chat = ({
  components: { Dialog: src_components_Dialog, Chat: src_components_Chat },
  created: function created() {
    var _this = this;

    this.ref = db.child('tickets/' + this.$route.params.ticketId);
    this.ref.on('value', function (snapshot) {
      var ticket = snapshot.val() || {};
      _this.messages = values_default()(ticket.messages || {});
      _this.location = _this.formatLocation(ticket.ipstack);
    });
  },
  destroyed: function destroyed() {
    this.ref.off('value');
  },
  data: function data() {
    return {
      messages: [],
      location: {}
    };
  },

  methods: {
    formatLocation: function formatLocation() {
      var ipstack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return ipstack.country_name + ', ' + ipstack.region_name + ', ' + ipstack.city;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-082e0686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/Chat.vue
var modals_Chat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"hideModalButtons":"","center":"","size":"extra-large","title":_vm.$route.params.ticketId}},[_c('chat',{attrs:{"messages":_vm.messages,"location":_vm.location,"ticketId":_vm.$route.params.ticketId}})],1)}
var modals_Chat_staticRenderFns = []
var modals_Chat_esExports = { render: modals_Chat_render, staticRenderFns: modals_Chat_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_modals_Chat = (modals_Chat_esExports);
// CONCATENATED MODULE: ./src/modals/Chat.vue
var modals_Chat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var modals_Chat___vue_template_functional__ = false
/* styles */
var modals_Chat___vue_styles__ = null
/* scopeId */
var modals_Chat___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var modals_Chat___vue_module_identifier__ = null
var modals_Chat_Component = modals_Chat_normalizeComponent(
  modals_Chat,
  selectortype_template_index_0_src_modals_Chat,
  modals_Chat___vue_template_functional__,
  modals_Chat___vue_styles__,
  modals_Chat___vue_scopeId__,
  modals_Chat___vue_module_identifier__
)

/* harmony default export */ var src_modals_Chat = (modals_Chat_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Companies/CreateCompany.gql
var CreateCompany = __webpack_require__("0vHi");
var CreateCompany_default = /*#__PURE__*/__webpack_require__.n(CreateCompany);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/EditCompanyModal.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var EditCompanyModal = ({
  name: 'edit-company-component',
  mixins: [ModalMixin],
  components: {
    Switches: vue_switches_src_switches,
    DialogComponent: src_components_Dialog
  },
  props: {
    id: String
  },

  data: function data() {
    return {
      company: {
        companyName: '',
        description: '',
        currency: 1,
        status: true
      },
      currencies: []
    };
  },

  computed: {
    title: function title() {
      return (this.id ? 'Update' : 'Create') + ' Company';
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var valid;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                valid = _context.sent;

                if (valid) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return');

              case 11:

                _this.$apollo.mutate({
                  mutation: _this.id ? EditCompany_default.a : CreateCompany_default.a,
                  variables: {
                    id: parseInt(_this.id),
                    input: omit_default()(_this.company, ['id'])
                  },
                  refetchQueries: function refetchQueries(_ref) {
                    var data = _ref.data;

                    var response = data.createCompany || data.updateCompany;
                    return response && response.success ? ['companies'] : [];
                  }
                }).then(function () {
                  _this.$notify({
                    group: 'success',
                    type: 'success',
                    text: 'Company was ' + (_this.id ? 'edited' : 'created')
                  });
                  _this.close();
                }).catch(function (e) {
                  if (e.message.includes('ER_DUP_ENTRY')) {
                    _this.$validator.errors.add('companyName', 'This Company Name already exists');
                  } else {
                    _this.$notify({
                      group: 'error',
                      type: 'error',
                      text: e.message
                    });
                  }
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    }
  },
  apollo: {
    company: {
      query: Company_default.a,
      fetchPolicy: 'cache-and-network',
      variables: function variables() {
        return {
          id: +this.id
        };
      },
      result: function result(_ref2) {
        var data = _ref2.data,
            loading = _ref2.loading;

        if (!loading) {
          this.company = {
            companyName: data.company.companyName,
            description: data.company.description,
            status: data.company.status
          };
        }
      },
      skip: function skip() {
        return !this.id;
      }
    },

    currencies: {
      query: Currencies_default.a,
      fetchPolicy: 'cache-and-network',
      result: function result(_ref3) {
        var data = _ref3.data,
            loading = _ref3.loading;

        if (!loading) {
          this.currencies = data.currencies;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03be4ff9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/EditCompanyModal.vue
var EditCompanyModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogComponent',{attrs:{"title":this.title},on:{"submit":_vm.onSubmit}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('b-form-group',{attrs:{"id":"campanyName","label":"Company name:","label-for":"campanyName"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.company.companyName),expression:"company.companyName",modifiers:{"trim":true}},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('companyName')},attrs:{"id":"campanyName","type":"text","placeholder":"Enter company name","data-vv-as":"Company Name","name":"companyName","autofocus":""},domProps:{"value":(_vm.company.companyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "companyName", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('companyName')),expression:"errors.has('companyName')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('companyName'))+"\n      ")])]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"currency","label":"Currency:","label-for":"currency"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.currency),expression:"company.currency"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('currency')},attrs:{"id":"currency","name":"currency","data-vv-as":"Currency"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.company, "currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":"","value":""}},[_vm._v("Select currency")]),_vm._v(" "),_vm._l((_vm.currencies),function(curr){return _c('option',{key:curr.id,domProps:{"value":+curr.id}},[_vm._v(_vm._s(curr.name))])})],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('currency')),expression:"errors.has('currency')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('currency'))+"\n      ")])]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"description","label":"Description:","label-for":"description"}},[_c('b-form-textarea',{attrs:{"placeholder":"Enter description","rows":3,"max-rows":6},model:{value:(_vm.company.description),callback:function ($$v) {_vm.$set(_vm.company, "description", $$v)},expression:"company.description"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"status"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Status")]),_vm._v(" "),_c('switches',{attrs:{"color":"green"},model:{value:(_vm.company.status),callback:function ($$v) {_vm.$set(_vm.company, "status", $$v)},expression:"company.status"}})],1)])],1)])}
var EditCompanyModal_staticRenderFns = []
var EditCompanyModal_esExports = { render: EditCompanyModal_render, staticRenderFns: EditCompanyModal_staticRenderFns }
/* harmony default export */ var modals_EditCompanyModal = (EditCompanyModal_esExports);
// CONCATENATED MODULE: ./src/modals/EditCompanyModal.vue
function EditCompanyModal_injectStyle (ssrContext) {
  __webpack_require__("mcae")
}
var EditCompanyModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditCompanyModal___vue_template_functional__ = false
/* styles */
var EditCompanyModal___vue_styles__ = EditCompanyModal_injectStyle
/* scopeId */
var EditCompanyModal___vue_scopeId__ = "data-v-03be4ff9"
/* moduleIdentifier (server only) */
var EditCompanyModal___vue_module_identifier__ = null
var EditCompanyModal_Component = EditCompanyModal_normalizeComponent(
  EditCompanyModal,
  modals_EditCompanyModal,
  EditCompanyModal___vue_template_functional__,
  EditCompanyModal___vue_styles__,
  EditCompanyModal___vue_scopeId__,
  EditCompanyModal___vue_module_identifier__
)

/* harmony default export */ var src_modals_EditCompanyModal = (EditCompanyModal_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Campaigns/CreateCampaign.gql
var CreateCampaign = __webpack_require__("yiFP");
var CreateCampaign_default = /*#__PURE__*/__webpack_require__.n(CreateCampaign);

// EXTERNAL MODULE: ./src/graphql/Campaigns/EditCampaign.gql
var EditCampaign = __webpack_require__("g4or");
var EditCampaign_default = /*#__PURE__*/__webpack_require__.n(EditCampaign);

// CONCATENATED MODULE: ./src/helpers/checkIsAccessDenied.js
/* harmony default export */ var checkIsAccessDenied = (function (error) {
  var isAccessDenied = false;

  if (!error.graphQLErrors || !error.graphQLErrors.length) {
    return false;
  }

  error.graphQLErrors.forEach(function (_ref) {
    var name = _ref.name;

    if (name === 'ACCESS_DENIED') {
      isAccessDenied = true;
    }
  });

  return isAccessDenied;
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/EditCampaignModal.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ var EditCampaignModal = ({
  name: 'edit-campaign-component',
  mixins: [ModalMixin],
  components: {
    Switches: vue_switches_src_switches,
    DialogComponent: src_components_Dialog,
    Multiselect: components_CustomMultiselect,
    Spinner: src_components_Spinner
  },
  props: {
    id: String
  },
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _ref, data;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$apollo.query({
                query: _this.isClient ? Company_default.a : Companies_default.a,
                variables: _this.isClient ? { id: _this.getAuthUser.companyId } : { limit: -1 }
              });

            case 2:
              _ref = _context.sent;
              data = _ref.data;

              _this.companies = _this.isClient ? [data.company] : data.companies.result;
              if (_this.isClient) {
                _this.campaign.company = data.company;
              }

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      companies: [],
      campaign: {
        campaignName: '',
        dispatchTo: '',
        dispatchToPhone: '',
        company: null,
        status: true,
        editable: false,
        whiteLabel: false
      },
      showSpinner: 0,
      optionStatus: [{ text: 'Enabled', value: true }, { text: 'Disabled', value: false }],
      optionEditable: [{ text: 'Yes', value: true }, { text: 'No', value: false }],
      optionWhitelabel: [{ text: 'Yes', value: true }, { text: 'No', value: false }]
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthUser']), {
    isClient: function isClient() {
      return this.getAuthUser.role.role_type === 'client';
    },
    title: function title() {
      return (this.id ? 'Update' : 'Create') + ' Campaign';
    }
  }),
  methods: {
    onSubmit: function onSubmit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var valid, _campaign, campaignName, dispatchTo, dispatchToPhone, company, status, editable, whiteLabel;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                valid = _context2.sent;

                if (valid) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return');

              case 6:
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);
                return _context2.abrupt('return');

              case 11:
                _campaign = _this2.campaign, campaignName = _campaign.campaignName, dispatchTo = _campaign.dispatchTo, dispatchToPhone = _campaign.dispatchToPhone, company = _campaign.company, status = _campaign.status, editable = _campaign.editable, whiteLabel = _campaign.whiteLabel;


                _this2.$apollo.mutate({
                  mutation: _this2.id ? EditCampaign_default.a : CreateCampaign_default.a,
                  variables: {
                    id: parseInt(_this2.id),
                    input: {
                      campaignName: campaignName,
                      dispatchTo: dispatchTo,
                      dispatchToPhone: dispatchToPhone,
                      companyId: parseInt(company.id),
                      status: status,
                      editable: editable,
                      whiteLabel: whiteLabel
                    }
                  },
                  refetchQueries: function refetchQueries(_ref2) {
                    var data = _ref2.data;

                    var response = data.createCampaign || data.updateCampaign;
                    return response.success ? ['campaigns'] : [];
                  }
                }).then(function () {
                  _this2.$notify({
                    group: 'success',
                    type: 'success',
                    text: 'Campaign was ' + (_this2.id ? 'edited' : 'created')
                  });
                  _this2.close();
                }).catch(function (e) {
                  var isAccessDenied = checkIsAccessDenied(e);

                  if (e.message.includes('ER_DUP_ENTRY')) {
                    return _this2.$validator.errors.add('campaignName', 'This Campaign Name already exists');
                  }

                  if (isAccessDenied) {
                    return _this2.$notify({
                      group: 'error',
                      type: 'error',
                      text: 'Access denied'
                    });
                  }

                  _this2.$notify({
                    group: 'error',
                    type: 'error',
                    text: e.message
                  });
                });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    }
  },
  apollo: {
    campaign: {
      query: Campaign_default.a,
      loadingKey: 'showSpinner',
      fetchPolicy: 'network-only',
      variables: function variables() {
        return {
          id: +this.id
        };
      },
      result: function result(_ref3) {
        var data = _ref3.data,
            loading = _ref3.loading;

        if (!loading) {
          this.campaign = {
            campaignName: data.campaign.campaignName,
            dispatchTo: data.campaign.dispatchTo,
            dispatchToPhone: data.campaign.dispatchToPhone,
            company: data.campaign.company,
            status: data.campaign.status,
            editable: data.campaign.editable,
            whiteLabel: data.campaign.whiteLabel
          };
        }
      },
      skip: function skip() {
        return !this.id;
      },
      error: function error(_error) {
        var isAccessDenied = checkIsAccessDenied(_error);

        if (isAccessDenied) {
          this.$router.push({ name: 'NotFound' });
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67879e1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/EditCampaignModal.vue
var EditCampaignModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSpinner)?_c('spinner',{attrs:{"fullScreen":""}}):_c('DialogComponent',{attrs:{"title":(_vm.campaign.campaignName) ? _vm.campaign.campaignName : 'Unknown Name'},on:{"submit":_vm.onSubmit}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.campaign.status),expression:"!campaign.status"}],staticClass:"alert alert-danger"},[_vm._v("The campaign is disabled")]),_vm._v(" "),_c('form',{on:{"submit":_vm.onSubmit}},[_c('b-form-group',{attrs:{"id":"campaignName","label":"Campaign name:","label-for":"campaignName"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.campaign.campaignName),expression:"campaign.campaignName"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('campaignName')},attrs:{"id":"campaignName","type":"text","placeholder":"Enter campaign name","name":"campaignName","data-vv-as":"Campaign Name","autofocus":""},domProps:{"value":(_vm.campaign.campaignName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.campaign, "campaignName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('campaignName')),expression:"errors.has('campaignName')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('campaignName'))+"\n      ")])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Company Name:","label-for":"companyName"}},[_c('multiselect',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"companyName","disabled":_vm.isClient,"options":_vm.companies,"fieldName":"companyName","defaultValue":_vm.campaign.company,"name":"company","data-vv-as":"Company","isValid":!_vm.errors.has('company')},model:{value:(_vm.campaign.company),callback:function ($$v) {_vm.$set(_vm.campaign, "company", $$v)},expression:"campaign.company"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('company')),expression:"errors.has('company')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('company'))+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('b-form-group',{attrs:{"id":"dispatchTo","label":"Send Leads to Email:","label-for":"dispatchTo"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.campaign.dispatchTo),expression:"campaign.dispatchTo"},{name:"validate",rawName:"v-validate",value:('required|emailStrict'),expression:"'required|emailStrict'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('dispatchTo')},attrs:{"id":"dispatchTo","type":"text","placeholder":"Enter dispatch email","data-vv-as":"Send Leads to Email:","name":"dispatchTo"},domProps:{"value":(_vm.campaign.dispatchTo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.campaign, "dispatchTo", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('dispatchTo')),expression:"errors.has('dispatchTo')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('dispatchTo'))+"\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('b-form-group',{attrs:{"id":"dispatchToPhone","label":"Send SMS Alerts to:","label-for":"dispatchToPhone"}},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"},{name:"model",rawName:"v-model",value:(_vm.campaign.dispatchToPhone),expression:"campaign.dispatchToPhone"},{name:"validate",rawName:"v-validate",value:({ regex: /^\(\d{3}\) \d{3}-\d{4}$/ }),expression:"{ regex: /^\\(\\d{3}\\) \\d{3}-\\d{4}$/ }"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('dispatchToPhone')},attrs:{"id":"dispatchToPhone","type":"text","placeholder":"(999) 999-9999","data-vv-as":"Send SMS Alerts to","name":"dispatchToPhone"},domProps:{"value":(_vm.campaign.dispatchToPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.campaign, "dispatchToPhone", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('dispatchToPhone')),expression:"errors.has('dispatchToPhone')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('dispatchToPhone'))+"\n      ")])])],1)]),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('b-form-group',{attrs:{"id":"status","label":"Status:","label-for":"status"}},[_c('b-form-select',{attrs:{"id":"status","options":_vm.optionStatus},model:{value:(_vm.campaign.status),callback:function ($$v) {_vm.$set(_vm.campaign, "status", $$v)},expression:"campaign.status"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('b-form-group',{attrs:{"id":"editable","label":"Editable:","label-for":"editable"}},[_c('b-form-select',{attrs:{"id":"editable","options":_vm.optionEditable},model:{value:(_vm.campaign.editable),callback:function ($$v) {_vm.$set(_vm.campaign, "editable", $$v)},expression:"campaign.editable"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('b-form-group',{attrs:{"id":"whitelabel","label":"White-Label:","label-for":"whitelabel"}},[_c('b-form-select',{attrs:{"id":"whitelabel","options":_vm.optionWhitelabel},model:{value:(_vm.campaign.whiteLabel),callback:function ($$v) {_vm.$set(_vm.campaign, "whiteLabel", $$v)},expression:"campaign.whiteLabel"}})],1)],1)]):_vm._e()],1)])}
var EditCampaignModal_staticRenderFns = []
var EditCampaignModal_esExports = { render: EditCampaignModal_render, staticRenderFns: EditCampaignModal_staticRenderFns }
/* harmony default export */ var modals_EditCampaignModal = (EditCampaignModal_esExports);
// CONCATENATED MODULE: ./src/modals/EditCampaignModal.vue
function EditCampaignModal_injectStyle (ssrContext) {
  __webpack_require__("AomL")
}
var EditCampaignModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditCampaignModal___vue_template_functional__ = false
/* styles */
var EditCampaignModal___vue_styles__ = EditCampaignModal_injectStyle
/* scopeId */
var EditCampaignModal___vue_scopeId__ = "data-v-67879e1e"
/* moduleIdentifier (server only) */
var EditCampaignModal___vue_module_identifier__ = null
var EditCampaignModal_Component = EditCampaignModal_normalizeComponent(
  EditCampaignModal,
  modals_EditCampaignModal,
  EditCampaignModal___vue_template_functional__,
  EditCampaignModal___vue_styles__,
  EditCampaignModal___vue_scopeId__,
  EditCampaignModal___vue_module_identifier__
)

/* harmony default export */ var src_modals_EditCampaignModal = (EditCampaignModal_Component.exports);

// CONCATENATED MODULE: ./src/helpers/formatError.js
function formatError(err) {
  if (!err.graphQLErrors || !err.graphQLErrors.length) {
    return err.message;
  }
  return err.graphQLErrors.reduce(function (message, err) {
    return message + '\n' + err.message;
  }, '');
}
// CONCATENATED MODULE: ./src/helpers/stepperApiCall.js




var stepperApiCall_apiCall = function apiCall(cb) {
  return (
    // eslint-disable-next-line
    function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _len,
            args,
            _key,
            _args = arguments;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                _context.prev = 1;

                for (_len = _args.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = _args[_key];
                }

                _context.next = 5;
                return cb.apply(this, args);

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](1);

                this.$notify({
                  group: 'error',
                  type: 'error',
                  text: formatError(_context.t0)
                });

              case 10:
                this.loading = false;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 7]]);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

/* harmony default export */ var stepperApiCall = (stepperApiCall_apiCall);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LeadQuestion.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LeadQuestion = ({
  props: {
    withCampaignName: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  computed: {
    types: function types() {
      return [{ text: 'Text', value: 'Free Text' }, { text: 'Email', value: 'Email' }, { text: 'Phone', value: 'Phone' }];
    }
  },
  data: function data() {
    return {
      campaignName: '',
      inputPrompt: '',
      isValid: true,
      questions: [{
        question: '',
        type: 'Free Text',
        mandatory: false
      }]
    };
  },

  methods: {
    addQuestion: function addQuestion() {
      this.questions.push({
        question: '',
        type: 'Free Text',
        mandatory: false
      });
    },
    removeQuestion: function removeQuestion(index) {
      this.questions.splice(index, 1);
    },
    validate: function validate() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var validatorResult;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validate();

              case 2:
                validatorResult = _context.sent;
                return _context.abrupt('return', validatorResult && _this.questions.length > 0);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var campaignName, questions, inputPrompt;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.validate();

              case 2:
                _this2.isValid = _context2.sent;

                if (_this2.isValid) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:
                campaignName = _this2.campaignName, questions = _this2.questions, inputPrompt = _this2.inputPrompt;

                _this2.$emit('submit', {
                  campaignName: campaignName,
                  inputPrompt: inputPrompt,
                  questions: questions
                });

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b10f0b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeadQuestion.vue
var LeadQuestion_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[(_vm.withCampaignName)?_c('v-container',{staticClass:"blue-grey lighten-5",attrs:{"px-3":"","pb-0":"","mb-4":""}},[_c('div',{staticClass:"pb-3 body-2"},[_vm._v("Name your campaign in a way that makes sense to you.")]),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"required":"","name":"campaignName","label":"Campaign Name","data-vv-as":"Campaign Name","error-messages":_vm.errors.first('campaignName'),"solo":""},model:{value:(_vm.campaignName),callback:function ($$v) {_vm.campaignName=$$v},expression:"campaignName"}})],1):_vm._e(),_vm._v(" "),_c('v-container',{staticClass:"green lighten-5 border-light",attrs:{"px-3":"","pt-3":"","pb-0":""}},[_c('div',{staticClass:"pb-4 body-2"},[_vm._v("Enter a short phrase / question to prompt your visitors to engage. For example: "),_c('span',{staticClass:"light-green--text"},[_vm._v("\"Describe your project?\"")])]),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"required":"","name":"inputPrompt","label":"Visitor Prompt","data-vv-as":"Visitor Prompt","error-messages":_vm.errors.first('inputPrompt'),"solo":""},model:{value:(_vm.inputPrompt),callback:function ($$v) {_vm.inputPrompt=$$v},expression:"inputPrompt"}})],1),_vm._v(" "),_c('v-container',{staticClass:"blue lighten-5 border-light",attrs:{"pa-3":"","mt-4":""}},[_c('div',{staticClass:"pb-4 body-2"},[_vm._v("List questions you want your visitors to provide answers to. For example: "),_c('span',{staticClass:"light-blue--text"},[_vm._v("\"What is your phone number?\"")])]),_vm._v(" "),_vm._l((_vm.questions),function(item,index){return [_c('v-layout',{key:index},[_c('v-flex',{attrs:{"md11":"","xs10":"","pr-1":"","py-0":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"required":"","name":("quesiton[" + index + "]"),"label":("Question " + (index+1)),"data-vv-as":"question","error-messages":_vm.errors.first(("question[" + index + "]")),"solo":""},model:{value:(item.question),callback:function ($$v) {_vm.$set(item, "question", $$v)},expression:"item.question"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","pa-0":""}},[_c('v-btn',{attrs:{"disabled":index == 0,"flat":"","icon":"","color":"red"},on:{"click":function($event){return _vm.removeQuestion(index)}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)]}),_vm._v(" "),(_vm.questions.length < 30)?_c('v-btn',{attrs:{"color":"pink","dark":""},on:{"click":_vm.addQuestion}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")]),_vm._v(" Add Question\n    ")],1):_vm._e()],2)],1)}
var LeadQuestion_staticRenderFns = []
var LeadQuestion_esExports = { render: LeadQuestion_render, staticRenderFns: LeadQuestion_staticRenderFns }
/* harmony default export */ var components_LeadQuestion = (LeadQuestion_esExports);
// CONCATENATED MODULE: ./src/components/LeadQuestion.vue
function LeadQuestion_injectStyle (ssrContext) {
  __webpack_require__("wUU+")
}
var LeadQuestion_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LeadQuestion___vue_template_functional__ = false
/* styles */
var LeadQuestion___vue_styles__ = LeadQuestion_injectStyle
/* scopeId */
var LeadQuestion___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LeadQuestion___vue_module_identifier__ = null
var LeadQuestion_Component = LeadQuestion_normalizeComponent(
  LeadQuestion,
  components_LeadQuestion,
  LeadQuestion___vue_template_functional__,
  LeadQuestion___vue_styles__,
  LeadQuestion___vue_scopeId__,
  LeadQuestion___vue_module_identifier__
)

/* harmony default export */ var src_components_LeadQuestion = (LeadQuestion_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CampaignMainInfo.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CampaignMainInfo = ({
  data: function data() {
    return {
      campaignName: '',
      dispatchTo: '',
      shouldCreateLanding: true
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var isValid;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validate();

              case 2:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                _this.$emit("submit", {
                  campaignName: _this.campaignName,
                  dispatchTo: _this.dispatchTo,
                  shouldCreateLanding: _this.shouldCreateLanding
                });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d3fa836","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CampaignMainInfo.vue
var CampaignMainInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[_c('v-container',{staticClass:"blue-grey lighten-5",attrs:{"px-3":"","pb-0":""}},[_c('div',{staticClass:"pb-3 body-2"},[_vm._v("Name your campaign in a way that makes sense to you.")]),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"required":"","name":"campaignName","label":"Campaign Name","data-vv-as":"Campaign Name","error-messages":_vm.errors.first('campaignName'),"solo":""},model:{value:(_vm.campaignName),callback:function ($$v) {_vm.campaignName=$$v},expression:"campaignName"}})],1),_vm._v(" "),_c('v-container',{staticClass:"green lighten-5 border-light",attrs:{"px-3":"","pb-0":"","mt-3":""}},[_c('div',{staticClass:"pb-3 body-2"},[_vm._v("This is email your leads will be sent to.")]),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"required":"","name":"dispatchTo","label":"Dispatch Email","data-vv-as":"Dispatch Email","error-messages":_vm.errors.first('dispatchTo'),"solo":""},model:{value:(_vm.dispatchTo),callback:function ($$v) {_vm.dispatchTo=$$v},expression:"dispatchTo"}})],1),_vm._v(" "),_c('v-container',{staticClass:"lighten-5",attrs:{"px-3":"","pb-0":""}},[_c('v-checkbox',{attrs:{"label":"Generate Landing Page"},model:{value:(_vm.shouldCreateLanding),callback:function ($$v) {_vm.shouldCreateLanding=$$v},expression:"shouldCreateLanding"}})],1)],1)}
var CampaignMainInfo_staticRenderFns = []
var CampaignMainInfo_esExports = { render: CampaignMainInfo_render, staticRenderFns: CampaignMainInfo_staticRenderFns }
/* harmony default export */ var components_CampaignMainInfo = (CampaignMainInfo_esExports);
// CONCATENATED MODULE: ./src/components/CampaignMainInfo.vue
function CampaignMainInfo_injectStyle (ssrContext) {
  __webpack_require__("DizW")
}
var CampaignMainInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CampaignMainInfo___vue_template_functional__ = false
/* styles */
var CampaignMainInfo___vue_styles__ = CampaignMainInfo_injectStyle
/* scopeId */
var CampaignMainInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CampaignMainInfo___vue_module_identifier__ = null
var CampaignMainInfo_Component = CampaignMainInfo_normalizeComponent(
  CampaignMainInfo,
  components_CampaignMainInfo,
  CampaignMainInfo___vue_template_functional__,
  CampaignMainInfo___vue_styles__,
  CampaignMainInfo___vue_scopeId__,
  CampaignMainInfo___vue_module_identifier__
)

/* harmony default export */ var src_components_CampaignMainInfo = (CampaignMainInfo_Component.exports);

// EXTERNAL MODULE: ./src/graphql/CreateCampaign.gql
var graphql_CreateCampaign = __webpack_require__("uXAO");
var graphql_CreateCampaign_default = /*#__PURE__*/__webpack_require__.n(graphql_CreateCampaign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/EditClientCampaignModal.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var EditClientCampaignModal = ({
  components: {
    Spinner: src_components_Spinner,
    LeadQuestion: src_components_LeadQuestion,
    CampaignMainInfo: src_components_CampaignMainInfo
  },
  data: function data() {
    return {
      step: 1,
      isShown: true,
      loading: false,
      campaignData: {}
    };
  },

  computed: {
    btnTitle: function btnTitle() {
      return this.step === 2 ? 'Create' : 'Next';
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['trackEvent']), {
    submitStep: function submitStep() {
      this.$refs[this.step].submit();
    },
    goBack: function goBack() {
      this.step = this.step - 1;
    },
    close: function close() {
      this.$router.go(-1);
    },
    saveCampaign: function saveCampaign(campaignData) {
      assign_default()(this.campaignData, campaignData);
      this.step = 2;
    },

    // eslint-disable-next-line
    saveQuestions: stepperApiCall(function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
        var inputPrompt = _ref2.inputPrompt,
            questions = _ref2.questions;
        var result;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$apollo.mutate({
                  mutation: graphql_CreateCampaign_default.a,
                  variables: {
                    input: extends_default()({}, this.campaignData, { inputPrompt: inputPrompt, questions: questions })
                  }
                });

              case 2:
                result = _context.sent;

                this.trackEvent({
                  name: "Campaign Created",
                  options: {
                    "campaign_name": this.campaignData.campaignName,
                    "campaign_uid": result.data.createCampaign.campaignId
                  }
                });
                this.$router.push({ name: 'CampaignDetails', params: { id: result.data.createCampaign.campaignId } });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87caca78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/EditClientCampaignModal.vue
var EditClientCampaignModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":true,"width":700},on:{"input":_vm.close}},[_c('v-card',[_c('v-card-title',{staticClass:"title font-weight-regular justify-space-between"},[_c('span',[_vm._v("New Campaign")]),_vm._v(" "),_c('v-avatar',{staticClass:"subheading white--text",attrs:{"color":"primary lighten-2","size":"24"},domProps:{"textContent":_vm._s(_vm.step)}})],1),_vm._v(" "),_c('keep-alive',[_c('v-window',{attrs:{"value":_vm.step}},[_c('v-window-item',{attrs:{"value":1}},[_c('v-card-text',[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('campaign-main-info',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"1",on:{"submit":_vm.saveCampaign}})],1)],1),_vm._v(" "),_c('v-window-item',{attrs:{"value":2}},[_c('v-card-text',[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('lead-question',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"2",attrs:{"withCampaignName":false},on:{"submit":_vm.saveQuestions}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"disabled":_vm.step === 1,"flat":""},on:{"click":function($event){_vm.step--}}},[_vm._v("\n        Back\n      ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading,"color":"primary","depressed":""},on:{"click":_vm.submitStep}},[_vm._v("\n        "+_vm._s(_vm.btnTitle)+"\n      ")])],1)],1)],1)}
var EditClientCampaignModal_staticRenderFns = []
var EditClientCampaignModal_esExports = { render: EditClientCampaignModal_render, staticRenderFns: EditClientCampaignModal_staticRenderFns }
/* harmony default export */ var modals_EditClientCampaignModal = (EditClientCampaignModal_esExports);
// CONCATENATED MODULE: ./src/modals/EditClientCampaignModal.vue
function EditClientCampaignModal_injectStyle (ssrContext) {
  __webpack_require__("Q5sR")
}
var EditClientCampaignModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditClientCampaignModal___vue_template_functional__ = false
/* styles */
var EditClientCampaignModal___vue_styles__ = EditClientCampaignModal_injectStyle
/* scopeId */
var EditClientCampaignModal___vue_scopeId__ = "data-v-87caca78"
/* moduleIdentifier (server only) */
var EditClientCampaignModal___vue_module_identifier__ = null
var EditClientCampaignModal_Component = EditClientCampaignModal_normalizeComponent(
  EditClientCampaignModal,
  modals_EditClientCampaignModal,
  EditClientCampaignModal___vue_template_functional__,
  EditClientCampaignModal___vue_styles__,
  EditClientCampaignModal___vue_scopeId__,
  EditClientCampaignModal___vue_module_identifier__
)

/* harmony default export */ var src_modals_EditClientCampaignModal = (EditClientCampaignModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/EditShopifyCampaignModal.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ var EditShopifyCampaignModal = ({
  name: 'edit-campaign-component',
  mixins: [ModalMixin],
  components: {
    Switches: vue_switches_src_switches,
    DialogComponent: src_components_Dialog,
    Multiselect: components_CustomMultiselect,
    Spinner: src_components_Spinner
  },
  props: {
    id: String
  },
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _ref, data;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$apollo.query({
                query: _this.isClient ? Company_default.a : Companies_default.a,
                variables: _this.isClient ? { id: _this.getAuthUser.companyId } : { limit: -1 }
              });

            case 2:
              _ref = _context.sent;
              data = _ref.data;

              _this.companies = _this.isClient ? [data.company] : data.companies.result;
              if (_this.isClient) {
                _this.campaign.company = data.company;
              }

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      companies: [],
      campaign: {
        campaignName: '',
        dispatchTo: '',
        dispatchToPhone: '',
        company: null,
        status: true,
        editable: false,
        whiteLabel: false,
        type: 'shopify'
      },
      showSpinner: 0,
      optionStatus: [{ text: 'Enabled', value: true }, { text: 'Disabled', value: false }],
      optionEditable: [{ text: 'Yes', value: true }, { text: 'No', value: false }],
      optionWhitelabel: [{ text: 'Yes', value: true }, { text: 'No', value: false }]
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthUser']), {
    isClient: function isClient() {
      return this.getAuthUser.role.role_type === 'client';
    },
    title: function title() {
      return (this.id ? 'Update' : 'Create') + ' Campaign';
    }
  }),
  methods: {
    onSubmit: function onSubmit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var valid, _campaign, campaignName, dispatchTo, dispatchToPhone, company, status, editable, whiteLabel, type;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                valid = _context2.sent;

                if (valid) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return');

              case 6:
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);
                return _context2.abrupt('return');

              case 11:
                _campaign = _this2.campaign, campaignName = _campaign.campaignName, dispatchTo = _campaign.dispatchTo, dispatchToPhone = _campaign.dispatchToPhone, company = _campaign.company, status = _campaign.status, editable = _campaign.editable, whiteLabel = _campaign.whiteLabel, type = _campaign.type;


                _this2.$apollo.mutate({
                  mutation: _this2.id ? EditCampaign_default.a : CreateCampaign_default.a,
                  variables: {
                    id: parseInt(_this2.id),
                    input: {
                      campaignName: campaignName,
                      dispatchTo: dispatchTo,
                      dispatchToPhone: dispatchToPhone,
                      companyId: parseInt(company.id),
                      status: status,
                      editable: editable,
                      whiteLabel: whiteLabel,
                      type: type
                    }
                  },
                  refetchQueries: function refetchQueries(_ref2) {
                    var data = _ref2.data;

                    var response = data.createCampaign || data.updateCampaign;
                    return response.success ? ['campaigns'] : [];
                  }
                }).then(function () {
                  _this2.$notify({
                    group: 'success',
                    type: 'success',
                    text: 'Campaign was ' + (_this2.id ? 'edited' : 'created')
                  });
                  _this2.close();
                }).catch(function (e) {
                  var isAccessDenied = checkIsAccessDenied(e);

                  if (e.message.includes('ER_DUP_ENTRY')) {
                    return _this2.$validator.errors.add('campaignName', 'This Campaign Name already exists');
                  }

                  if (isAccessDenied) {
                    return _this2.$notify({
                      group: 'error',
                      type: 'error',
                      text: 'Access denied'
                    });
                  }

                  _this2.$notify({
                    group: 'error',
                    type: 'error',
                    text: e.message
                  });
                });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    }
  },
  apollo: {
    campaign: {
      query: Campaign_default.a,
      loadingKey: 'showSpinner',
      fetchPolicy: 'network-only',
      variables: function variables() {
        return {
          id: +this.id
        };
      },
      result: function result(_ref3) {
        var data = _ref3.data,
            loading = _ref3.loading;

        if (!loading) {
          this.campaign = {
            campaignName: data.campaign.campaignName,
            dispatchTo: data.campaign.dispatchTo,
            dispatchToPhone: data.campaign.dispatchToPhone,
            company: data.campaign.company,
            status: data.campaign.status,
            editable: data.campaign.editable,
            whiteLabel: data.campaign.whiteLabel
          };
        }
      },
      skip: function skip() {
        return !this.id;
      },
      error: function error(_error) {
        var isAccessDenied = checkIsAccessDenied(_error);

        if (isAccessDenied) {
          this.$router.push({ name: 'NotFound' });
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90e0f846","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/EditShopifyCampaignModal.vue
var EditShopifyCampaignModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSpinner)?_c('spinner',{attrs:{"fullScreen":""}}):_c('DialogComponent',{attrs:{"title":(_vm.campaign.campaignName) ? _vm.campaign.campaignName : 'Unknown Name'},on:{"submit":_vm.onSubmit}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.campaign.status),expression:"!campaign.status"}],staticClass:"alert alert-danger"},[_vm._v("The campaign is disabled")]),_vm._v(" "),_c('form',{on:{"submit":_vm.onSubmit}},[_c('b-form-group',{attrs:{"id":"campaignName","label":"Campaign name:","label-for":"campaignName"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.campaign.campaignName),expression:"campaign.campaignName"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('campaignName')},attrs:{"id":"campaignName","type":"text","placeholder":"Enter campaign name","name":"campaignName","data-vv-as":"Campaign Name","autofocus":""},domProps:{"value":(_vm.campaign.campaignName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.campaign, "campaignName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('campaignName')),expression:"errors.has('campaignName')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('campaignName'))+"\n      ")])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Company Name:","label-for":"companyName"}},[_c('multiselect',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"companyName","disabled":_vm.isClient,"options":_vm.companies,"fieldName":"companyName","defaultValue":_vm.campaign.company,"name":"company","data-vv-as":"Company","isValid":!_vm.errors.has('company')},model:{value:(_vm.campaign.company),callback:function ($$v) {_vm.$set(_vm.campaign, "company", $$v)},expression:"campaign.company"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('company')),expression:"errors.has('company')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('company'))+"\n      ")])],1),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('b-form-group',{attrs:{"id":"status","label":"Status:","label-for":"status"}},[_c('b-form-select',{attrs:{"id":"status","options":_vm.optionStatus},model:{value:(_vm.campaign.status),callback:function ($$v) {_vm.$set(_vm.campaign, "status", $$v)},expression:"campaign.status"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('b-form-group',{attrs:{"id":"editable","label":"Editable:","label-for":"editable"}},[_c('b-form-select',{attrs:{"id":"editable","options":_vm.optionEditable},model:{value:(_vm.campaign.editable),callback:function ($$v) {_vm.$set(_vm.campaign, "editable", $$v)},expression:"campaign.editable"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('b-form-group',{attrs:{"id":"whitelabel","label":"White-Label:","label-for":"whitelabel"}},[_c('b-form-select',{attrs:{"id":"whitelabel","options":_vm.optionWhitelabel},model:{value:(_vm.campaign.whiteLabel),callback:function ($$v) {_vm.$set(_vm.campaign, "whiteLabel", $$v)},expression:"campaign.whiteLabel"}})],1)],1)]):_vm._e()],1)])}
var EditShopifyCampaignModal_staticRenderFns = []
var EditShopifyCampaignModal_esExports = { render: EditShopifyCampaignModal_render, staticRenderFns: EditShopifyCampaignModal_staticRenderFns }
/* harmony default export */ var modals_EditShopifyCampaignModal = (EditShopifyCampaignModal_esExports);
// CONCATENATED MODULE: ./src/modals/EditShopifyCampaignModal.vue
function EditShopifyCampaignModal_injectStyle (ssrContext) {
  __webpack_require__("ESIV")
}
var EditShopifyCampaignModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditShopifyCampaignModal___vue_template_functional__ = false
/* styles */
var EditShopifyCampaignModal___vue_styles__ = EditShopifyCampaignModal_injectStyle
/* scopeId */
var EditShopifyCampaignModal___vue_scopeId__ = "data-v-90e0f846"
/* moduleIdentifier (server only) */
var EditShopifyCampaignModal___vue_module_identifier__ = null
var EditShopifyCampaignModal_Component = EditShopifyCampaignModal_normalizeComponent(
  EditShopifyCampaignModal,
  modals_EditShopifyCampaignModal,
  EditShopifyCampaignModal___vue_template_functional__,
  EditShopifyCampaignModal___vue_styles__,
  EditShopifyCampaignModal___vue_scopeId__,
  EditShopifyCampaignModal___vue_module_identifier__
)

/* harmony default export */ var src_modals_EditShopifyCampaignModal = (EditShopifyCampaignModal_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Billing/NewCard.gql
var NewCard = __webpack_require__("OGcx");
var NewCard_default = /*#__PURE__*/__webpack_require__.n(NewCard);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/AddCardModal.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* eslint-disable no-undef */
var stripe = Stripe("pk_live_Xg9jv6EY3sMdXBnMVapBbzLe");

var AddCardModal_style = {
  base: {
    border: '1px solid #d8d8d8',
    borderRadius: '1px',
    color: '#54667a',
    fontSize: '16px',
    lineHeight: '26px',

    '::placeholder': {
      color: 'lightgray'
    }
  },
  invalid: {
    color: '#e25950'
  }
};

var elementClasses = {
  focus: 'focused',
  empty: 'empty',
  invalid: 'invalid'
};

var elementOptions = {
  style: AddCardModal_style,
  classes: elementClasses
};

/* harmony default export */ var AddCardModal = ({
  name: 'add-card-component',
  mixins: [ModalMixin],
  components: {
    Dialog: src_components_Dialog,
    Switches: vue_switches_src_switches,
    Spinner: src_components_Spinner
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      userEmail: this.$store.getters.getAuthUser.email,
      zip: '',
      maxZip: 6,
      cardName: '',
      cardEmail: '',
      errorMessage: {},
      showSpinner: 0
    };
  },

  computed: {
    title: function title() {
      return 'Add Payment Card';
    },

    cardZip: {
      get: function get() {
        return this.zip || '';
      },
      set: function set(val) {
        this.zip = val;
      }
    }
  },
  mounted: function mounted() {
    var elements = stripe.elements();

    this.cardNumber = elements.create('cardNumber', elementOptions);
    this.cardNumber.mount('#card-number');

    this.cardExpiry = elements.create('cardExpiry', elementOptions);
    this.cardExpiry.mount('#card-expiry');

    this.cardCvc = elements.create('cardCvc', elementOptions);
    this.cardCvc.mount('#card-cvc');
  },

  methods: {
    validMaxLength: function validMaxLength(number) {
      return this.cardZip.length > number;
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.showSpinner) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', null);

              case 2:
                _this.showSpinner = true;
                _context.next = 5;
                return _this.sent();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    sent: function sent() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var options, token, isValid;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = {
                  address_zip: _this2.cardZip
                };
                _context2.next = 3;
                return stripe.createToken(_this2.cardNumber, options);

              case 3:
                token = _context2.sent;
                _context2.next = 6;
                return _this2.$validator.validateAll();

              case 6:
                isValid = _context2.sent;
                _context2.prev = 7;

                _this2.cardHandler(token);

                if (isValid) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt('return', null);

              case 11:
                _this2.createCard(token.token.id);
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](7);

                /* eslint-disable no-console */
                console.error('Error', _context2.t0);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 14]]);
      }))();
    },
    cardHandler: function cardHandler(_ref) {
      var error = _ref.error;

      if (error) {
        this.errorMessage = {};
        if (error.code === 'incomplete_number' || error.code === 'invalid_number') {
          this.errorMessage.cardNumberError = error.message;
        } else if (error.code === 'incomplete_cvc') {
          this.errorMessage.cardCVCError = error.message;
        } else if (error.code === 'incomplete_expiry') {
          this.errorMessage.cardExpiryError = error.message;
        }
      } else {
        this.errorMessage = {};
      }
    },
    createCard: function createCard(token) {
      var _this3 = this;

      this.$apollo.mutate({
        mutation: NewCard_default.a,
        variables: {
          id: this.id,
          input: {
            token: token,
            customerEmail: this.userEmail,
            holderEmail: this.cardEmail,
            cardholder: this.cardName
          }
        },
        refetchQueries: function refetchQueries(_ref2) {
          var data = _ref2.data;

          var response = data.addCard;
          return response && response.success ? ['billing'] : [];
        }
      }).then(function () {
        _this3.$notify({
          group: 'success',
          type: 'success',
          text: 'Card was created'
        });

        _this3.close();
      }).catch(function (e) {
        _this3.$notify({
          group: 'error',
          type: 'error',
          text: e.message
        });
      }).finally(function () {
        _this3.showSpinner = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218bb720","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/AddCardModal.vue
var AddCardModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"title":_vm.title},on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"billing-modal"},[(_vm.showSpinner)?_c('div',{staticClass:"spinner-wrap"},[_c('spinner')],1):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"card-number"}},[_vm._v("Card Number*")]),_vm._v(" "),_c('div',{staticClass:"stripe-element",class:{'is-invalid': _vm.errorMessage.cardNumberError},attrs:{"id":"card-number"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorMessage.cardNumberError),expression:"errorMessage.cardNumberError"}],staticClass:"invalid-feedback"},[_vm._v("\n          "+_vm._s(_vm.errorMessage.cardNumberError)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"card-expiry"}},[_vm._v("Expiration*")]),_vm._v(" "),_c('div',{staticClass:"stripe-element",class:{'is-invalid': _vm.errorMessage.cardExpiryError},attrs:{"id":"card-expiry"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorMessage.cardExpiryError),expression:"errorMessage.cardExpiryError"}],staticClass:"invalid-feedback"},[_vm._v("\n              "+_vm._s(_vm.errorMessage.cardExpiryError)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"card-cvc"}},[_vm._v("CVC*")]),_vm._v(" "),_c('div',{staticClass:"stripe-element",class:{'is-invalid': _vm.errorMessage.cardCVCError},attrs:{"id":"card-cvc"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorMessage.cardCVCError),expression:"errorMessage.cardCVCError"}],staticClass:"invalid-feedback"},[_vm._v("\n              "+_vm._s(_vm.errorMessage.cardCVCError)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"card-zip"}},[_vm._v("Zip/Postal*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.cardZip),expression:"cardZip",modifiers:{"trim":true}},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('cardZip') || _vm.validMaxLength(_vm.maxZip)},attrs:{"id":"card-zip","type":"text","name":"cardZip","placeholder":"9210"},domProps:{"value":(_vm.cardZip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cardZip=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('cardZip')),expression:"errors.has('cardZip')"}],staticClass:"invalid-feedback"},[_vm._v("\n              "+_vm._s(_vm.errors.first('cardZip'))+"\n            ")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.validMaxLength(_vm.maxZip)),expression:"validMaxLength(maxZip)"}],staticClass:"invalid-feedback"},[_vm._v("\n              Max length can't be then "+_vm._s(_vm.maxZip)+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"card-name"}},[_vm._v("Cardholder name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.cardName),expression:"cardName",modifiers:{"trim":true}},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('cardName')},attrs:{"id":"card-name","type":"text","name":"cardName","placeholder":"Cardholder full name"},domProps:{"value":(_vm.cardName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cardName=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('cardName')),expression:"errors.has('cardName')"}],staticClass:"invalid-feedback"},[_vm._v("\n          "+_vm._s(_vm.errors.first('cardName'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"card-email"}},[_vm._v("Cardholder email*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.cardEmail),expression:"cardEmail",modifiers:{"trim":true}},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('cardEmail')},attrs:{"id":"card-email","type":"text","name":"cardEmail","placeholder":"Cardholder email"},domProps:{"value":(_vm.cardEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cardEmail=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('cardEmail')),expression:"errors.has('cardEmail')"}],staticClass:"invalid-feedback"},[_vm._v("\n          "+_vm._s(_vm.errors.first('cardEmail'))+"\n        ")])])])])])}
var AddCardModal_staticRenderFns = []
var AddCardModal_esExports = { render: AddCardModal_render, staticRenderFns: AddCardModal_staticRenderFns }
/* harmony default export */ var modals_AddCardModal = (AddCardModal_esExports);
// CONCATENATED MODULE: ./src/modals/AddCardModal.vue
function AddCardModal_injectStyle (ssrContext) {
  __webpack_require__("u3Bu")
}
var AddCardModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AddCardModal___vue_template_functional__ = false
/* styles */
var AddCardModal___vue_styles__ = AddCardModal_injectStyle
/* scopeId */
var AddCardModal___vue_scopeId__ = "data-v-218bb720"
/* moduleIdentifier (server only) */
var AddCardModal___vue_module_identifier__ = null
var AddCardModal_Component = AddCardModal_normalizeComponent(
  AddCardModal,
  modals_AddCardModal,
  AddCardModal___vue_template_functional__,
  AddCardModal___vue_styles__,
  AddCardModal___vue_scopeId__,
  AddCardModal___vue_module_identifier__
)

/* harmony default export */ var src_modals_AddCardModal = (AddCardModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/FieldAndQuery/components/EditableInput.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditableInput = ({
  name: 'edit-input-component',
  props: {
    column: Boolean,
    formatValue: Function,
    value: String,
    isLast: Boolean
  },

  data: function data() {
    return {
      input: {
        ownValue: '',
        isEditable: true
      }
    };
  },


  methods: {
    removeItem: function removeItem() {
      if (this.isLast) {
        return;
      }

      this.$emit('remove', this.value);
    },
    onValueChange: function onValueChange(newVal) {
      this.input.ownValue = newVal;
    },
    onAccept: function onAccept() {
      this.$emit('change', lodash_default.a.cloneDeep(this.input.ownValue));
      this.$emit('input', lodash_default.a.cloneDeep(this.input.ownValue));

      this.input.isEditable = false;

      document.removeEventListener('click', this.blurHandler);
    },
    onCancel: function onCancel() {
      this.input.isEditable = false;
      this.input.ownValue = lodash_default.a.cloneDeep(this.value);

      document.removeEventListener('click', this.blurHandler);
      this.$emit('cancel', this.input.ownValue);
    },
    onEditableClick: function onEditableClick() {
      this.enableEdit();
    },
    blurHandler: function blurHandler(event) {
      var el = event.target;
      if (el instanceof HTMLElement && !this.$refs.inputWrapper.contains(el)) {
        this.onCancel();
        document.removeEventListener('click', this.blurHandler);
      }
    },
    enableEdit: function enableEdit() {
      var _this = this;

      this.input.isEditable = true;
      setTimeout(function () {
        document.addEventListener('click', _this.blurHandler);
      }, 0);
    }
  },

  mounted: function mounted() {
    this.input.ownValue = lodash_default.a.cloneDeep(this.value);

    this.input.isEditable = false;
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.blurHandler);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1de7f945","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/FieldAndQuery/components/EditableInput.vue
var EditableInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"inputWrapper",staticClass:"wrapper"},[(!_vm.input.isEditable)?_c('div',{on:{"click":function($event){$event.preventDefault();return _vm.onEditableClick($event)}}},[_c('span',{staticClass:"editable-click editable-unsaved"},[_vm._v("\n      "+_vm._s(_vm.input.ownValue)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"remove-button",class:{ 'disable-remove': _vm.isLast },on:{"click":function($event){$event.stopPropagation();return _vm.removeItem($event)}}},[_c('i',{staticClass:"fa fa-trash"})])]):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.ownValue),expression:"input.ownValue"}],staticClass:"edit-input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.input.ownValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "ownValue", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"editable-buttons"},[_c('button',{staticClass:"btn btn-primary waves-effect waves-light ok-button",on:{"click":function($event){$event.preventDefault();return _vm.onAccept($event)}}},[_c('i',{staticClass:"mdi mdi-check"})]),_vm._v(" "),_c('button',{staticClass:"btn editable-cancel waves-effect waves-light cancel-button",on:{"click":function($event){$event.preventDefault();return _vm.onCancel($event)}}},[_c('i',{staticClass:"mdi mdi-close"})])])])])}
var EditableInput_staticRenderFns = []
var EditableInput_esExports = { render: EditableInput_render, staticRenderFns: EditableInput_staticRenderFns }
/* harmony default export */ var components_EditableInput = (EditableInput_esExports);
// CONCATENATED MODULE: ./src/modals/FieldAndQuery/components/EditableInput.vue
function EditableInput_injectStyle (ssrContext) {
  __webpack_require__("l1nu")
}
var EditableInput_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditableInput___vue_template_functional__ = false
/* styles */
var EditableInput___vue_styles__ = EditableInput_injectStyle
/* scopeId */
var EditableInput___vue_scopeId__ = "data-v-1de7f945"
/* moduleIdentifier (server only) */
var EditableInput___vue_module_identifier__ = null
var EditableInput_Component = EditableInput_normalizeComponent(
  EditableInput,
  components_EditableInput,
  EditableInput___vue_template_functional__,
  EditableInput___vue_styles__,
  EditableInput___vue_scopeId__,
  EditableInput___vue_module_identifier__
)

/* harmony default export */ var FieldAndQuery_components_EditableInput = (EditableInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/FieldAndQuery/components/MultipleAndExclusiveChoice.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MultipleAndExclusiveChoice = ({
  name: 'multiple-and-exclusive-choice-component',
  components: {
    EditableInput: FieldAndQuery_components_EditableInput
  },
  props: {
    value: { type: Array, default: function _default() {
        return [];
      } },
    type: { type: String, default: '' }
  },

  data: function data() {
    return {
      options: []
    };
  },

  methods: {
    generateId: function generateId() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var newId = id + 1;

      if (this.options.includes('Option ' + newId)) {
        return this.generateId(newId);
      }

      return newId;
    },
    addNewOption: function addNewOption() {
      this.options.push('Option ' + this.generateId());
      this.$emit('input', this.options);
    },
    removeOption: function removeOption(option) {
      this.options = this.options.filter(function (opt) {
        return opt !== option;
      });
      this.$emit('input', this.options);
    }
  },
  computed: {
    isLast: function isLast() {
      return this.options.length === 1;
    }
  },
  mounted: function mounted() {
    if (!this.value.length) {
      this.addNewOption();
    } else {
      this.options = [].concat(toConsumableArray_default()(this.value));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a61e63d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/FieldAndQuery/components/MultipleAndExclusiveChoice.vue
var MultipleAndExclusiveChoice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.options),function(option,index){return _c('div',[_c('EditableInput',{attrs:{"isLast":_vm.isLast},on:{"input":function($event){return _vm.$emit('input', _vm.options)},"remove":_vm.removeOption},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.model.ownValue),expression:"props.model.ownValue"}],staticClass:"form-control text-muted input-sm editable-input",attrs:{"type":"text"},domProps:{"value":(props.model.ownValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.model, "ownValue", $event.target.value)}}})]}}],null,true),model:{value:(_vm.options[index]),callback:function ($$v) {_vm.$set(_vm.options, index, $$v)},expression:"options[index]"}})],1)}),_vm._v(" "),_c('div',{staticClass:"add-option",on:{"click":function($event){$event.preventDefault();return _vm.addNewOption($event)}}},[_vm._v("Add option")])],2)}
var MultipleAndExclusiveChoice_staticRenderFns = []
var MultipleAndExclusiveChoice_esExports = { render: MultipleAndExclusiveChoice_render, staticRenderFns: MultipleAndExclusiveChoice_staticRenderFns }
/* harmony default export */ var components_MultipleAndExclusiveChoice = (MultipleAndExclusiveChoice_esExports);
// CONCATENATED MODULE: ./src/modals/FieldAndQuery/components/MultipleAndExclusiveChoice.vue
function MultipleAndExclusiveChoice_injectStyle (ssrContext) {
  __webpack_require__("TcGh")
}
var MultipleAndExclusiveChoice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MultipleAndExclusiveChoice___vue_template_functional__ = false
/* styles */
var MultipleAndExclusiveChoice___vue_styles__ = MultipleAndExclusiveChoice_injectStyle
/* scopeId */
var MultipleAndExclusiveChoice___vue_scopeId__ = "data-v-1a61e63d"
/* moduleIdentifier (server only) */
var MultipleAndExclusiveChoice___vue_module_identifier__ = null
var MultipleAndExclusiveChoice_Component = MultipleAndExclusiveChoice_normalizeComponent(
  MultipleAndExclusiveChoice,
  components_MultipleAndExclusiveChoice,
  MultipleAndExclusiveChoice___vue_template_functional__,
  MultipleAndExclusiveChoice___vue_styles__,
  MultipleAndExclusiveChoice___vue_scopeId__,
  MultipleAndExclusiveChoice___vue_module_identifier__
)

/* harmony default export */ var FieldAndQuery_components_MultipleAndExclusiveChoice = (MultipleAndExclusiveChoice_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Questions/Question.gql
var Question = __webpack_require__("oXyk");
var Question_default = /*#__PURE__*/__webpack_require__.n(Question);

// EXTERNAL MODULE: ./src/graphql/Questions/CreateQuestion.gql
var CreateQuestion = __webpack_require__("wNZm");
var CreateQuestion_default = /*#__PURE__*/__webpack_require__.n(CreateQuestion);

// EXTERNAL MODULE: ./src/graphql/Questions/EditQuestion.gql
var EditQuestion = __webpack_require__("k/iC");
var EditQuestion_default = /*#__PURE__*/__webpack_require__.n(EditQuestion);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/FieldAndQuery/EditFieldAndQueryModal.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var EditFieldAndQueryModal = ({
  name: 'edit-field-and-query-component',
  components: {
    Switches: vue_switches_src_switches,
    DialogComponent: src_components_Dialog,
    ExChoice: FieldAndQuery_components_MultipleAndExclusiveChoice,
    Spinner: src_components_Spinner
  },
  props: {
    id: String,
    questionId: String
  },

  data: function data() {
    return {
      types: ['Free text', 'Multiple Choice', 'Exclusive Choice', 'Date', 'Phone', 'Email', 'Time'],
      question: {
        fieldName: '',
        question: '',
        type: null,
        mandatory: false,
        params: {
          options: []
        }
      },
      showModalSpinner: 0
    };
  },

  computed: {
    title: function title() {
      return (this.questionId ? 'Update' : 'Create') + ' Field and Question';
    },
    currentName: function currentName() {
      return {
        'Free text': 'Freetext',
        'Multiple Choice': 'MultipleChoice',
        'Exclusive Choice': 'ExclusiveChoice',
        Date: 'Date',
        Phone: 'Phone',
        Email: 'Email',
        Time: 'Time'
      }[this.question.type];
    },
    showChoice: function showChoice() {
      return this.question.type === 'Multiple Choice' || this.question.type === 'Exclusive Choice';
    }
  },
  methods: {
    close: function close() {
      this.$router.push({ name: 'CampaignDetails', params: { id: this.id } });
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var valid, _question, fieldName, question, type, mandatory, params;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                valid = _context.sent;

                if (valid) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return');

              case 11:
                _question = _this.question, fieldName = _question.fieldName, question = _question.question, type = _question.type, mandatory = _question.mandatory, params = _question.params;


                _this.$apollo.mutate({
                  mutation: _this.questionId ? EditQuestion_default.a : CreateQuestion_default.a,
                  variables: {
                    id: parseInt(_this.questionId),
                    input: {
                      fieldName: fieldName,
                      question: question,
                      type: type,
                      mandatory: mandatory,
                      campaignId: _this.id,
                      params: stringify_default()(params)
                    }
                  },
                  refetchQueries: function refetchQueries(_ref) {
                    var data = _ref.data;

                    var response = data.createQuestion || data.updateQuestion;
                    return response.success ? ['questions'] : [];
                  }
                }).then(function () {
                  _this.$notify({
                    group: 'success',
                    type: 'success',
                    text: 'Question was ' + (_this.id ? 'edited' : 'created')
                  });
                  _this.close();
                }).catch(function (e) {
                  var isAccessDenied = checkIsAccessDenied(e);

                  if (e.message.includes('ER_DUP_ENTRY')) {
                    return _this.$validator.errors.add('fieldName', 'This Field Name already exists');
                  }

                  if (isAccessDenied) {
                    return _this.$notify({
                      group: 'error',
                      type: 'error',
                      text: 'Access denied'
                    });
                  }

                  _this.$notify({
                    group: 'error',
                    type: 'error',
                    text: e.message
                  });
                });

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    }
  },
  apollo: {
    question: {
      query: Question_default.a,
      loadingKey: 'showModalSpinner',
      fetchPolicy: 'network-only',
      variables: function variables() {
        return {
          id: +this.questionId
        };
      },
      result: function result(_ref2) {
        var data = _ref2.data,
            loading = _ref2.loading;

        if (!loading) {
          this.question = extends_default()({}, data.question, {
            params: JSON.parse(data.question.params)
          });
        }
      },
      skip: function skip() {
        return !this.questionId;
      },
      error: function error(_error) {
        var isAccessDenied = checkIsAccessDenied(_error);

        if (isAccessDenied) {
          this.$router.push({ name: 'NotFound' });
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01fc5c3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/FieldAndQuery/EditFieldAndQueryModal.vue
var EditFieldAndQueryModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModalSpinner)?_c('spinner',{attrs:{"fullScreen":""}}):_c('DialogComponent',{attrs:{"title":this.title,"customClose":this.close},on:{"submit":_vm.onSubmit}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('b-form-group',{attrs:{"id":"fieldName","label":"Field name:","label-for":"fieldName","label-class":"label-bold"}},[_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" Provide a descriptive label for this question. Example: \"phone\" ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.question.fieldName),expression:"question.fieldName"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('fieldName')},attrs:{"id":"fieldName","type":"text","placeholder":"Enter field name","name":"fieldName","data-vv-as":"Field Name","autofocus":""},domProps:{"value":(_vm.question.fieldName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.question, "fieldName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('fieldName')),expression:"errors.has('fieldName')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('fieldName'))+"\n      ")])]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"question","label":"Question:","label-for":"question","label-class":"label-bold"}},[_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" Example: \"What is your phone number?\" ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.question.question),expression:"question.question"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('question')},attrs:{"id":"question","type":"text","placeholder":"Enter question","data-vv-as":"Question:","name":"question"},domProps:{"value":(_vm.question.question)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.question, "question", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('question')),expression:"errors.has('question')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('question'))+"\n      ")])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Field Type:","label-for":"type","label-class":"label-bold"}},[_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" What should be the format of the question response? Keep \"Free Text\" if not sure.")])]),_vm._v(" "),_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'is-invalid': _vm.errors.has('type')},attrs:{"options":_vm.types,"name":"type"},model:{value:(_vm.question.type),callback:function ($$v) {_vm.$set(_vm.question, "type", $$v)},expression:"question.type"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('type')),expression:"errors.has('type')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('type'))+"\n      ")])],1),_vm._v(" "),(_vm.showChoice)?_c('ex-choice',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"mb-3",attrs:{"type":_vm.question.type,"name":_vm.currentName},model:{value:(_vm.question.params.options),callback:function ($$v) {_vm.$set(_vm.question.params, "options", $$v)},expression:"question.params.options"}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.currentName)),expression:"errors.has(currentName)"}],staticClass:"error-form"},[_vm._v("\n      "+_vm._s(_vm.errors.first(_vm.currentName))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"pb-1"},[_c('span',{staticClass:"hint"},[_c('i',{staticClass:"mdi mdi-information-outline"}),_vm._v(" Required questions must be answered for lead to be marked completed. To maximize lead completion, keep Required questions to a minimum.")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox pb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.question.mandatory),expression:"question.mandatory"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"customCheck1"},domProps:{"checked":Array.isArray(_vm.question.mandatory)?_vm._i(_vm.question.mandatory,null)>-1:(_vm.question.mandatory)},on:{"change":function($event){var $$a=_vm.question.mandatory,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.question, "mandatory", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.question, "mandatory", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.question, "mandatory", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"customCheck1"}},[_vm._v(" "+_vm._s((_vm.question.mandatory) ? 'Required' : 'Optional'))])])],1)])}
var EditFieldAndQueryModal_staticRenderFns = []
var EditFieldAndQueryModal_esExports = { render: EditFieldAndQueryModal_render, staticRenderFns: EditFieldAndQueryModal_staticRenderFns }
/* harmony default export */ var FieldAndQuery_EditFieldAndQueryModal = (EditFieldAndQueryModal_esExports);
// CONCATENATED MODULE: ./src/modals/FieldAndQuery/EditFieldAndQueryModal.vue
function EditFieldAndQueryModal_injectStyle (ssrContext) {
  __webpack_require__("6YeP")
}
var EditFieldAndQueryModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditFieldAndQueryModal___vue_template_functional__ = false
/* styles */
var EditFieldAndQueryModal___vue_styles__ = EditFieldAndQueryModal_injectStyle
/* scopeId */
var EditFieldAndQueryModal___vue_scopeId__ = "data-v-01fc5c3e"
/* moduleIdentifier (server only) */
var EditFieldAndQueryModal___vue_module_identifier__ = null
var EditFieldAndQueryModal_Component = EditFieldAndQueryModal_normalizeComponent(
  EditFieldAndQueryModal,
  FieldAndQuery_EditFieldAndQueryModal,
  EditFieldAndQueryModal___vue_template_functional__,
  EditFieldAndQueryModal___vue_styles__,
  EditFieldAndQueryModal___vue_scopeId__,
  EditFieldAndQueryModal___vue_module_identifier__
)

/* harmony default export */ var modals_FieldAndQuery_EditFieldAndQueryModal = (EditFieldAndQueryModal_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Users/UserPhoto.gql
var UserPhoto = __webpack_require__("lgdi");
var UserPhoto_default = /*#__PURE__*/__webpack_require__.n(UserPhoto);

// EXTERNAL MODULE: ./src/graphql/Users/UpdateUserPhoto.gql
var UpdateUserPhoto = __webpack_require__("Trcj");
var UpdateUserPhoto_default = /*#__PURE__*/__webpack_require__.n(UpdateUserPhoto);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/UserPhotoModal.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var UserPhotoModal = ({
  name: 'user-photo',
  mixins: [ModalMixin],
  components: {
    DialogComponent: src_components_Dialog
  },
  props: {
    id: String
  },

  data: function data() {
    return {
      photoUrl: null,
      thumb: null
    };
  },

  computed: {
    title: function title() {
      return 'User Photo';
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var valid;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                valid = _context.sent;

                if (valid) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return');

              case 11:

                _this.$apollo.mutate({
                  mutation: UpdateUserPhoto_default.a,
                  variables: {
                    id: parseInt(_this.id),
                    photoUrl: _this.photoUrl
                  },
                  refetchQueries: function refetchQueries(_ref) {
                    var data = _ref.data;

                    var response = data.updateUserPhoto;
                    return response && response.success ? ['users'] : [];
                  }
                }).then(function () {
                  _this.$notify({
                    group: 'success',
                    type: 'success',
                    text: 'User photo was updated'
                  });
                  _this.close();
                }).catch(function (e) {
                  _this.$notify({
                    group: 'error',
                    type: 'error',
                    text: e.message
                  });
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    }
  },
  apollo: {
    user: {
      query: UserPhoto_default.a,
      fetchPolicy: 'cache-and-network',
      variables: function variables() {
        return {
          id: +this.id
        };
      },
      result: function result(_ref2) {
        var data = _ref2.data,
            loading = _ref2.loading;

        if (!loading) {
          this.photoUrl = data.user.photo.fullSize;
          this.thumb = data.user.photo.thumb150;
        }
      },
      skip: function skip() {
        return !this.id;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2665f7cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/UserPhotoModal.vue
var UserPhotoModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogComponent',{attrs:{"title":this.title},on:{"submit":_vm.onSubmit}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"image-preview"},[(_vm.thumb)?_c('img',{attrs:{"height":"150px","src":_vm.thumb}}):_vm._e(),_vm._v(" "),(!_vm.thumb)?_c('i',{staticClass:"mdi mdi-account-circle"}):_vm._e()]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"photoUrl","label":"Photo URL:","label-for":"photoUrl"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.photoUrl),expression:"photoUrl"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('photoUrl')},attrs:{"id":"photoUrl","type":"text","placeholder":"Enter image URL","data-vv-as":"Image URL","name":"photoUrl","autofocus":""},domProps:{"value":(_vm.photoUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.photoUrl=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('photoUrl')),expression:"errors.has('photoUrl')"}],staticClass:"error-message"},[_vm._v("\n        "+_vm._s(_vm.errors.first('photoUrl'))+"\n      ")])])],1)])}
var UserPhotoModal_staticRenderFns = []
var UserPhotoModal_esExports = { render: UserPhotoModal_render, staticRenderFns: UserPhotoModal_staticRenderFns }
/* harmony default export */ var modals_UserPhotoModal = (UserPhotoModal_esExports);
// CONCATENATED MODULE: ./src/modals/UserPhotoModal.vue
function UserPhotoModal_injectStyle (ssrContext) {
  __webpack_require__("8azP")
}
var UserPhotoModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UserPhotoModal___vue_template_functional__ = false
/* styles */
var UserPhotoModal___vue_styles__ = UserPhotoModal_injectStyle
/* scopeId */
var UserPhotoModal___vue_scopeId__ = "data-v-2665f7cc"
/* moduleIdentifier (server only) */
var UserPhotoModal___vue_module_identifier__ = null
var UserPhotoModal_Component = UserPhotoModal_normalizeComponent(
  UserPhotoModal,
  modals_UserPhotoModal,
  UserPhotoModal___vue_template_functional__,
  UserPhotoModal___vue_styles__,
  UserPhotoModal___vue_scopeId__,
  UserPhotoModal___vue_module_identifier__
)

/* harmony default export */ var src_modals_UserPhotoModal = (UserPhotoModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/File.vue
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var modals_File = ({
  name: 'file-modal',
  mixins: [ModalMixin],
  components: { Dialog: src_components_Dialog },
  methods: {
    close: function close() {
      this.$router.go(-1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae17454","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/File.vue
var File_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"hideModalButtons":"","center":"","size":"extra-large","title":_vm.$route.query.name,"customClose":_vm.close}},[_c('img',{staticClass:"zoomed-file",attrs:{"src":_vm.$route.query.url,"alt":"zoomed file"}})])}
var File_staticRenderFns = []
var File_esExports = { render: File_render, staticRenderFns: File_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_modals_File = (File_esExports);
// CONCATENATED MODULE: ./src/modals/File.vue
function File_injectStyle (ssrContext) {
  __webpack_require__("CtNn")
}
var File_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var File___vue_template_functional__ = false
/* styles */
var File___vue_styles__ = File_injectStyle
/* scopeId */
var File___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var File___vue_module_identifier__ = null
var File_Component = File_normalizeComponent(
  modals_File,
  selectortype_template_index_0_src_modals_File,
  File___vue_template_functional__,
  File___vue_styles__,
  File___vue_scopeId__,
  File___vue_module_identifier__
)

/* harmony default export */ var src_modals_File = (File_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Campaigns/CreateQuestion.gql
var Campaigns_CreateQuestion = __webpack_require__("kZy8");
var Campaigns_CreateQuestion_default = /*#__PURE__*/__webpack_require__.n(Campaigns_CreateQuestion);

// EXTERNAL MODULE: ./src/graphql/Campaigns/EditQuestion.gql
var Campaigns_EditQuestion = __webpack_require__("P++x");
var Campaigns_EditQuestion_default = /*#__PURE__*/__webpack_require__.n(Campaigns_EditQuestion);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/NewQuestions.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var NewQuestions = ({
  components: {
    Dialog: src_components_Dialog
  },
  props: {
    campaignId: {
      type: Number,
      required: true
    },
    questionId: Number,
    question: String,
    answer: String
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthUser']), {
    buttonText: function buttonText() {
      return this.questionId === undefined ? 'Save' : 'Save';
    },
    title: function title() {
      return this.questionId === undefined ? 'New Question' : 'Edit Question';
    }
  }),
  data: function data() {
    return {
      questionText: this.question || '',
      answerText: this.answer || '',
      showSpinner: false
    };
  },

  methods: {
    close: function close() {
      this.$router.push({
        name: 'CampaignDetails',
        params: { id: this.campaignId },
        query: { updatedAt: Date.now(), tab: 'q_a' }
      });
    },
    saveQuestion: function saveQuestion() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var isValid;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validateAll();

              case 2:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                _this.showSpinner = true;
                _context.next = 8;
                return _this.$apollo.mutate({
                  mutation: _this.questionId === undefined ? Campaigns_CreateQuestion_default.a : Campaigns_EditQuestion_default.a,
                  variables: {
                    question: extends_default()({}, optionIf(!_this.questionId, 'campaignId', _this.campaignId), stdlib_option('questionId', _this.questionId), {
                      question: _this.questionText,
                      answer: _this.answerText
                    })
                  }
                });

              case 8:
                _this.close();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c35fab7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/NewQuestions.vue
var NewQuestions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"title":_vm.title,"customClose":_vm.close,"submitButtonText":_vm.buttonText},on:{"submit":_vm.saveQuestion}},[(_vm.showSpinner)?_c('div',{staticClass:"spinner-wrap"},[_c('spinner')],1):_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.saveQuestion($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"question"}},[_vm._v("Question Text*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:255'),expression:"'required|max:255'"},{name:"model",rawName:"v-model.trim",value:(_vm.questionText),expression:"questionText",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('question')},attrs:{"type":"text","id":"question","name":"question","autofocus":""},domProps:{"value":(_vm.questionText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.questionText=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('question')),expression:"errors.has('question')"}],staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.errors.first('question'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"question"}},[_vm._v("Answer Text*")]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1024'),expression:"'required|max:1024'"},{name:"model",rawName:"v-model.trim",value:(_vm.answerText),expression:"answerText",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('answer')},attrs:{"id":"answer","name":"answer","autofocus":""},domProps:{"value":(_vm.answerText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.answerText=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('answer')),expression:"errors.has('answer')"}],staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.errors.first('answer'))+"\n      ")])])])])}
var NewQuestions_staticRenderFns = []
var NewQuestions_esExports = { render: NewQuestions_render, staticRenderFns: NewQuestions_staticRenderFns }
/* harmony default export */ var modals_NewQuestions = (NewQuestions_esExports);
// CONCATENATED MODULE: ./src/modals/NewQuestions.vue
function NewQuestions_injectStyle (ssrContext) {
  __webpack_require__("qrNM")
}
var NewQuestions_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NewQuestions___vue_template_functional__ = false
/* styles */
var NewQuestions___vue_styles__ = NewQuestions_injectStyle
/* scopeId */
var NewQuestions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NewQuestions___vue_module_identifier__ = null
var NewQuestions_Component = NewQuestions_normalizeComponent(
  NewQuestions,
  modals_NewQuestions,
  NewQuestions___vue_template_functional__,
  NewQuestions___vue_styles__,
  NewQuestions___vue_scopeId__,
  NewQuestions___vue_module_identifier__
)

/* harmony default export */ var src_modals_NewQuestions = (NewQuestions_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Campaigns/CloneCampaign.gql
var CloneCampaign = __webpack_require__("rjQg");
var CloneCampaign_default = /*#__PURE__*/__webpack_require__.n(CloneCampaign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/CloneCampaignModal.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var CloneCampaignModal = ({
  mixins: [ModalMixin],
  components: { Dialog: src_components_Dialog, Spinner: src_components_Spinner },
  props: {
    campaignId: {
      type: Number,
      required: true
    },
    campaignName: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      errorMessage: {},
      showSpinner: false
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['trackEvent']), {
    close: function close() {
      this.$router.go(-1);
    },
    cloneCampaign: function cloneCampaign() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var isValid, result;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validateAll();

              case 2:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                _this.showSpinner = true;
                _context.next = 8;
                return _this.$apollo.mutate({
                  mutation: CloneCampaign_default.a,
                  variables: {
                    name: _this.campaignName,
                    id: _this.campaignId
                  }
                });

              case 8:
                result = _context.sent;

                _this.trackEvent({
                  name: "Campaign Cloned",
                  options: {
                    "campaign_name": _this.campaignName,
                    "campaign_uid": result.data.cloneCampaign.id
                  }
                });
                _this.$router.push({ name: 'CampaignDetails', params: { id: result.data.cloneCampaign.id } });
                _this.$notify({
                  group: 'success',
                  type: 'success',
                  text: 'Campaign was cloned'
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09f243a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/CloneCampaignModal.vue
var CloneCampaignModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"title":"Clone Campaign","customClose":_vm.close,"disableButtons":_vm.showSpinner},on:{"submit":_vm.cloneCampaign}},[(_vm.showSpinner)?_c('div',{staticClass:"spinner-wrap"},[_c('spinner')],1):_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.cloneCampaign($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"campaign-name"}},[_vm._v("Campaign Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.campaignName),expression:"campaignName",modifiers:{"trim":true}},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('campaignName')},attrs:{"id":"campaign-name","type":"text","name":"campaignName","placeholder":"Name"},domProps:{"value":(_vm.campaignName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.campaignName=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorMessage.campaignName),expression:"errorMessage.campaignName"}],staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.errorMessage.campaignName)+"\n      ")])])])])}
var CloneCampaignModal_staticRenderFns = []
var CloneCampaignModal_esExports = { render: CloneCampaignModal_render, staticRenderFns: CloneCampaignModal_staticRenderFns }
/* harmony default export */ var modals_CloneCampaignModal = (CloneCampaignModal_esExports);
// CONCATENATED MODULE: ./src/modals/CloneCampaignModal.vue
function CloneCampaignModal_injectStyle (ssrContext) {
  __webpack_require__("iwwK")
}
var CloneCampaignModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CloneCampaignModal___vue_template_functional__ = false
/* styles */
var CloneCampaignModal___vue_styles__ = CloneCampaignModal_injectStyle
/* scopeId */
var CloneCampaignModal___vue_scopeId__ = "data-v-09f243a8"
/* moduleIdentifier (server only) */
var CloneCampaignModal___vue_module_identifier__ = null
var CloneCampaignModal_Component = CloneCampaignModal_normalizeComponent(
  CloneCampaignModal,
  modals_CloneCampaignModal,
  CloneCampaignModal___vue_template_functional__,
  CloneCampaignModal___vue_styles__,
  CloneCampaignModal___vue_scopeId__,
  CloneCampaignModal___vue_module_identifier__
)

/* harmony default export */ var src_modals_CloneCampaignModal = (CloneCampaignModal_Component.exports);

// EXTERNAL MODULE: ./src/graphql/Transactions/NewLeadTransaction.gql
var NewLeadTransaction = __webpack_require__("nd0L");
var NewLeadTransaction_default = /*#__PURE__*/__webpack_require__.n(NewLeadTransaction);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/modals/LeadRefundModal.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var LeadRefundModal = ({
  name: 'refund-lead-transaction',
  mixins: [ModalMixin],
  components: {
    Dialog: src_components_Dialog,
    Switches: vue_switches_src_switches
  },
  props: {
    trx: Object
  },
  data: function data() {
    return {
      transaction: {
        amount: '',
        notes: '',
        invalidateLead: true
      }
    };
  },
  mounted: function mounted() {
    if (this.trx) {
      this.transaction.amount = -this.trx.amount;
    }
  },

  computed: {
    title: function title() {
      return 'Refund Lead #' + this.trx.leadId;
    },

    amount: {
      get: function get() {
        return this.transaction && this.transaction.amount || '';
      },
      set: function set(val) {
        this.transaction.amount = val;
      }
    },
    notes: {
      get: function get() {
        return this.transaction && this.transaction.notes || '';
      },
      set: function set(val) {
        this.transaction.notes = val;
      }
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var isValid;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return');

              case 11:

                _this.createTransaction();

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    createTransaction: function createTransaction() {
      var _this2 = this;

      this.$apollo.mutate({
        mutation: NewLeadTransaction_default.a,
        variables: {
          id: this.trx.companyId,
          input: extends_default()({}, this.transaction, {
            leadId: this.trx.leadId,
            currencyId: this.trx.currencyId
          })
        },
        refetchQueries: function refetchQueries(_ref) {
          var data = _ref.data;

          var response = data.createTransaction;
          return response && response.success ? ['transactions'] : [];
        }
      }).then(function () {
        _this2.$notify({
          group: 'success',
          type: 'success',
          text: 'Transaction was created'
        });
        _this2.close();
      }).catch(function (e) {
        _this2.$notify({
          group: 'error',
          type: 'error',
          text: e.message
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a81ad5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modals/LeadRefundModal.vue
var LeadRefundModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"title":_vm.title},on:{"submit":_vm.onSubmit}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"amount"}},[_vm._v("Amount* "),_c('span',{staticClass:"badge badge-warning"},[_vm._v(_vm._s(_vm.trx.currency))])]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model.trim",value:(_vm.amount),expression:"amount",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('amount')},attrs:{"type":"number","id":"amount","name":"amount","autofocus":""},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('amount')),expression:"errors.has('amount')"}],staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.errors.first('amount'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"description"}},[_vm._v("Description*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notes),expression:"notes"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control main-textarea",class:{'is-invalid': _vm.errors.has('description')},attrs:{"rows":"3","id":"description","name":"description","placeholder":"Enter description"},domProps:{"value":(_vm.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notes=$event.target.value}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('description')),expression:"errors.has('description')"}],staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.errors.first('description'))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox mr-sm-2 mb-3 mt-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.transaction.invalidateLead),expression:"transaction.invalidateLead"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"checkbox0","value":"check"},domProps:{"checked":Array.isArray(_vm.transaction.invalidateLead)?_vm._i(_vm.transaction.invalidateLead,"check")>-1:(_vm.transaction.invalidateLead)},on:{"change":function($event){var $$a=_vm.transaction.invalidateLead,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="check",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.transaction, "invalidateLead", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.transaction, "invalidateLead", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.transaction, "invalidateLead", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"checkbox0"}},[_vm._v("Invalidate the Lead")])])])])])}
var LeadRefundModal_staticRenderFns = []
var LeadRefundModal_esExports = { render: LeadRefundModal_render, staticRenderFns: LeadRefundModal_staticRenderFns }
/* harmony default export */ var modals_LeadRefundModal = (LeadRefundModal_esExports);
// CONCATENATED MODULE: ./src/modals/LeadRefundModal.vue
function LeadRefundModal_injectStyle (ssrContext) {
  __webpack_require__("K28h")
}
var LeadRefundModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LeadRefundModal___vue_template_functional__ = false
/* styles */
var LeadRefundModal___vue_styles__ = LeadRefundModal_injectStyle
/* scopeId */
var LeadRefundModal___vue_scopeId__ = "data-v-1a81ad5c"
/* moduleIdentifier (server only) */
var LeadRefundModal___vue_module_identifier__ = null
var LeadRefundModal_Component = LeadRefundModal_normalizeComponent(
  LeadRefundModal,
  modals_LeadRefundModal,
  LeadRefundModal___vue_template_functional__,
  LeadRefundModal___vue_styles__,
  LeadRefundModal___vue_scopeId__,
  LeadRefundModal___vue_module_identifier__
)

/* harmony default export */ var src_modals_LeadRefundModal = (LeadRefundModal_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("Zx67");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/helpers/Router.js









var Router_Router = function (_VueRouter) {
  inherits_default()(Router, _VueRouter);

  function Router(options) {
    classCallCheck_default()(this, Router);

    var _this = possibleConstructorReturn_default()(this, (Router.__proto__ || get_prototype_of_default()(Router)).call(this, options));

    _this.beforeEach(function (to, from, next) {
      var permissions = store.getters.getAuth ? store.getters.getAuth.permission : [];
      var granted = _this.isPathGranted(to.meta.grants, permissions);
      if (!granted) {
        sweetalert2_all_default()({
          text: 'Access denied',
          type: 'error',
          timer: 5000,
          confirmButtonText: 'Close'
        }).catch(sweetalert2_all_default.a.noop);
        next({ path: from.fullPath });
        return;
      }
      next();
    });
    // this.afterEach((to, from) => {
    //   store.dispatch('trackEvent', {
    //     name: "Navigation",
    //     options: {
    //       from: from.fullPath,
    //       to: to.fullPath,
    //     }
    //   });
    // })
    return _this;
  }

  createClass_default()(Router, [{
    key: 'canSee',
    value: function canSee(need) {
      var newNeed = Array.isArray(need) ? need : [need];
      var permissions = store.getters.getAuth ? store.getters.getAuth.permission : [];

      if (!permissions) {
        return false;
      }

      var res = newNeed.filter(function (item) {
        return permissions.includes(item);
      });

      if (res.length) {
        return true;
      }

      return newNeed.filter(function (i) {
        return permissions.includes(i.split('.').shift());
      }).length;
    }
  }, {
    key: 'isPathGranted',
    value: function isPathGranted(routeGrants, grants) {
      if (routeGrants[0] === '*') {
        return true;
      }

      if (!grants) {
        return true;
      }

      var res = routeGrants.filter(function (item) {
        return grants.includes(item);
      });
      if (res.length) {
        return true;
      }

      return routeGrants.filter(function (i) {
        return grants.includes(i.split('.').shift());
      }).length;
    }
  }]);

  return Router;
}(vue_router_esm["a" /* default */]);

/* harmony default export */ var helpers_Router = (Router_Router);
// EXTERNAL MODULE: ./src/graphql/Reports/Agents.gql
var Agents = __webpack_require__("85oc");
var Agents_default = /*#__PURE__*/__webpack_require__.n(Agents);

// EXTERNAL MODULE: ./src/graphql/Reports/AgentsName.gql
var AgentsName = __webpack_require__("1Prk");
var AgentsName_default = /*#__PURE__*/__webpack_require__.n(AgentsName);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Reports/Agents.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Reports_Agents = ({
  name: 'Agents',
  components: {
    DataTable: components_DataTable
  },
  data: function data() {
    return {
      headers: [{ field: 'id', title: 'Id' }, { title: 'Name', field: 'name' }, { title: 'Total Leads', field: 'totalLeads' }, { title: 'Completed Leads', field: 'completedLeads' }, { title: 'Partial Leads', field: 'partialLeads' }, { title: 'CTR (Leads)', field: 'ctrLeads' }, { title: 'Total DP', field: 'totalDP' }, { title: 'Mandatory DP', field: 'mandatoryDP' }, { title: 'Collected DP', field: 'collectedDP' }, { title: 'CTR (DP)', field: 'ctrDP' }, { title: 'Completed DP', field: 'completedDP' }, { title: 'CTR (DP1)', field: 'ctrCompletedDP' }, { title: 'Partials DP', field: 'partialsDP' }, { title: 'CTR (DP2)', field: 'ctrPartialsDP' }, { title: 'Notes', field: 'notes' }, { title: 'Average RT', field: 'averageRT' }, { title: 'Min RT', field: 'minRT' }, { title: 'Max RT', field: 'maxRT' }, { title: 'Average CT', field: 'averageCT' }, { title: 'Min CT', field: 'minCT' }, { title: 'Max CT', field: 'maxCT' }],
      periods: [{
        value: 'today',
        title: 'Today'
      }, {
        value: 'yesterday',
        title: 'Yesterday'
      }, {
        value: 'week',
        title: 'This week'
      }, {
        value: 'last-week',
        title: 'Last week'
      }, {
        value: 'month',
        title: 'This month'
      }, {
        value: 'last-month',
        title: 'Last month'
      }],
      period: 'today',
      agentId: '0',
      collections: Agents_default.a,
      agentsName: []
    };
  },

  computed: {
    variables: function variables() {
      return {
        agentId: this.agentId,
        period: this.period
      };
    }
  },
  apollo: {
    agentsName: {
      query: AgentsName_default.a,
      fetchPolicy: 'network-only',
      result: function result(_ref) {
        var data = _ref.data,
            loading = _ref.loading;

        if (!loading) {
          this.agentsName = data.agentsName.result;
        }
      },
      skip: function skip() {
        return false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f00745ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports/Agents.vue
var Agents_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('breadcrumbs'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_vm._v("Agents")]),_vm._v(" "),_c('h6',{staticClass:"card-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('data-table',{attrs:{"columns":_vm.headers,"fieldName":"agents","variables":_vm.variables,"query":_vm.collections}},[_c('div',{staticClass:"filter-controls pull-right",attrs:{"slot":"filter"},slot:"filter"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.agentId),expression:"agentId"}],staticClass:"form-control",attrs:{"id":"agent-filter"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.agentId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"","value":"0"}},[_vm._v("All Agents")]),_vm._v(" "),_vm._l((_vm.agentsName),function(agent){return _c('option',{key:agent.id,domProps:{"value":agent.id}},[_vm._v(_vm._s(agent.name))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.period),expression:"period"}],staticClass:"form-control",attrs:{"id":"period-filter"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.period=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.periods),function(period){return _c('option',{key:period.value,domProps:{"value":period.value}},[_vm._v(_vm._s(period.title))])}),0)])])],1)])])])],1)}
var Agents_staticRenderFns = []
var Agents_esExports = { render: Agents_render, staticRenderFns: Agents_staticRenderFns }
/* harmony default export */ var pages_Reports_Agents = (Agents_esExports);
// CONCATENATED MODULE: ./src/pages/Reports/Agents.vue
function Agents_injectStyle (ssrContext) {
  __webpack_require__("w80f")
}
var Agents_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Agents___vue_template_functional__ = false
/* styles */
var Agents___vue_styles__ = Agents_injectStyle
/* scopeId */
var Agents___vue_scopeId__ = "data-v-f00745ac"
/* moduleIdentifier (server only) */
var Agents___vue_module_identifier__ = null
var Agents_Component = Agents_normalizeComponent(
  Reports_Agents,
  pages_Reports_Agents,
  Agents___vue_template_functional__,
  Agents___vue_styles__,
  Agents___vue_scopeId__,
  Agents___vue_module_identifier__
)

/* harmony default export */ var src_pages_Reports_Agents = (Agents_Component.exports);

// EXTERNAL MODULE: ./src/graphql/SignupUser.gql
var SignupUser = __webpack_require__("Cyu/");
var SignupUser_default = /*#__PURE__*/__webpack_require__.n(SignupUser);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VuetifyDialog.vue

/* harmony default export */ var VuetifyDialog = ({
  name: "VuetifyDialog",
  props: {
    title: { type: String, default: "" },
    button: { type: String, default: "Save" },
    closeable: { type: Boolean, default: true },
    show: { type: Boolean, default: false }
  },
  methods: {
    close: function close() {
      this.isOpen = false;
      this.$emit("close");
    },
    submit: function submit() {
      this.$emit("submit");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfaf812c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VuetifyDialog.vue
var VuetifyDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"lazy":"","fullscreen":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"blue"}},[(_vm.closeable)?_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("close")])],1):_vm._e(),_vm._v(" "),_c('v-toolbar-title',{staticStyle:{"font-weight":"300"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._t("buttons",[_c('v-toolbar-items',[_c('v-btn',{staticClass:"pr-0",attrs:{"dark":"","flat":""},on:{"click":_vm.submit}},[_vm._v("\r              "+_vm._s(_vm.button)+"\r              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("navigate_next")])],1)],1)])],2),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"mx-auto",staticStyle:{"max-width":"760px"}},[_vm._t("default")],2)])],1)],1)}
var VuetifyDialog_staticRenderFns = []
var VuetifyDialog_esExports = { render: VuetifyDialog_render, staticRenderFns: VuetifyDialog_staticRenderFns }
/* harmony default export */ var components_VuetifyDialog = (VuetifyDialog_esExports);
// CONCATENATED MODULE: ./src/components/VuetifyDialog.vue
function VuetifyDialog_injectStyle (ssrContext) {
  __webpack_require__("GXit")
}
var VuetifyDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VuetifyDialog___vue_template_functional__ = false
/* styles */
var VuetifyDialog___vue_styles__ = VuetifyDialog_injectStyle
/* scopeId */
var VuetifyDialog___vue_scopeId__ = "data-v-bfaf812c"
/* moduleIdentifier (server only) */
var VuetifyDialog___vue_module_identifier__ = null
var VuetifyDialog_Component = VuetifyDialog_normalizeComponent(
  VuetifyDialog,
  components_VuetifyDialog,
  VuetifyDialog___vue_template_functional__,
  VuetifyDialog___vue_styles__,
  VuetifyDialog___vue_scopeId__,
  VuetifyDialog___vue_module_identifier__
)

/* harmony default export */ var src_components_VuetifyDialog = (VuetifyDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Signup/Account.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Account = ({
  components: {
    VuetifyDialog: src_components_VuetifyDialog
  },
  props: {
    title: { type: String, default: "" },
    button: { type: String, default: "Next" },
    closeable: { type: Boolean, default: false },
    reference: { type: String, default: "modal" },
    show: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      companyName: '',
      userName: '',
      email: '',
      phone: '',
      password: '',
      confirmedPassword: '',
      isValid: true
    };
  },

  methods: {
    getError: function getError(name) {
      return this.isValid ? '' : this.errors.first(name);
    },
    validateOnInput: function validateOnInput() {
      this.isValid = true;
    },
    submit: function submit() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var companyName, userName, email, phone, password;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validate();

              case 2:
                _this.isValid = _context.sent;

                if (_this.isValid) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                companyName = _this.companyName, userName = _this.userName, email = _this.email, phone = _this.phone, password = _this.password;

                _this.$emit('submit', {
                  companyName: companyName || userName,
                  userName: userName,
                  email: email,
                  phone: phone,
                  password: password
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52cd289a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Signup/Account.vue
var Account_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-dialog',{ref:_vm.reference,attrs:{"title":_vm.title,"button":_vm.button,"show":_vm.show,"closeable":_vm.closeable},on:{"submit":_vm.submit}},[_c('v-form',{staticClass:"pt-3"},[_c('v-text-field',{attrs:{"label":"Organization","placeholder":"Company name","append-icon":"domain"},model:{value:(_vm.companyName),callback:function ($$v) {_vm.companyName=$$v},expression:"companyName"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"required":"","name":"name","label":"Name","placeholder":"Your name","data-vv-as":"Name","error-messages":_vm.getError('name'),"append-icon":"person"},on:{"change":_vm.validateOnInput},model:{value:(_vm.userName),callback:function ($$v) {_vm.userName=$$v},expression:"userName"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"required":"","name":"email","label":"Email","placeholder":"Email address","data-vv-as":"Email","error-messages":_vm.getError('email'),"type":"email","append-icon":"email"},on:{"change":_vm.validateOnInput},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"mask":"phone","label":"Phone","placeholder":"Phone number","type":"phone","append-icon":"phone"},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],ref:"passwordRef",attrs:{"required":"","name":"password","type":"password","label":"Password (minimum 6 characters)","placeholder":"Password","data-vv-as":"password","error-messages":_vm.getError('password'),"append-icon":"visibility_off"},on:{"change":_vm.validateOnInput},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:passwordRef'),expression:"'required|confirmed:passwordRef'"}],ref:"confirmedPassword",attrs:{"required":"","type":"password","label":"Confirm Password","placeholder":"Password","name":"password_confirmation","data-vv-as":"password","error-messages":_vm.getError('password_confirmation'),"append-icon":"visibility_off"},on:{"change":_vm.validateOnInput},model:{value:(_vm.confirmedPassword),callback:function ($$v) {_vm.confirmedPassword=$$v},expression:"confirmedPassword"}})],1),_vm._v(" "),_c('div',{staticClass:"pa-2 mb-3 text-xs-center"},[_c('v-btn',{staticClass:"v-btn v-btn--large theme--dark success",attrs:{"target":"_blank"},on:{"click":_vm.submit}},[_vm._v("\n      "+_vm._s(_vm.button)+"\n    ")])],1)],1)}
var Account_staticRenderFns = []
var Account_esExports = { render: Account_render, staticRenderFns: Account_staticRenderFns }
/* harmony default export */ var Signup_Account = (Account_esExports);
// CONCATENATED MODULE: ./src/pages/Signup/Account.vue
var Account_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Account___vue_template_functional__ = false
/* styles */
var Account___vue_styles__ = null
/* scopeId */
var Account___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Account___vue_module_identifier__ = null
var Account_Component = Account_normalizeComponent(
  Account,
  Signup_Account,
  Account___vue_template_functional__,
  Account___vue_styles__,
  Account___vue_scopeId__,
  Account___vue_module_identifier__
)

/* harmony default export */ var pages_Signup_Account = (Account_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Signup/Payment.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* eslint-disable no-undef */
var Payment_stripe = Stripe("pk_live_Xg9jv6EY3sMdXBnMVapBbzLe");

var Payment_style = {
  base: {
    color: '#54667a',
    fontSize: '16px',
    lineHeight: '20px',
    '::placeholder': {
      color: '#E0E0E0'
    }
  },
  invalid: {
    color: '#e25950'
  }
};

var Payment_elementClasses = {
  focus: 'focused',
  empty: 'empty',
  invalid: 'invalid'
};

var Payment_elementOptions = {
  style: Payment_style,
  classes: Payment_elementClasses
};

/* harmony default export */ var Payment = ({
  components: {
    VuetifyDialog: src_components_VuetifyDialog
  },
  props: {
    title: { type: String, default: "" },
    button: { type: String, default: "Next" },
    closeable: { type: Boolean, default: false },
    reference: { type: String, default: "modal" },
    show: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      zip: '',
      name: '',
      errorMessage: {},
      showSpinner: 0,
      isValid: true,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      cardNumberInFocus: false,
      cardExpiryInFocus: false,
      cardCvcInFocus: false,
      info: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    var elements = Payment_stripe.elements();

    this.cardNumber = elements.create('cardNumber', extends_default()({}, Payment_elementOptions, { placeholder: 'XXXX XXXX XXXX XXXX' }));
    this.cardExpiry = elements.create('cardExpiry', Payment_elementOptions);
    this.cardCvc = elements.create('cardCvc', Payment_elementOptions);

    setTimeout(function () {
      _this.cardNumber.mount('#card-number');
      _this.cardExpiry.mount('#card-expiry');
      _this.cardCvc.mount('#card-cvc');

      _this.cardNumber.on('focus', function (event) {
        _this.onFocus(event);
      });
      _this.cardExpiry.on('focus', function (event) {
        _this.onFocus(event);
      });
      _this.cardCvc.on('focus', function (event) {
        _this.onFocus(event);
      });
      _this.cardNumber.on('blur', function (event) {
        _this.onBlur(event);
      });
      _this.cardExpiry.on('blur', function (event) {
        _this.onBlur(event);
      });
      _this.cardCvc.on('blur', function (event) {
        _this.onBlur(event);
      });
    }, 1000);
  },

  methods: {
    getError: function getError(name) {
      return this.isValid ? '' : this.errors.first(name);
    },
    onFocus: function onFocus(event) {
      switch (event.elementType) {
        case "cardNumber":
          this.cardNumberInFocus = true;
          break;
        case "cardExpiry":
          this.cardExpiryInFocus = true;
          break;
        case "cardCvc":
          this.cardCvcInFocus = true;
          break;
        default:
      }
    },
    onBlur: function onBlur(event) {
      switch (event.elementType) {
        case "cardNumber":
          this.cardNumberInFocus = false;
          break;
        case "cardExpiry":
          this.cardExpiryInFocus = false;
          break;
        case "cardCvc":
          this.cardCvcInFocus = false;
          break;
        default:
      }
    },
    cardHandler: function cardHandler(_ref) {
      var error = _ref.error;

      if (error) {
        this.errorMessage = {};
        if (error.code === 'incomplete_number' || error.code === 'invalid_number' || error.code === 'incorrect_number' || error.code === 'invalid_card_type' || error.code === 'card_declined') {
          this.errorMessage.cardNumberError = error.message;
        } else if (error.code === 'incomplete_cvc' || error.code === 'invalid_cvc' || error.code === 'incorrect_cvc') {
          this.errorMessage.cardCVCError = error.message;
        } else if (error.code === 'incomplete_expiry' || error.code === 'expired_card' || error.code === 'invalid_expiry_month' || error.code === 'invalid_expiry_year' || error.code === 'invalid_expiry_year_past') {
          this.errorMessage.cardExpiryError = error.message;
        } else {
          this.errorMessage.cardNumberError = error.message;
        }
      } else {
        this.errorMessage = {};
      }
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var options, token;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = {};
                _context.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                _this2.isValid = _context.sent;
                _context.next = 6;
                return Payment_stripe.createToken(_this2.cardNumber, options);

              case 6:
                token = _context.sent;
                _context.prev = 7;

                _this2.cardHandler(token);
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](7);

                /* eslint-disable no-console */
                console.error('Error', _context.t0);
                return _context.abrupt('return', null);

              case 15:
                if (!(!_this2.isValid || token.error)) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt('return', null);

              case 17:

                // this.$refs.modal.close();
                // this.createCard(token.token.id);
                _this2.$emit('submit', {
                  name: _this2.name,
                  token: token.token
                });

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[7, 11]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60120ade","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Signup/Payment.vue
var Payment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-dialog',{ref:_vm.reference,attrs:{"title":_vm.title,"button":_vm.button,"show":_vm.show,"closeable":_vm.closeable},on:{"submit":_vm.submit}},[_c('div',[(_vm.info)?_c('v-container',{staticClass:"py-0"},[_c('v-layout',{attrs:{"row":""}},[_c('div',{staticClass:"flex xs12"},[_c('v-alert',{staticClass:"v-alert--no-icon",attrs:{"dismissible":"","type":"success","outline":""},model:{value:(_vm.info),callback:function ($$v) {_vm.info=$$v},expression:"info"}},[_vm._v("\n            Your credit card will not be charged without your prior express consent, and we will email you a few days before applying a charge. If you decide that NextLead isn't for you, you can cancel and remove card from your account at any time.\n          ")])],1)])],1):_vm._e()],1),_vm._v(" "),_c('v-form',[_c('v-container',{staticClass:"px-0"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"name","label":"Cardholder Name","placeholder":"Full Name","required":"","data-vv-as":"Name","error-messages":_vm.getError('name')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"v-input v-text-field v-text-field--placeholder theme--light",class:{'v-input--is-focused primary--text': _vm.cardNumberInFocus}},[_c('div',{staticClass:"v-input__control"},[_c('div',{staticClass:"v-input__slot"},[_c('div',{staticClass:"v-text-field__slot"},[_c('label',{staticClass:"v-label v-label--active theme--light",class:{'error--text': _vm.errorMessage.cardNumberError, 'primary--text': _vm.cardNumberInFocus},staticStyle:{"left":"0px","right":"auto","position":"absolute"},attrs:{"for":"card-number"}},[_vm._v("Card Number")]),_vm._v(" "),_c('div',{staticClass:"stripe_element",attrs:{"id":"card-number"}})]),_vm._v(" "),_c('div',{staticClass:"v-input__append-inner"},[_c('div',{staticClass:"v-input__icon v-input__icon--append"},[_c('i',{staticClass:"v-icon material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("credit_card")])])])]),_vm._v(" "),_c('div',{staticClass:"v-text-field__details"},[_c('div',{staticClass:"v-messages theme--light error--text"},[_c('div',{staticClass:"v-messages__wrapper"},[_vm._v(_vm._s(_vm.errorMessage.cardNumberError))])])])])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"v-input v-text-field v-text-field--placeholder theme--light",class:{'v-input--is-focused primary--text': _vm.cardExpiryInFocus}},[_c('div',{staticClass:"v-input__control"},[_c('div',{staticClass:"v-input__slot"},[_c('div',{staticClass:"v-text-field__slot"},[_c('label',{staticClass:"v-label v-label--active theme--light",class:{'error--text': _vm.errorMessage.cardExpiryError, 'primary--text': _vm.cardExpiryInFocus},staticStyle:{"left":"0px","right":"auto","position":"absolute"},attrs:{"for":"card-expiry"}},[_vm._v("Expiration")]),_vm._v(" "),_c('div',{staticClass:"stripe_element",attrs:{"id":"card-expiry"}})]),_vm._v(" "),_c('div',{staticClass:"v-input__append-inner"},[_c('div',{staticClass:"v-input__icon v-input__icon--append"},[_c('i',{staticClass:"v-icon material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("today")])])])]),_vm._v(" "),_c('div',{staticClass:"v-text-field__details"},[_c('div',{staticClass:"v-messages theme--light error--text"},[_c('div',{staticClass:"v-messages__wrapper"},[_vm._v(_vm._s(_vm.errorMessage.cardExpiryError))])])])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"v-input v-text-field v-text-field--placeholder theme--light",class:{'v-input--is-focused primary--text': _vm.cardCvcInFocus}},[_c('div',{staticClass:"v-input__control"},[_c('div',{staticClass:"v-input__slot"},[_c('div',{staticClass:"v-text-field__slot"},[_c('label',{staticClass:"v-label v-label--active theme--light",class:{'error--text': _vm.errorMessage.cardCVCError, 'primary--text': _vm.cardCvcInFocus},staticStyle:{"left":"0px","right":"auto","position":"absolute"},attrs:{"for":"card-cvc"}},[_vm._v("CVC")]),_vm._v(" "),_c('div',{staticClass:"stripe_element",attrs:{"id":"card-cvc"}})]),_vm._v(" "),_c('div',{staticClass:"v-input__append-inner"},[_c('div',{staticClass:"v-input__icon v-input__icon--append"},[_c('i',{staticClass:"v-icon material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("verified_user")])])])]),_vm._v(" "),_c('div',{staticClass:"v-text-field__details"},[_c('div',{staticClass:"v-messages theme--light error--text"},[_c('div',{staticClass:"v-messages__wrapper"},[_vm._v(_vm._s(_vm.errorMessage.cardCVCError))])])])])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"pa-2 mb-3 text-xs-center"},[_c('v-btn',{staticClass:"v-btn v-btn--large theme--dark success",attrs:{"target":"_blank"},on:{"click":_vm.submit}},[_vm._v("\n      "+_vm._s(_vm.button)+"\n    ")])],1)],1)}
var Payment_staticRenderFns = []
var Payment_esExports = { render: Payment_render, staticRenderFns: Payment_staticRenderFns }
/* harmony default export */ var Signup_Payment = (Payment_esExports);
// CONCATENATED MODULE: ./src/pages/Signup/Payment.vue
function Payment_injectStyle (ssrContext) {
  __webpack_require__("i0HN")
}
var Payment_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Payment___vue_template_functional__ = false
/* styles */
var Payment___vue_styles__ = Payment_injectStyle
/* scopeId */
var Payment___vue_scopeId__ = "data-v-60120ade"
/* moduleIdentifier (server only) */
var Payment___vue_module_identifier__ = null
var Payment_Component = Payment_normalizeComponent(
  Payment,
  Signup_Payment,
  Payment___vue_template_functional__,
  Payment___vue_styles__,
  Payment___vue_scopeId__,
  Payment___vue_module_identifier__
)

/* harmony default export */ var pages_Signup_Payment = (Payment_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Signup/Thanks.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Thanks = ({
  props: {
    title: { type: String, default: "" },
    button: { type: String, default: "Login" },
    closeable: { type: Boolean, default: false },
    reference: { type: String, default: "modal" },
    show: { type: Boolean, default: false }
  },
  components: {
    VuetifyDialog: src_components_VuetifyDialog
  },
  methods: {
    submit: function submit() {
      this.$emit('submit');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1aedd58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Signup/Thanks.vue
var Thanks_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-dialog',{ref:_vm.reference,attrs:{"title":_vm.title,"button":_vm.button,"show":_vm.show,"closeable":_vm.closeable},on:{"submit":_vm.submit}},[_c('div',{staticClass:"form-container d-flex flex-column justify-content-center align-items-center p-4"},[_c('div',{staticClass:"text-center"},[_c('h2',{staticClass:"px-5 pt-4 pb-2"},[_vm._v("Thank you!")]),_vm._v(" "),_c('div',{staticClass:"subheading font-weight-light pt-3"},[_vm._v("Your account is all setup. We'll contact you shortly to discuss your landing page(s) requirements.")])])]),_vm._v(" "),_c('div',{staticClass:"pa-2 mb-3 text-xs-center"},[_c('v-btn',{staticClass:"v-btn v-btn--large theme--dark success",attrs:{"target":"_blank"},on:{"click":_vm.submit}},[_vm._v("\n      "+_vm._s(_vm.button)+"\n    ")])],1)])}
var Thanks_staticRenderFns = []
var Thanks_esExports = { render: Thanks_render, staticRenderFns: Thanks_staticRenderFns }
/* harmony default export */ var Signup_Thanks = (Thanks_esExports);
// CONCATENATED MODULE: ./src/pages/Signup/Thanks.vue
function Thanks_injectStyle (ssrContext) {
  __webpack_require__("KjBi")
}
var Thanks_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Thanks___vue_template_functional__ = false
/* styles */
var Thanks___vue_styles__ = Thanks_injectStyle
/* scopeId */
var Thanks___vue_scopeId__ = "data-v-d1aedd58"
/* moduleIdentifier (server only) */
var Thanks___vue_module_identifier__ = null
var Thanks_Component = Thanks_normalizeComponent(
  Thanks,
  Signup_Thanks,
  Thanks___vue_template_functional__,
  Thanks___vue_styles__,
  Thanks___vue_scopeId__,
  Thanks___vue_module_identifier__
)

/* harmony default export */ var pages_Signup_Thanks = (Thanks_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Signup/Congratulations.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Congratulations = ({
  props: {
    value: String,
    campaignId: [Number, String]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba0ed9ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Signup/Congratulations.vue
var Congratulations_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('v-list',{staticClass:"ma-3",attrs:{"two-line":""}},[_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"ripple":"","href":_vm.value,"target":"_blank"}},[_c('v-list-tile-avatar',[_c('v-avatar',{staticClass:"subheading white--text",attrs:{"color":"blue-grey lighten-2","size":"24"},domProps:{"textContent":_vm._s(1)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold blue--text"},[_vm._v("\n          Generate Leads from Landing Page\n        ")]),_vm._v(" "),_c('v-list-tile-sub-title',{},[_vm._v("\n          Drive traffic to your page to capture leads.\n        ")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"ripple":"","to":{ name: 'CampaignDetails', params: { id: _vm.campaignId }, query: { tab: 'widget_code' }},"target":"_blank"}},[_c('v-list-tile-avatar',[_c('v-avatar',{staticClass:"subheading white--text",attrs:{"color":"blue-grey lighten-2","size":"24"},domProps:{"textContent":_vm._s(2)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold blue--text"},[_vm._v("\n          Generate Leads from your Web-site\n        ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n          Add widget code to your site to start capturing leads.\n        ")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"ripple":"","to":{ name: 'CampaignDetails', params: { id: _vm.campaignId }, query: { tab: 'landing_page' }},"target":"_blank"}},[_c('v-list-tile-avatar',[_c('v-avatar',{staticClass:"subheading white--text",attrs:{"color":"blue-grey lighten-2","size":"24"},domProps:{"textContent":_vm._s(3)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold blue--text"},[_vm._v("\n          Edit Campaign and Landing Page\n        ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n          Click \"GO TO MY ACCOUNT\" button to edit your campaign and landing page.\n        ")])],1)],1),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('div',{staticClass:"pa-4 mb-3 text-xs-center"},[_c('a',{staticClass:"v-btn v-btn--large theme--dark success",attrs:{"href":_vm.value,"target":"_blank"}},[_vm._v("\n      View Landing Page\n    ")])])],1)}
var Congratulations_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"px-5 pt-4 pb-2"},[_vm._v("Congratulations 🎉, Your campaign and landing page are ready to accept leads!")]),_vm._v(" "),_c('div',{staticClass:"subheading font-weight-light pt-3"},[_vm._v("Things you can do now:")])])}]
var Congratulations_esExports = { render: Congratulations_render, staticRenderFns: Congratulations_staticRenderFns }
/* harmony default export */ var Signup_Congratulations = (Congratulations_esExports);
// CONCATENATED MODULE: ./src/pages/Signup/Congratulations.vue
function Congratulations_injectStyle (ssrContext) {
  __webpack_require__("5S2H")
}
var Congratulations_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Congratulations___vue_template_functional__ = false
/* styles */
var Congratulations___vue_styles__ = Congratulations_injectStyle
/* scopeId */
var Congratulations___vue_scopeId__ = "data-v-ba0ed9ca"
/* moduleIdentifier (server only) */
var Congratulations___vue_module_identifier__ = null
var Congratulations_Component = Congratulations_normalizeComponent(
  Congratulations,
  Signup_Congratulations,
  Congratulations___vue_template_functional__,
  Congratulations___vue_styles__,
  Congratulations___vue_scopeId__,
  Congratulations___vue_module_identifier__
)

/* harmony default export */ var pages_Signup_Congratulations = (Congratulations_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Signup/Signup.vue



//
//
//
//
//
//
//
//
//



// import CREATE_CAMPAIGN from '@/graphql/CreateCampaign.gql';









/* harmony default export */ var Signup = ({
  components: {
    Account: pages_Signup_Account,
    Payment: pages_Signup_Payment,
    Thanks: pages_Signup_Thanks,
    LeadQuestion: src_components_LeadQuestion,
    Spinner: src_components_Spinner,
    Congratulations: pages_Signup_Congratulations
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getLastSignupStep', 'getLandingUrl', 'getNewCampaignId'])),
  data: function data() {
    return {
      loading: false,
      context: this.$route.query.context ? atob(this.$route.query.context) : '',
      companyId: null,
      email: null,
      gclid: null,
      affid: null
    };
  },
  created: function created() {
    this.checkAuth();
    this.checkCurrentStep();
  },
  mounted: function mounted() {
    if (localStorage.getItem('affid')) {
      this.affid = localStorage.getItem('affid');
    } else {
      this.affid = this.$route.query.affid;
      if (this.affid) {
        localStorage.setItem('affid', this.affid);
      }
    }
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['login', 'checkCurrentStep', 'submitStep', 'saveNewCampaignId', 'saveLandingUrl', 'checkAuth', 'trackEvent', 'trackAffilate', 'trackPaymentInfo']), {
    // eslint-disable-next-line
    saveAccount: stepperApiCall(function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(input) {
        var result, signupByUser;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$apollo.mutate({
                  mutation: SignupUser_default.a,
                  variables: { input: extends_default()({}, input, {
                      affiliateId: this.affid
                    }) }
                });

              case 2:
                result = _context.sent;
                signupByUser = result.data.signupByUser;


                this.companyId = signupByUser.user.companyId;
                this.email = input.email;

                this.login(signupByUser);
                this.submitStep(this.getLastSignupStep);
                this.sendGtagEvent('Account Created', input.companyName + ' | ' + input.userName + ' <' + input.email + '>');
                this.trackEvent({ name: "Signup" });
                // if (this.affid) {
                //   this.trackAffilate({affiliateId: this.affid});
                // }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()),
    // eslint-disable-next-line
    savePayment: stepperApiCall(function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(input) {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$apollo.mutate({
                  mutation: NewCard_default.a,
                  variables: {
                    id: this.companyId,
                    input: {
                      token: input.token.id,
                      customerEmail: this.email,
                      holderEmail: this.email,
                      cardholder: input.name
                    }
                  }
                });

              case 2:

                this.submitStep(this.getLastSignupStep);
                this.sendGtagEvent('Payment Added', this.companyId);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()),
    // eslint-disable-next-line
    // saveCampaign: apiCall(async function(input) {
    //   const result = await this.$apollo.mutate({
    //     mutation: CREATE_CAMPAIGN,
    //     variables: { input },
    //   });
    //   this.saveNewCampaignId(result.data.createCampaign.campaignId);
    //   this.saveLandingUrl(
    //     `${process.env.PAGES_URI}/${result.data.createCampaign.landingName}`
    //   );
    //   this.sendGtagEvent('Campaign Created', input.campaignName);
    //   this.trackEvent({
    //     name: "Campaign Created",
    //     options: {
    //       "campaignName": input.campaignName,
    //     }
    //   });
    //   this.submitStep(this.getLastSignupStep);
    // }),
    // nextStep(input) {
    //   const step = this.getLastSignupStep;
    //   this.submitStep(step);
    // },
    goToLogin: function goToLogin() {
      this.$router.push({ name: 'Login' });
    },

    // goToNextStep() {
    //   this.$refs[this.getLastSignupStep].submit();
    // },
    sendGtagEvent: function sendGtagEvent(action, label) {
      if (window.gtag) {
        window.gtag('event', action, {
          'event_category': 'NextLead_Portal_Signup',
          'event_label': label
        });
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-108fa7a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Signup/Signup.vue
var Signup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme--light.application"},[(_vm.getLastSignupStep === 1)?_c('account',{attrs:{"reference":"modal1","title":"New Account","button":"Next","show":_vm.getLastSignupStep === 1},on:{"submit":_vm.saveAccount}}):_vm._e(),_vm._v(" "),(_vm.getLastSignupStep === 2)?_c('payment',{attrs:{"reference":"modal2","title":"Payment Method","button":"Next","show":_vm.getLastSignupStep === 2},on:{"submit":_vm.savePayment}}):_vm._e(),_vm._v(" "),(_vm.getLastSignupStep === 3)?_c('thanks',{attrs:{"reference":"modal3","title":"Done","button":"Login","show":_vm.getLastSignupStep === 3},on:{"submit":_vm.goToLogin}}):_vm._e(),_vm._v(" "),(_vm.loading)?_c('spinner',{attrs:{"fullScreen":true}}):_vm._e(),_vm._v(" "),_c('notifications',{attrs:{"group":"error","position":"bottom right"}})],1)}
var Signup_staticRenderFns = []
var Signup_esExports = { render: Signup_render, staticRenderFns: Signup_staticRenderFns }
/* harmony default export */ var Signup_Signup = (Signup_esExports);
// CONCATENATED MODULE: ./src/pages/Signup/Signup.vue
function Signup_injectStyle (ssrContext) {
  __webpack_require__("BxM0")
}
var Signup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Signup___vue_template_functional__ = false
/* styles */
var Signup___vue_styles__ = Signup_injectStyle
/* scopeId */
var Signup___vue_scopeId__ = "data-v-108fa7a0"
/* moduleIdentifier (server only) */
var Signup___vue_module_identifier__ = null
var Signup_Component = Signup_normalizeComponent(
  Signup,
  Signup_Signup,
  Signup___vue_template_functional__,
  Signup___vue_styles__,
  Signup___vue_scopeId__,
  Signup___vue_module_identifier__
)

/* harmony default export */ var pages_Signup_Signup = (Signup_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js










































vue_esm["default"].use(helpers_Router);

/* harmony default export */ var router = (new helpers_Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Dashboard',
    component: src_components_Dashboard,
    beforeEnter: function beforeEnter(to, from, next) {
      if (store.state.auth) {
        var args = to.fullPath === '/' || to === '/' ? ['/leads'] : [];
        next.apply(undefined, args);
      } else {
        next(to === '/signup' ? to : '/login');
      }
    },
    meta: {
      grants: ['*']
    },
    children: [{
      path: '/leads',
      name: 'Leads',
      component: pages_Leads_Leads,
      meta: {
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Leads', text: 'Leads' }],
        grants: ['leads.find']
      },
      children: [{
        path: 'json-detail/:id',
        name: 'Lead',
        component: src_modals_LeadModal,
        meta: {
          breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Leads', text: 'Leads' }, { name: 'Lead', text: 'Lead' }],
          grants: ['leads.find']
        }
      }]
    }, {
      path: '/search/lead',
      name: 'SearchLead',
      component: pages_Search_Search,
      meta: {
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Leads', text: 'Leads' }, { name: 'SearchLead', text: 'Search' }],
        grants: ['leads.search']
      }
    }, {
      path: '/leads/:id',
      name: 'LeadDetails',
      component: pages_Leads_LeadDetails,
      meta: {
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Leads', text: 'Leads' }],
        grants: ['leads.find']
      }
    }, {
      path: '/leads/:id/refund',
      name: 'LeadRefund',
      components: { default: pages_Leads_LeadDetails, modal: src_modals_LeadRefundModal },
      meta: {
        grants: ['companies.update'],
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Leads', text: 'Leads' }]
      },
      props: { default: true, modal: true }
    }, {
      path: '/tickets',
      name: 'Tickets',
      component: pages_Tickets_Tickets,
      meta: {
        grants: ['tickets.find'],
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Tickets', text: 'Tckets' }]
      }
    }, {
      path: '/users',
      name: 'Users',
      component: src_pages_Users_Users,
      meta: {
        grants: ['users.find'],
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Users', text: 'Users' }]
      }
    }, {
      path: '/users/photo/:id',
      name: 'UserPhoto',
      components: { default: src_pages_Users_Users, modal: src_modals_UserPhotoModal },
      meta: {
        grants: ['users.find'],
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Users', text: 'Users' }]
      },
      props: { default: false, modal: true }
    }, {
      path: '/campaigns/:id/clone/:name',
      name: 'CloneCampaign',
      components: { default: Campaigns_Details_CampaignDetails, modal: src_modals_CloneCampaignModal },
      meta: {
        grants: ['campaigns.create']
      },
      props: {
        default: false,
        modal: function modal(route) {
          return {
            campaignId: +route.params.id,
            campaignName: route.params.name
          };
        }
      }
    }, {
      path: '/campaigns/:id/questions/new',
      name: 'NewCampaignQuestion',
      components: { default: Campaigns_Details_CampaignDetails, modal: src_modals_NewQuestions },
      meta: {
        grants: ['*']
      },
      props: {
        default: false,
        modal: function modal(route) {
          return {
            campaignId: +route.params.id
          };
        }
      }
    }, {
      path: '/campaigns/:id/questions/edit/:questionId',
      name: 'EditCampaignQuestion',
      components: { default: Campaigns_Details_CampaignDetails, modal: src_modals_NewQuestions },
      meta: {
        grants: ['*']
      },
      props: {
        default: false,
        modal: function modal(route) {
          return {
            questionId: +route.params.questionId,
            campaignId: +route.params.id,
            question: route.query.question,
            answer: route.query.answer
          };
        }
      }
    }, {
      path: '/campaigns/:id/file',
      name: 'FileModal',
      components: { default: Campaigns_Details_CampaignDetails, modal: src_modals_File },
      meta: {
        grants: ['*']
      },
      props: { default: false, modal: true }
    }, {
      path: '/users/add',
      name: 'AddUser',
      components: { default: src_pages_Users_Users, modal: src_modals_AddUser },
      meta: {
        grants: ['users.create'],
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Users', text: 'Users' }]
      }
    }, {
      path: '/messages/:ticketId',
      name: 'Messages',
      components: { default: pages_Tickets_Tickets, modal: src_modals_Chat },
      meta: {
        grants: ['tickets.messages'],
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Tickets', text: 'Tickets' }]
      }
    }, {
      path: '/users/update/:userId',
      name: 'UpdateUser',
      components: { default: src_pages_Users_Users, modal: src_modals_AddUser },
      meta: {
        grants: ['users.update'],
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Users', text: 'Users' }]
      },
      props: {
        default: false,
        modal: function modal(route) {
          return {
            userId: +route.params.userId
          };
        }
      }
    }, {
      path: '/users/:userId/campaigns',
      name: 'AssignCampaigns',
      components: { default: src_pages_Users_Users, modal: src_modals_AssignCampaign },
      meta: {
        grants: ['users.update', 'users.create'],
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Users', text: 'Users' }]
      },
      props: {
        default: false,
        modal: function modal(route) {
          return {
            userId: +route.params.userId
          };
        }
      }
    }, {
      path: '/campaigns/assign/:campaignId',
      name: 'AssignUsers',
      components: { default: src_pages_Campaigns_Campaigns, modal: src_modals_AssignUser },
      meta: {
        grants: ['campaigns.update', 'campaigns.create'],
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Campaigns', text: 'Campaigns' }]
      },
      props: {
        default: false,
        modal: function modal(route) {
          return {
            campaignId: +route.params.campaignId,
            companyId: +route.query.companyId
          };
        }
      }
    }, {
      path: '/campaigns',
      name: 'Campaigns',
      component: src_pages_Campaigns_Campaigns,
      meta: {
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Campaigns', text: 'Campaigns' }],
        grants: ['campaigns.find']
      }
    }, {
      path: '/guides/:id',
      name: 'Guides',
      component: pages_Guide_Guide,
      meta: {
        grants: ['*'],
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Guides', text: 'Guides' }]
      },
      props: true
    }, {
      path: '/campaigns/new',
      name: 'NewCampaign',
      components: {
        default: src_pages_Campaigns_Campaigns,
        modal: {
          components: { EditCampaign: src_modals_EditCampaignModal, EditClientCampaign: src_modals_EditClientCampaignModal },
          computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthUser'])),
          render: function render(h) {
            var props = {
              attrs: this.$attrs,
              props: this.$props,
              slots: this.$slots,
              on: this.$listeners
            };
            return this.getAuthUser.role.role_type === 'administrator' ? h('edit-campaign', props) : h('edit-client-campaign', props);
          }
        }
      },
      meta: {
        grants: ['campaigns.create'],
        breadcrumbs: [{ name: 'Campaigns', text: 'Campaigns' }]
      },
      props: { default: false, modal: true }
    }, {
      path: '/campaigns/new-shopify',
      name: 'NewShopifyCampaign',
      components: {
        default: src_pages_Campaigns_Campaigns,
        modal: {
          components: { EditShopifyCampaign: src_modals_EditShopifyCampaignModal },
          computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['getAuthUser'])),
          render: function render(h) {
            var props = {
              attrs: this.$attrs,
              props: this.$props,
              slots: this.$slots,
              on: this.$listeners
            };
            return this.getAuthUser.role.role_type === 'administrator' ? h('edit-shopify-campaign', props) : null;
          }
        }
      },
      meta: {
        grants: ['campaigns.create'],
        breadcrumbs: [{ name: 'Campaigns', text: 'Campaigns' }]
      },
      props: { default: false, modal: true }
    }, {
      path: '/campaigns/edit/:id',
      name: 'EditCampaign',
      components: { default: src_pages_Campaigns_Campaigns, modal: src_modals_EditCampaignModal },
      meta: {
        grants: ['campaigns.update'],
        breadcrumbs: [{ name: 'Campaigns', text: 'Campaigns' }]
      },
      props: { default: false, modal: true }
    }, {
      path: '/campaigns/edit-shopify/:id',
      name: 'EditShopifyCampaign',
      components: { default: src_pages_Campaigns_Campaigns, modal: src_modals_EditShopifyCampaignModal },
      meta: {
        grants: ['campaigns.update'],
        breadcrumbs: [{ name: 'Campaigns', text: 'Campaigns' }]
      },
      props: { default: false, modal: true }
    }, {
      path: '/questions/:id/new',
      name: 'NewQuestion',
      components: { default: Campaigns_Details_CampaignDetails, modal: modals_FieldAndQuery_EditFieldAndQueryModal },
      meta: {
        grants: ['questions.create'],
        breadcrumbs: [{ name: 'Campaigns', text: 'Campaigns' }]
      },
      props: { default: false, modal: true }
    }, {
      path: '/questions/:id/edit/:questionId',
      name: 'EditQuestion',
      components: { default: Campaigns_Details_CampaignDetails, modal: modals_FieldAndQuery_EditFieldAndQueryModal },
      meta: {
        grants: ['questions.update'],
        breadcrumbs: [{ name: 'Campaigns', text: 'Campaigns' }]
      },
      props: { default: false, modal: true }
    }, {
      path: '/campaigns/:id',
      name: 'CampaignDetails',
      component: Campaigns_Details_CampaignDetails,
      meta: {
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Campaigns', text: 'Campaigns' }],
        grants: ['campaigns.details']
      }
    }, {
      path: '/companies',
      name: 'Companies',
      component: src_pages_Companies_Companies,
      meta: {
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Companies', text: 'Companies' }],
        grants: ['companies.find']
      }
    }, {
      path: '/companies/new',
      name: 'NewCompany',
      components: { default: src_pages_Companies_Companies, modal: src_modals_EditCompanyModal },
      meta: {
        grants: ['companies.create'],
        breadcrumbs: [{ name: 'Companies', text: 'Companies' }]
      },
      props: { default: false, modal: true }
    }, {
      path: '/companies/edit/:id',
      name: 'EditCompany',
      component: pages_Companies_CompanyDetails,
      meta: {
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Companies', text: 'Companies' }],
        grants: ['companies.update']
      },
      beforeEnter: function beforeEnter(to, from, next) {
        var _store$getters$getAut = store.getters.getAuthUser,
            roleType = _store$getters$getAut.role.role_type,
            companyId = _store$getters$getAut.companyId;

        // check authentication

        if (roleType === 'administrator' || companyId) {
          next();
        } else {
          next('/');
        }
      }
    }, {
      path: '/companies/edit/:id/transaction/new',
      name: 'NewTransaction',
      components: { default: pages_Companies_CompanyDetails, modal: src_modals_AddTransactionModal },
      meta: {
        grants: ['companies.update'],
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Companies', text: 'Companies' }, { name: 'EditCompany', text: 'Company' }]
      },
      props: { default: false, modal: true }
    }, {
      path: '/companies/edit/:id/payment/new',
      name: 'NewPayment',
      components: { default: pages_Companies_CompanyDetails, modal: src_modals_CreatePaymentModal },
      meta: {
        grants: ['companies.createPayment'],
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Companies', text: 'Companies' }, { name: 'EditCompany', text: 'Company' }]
      },
      props: { default: false, modal: true }
    }, {
      path: '/reports/agents',
      name: 'Agents',
      component: src_pages_Reports_Agents,
      meta: {
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Agents', text: 'Agents' }],
        grants: ['companies.find']
      }
    }, {
      path: '/companies/edit/:id/billing/new',
      name: 'NewCard',
      components: { default: pages_Companies_CompanyDetails, modal: src_modals_AddCardModal },
      meta: {
        grants: ['companies.update'],
        breadcrumbs: [{ name: 'Dashboard', text: 'Home' }, { name: 'Companies', text: 'Companies' }, { name: 'EditCompany', text: 'Company' }]
      },
      props: { default: false, modal: true }
    }]
  }, {
    path: '/m',
    name: 'Mobile',
    component: src_components_Mobile,
    meta: {
      grants: ['*']
    },
    children: [{
      path: 'lead/:token',
      name: 'Lead',
      component: pages_Leads_LeadMobile,
      meta: {
        grants: ['*']
      }
    }]
  }, {
    path: '/login',
    name: 'Login',
    component: pages_Login_Login,
    meta: {
      grants: ['*']
    }
  }, {
    path: '/signup',
    name: 'Signup',
    component: pages_Signup_Signup,
    meta: {
      grants: ['*']
    }
  }, {
    path: '/notfound',
    name: 'NotFound',
    component: pages_NotFound_NotFound,
    meta: {
      grants: ['*']
    }
  }]
}));
// EXTERNAL MODULE: ./src/helpers/grantedDirective.js
var grantedDirective = __webpack_require__("m2+Y");
var grantedDirective_default = /*#__PURE__*/__webpack_require__.n(grantedDirective);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RouteTab.vue


/* harmony default export */ var RouteTab = ({
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    default: Boolean
  },
  computed: {
    _isTab: function _isTab() {
      return true;
    },

    localActive: {
      get: function get() {
        return this.$route.query.tab === this.name;
      },
      set: function set(active) {
        this.$set(this.$refs.tab, 'localActive', active);
        if (!active) {
          return;
        }
        this.changeTabRoute();
      }
    }
  },
  updated: function updated() {
    if (!this.$route.query.tab && this.default) {
      this.changeTabRoute();
    }
  },
  render: function render(h) {
    var _this = this;

    return h('b-tab', {
      ref: 'tab',
      props: {
        title: this.$props.title,
        active: this.$route.query.tab === this.name
      },
      on: {
        click: function click() {
          return _this.changeTabRoute();
        }
      }
    }, [this.$slots.default]);
  },

  methods: {
    changeTabRoute: function changeTabRoute() {
      this.$router.replace({ query: extends_default()({}, this.$route.query, { tab: this.name }) });
      this.$emit('click');
    }
  }
});
// CONCATENATED MODULE: ./src/components/RouteTab.vue
var RouteTab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var RouteTab___vue_template__ = null
/* template functional */
var RouteTab___vue_template_functional__ = false
/* styles */
var RouteTab___vue_styles__ = null
/* scopeId */
var RouteTab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var RouteTab___vue_module_identifier__ = null
var RouteTab_Component = RouteTab_normalizeComponent(
  RouteTab,
  RouteTab___vue_template__,
  RouteTab___vue_template_functional__,
  RouteTab___vue_styles__,
  RouteTab___vue_scopeId__,
  RouteTab___vue_module_identifier__
)

/* harmony default export */ var components_RouteTab = (RouteTab_Component.exports);

// CONCATENATED MODULE: ./src/validations.js
var validations = {
  emailStrict: {
    getMessage: function getMessage() {
      return 'Email field can only contain alphanumeric latin characters and special symbols . and _';
    },
    validate: function validate(value) {
      // eslint-disable-next-line no-useless-escape
      var regExp = new RegExp(/^(([0-9\-_a-zA-Z+]+(\.[0-9\-_a-zA-Z+]+)*)|(".+"))@(([a-zA-Z\-_0-9]+\.)?([a-zA-Z0-9]+\.)[a-zA-Z]{2,})$/);
      var match = value.match(regExp);
      return {
        valid: match ? !!match.length : false
      };
    }
  }
};

var dictionary = {
  custom: {
    MultipleChoice: {
      required: 'You need to choose at least one option'
    }
  }
};


// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











// include theme styles













vue_esm["default"].config.productionTip = "production" === 'production';

vue_esm["default"].use(vuetify_default.a, {
  iconfont: 'md' // 'md' || 'mdi' || 'fa' || 'fa4'
});

vue_esm["default"].use(es["a" /* default */]);

vue_esm["default"].use(vee_validate_esm["b" /* default */], {
  events: 'input|submit',
  dictionary: dictionary
});

keys_default()(validations).forEach(function (name) {
  vee_validate_esm["a" /* Validator */].extend(name, validations[name]);
});

vue_esm["default"].use(dist_default.a);

vue_esm["default"].component('breadcrumbs', src_components_Breadcrumb);
vue_esm["default"].component('reoute-tab', components_RouteTab);

vue_esm["default"].directive('granted', grantedDirective_default.a);

vue_esm["default"].use(v_mask_esm["a" /* default */]);

vue_esm["default"].use(vue2_filters_default.a);

// sync the router with the vuex store.
// this registers `store.state.route`
Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].use(vue_moment_default.a);

// register custom filters
vue_esm["default"].filter('date', function (timestamp) {
  var date = new Date(timestamp);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
});

vue_esm["default"].filter('thumb', function (imageUrl, height, width) {
  return imageUrl.replace('/image/upload/', '/image/upload/c_thumb,g_face,h_' + height + ',w_' + width + '/');
});

// Vue.filter('currency', ({balance, amount, currency}, locales = 'en-US') => {
//   const number = balance || amount;
//   if (number === undefined) {
//     return '';
//   }
//   if (currency === undefined) {
//     return number;
//   }
//   return new Intl.NumberFormat(locales, { style: 'currency', currency }).format(number);
// });

store.dispatch('checkAuth');
store.dispatch('checkWhiteLabel');

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: router,
  store: store,
  provide: apollo.provide(),
  render: function render(h) {
    return h(src_App);
  }
});

/***/ }),

/***/ "NUn7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OGcx":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CardInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCustomerCreated"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":125}};
    doc.loc.source = {"body":"mutation addCard($id: ID!, $input: CardInput!) {\n  addCard(id: $id, input: $input) {\n    success\n    isCustomerCreated\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["addCard"] = oneQuery(doc, "addCard");
        


/***/ }),

/***/ "P++x":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editCampaignQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"question"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditQuestionInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editCampaignQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"question"},"value":{"kind":"Variable","name":{"kind":"Name","value":"question"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":127}};
    doc.loc.source = {"body":"mutation editCampaignQuestion($question: EditQuestionInput!) {\n  editCampaignQuestion(question: $question) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["editCampaignQuestion"] = oneQuery(doc, "editCampaignQuestion");
        


/***/ }),

/***/ "PgCQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Psz0":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"questions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fieldName"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":114}};
    doc.loc.source = {"body":"query questions($where: String)  {\n  questions(where: $where) {\n    result {\n      id\n      fieldName\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["questions"] = oneQuery(doc, "questions");
        


/***/ }),

/***/ "Q5sR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R8cP":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currencies"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencies"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":67}};
    doc.loc.source = {"body":"query currencies {\n  currencies {\n    id,\n    name,\n    code\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["currencies"] = oneQuery(doc, "currencies");
        


/***/ }),

/***/ "RgsP":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"orderQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderInput"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":100}};
    doc.loc.source = {"body":"mutation orderQuestions($input: [OrderInput]!) {\n  orderQuestions(input: $input) {\n    success\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["orderQuestions"] = oneQuery(doc, "orderQuestions");
        


/***/ }),

/***/ "RtgL":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assignedCampaigns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignedCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":110}};
    doc.loc.source = {"body":"query assignedCampaigns($userId: Int!) {\n  assignedCampaigns(userId: $userId) {\n    campaignName\n    id\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["assignedCampaigns"] = oneQuery(doc, "assignedCampaigns");
        


/***/ }),

/***/ "T5Lr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TcGh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Trcj":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserPhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photoUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserPhoto"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"photoUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photoUrl"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":125}};
    doc.loc.source = {"body":"mutation updateUserPhoto($id: ID!, $photoUrl: String!) {\n  updateUserPhoto(id: $id, photoUrl: $photoUrl) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updateUserPhoto"] = oneQuery(doc, "updateUserPhoto");
        


/***/ }),

/***/ "TutB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U9Rq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UqoZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VfHG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wfjt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y8Br":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y9O/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YRmT":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":86}};
    doc.loc.source = {"body":"mutation deleteFile($fileId: ID!) {\n  deleteFile(fileId: $fileId) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["deleteFile"] = oneQuery(doc, "deleteFile");
        


/***/ }),

/***/ "YfVO":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"roles"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role_type"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":52}};
    doc.loc.source = {"body":"query roles {\n  roles {\n    id,\n    role_type,\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["roles"] = oneQuery(doc, "roles");
        


/***/ }),

/***/ "ZrH6":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":84}};
    doc.loc.source = {"body":"mutation addUser($input: UserInput!) {\n  addUser(input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["addUser"] = oneQuery(doc, "addUser");
        


/***/ }),

/***/ "Zymp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "azm8":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createLanding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePageInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLanding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"head"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":159}};
    doc.loc.source = {"body":"mutation createLanding($campaignId: ID!, $input: CreatePageInput) {\n  createLanding(campaignId: $campaignId, input: $input) {\n    body\n    head\n    name\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["createLanding"] = oneQuery(doc, "createLanding");
        


/***/ }),

/***/ "bF3y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bzhp":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCampaignPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignPolicyInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCampaignPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":163}};
    doc.loc.source = {"body":"mutation createCampaignPolicy($campaignId: ID!, $input: CampaignPolicyInput!) {\n  createCampaignPolicy(campaignId: $campaignId, input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["createCampaignPolicy"] = oneQuery(doc, "createCampaignPolicy");
        


/***/ }),

/***/ "cmmC":
/***/ (function(module, exports) {

var generateNotification = function generateNotification(type, group) {
  return function (text) {
    return {
      type: type,
      text: text,
      group: group
    };
  };
};

module.exports = {
  error: generateNotification('error', 'error'),
  success: generateNotification('success', 'success')
};

/***/ }),

/***/ "dW2o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eesH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fAmc":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":82}};
    doc.loc.source = {"body":"mutation deleteQuestion($id: ID!) {\n  deleteQuestion(id: $id) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["deleteQuestion"] = oneQuery(doc, "deleteQuestion");
        


/***/ }),

/***/ "fI04":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":109}};
    doc.loc.source = {"body":"mutation updateUser($id: ID!, $input: UserInput!) {\n  updateUser(id: $id, input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updateUser"] = oneQuery(doc, "updateUser");
        


/***/ }),

/***/ "fVsU":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descending"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"descending"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descending"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overdue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overdueSince"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":365}};
    doc.loc.source = {"body":"query companies($descending: Boolean, $sortBy: String, $limit: Int, $page: Int, $name: String) {\n  companies(descending: $descending, sortBy: $sortBy, limit: $limit, page: $page, name: $name) {\n    result {\n      id\n      companyName\n      status\n      description\n      created\n      overdue\n      overdueSince\n    }\n    meta {\n      limit\n      count\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["companies"] = oneQuery(doc, "companies");
        


/***/ }),

/***/ "fYSq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ftLw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g4or":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":121}};
    doc.loc.source = {"body":"mutation updateCampaign($id: ID!, $input: CampaignInput!) {\n  updateCampaign(id: $id, input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updateCampaign"] = oneQuery(doc, "updateCampaign");
        


/***/ }),

/***/ "gJtD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gO4H":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"campaignQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"question"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"answer"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":254}};
    doc.loc.source = {"body":"query campaignQuestions($campaignId: ID!, $limit: Int, $offset: Int) {\n  campaignQuestions(campaignId: $campaignId, limit: $limit, offset: $offset) {\n    meta {\n      count\n    }\n    result {\n      id\n      userId\n      question\n      answer\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["campaignQuestions"] = oneQuery(doc, "campaignQuestions");
        


/***/ }),

/***/ "i0HN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iJZB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "in+Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iwwK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jyry":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k/Wj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k/iC":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuestionInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":121}};
    doc.loc.source = {"body":"mutation updateQuestion($id: ID!, $input: QuestionInput!) {\n  updateQuestion(id: $id, input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updateQuestion"] = oneQuery(doc, "updateQuestion");
        


/***/ }),

/***/ "kWYe":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCampaignPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignPlanInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCampaignPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":133}};
    doc.loc.source = {"body":"mutation updateCampaignPlan($id: ID!, $input: CampaignPlanInput!) {\n  updateCampaignPlan(id: $id, input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updateCampaignPlan"] = oneQuery(doc, "updateCampaignPlan");
        


/***/ }),

/***/ "kZy8":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCampaignQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"question"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateQuestionInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCampaignQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"question"},"value":{"kind":"Variable","name":{"kind":"Name","value":"question"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":133}};
    doc.loc.source = {"body":"mutation createCampaignQuestion($question: CreateQuestionInput!) {\n  createCampaignQuestion(question: $question) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["createCampaignQuestion"] = oneQuery(doc, "createCampaignQuestion");
        


/***/ }),

/***/ "ktr9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l1nu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lgdi":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userPhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullSize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thumb150"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":131}};
    doc.loc.source = {"body":"query userPhoto($id: ID, $email: String) {\n  user(id: $id, email: $email) {\n    photo {\n      fullSize,\n      thumb150\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["userPhoto"] = oneQuery(doc, "userPhoto");
        


/***/ }),

/***/ "lsUh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m2+Y":
/***/ (function(module, exports) {

module.exports = function (el, binding, vnode) {
  var currentRouter = vnode.componentInstance ? vnode.componentInstance.$router : vnode.context.$router;

  if (!currentRouter.canSee(binding.value)) {
    // Implement v-if directive
    var comment = document.createComment(' ');
    Object.defineProperty(comment, 'setAttribute', {
      value: function value() {
        return undefined;
      }
    });
    /* eslint-disable no-param-reassign */
    vnode.elm = comment;
    vnode.text = ' ';
    vnode.isComment = true;
    vnode.context = undefined;
    vnode.tag = undefined;
    vnode.data.directives = undefined;

    if (vnode.componentInstance) {
      vnode.componentInstance.$el = comment;
    }
    /* eslint-enable no-param-reassign */

    if (el.parentNode) {
      el.parentNode.replaceChild(comment, el);
    }
  }
};

/***/ }),

/***/ "mWDM":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"transactionsByLeadId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionsByLeadId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currencyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leadId"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":186}};
    doc.loc.source = {"body":"query transactionsByLeadId($id: Int) {\n  transactionsByLeadId(id: $id) {\n    id\n    companyId\n    created\n    createdBy\n    notes\n    currency\n    currencyId\n    amount\n    leadId\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["transactionsByLeadId"] = oneQuery(doc, "transactionsByLeadId");
        


/***/ }),

/***/ "mcae":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n5R8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nextlead-dark-logo.6e4e1eb.png";

/***/ }),

/***/ "n9mN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nDDb":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"assignCampaigns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"campaignIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignIds"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":146}};
    doc.loc.source = {"body":"mutation assignCampaigns($userId: Int!, $campaignIds: [Int]!) {\n  assignCampaigns(userId: $userId, campaignIds: $campaignIds) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["assignCampaigns"] = oneQuery(doc, "assignCampaigns");
        


/***/ }),

/***/ "nd0L":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createLeadTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LeadTransactionInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLeadTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":142}};
    doc.loc.source = {"body":"mutation createLeadTransaction($id: ID!, $input: LeadTransactionInput!) {\n  createLeadTransaction(id: $id, input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["createLeadTransaction"] = oneQuery(doc, "createLeadTransaction");
        


/***/ }),

/***/ "nyn+":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"user"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role_type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":253}};
    doc.loc.source = {"body":"query user($id: ID, $email: String) {\n  user(id: $id, email: $email) {\n    name\n    company {\n      id\n      companyName\n    }\n    email\n    phone\n    role {\n      id\n      role_type\n    }\n    company {\n      id\n      companyName\n    }\n    status\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["user"] = oneQuery(doc, "user");
        


/***/ }),

/***/ "oFuQ":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"files"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":88}};
    doc.loc.source = {"body":"query files($campaignId: ID!) {\n  files(campaignId: $campaignId) {\n    url\n    id\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["files"] = oneQuery(doc, "files");
        


/***/ }),

/***/ "oU2R":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"campaigns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descending"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"descending"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descending"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dispatchTo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dispatchToPhone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leadQty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whiteLabel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":445}};
    doc.loc.source = {"body":"query campaigns($descending: Boolean, $sortBy: String, $limit: Int, $page: Int, $name: String) {\n  campaigns(descending: $descending, sortBy: $sortBy, limit: $limit, page: $page, name: $name) {\n    result {\n      id\n      companyId\n      campaignName\n      dispatchTo\n      dispatchToPhone\n      leadQty\n      status\n      editable\n      whiteLabel\n      companyName\n      created\n      type\n    }\n    meta {\n      limit\n      count\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["campaigns"] = oneQuery(doc, "campaigns");
        


/***/ }),

/***/ "oXyk":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"question"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fieldName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"question"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mandatory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"params"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":150}};
    doc.loc.source = {"body":"query question($id: Int) {\n  question(id: $id) {\n    id\n    fieldName\n    question\n    type\n    mandatory\n    created\n    campaignId\n    params\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["question"] = oneQuery(doc, "question");
        


/***/ }),

/***/ "pNQG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ptbP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qpFb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qrNM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/progress/_progress.js
var _progress = __webpack_require__("E9Zr");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/progress/progress.vue
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var progress = (_progress["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/progress/progress.vue
function injectStyle (ssrContext) {
  __webpack_require__("dW2o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  progress,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var progress_progress = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rGpa":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"leads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descending"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"period"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"answer"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"descending"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descending"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"period"},"value":{"kind":"Variable","name":{"kind":"Name","value":"period"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"answer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"answer"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agentName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfMandatoryQuestions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfQuestions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfQuestionsAnswered"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"names"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phones"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":754}};
    doc.loc.source = {"body":"query leads($descending: Boolean, $sortBy: String, $limit: Int, $page: Int, $companyId: Int, $campaignId: Int, $period: String, $status: String, $id: String, $answer: String) {\n  leads(descending: $descending, sortBy: $sortBy, limit: $limit, page: $page, companyId: $companyId, campaignId: $campaignId, period: $period, status: $status, id: $id, answer: $answer) {\n    result {\n      id\n      companyName\n      campaignName\n      companyId\n      campaignId\n      agentName\n      created\n      data {\n        stats {\n          numberOfMandatoryQuestions\n          numberOfQuestions\n          numberOfQuestionsAnswered\n        }\n      }\n      completed\n      notes\n      names\n      phones\n      emails\n    }\n    meta {\n      limit\n      count\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["leads"] = oneQuery(doc, "leads");
        


/***/ }),

/***/ "rQbI":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assignableCampaigns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descending"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignableCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"descending"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descending"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyName"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":306}};
    doc.loc.source = {"body":"query assignableCampaigns(\n  $userId: Int\n  $companyId: Int\n  $descending: Boolean\n  $sortBy: String\n  $limit: Int\n) {\n  assignableCampaigns(\n    userId: $userId\n    companyId: $companyId\n    descending: $descending\n    sortBy: $sortBy\n    limit: $limit\n  ) {\n    id\n    campaignName\n    companyName\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["assignableCampaigns"] = oneQuery(doc, "assignableCampaigns");
        


/***/ }),

/***/ "rUqi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rjQg":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cloneCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cloneCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":116}};
    doc.loc.source = {"body":"mutation cloneCampaign($id: ID!, $name: String!) {\n  cloneCampaign(id: $id, name: $name) {\n    success\n    id\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["cloneCampaign"] = oneQuery(doc, "cloneCampaign");
        


/***/ }),

/***/ "rqlc":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCampaignQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCampaignQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"questionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":122}};
    doc.loc.source = {"body":"mutation removeCampaignQuestion($questionId: ID!) {\n  removeCampaignQuestion(questionId: $questionId) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["removeCampaignQuestion"] = oneQuery(doc, "removeCampaignQuestion");
        


/***/ }),

/***/ "sA56":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u3Bu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u4yn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uRGi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uXAO":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCampaignInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"landingName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":139}};
    doc.loc.source = {"body":"mutation createCampaign($input: CreateCampaignInput!) {\n  createCampaign(input: $input) {\n    success\n    landingName\n    campaignId\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["createCampaign"] = oneQuery(doc, "createCampaign");
        


/***/ }),

/***/ "uib0":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"webhookTypes"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webhookTypes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":61}};
    doc.loc.source = {"body":"query webhookTypes {\n  webhookTypes {\n    id,\n    type,\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["webhookTypes"] = oneQuery(doc, "webhookTypes");
        


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v/oQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vaFs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vcXL":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCompany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":118}};
    doc.loc.source = {"body":"mutation updateCompany($id: ID!, $input: CompanyInput!) {\n  updateCompany(id: $id, input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updateCompany"] = oneQuery(doc, "updateCompany");
        


/***/ }),

/***/ "vsB3":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"users"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descending"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"descending"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descending"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"photo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumb50"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":481}};
    doc.loc.source = {"body":"query users(\n  $name: String\n  $filter: UserFilter\n  $limit: Int\n  $page: Int\n  $descending: Boolean\n  $sortBy: String\n) {\n  users(\n    name: $name\n    filter: $filter\n    limit: $limit\n    page: $page\n    descending: $descending\n    sortBy: $sortBy\n  ) {\n    result {\n      id\n      name\n      companyName\n      companyId\n      email\n      phone\n      role_type\n      status\n      created\n      photo {\n        thumb50\n      }\n    }\n    meta {\n      limit\n      count\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["users"] = oneQuery(doc, "users");
        


/***/ }),

/***/ "w4X2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w80f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wDBB":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"campaignPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"policy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":168}};
    doc.loc.source = {"body":"query campaignPolicy($campaignId: ID!) {\n  campaignPolicy(campaignId: $campaignId) {\n    id\n    campaignId\n    name\n    created\n    updated\n    policy\n    status\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["campaignPolicy"] = oneQuery(doc, "campaignPolicy");
        


/***/ }),

/***/ "wE0Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wNZm":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuestionInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":102}};
    doc.loc.source = {"body":"mutation createQuestion($input: QuestionInput!) {\n  createQuestion(input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["createQuestion"] = oneQuery(doc, "createQuestion");
        


/***/ }),

/***/ "wUU+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x885":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xBwK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xCFp":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"balances"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balances"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currencyId"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":76}};
    doc.loc.source = {"body":"query balances {\n  balances {\n    balance\n    currency\n    currencyId\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["balances"] = oneQuery(doc, "balances");
        


/***/ }),

/***/ "xTCs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xmWa":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"campaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dispatchTo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dispatchToPhone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leadQty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whiteLabel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widget"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":244}};
    doc.loc.source = {"body":"query campaign($id: Int) {\n  campaign(id: $id) {\n    id\n    campaignName\n    dispatchTo\n    dispatchToPhone\n    leadQty\n    status\n    editable\n    whiteLabel\n    company {\n      id\n      companyName\n    }\n    created\n    widget\n    type\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["campaign"] = oneQuery(doc, "campaign");
        


/***/ }),

/***/ "xzce":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yJHn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yiFP":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":102}};
    doc.loc.source = {"body":"mutation createCampaign($input: CampaignInput!) {\n  createCampaign(input: $input) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["createCampaign"] = oneQuery(doc, "createCampaign");
        


/***/ }),

/***/ "zhG3":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"assignUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignUsers"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}},{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":177}};
    doc.loc.source = {"body":"mutation assignUsers($campaignId: Int!, $users: [AssignUsers]!, $userIds: [Int]!) {\n  assignUsers(campaignId: $campaignId, users: $users, userIds: $userIds) {\n    success\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["assignUsers"] = oneQuery(doc, "assignUsers");
        


/***/ }),

/***/ "zqTu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.cb9c10ba2a8f7bb3957c.js